/**
 * _theme.js
 */

/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
  "use strict"
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document) throw new Error("jQuery requires a window with a document")
            return t(e)
          })
    : t(e)
})("undefined" != typeof window ? window : this, function (e, t) {
  "use strict"
  var n = [],
    r = e.document,
    i = Object.getPrototypeOf,
    o = n.slice,
    a = n.concat,
    s = n.push,
    u = n.indexOf,
    l = {},
    c = l.toString,
    f = l.hasOwnProperty,
    p = f.toString,
    d = p.call(Object),
    h = {},
    g = function e(t) {
      return "function" == typeof t && "number" != typeof t.nodeType
    },
    y = function e(t) {
      return null != t && t === t.window
    },
    v = { type: !0, src: !0, noModule: !0 }
  function m(e, t, n) {
    var i,
      o = (t = t || r).createElement("script")
    if (((o.text = e), n)) for (i in v) n[i] && (o[i] = n[i])
    t.head.appendChild(o).parentNode.removeChild(o)
  }
  function x(e) {
    return null == e
      ? e + ""
      : "object" == typeof e || "function" == typeof e
      ? l[c.call(e)] || "object"
      : typeof e
  }
  var b = "3.3.1",
    w = function (e, t) {
      return new w.fn.init(e, t)
    },
    T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
  ;(w.fn = w.prototype =
    {
      jquery: "3.3.1",
      constructor: w,
      length: 0,
      toArray: function () {
        return o.call(this)
      },
      get: function (e) {
        return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e]
      },
      pushStack: function (e) {
        var t = w.merge(this.constructor(), e)
        return (t.prevObject = this), t
      },
      each: function (e) {
        return w.each(this, e)
      },
      map: function (e) {
        return this.pushStack(
          w.map(this, function (t, n) {
            return e.call(t, n, t)
          })
        )
      },
      slice: function () {
        return this.pushStack(o.apply(this, arguments))
      },
      first: function () {
        return this.eq(0)
      },
      last: function () {
        return this.eq(-1)
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (e < 0 ? t : 0)
        return this.pushStack(n >= 0 && n < t ? [this[n]] : [])
      },
      end: function () {
        return this.prevObject || this.constructor()
      },
      push: s,
      sort: n.sort,
      splice: n.splice
    }),
    (w.extend = w.fn.extend =
      function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          a = arguments[0] || {},
          s = 1,
          u = arguments.length,
          l = !1
        for (
          "boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++),
            "object" == typeof a || g(a) || (a = {}),
            s === u && ((a = this), s--);
          s < u;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (n = a[t]),
                a !== (r = e[t]) &&
                  (l && r && (w.isPlainObject(r) || (i = Array.isArray(r)))
                    ? (i
                        ? ((i = !1), (o = n && Array.isArray(n) ? n : []))
                        : (o = n && w.isPlainObject(n) ? n : {}),
                      (a[t] = w.extend(l, o, r)))
                    : void 0 !== r && (a[t] = r))
        return a
      }),
    w.extend({
      expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e)
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n
        return (
          !(!e || "[object Object]" !== c.call(e)) &&
          (!(t = i(e)) ||
            ("function" == typeof (n = f.call(t, "constructor") && t.constructor) &&
              p.call(n) === d))
        )
      },
      isEmptyObject: function (e) {
        var t
        for (t in e) return !1
        return !0
      },
      globalEval: function (e) {
        m(e)
      },
      each: function (e, t) {
        var n,
          r = 0
        if (C(e)) {
          for (n = e.length; r < n; r++) if (!1 === t.call(e[r], r, e[r])) break
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break
        return e
      },
      trim: function (e) {
        return null == e ? "" : (e + "").replace(T, "")
      },
      makeArray: function (e, t) {
        var n = t || []
        return (
          null != e && (C(Object(e)) ? w.merge(n, "string" == typeof e ? [e] : e) : s.call(n, e)), n
        )
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : u.call(t, e, n)
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r]
        return (e.length = i), e
      },
      grep: function (e, t, n) {
        for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++)
          (r = !t(e[o], o)) !== s && i.push(e[o])
        return i
      },
      map: function (e, t, n) {
        var r,
          i,
          o = 0,
          s = []
        if (C(e)) for (r = e.length; o < r; o++) null != (i = t(e[o], o, n)) && s.push(i)
        else for (o in e) null != (i = t(e[o], o, n)) && s.push(i)
        return a.apply([], s)
      },
      guid: 1,
      support: h
    }),
    "function" == typeof Symbol && (w.fn[Symbol.iterator] = n[Symbol.iterator]),
    w.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function (e, t) {
        l["[object " + t + "]"] = t.toLowerCase()
      }
    )
  function C(e) {
    var t = !!e && "length" in e && e.length,
      n = x(e)
    return (
      !g(e) && !y(e) && ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e))
    )
  }
  var E = (function (e) {
    var t,
      n,
      r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f,
      p,
      d,
      h,
      g,
      y,
      v,
      m,
      x,
      b = "sizzle" + 1 * new Date(),
      w = e.document,
      T = 0,
      C = 0,
      E = ae(),
      k = ae(),
      S = ae(),
      D = function (e, t) {
        return e === t && (f = !0), 0
      },
      N = {}.hasOwnProperty,
      A = [],
      j = A.pop,
      q = A.push,
      L = A.push,
      H = A.slice,
      O = function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n
        return -1
      },
      P =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      M = "[\\x20\\t\\r\\n\\f]",
      R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
      I =
        "\\[" +
        M +
        "*(" +
        R +
        ")(?:" +
        M +
        "*([*^$|!~]?=)" +
        M +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        R +
        "))|)" +
        M +
        "*\\]",
      W =
        ":(" +
        R +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        I +
        ")*)|.*)\\)|)",
      $ = new RegExp(M + "+", "g"),
      B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
      F = new RegExp("^" + M + "*," + M + "*"),
      _ = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
      z = new RegExp("=" + M + "*([^\\]'\"]*?)" + M + "*\\]", "g"),
      X = new RegExp(W),
      U = new RegExp("^" + R + "$"),
      V = {
        ID: new RegExp("^#(" + R + ")"),
        CLASS: new RegExp("^\\.(" + R + ")"),
        TAG: new RegExp("^(" + R + "|[*])"),
        ATTR: new RegExp("^" + I),
        PSEUDO: new RegExp("^" + W),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            M +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            M +
            "*(?:([+-]|)" +
            M +
            "*(\\d+)|))" +
            M +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + P + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            M +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            M +
            "*((?:-\\d)?\\d*)" +
            M +
            "*\\)|)(?=[^-]|$)",
          "i"
        )
      },
      G = /^(?:input|select|textarea|button)$/i,
      Y = /^h\d$/i,
      Q = /^[^{]+\{\s*\[native \w/,
      J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      K = /[+~]/,
      Z = new RegExp("\\\\([\\da-f]{1,6}" + M + "?|(" + M + ")|.)", "ig"),
      ee = function (e, t, n) {
        var r = "0x" + t - 65536
        return r !== r || n
          ? t
          : r < 0
          ? String.fromCharCode(r + 65536)
          : String.fromCharCode((r >> 10) | 55296, (1023 & r) | 56320)
      },
      te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ne = function (e, t) {
        return t
          ? "\0" === e
            ? "\ufffd"
            : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " "
          : "\\" + e
      },
      re = function () {
        p()
      },
      ie = me(
        function (e) {
          return !0 === e.disabled && ("form" in e || "label" in e)
        },
        { dir: "parentNode", next: "legend" }
      )
    try {
      L.apply((A = H.call(w.childNodes)), w.childNodes), A[w.childNodes.length].nodeType
    } catch (e) {
      L = {
        apply: A.length
          ? function (e, t) {
              q.apply(e, H.call(t))
            }
          : function (e, t) {
              var n = e.length,
                r = 0
              while ((e[n++] = t[r++]));
              e.length = n - 1
            }
      }
    }
    function oe(e, t, r, i) {
      var o,
        s,
        l,
        c,
        f,
        h,
        v,
        m = t && t.ownerDocument,
        T = t ? t.nodeType : 9
      if (((r = r || []), "string" != typeof e || !e || (1 !== T && 9 !== T && 11 !== T))) return r
      if (!i && ((t ? t.ownerDocument || t : w) !== d && p(t), (t = t || d), g)) {
        if (11 !== T && (f = J.exec(e)))
          if ((o = f[1])) {
            if (9 === T) {
              if (!(l = t.getElementById(o))) return r
              if (l.id === o) return r.push(l), r
            } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o) return r.push(l), r
          } else {
            if (f[2]) return L.apply(r, t.getElementsByTagName(e)), r
            if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName)
              return L.apply(r, t.getElementsByClassName(o)), r
          }
        if (n.qsa && !S[e + " "] && (!y || !y.test(e))) {
          if (1 !== T) (m = t), (v = e)
          else if ("object" !== t.nodeName.toLowerCase()) {
            ;(c = t.getAttribute("id")) ? (c = c.replace(te, ne)) : t.setAttribute("id", (c = b)),
              (s = (h = a(e)).length)
            while (s--) h[s] = "#" + c + " " + ve(h[s])
            ;(v = h.join(",")), (m = (K.test(e) && ge(t.parentNode)) || t)
          }
          if (v)
            try {
              return L.apply(r, m.querySelectorAll(v)), r
            } catch (e) {
            } finally {
              c === b && t.removeAttribute("id")
            }
        }
      }
      return u(e.replace(B, "$1"), t, r, i)
    }
    function ae() {
      var e = []
      function t(n, i) {
        return e.push(n + " ") > r.cacheLength && delete t[e.shift()], (t[n + " "] = i)
      }
      return t
    }
    function se(e) {
      return (e[b] = !0), e
    }
    function ue(e) {
      var t = d.createElement("fieldset")
      try {
        return !!e(t)
      } catch (e) {
        return !1
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null)
      }
    }
    function le(e, t) {
      var n = e.split("|"),
        i = n.length
      while (i--) r.attrHandle[n[i]] = t
    }
    function ce(e, t) {
      var n = t && e,
        r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex
      if (r) return r
      if (n) while ((n = n.nextSibling)) if (n === t) return -1
      return e ? 1 : -1
    }
    function fe(e) {
      return function (t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e
      }
    }
    function pe(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase()
        return ("input" === n || "button" === n) && t.type === e
      }
    }
    function de(e) {
      return function (t) {
        return "form" in t
          ? t.parentNode && !1 === t.disabled
            ? "label" in t
              ? "label" in t.parentNode
                ? t.parentNode.disabled === e
                : t.disabled === e
              : t.isDisabled === e || (t.isDisabled !== !e && ie(t) === e)
            : t.disabled === e
          : "label" in t && t.disabled === e
      }
    }
    function he(e) {
      return se(function (t) {
        return (
          (t = +t),
          se(function (n, r) {
            var i,
              o = e([], n.length, t),
              a = o.length
            while (a--) n[(i = o[a])] && (n[i] = !(r[i] = n[i]))
          })
        )
      })
    }
    function ge(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e
    }
    ;(n = oe.support = {}),
      (o = oe.isXML =
        function (e) {
          var t = e && (e.ownerDocument || e).documentElement
          return !!t && "HTML" !== t.nodeName
        }),
      (p = oe.setDocument =
        function (e) {
          var t,
            i,
            a = e ? e.ownerDocument || e : w
          return a !== d && 9 === a.nodeType && a.documentElement
            ? ((d = a),
              (h = d.documentElement),
              (g = !o(d)),
              w !== d &&
                (i = d.defaultView) &&
                i.top !== i &&
                (i.addEventListener
                  ? i.addEventListener("unload", re, !1)
                  : i.attachEvent && i.attachEvent("onunload", re)),
              (n.attributes = ue(function (e) {
                return (e.className = "i"), !e.getAttribute("className")
              })),
              (n.getElementsByTagName = ue(function (e) {
                return e.appendChild(d.createComment("")), !e.getElementsByTagName("*").length
              })),
              (n.getElementsByClassName = Q.test(d.getElementsByClassName)),
              (n.getById = ue(function (e) {
                return (
                  (h.appendChild(e).id = b), !d.getElementsByName || !d.getElementsByName(b).length
                )
              })),
              n.getById
                ? ((r.filter.ID = function (e) {
                    var t = e.replace(Z, ee)
                    return function (e) {
                      return e.getAttribute("id") === t
                    }
                  }),
                  (r.find.ID = function (e, t) {
                    if ("undefined" != typeof t.getElementById && g) {
                      var n = t.getElementById(e)
                      return n ? [n] : []
                    }
                  }))
                : ((r.filter.ID = function (e) {
                    var t = e.replace(Z, ee)
                    return function (e) {
                      var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id")
                      return n && n.value === t
                    }
                  }),
                  (r.find.ID = function (e, t) {
                    if ("undefined" != typeof t.getElementById && g) {
                      var n,
                        r,
                        i,
                        o = t.getElementById(e)
                      if (o) {
                        if ((n = o.getAttributeNode("id")) && n.value === e) return [o]
                        ;(i = t.getElementsByName(e)), (r = 0)
                        while ((o = i[r++]))
                          if ((n = o.getAttributeNode("id")) && n.value === e) return [o]
                      }
                      return []
                    }
                  })),
              (r.find.TAG = n.getElementsByTagName
                ? function (e, t) {
                    return "undefined" != typeof t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : n.qsa
                      ? t.querySelectorAll(e)
                      : void 0
                  }
                : function (e, t) {
                    var n,
                      r = [],
                      i = 0,
                      o = t.getElementsByTagName(e)
                    if ("*" === e) {
                      while ((n = o[i++])) 1 === n.nodeType && r.push(n)
                      return r
                    }
                    return o
                  }),
              (r.find.CLASS =
                n.getElementsByClassName &&
                function (e, t) {
                  if ("undefined" != typeof t.getElementsByClassName && g)
                    return t.getElementsByClassName(e)
                }),
              (v = []),
              (y = []),
              (n.qsa = Q.test(d.querySelectorAll)) &&
                (ue(function (e) {
                  ;(h.appendChild(e).innerHTML =
                    "<a id='" +
                    b +
                    "'></a><select id='" +
                    b +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    e.querySelectorAll("[msallowcapture^='']").length &&
                      y.push("[*^$]=" + M + "*(?:''|\"\")"),
                    e.querySelectorAll("[selected]").length ||
                      y.push("\\[" + M + "*(?:value|" + P + ")"),
                    e.querySelectorAll("[id~=" + b + "-]").length || y.push("~="),
                    e.querySelectorAll(":checked").length || y.push(":checked"),
                    e.querySelectorAll("a#" + b + "+*").length || y.push(".#.+[+~]")
                }),
                ue(function (e) {
                  e.innerHTML =
                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>"
                  var t = d.createElement("input")
                  t.setAttribute("type", "hidden"),
                    e.appendChild(t).setAttribute("name", "D"),
                    e.querySelectorAll("[name=d]").length && y.push("name" + M + "*[*^$|!~]?="),
                    2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"),
                    (h.appendChild(e).disabled = !0),
                    2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"),
                    e.querySelectorAll("*,:x"),
                    y.push(",.*:")
                })),
              (n.matchesSelector = Q.test(
                (m =
                  h.matches ||
                  h.webkitMatchesSelector ||
                  h.mozMatchesSelector ||
                  h.oMatchesSelector ||
                  h.msMatchesSelector)
              )) &&
                ue(function (e) {
                  ;(n.disconnectedMatch = m.call(e, "*")), m.call(e, "[s!='']:x"), v.push("!=", W)
                }),
              (y = y.length && new RegExp(y.join("|"))),
              (v = v.length && new RegExp(v.join("|"))),
              (t = Q.test(h.compareDocumentPosition)),
              (x =
                t || Q.test(h.contains)
                  ? function (e, t) {
                      var n = 9 === e.nodeType ? e.documentElement : e,
                        r = t && t.parentNode
                      return (
                        e === r ||
                        !(
                          !r ||
                          1 !== r.nodeType ||
                          !(n.contains
                            ? n.contains(r)
                            : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))
                        )
                      )
                    }
                  : function (e, t) {
                      if (t) while ((t = t.parentNode)) if (t === e) return !0
                      return !1
                    }),
              (D = t
                ? function (e, t) {
                    if (e === t) return (f = !0), 0
                    var r = !e.compareDocumentPosition - !t.compareDocumentPosition
                    return (
                      r ||
                      (1 &
                        (r =
                          (e.ownerDocument || e) === (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1) ||
                      (!n.sortDetached && t.compareDocumentPosition(e) === r)
                        ? e === d || (e.ownerDocument === w && x(w, e))
                          ? -1
                          : t === d || (t.ownerDocument === w && x(w, t))
                          ? 1
                          : c
                          ? O(c, e) - O(c, t)
                          : 0
                        : 4 & r
                        ? -1
                        : 1)
                    )
                  }
                : function (e, t) {
                    if (e === t) return (f = !0), 0
                    var n,
                      r = 0,
                      i = e.parentNode,
                      o = t.parentNode,
                      a = [e],
                      s = [t]
                    if (!i || !o)
                      return e === d ? -1 : t === d ? 1 : i ? -1 : o ? 1 : c ? O(c, e) - O(c, t) : 0
                    if (i === o) return ce(e, t)
                    n = e
                    while ((n = n.parentNode)) a.unshift(n)
                    n = t
                    while ((n = n.parentNode)) s.unshift(n)
                    while (a[r] === s[r]) r++
                    return r ? ce(a[r], s[r]) : a[r] === w ? -1 : s[r] === w ? 1 : 0
                  }),
              d)
            : d
        }),
      (oe.matches = function (e, t) {
        return oe(e, null, null, t)
      }),
      (oe.matchesSelector = function (e, t) {
        if (
          ((e.ownerDocument || e) !== d && p(e),
          (t = t.replace(z, "='$1']")),
          n.matchesSelector && g && !S[t + " "] && (!v || !v.test(t)) && (!y || !y.test(t)))
        )
          try {
            var r = m.call(e, t)
            if (r || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return r
          } catch (e) {}
        return oe(t, d, null, [e]).length > 0
      }),
      (oe.contains = function (e, t) {
        return (e.ownerDocument || e) !== d && p(e), x(e, t)
      }),
      (oe.attr = function (e, t) {
        ;(e.ownerDocument || e) !== d && p(e)
        var i = r.attrHandle[t.toLowerCase()],
          o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0
        return void 0 !== o
          ? o
          : n.attributes || !g
          ? e.getAttribute(t)
          : (o = e.getAttributeNode(t)) && o.specified
          ? o.value
          : null
      }),
      (oe.escape = function (e) {
        return (e + "").replace(te, ne)
      }),
      (oe.error = function (e) {
        throw new Error("Syntax error, unrecognized expression: " + e)
      }),
      (oe.uniqueSort = function (e) {
        var t,
          r = [],
          i = 0,
          o = 0
        if (((f = !n.detectDuplicates), (c = !n.sortStable && e.slice(0)), e.sort(D), f)) {
          while ((t = e[o++])) t === e[o] && (i = r.push(o))
          while (i--) e.splice(r[i], 1)
        }
        return (c = null), e
      }),
      (i = oe.getText =
        function (e) {
          var t,
            n = "",
            r = 0,
            o = e.nodeType
          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ("string" == typeof e.textContent) return e.textContent
              for (e = e.firstChild; e; e = e.nextSibling) n += i(e)
            } else if (3 === o || 4 === o) return e.nodeValue
          } else while ((t = e[r++])) n += i(t)
          return n
        }),
      ((r = oe.selectors =
        {
          cacheLength: 50,
          createPseudo: se,
          match: V,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" }
          },
          preFilter: {
            ATTR: function (e) {
              return (
                (e[1] = e[1].replace(Z, ee)),
                (e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee)),
                "~=" === e[2] && (e[3] = " " + e[3] + " "),
                e.slice(0, 4)
              )
            },
            CHILD: function (e) {
              return (
                (e[1] = e[1].toLowerCase()),
                "nth" === e[1].slice(0, 3)
                  ? (e[3] || oe.error(e[0]),
                    (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))),
                    (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                  : e[3] && oe.error(e[0]),
                e
              )
            },
            PSEUDO: function (e) {
              var t,
                n = !e[6] && e[2]
              return V.CHILD.test(e[0])
                ? null
                : (e[3]
                    ? (e[2] = e[4] || e[5] || "")
                    : n &&
                      X.test(n) &&
                      (t = a(n, !0)) &&
                      (t = n.indexOf(")", n.length - t) - n.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                  e.slice(0, 3))
            }
          },
          filter: {
            TAG: function (e) {
              var t = e.replace(Z, ee).toLowerCase()
              return "*" === e
                ? function () {
                    return !0
                  }
                : function (e) {
                    return e.nodeName && e.nodeName.toLowerCase() === t
                  }
            },
            CLASS: function (e) {
              var t = E[e + " "]
              return (
                t ||
                ((t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) &&
                  E(e, function (e) {
                    return t.test(
                      ("string" == typeof e.className && e.className) ||
                        ("undefined" != typeof e.getAttribute && e.getAttribute("class")) ||
                        ""
                    )
                  }))
              )
            },
            ATTR: function (e, t, n) {
              return function (r) {
                var i = oe.attr(r, e)
                return null == i
                  ? "!=" === t
                  : !t ||
                      ((i += ""),
                      "=" === t
                        ? i === n
                        : "!=" === t
                        ? i !== n
                        : "^=" === t
                        ? n && 0 === i.indexOf(n)
                        : "*=" === t
                        ? n && i.indexOf(n) > -1
                        : "$=" === t
                        ? n && i.slice(-n.length) === n
                        : "~=" === t
                        ? (" " + i.replace($, " ") + " ").indexOf(n) > -1
                        : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"))
              }
            },
            CHILD: function (e, t, n, r, i) {
              var o = "nth" !== e.slice(0, 3),
                a = "last" !== e.slice(-4),
                s = "of-type" === t
              return 1 === r && 0 === i
                ? function (e) {
                    return !!e.parentNode
                  }
                : function (t, n, u) {
                    var l,
                      c,
                      f,
                      p,
                      d,
                      h,
                      g = o !== a ? "nextSibling" : "previousSibling",
                      y = t.parentNode,
                      v = s && t.nodeName.toLowerCase(),
                      m = !u && !s,
                      x = !1
                    if (y) {
                      if (o) {
                        while (g) {
                          p = t
                          while ((p = p[g]))
                            if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1
                          h = g = "only" === e && !h && "nextSibling"
                        }
                        return !0
                      }
                      if (((h = [a ? y.firstChild : y.lastChild]), a && m)) {
                        ;(x =
                          (d =
                            (l =
                              (c =
                                (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2]),
                          (p = d && y.childNodes[d])
                        while ((p = (++d && p && p[g]) || (x = d = 0) || h.pop()))
                          if (1 === p.nodeType && ++x && p === t) {
                            c[e] = [T, d, x]
                            break
                          }
                      } else if (
                        (m &&
                          (x = d =
                            (l =
                              (c =
                                (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]),
                        !1 === x)
                      )
                        while ((p = (++d && p && p[g]) || (x = d = 0) || h.pop()))
                          if (
                            (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) &&
                            ++x &&
                            (m &&
                              ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[
                                e
                              ] = [T, x]),
                            p === t)
                          )
                            break
                      return (x -= i) === r || (x % r == 0 && x / r >= 0)
                    }
                  }
            },
            PSEUDO: function (e, t) {
              var n,
                i =
                  r.pseudos[e] ||
                  r.setFilters[e.toLowerCase()] ||
                  oe.error("unsupported pseudo: " + e)
              return i[b]
                ? i(t)
                : i.length > 1
                ? ((n = [e, e, "", t]),
                  r.setFilters.hasOwnProperty(e.toLowerCase())
                    ? se(function (e, n) {
                        var r,
                          o = i(e, t),
                          a = o.length
                        while (a--) e[(r = O(e, o[a]))] = !(n[r] = o[a])
                      })
                    : function (e) {
                        return i(e, 0, n)
                      })
                : i
            }
          },
          pseudos: {
            not: se(function (e) {
              var t = [],
                n = [],
                r = s(e.replace(B, "$1"))
              return r[b]
                ? se(function (e, t, n, i) {
                    var o,
                      a = r(e, null, i, []),
                      s = e.length
                    while (s--) (o = a[s]) && (e[s] = !(t[s] = o))
                  })
                : function (e, i, o) {
                    return (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop()
                  }
            }),
            has: se(function (e) {
              return function (t) {
                return oe(e, t).length > 0
              }
            }),
            contains: se(function (e) {
              return (
                (e = e.replace(Z, ee)),
                function (t) {
                  return (t.textContent || t.innerText || i(t)).indexOf(e) > -1
                }
              )
            }),
            lang: se(function (e) {
              return (
                U.test(e || "") || oe.error("unsupported lang: " + e),
                (e = e.replace(Z, ee).toLowerCase()),
                function (t) {
                  var n
                  do {
                    if ((n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")))
                      return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                  } while ((t = t.parentNode) && 1 === t.nodeType)
                  return !1
                }
              )
            }),
            target: function (t) {
              var n = e.location && e.location.hash
              return n && n.slice(1) === t.id
            },
            root: function (e) {
              return e === h
            },
            focus: function (e) {
              return (
                e === d.activeElement &&
                (!d.hasFocus || d.hasFocus()) &&
                !!(e.type || e.href || ~e.tabIndex)
              )
            },
            enabled: de(!1),
            disabled: de(!0),
            checked: function (e) {
              var t = e.nodeName.toLowerCase()
              return ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
            },
            selected: function (e) {
              return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            },
            empty: function (e) {
              for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1
              return !0
            },
            parent: function (e) {
              return !r.pseudos.empty(e)
            },
            header: function (e) {
              return Y.test(e.nodeName)
            },
            input: function (e) {
              return G.test(e.nodeName)
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase()
              return ("input" === t && "button" === e.type) || "button" === t
            },
            text: function (e) {
              var t
              return (
                "input" === e.nodeName.toLowerCase() &&
                "text" === e.type &&
                (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
              )
            },
            first: he(function () {
              return [0]
            }),
            last: he(function (e, t) {
              return [t - 1]
            }),
            eq: he(function (e, t, n) {
              return [n < 0 ? n + t : n]
            }),
            even: he(function (e, t) {
              for (var n = 0; n < t; n += 2) e.push(n)
              return e
            }),
            odd: he(function (e, t) {
              for (var n = 1; n < t; n += 2) e.push(n)
              return e
            }),
            lt: he(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; --r >= 0; ) e.push(r)
              return e
            }),
            gt: he(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r)
              return e
            })
          }
        }).pseudos.nth = r.pseudos.eq)
    for (t in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) r.pseudos[t] = fe(t)
    for (t in { submit: !0, reset: !0 }) r.pseudos[t] = pe(t)
    function ye() {}
    ;(ye.prototype = r.filters = r.pseudos),
      (r.setFilters = new ye()),
      (a = oe.tokenize =
        function (e, t) {
          var n,
            i,
            o,
            a,
            s,
            u,
            l,
            c = k[e + " "]
          if (c) return t ? 0 : c.slice(0)
          ;(s = e), (u = []), (l = r.preFilter)
          while (s) {
            ;(n && !(i = F.exec(s))) || (i && (s = s.slice(i[0].length) || s), u.push((o = []))),
              (n = !1),
              (i = _.exec(s)) &&
                ((n = i.shift()),
                o.push({ value: n, type: i[0].replace(B, " ") }),
                (s = s.slice(n.length)))
            for (a in r.filter)
              !(i = V[a].exec(s)) ||
                (l[a] && !(i = l[a](i))) ||
                ((n = i.shift()),
                o.push({ value: n, type: a, matches: i }),
                (s = s.slice(n.length)))
            if (!n) break
          }
          return t ? s.length : s ? oe.error(e) : k(e, u).slice(0)
        })
    function ve(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value
      return r
    }
    function me(e, t, n) {
      var r = t.dir,
        i = t.next,
        o = i || r,
        a = n && "parentNode" === o,
        s = C++
      return t.first
        ? function (t, n, i) {
            while ((t = t[r])) if (1 === t.nodeType || a) return e(t, n, i)
            return !1
          }
        : function (t, n, u) {
            var l,
              c,
              f,
              p = [T, s]
            if (u) {
              while ((t = t[r])) if ((1 === t.nodeType || a) && e(t, n, u)) return !0
            } else
              while ((t = t[r]))
                if (1 === t.nodeType || a)
                  if (
                    ((f = t[b] || (t[b] = {})),
                    (c = f[t.uniqueID] || (f[t.uniqueID] = {})),
                    i && i === t.nodeName.toLowerCase())
                  )
                    t = t[r] || t
                  else {
                    if ((l = c[o]) && l[0] === T && l[1] === s) return (p[2] = l[2])
                    if (((c[o] = p), (p[2] = e(t, n, u)))) return !0
                  }
            return !1
          }
    }
    function xe(e) {
      return e.length > 1
        ? function (t, n, r) {
            var i = e.length
            while (i--) if (!e[i](t, n, r)) return !1
            return !0
          }
        : e[0]
    }
    function be(e, t, n) {
      for (var r = 0, i = t.length; r < i; r++) oe(e, t[r], n)
      return n
    }
    function we(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)))
      return a
    }
    function Te(e, t, n, r, i, o) {
      return (
        r && !r[b] && (r = Te(r)),
        i && !i[b] && (i = Te(i, o)),
        se(function (o, a, s, u) {
          var l,
            c,
            f,
            p = [],
            d = [],
            h = a.length,
            g = o || be(t || "*", s.nodeType ? [s] : s, []),
            y = !e || (!o && t) ? g : we(g, p, e, s, u),
            v = n ? (i || (o ? e : h || r) ? [] : a) : y
          if ((n && n(y, v, s, u), r)) {
            ;(l = we(v, d)), r(l, [], s, u), (c = l.length)
            while (c--) (f = l[c]) && (v[d[c]] = !(y[d[c]] = f))
          }
          if (o) {
            if (i || e) {
              if (i) {
                ;(l = []), (c = v.length)
                while (c--) (f = v[c]) && l.push((y[c] = f))
                i(null, (v = []), l, u)
              }
              c = v.length
              while (c--) (f = v[c]) && (l = i ? O(o, f) : p[c]) > -1 && (o[l] = !(a[l] = f))
            }
          } else (v = we(v === a ? v.splice(h, v.length) : v)), i ? i(null, a, v, u) : L.apply(a, v)
        })
      )
    }
    function Ce(e) {
      for (
        var t,
          n,
          i,
          o = e.length,
          a = r.relative[e[0].type],
          s = a || r.relative[" "],
          u = a ? 1 : 0,
          c = me(
            function (e) {
              return e === t
            },
            s,
            !0
          ),
          f = me(
            function (e) {
              return O(t, e) > -1
            },
            s,
            !0
          ),
          p = [
            function (e, n, r) {
              var i = (!a && (r || n !== l)) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r))
              return (t = null), i
            }
          ];
        u < o;
        u++
      )
        if ((n = r.relative[e[u].type])) p = [me(xe(p), n)]
        else {
          if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
            for (i = ++u; i < o; i++) if (r.relative[e[i].type]) break
            return Te(
              u > 1 && xe(p),
              u > 1 &&
                ve(e.slice(0, u - 1).concat({ value: " " === e[u - 2].type ? "*" : "" })).replace(
                  B,
                  "$1"
                ),
              n,
              u < i && Ce(e.slice(u, i)),
              i < o && Ce((e = e.slice(i))),
              i < o && ve(e)
            )
          }
          p.push(n)
        }
      return xe(p)
    }
    function Ee(e, t) {
      var n = t.length > 0,
        i = e.length > 0,
        o = function (o, a, s, u, c) {
          var f,
            h,
            y,
            v = 0,
            m = "0",
            x = o && [],
            b = [],
            w = l,
            C = o || (i && r.find.TAG("*", c)),
            E = (T += null == w ? 1 : Math.random() || 0.1),
            k = C.length
          for (c && (l = a === d || a || c); m !== k && null != (f = C[m]); m++) {
            if (i && f) {
              ;(h = 0), a || f.ownerDocument === d || (p(f), (s = !g))
              while ((y = e[h++]))
                if (y(f, a || d, s)) {
                  u.push(f)
                  break
                }
              c && (T = E)
            }
            n && ((f = !y && f) && v--, o && x.push(f))
          }
          if (((v += m), n && m !== v)) {
            h = 0
            while ((y = t[h++])) y(x, b, a, s)
            if (o) {
              if (v > 0) while (m--) x[m] || b[m] || (b[m] = j.call(u))
              b = we(b)
            }
            L.apply(u, b), c && !o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u)
          }
          return c && ((T = E), (l = w)), x
        }
      return n ? se(o) : o
    }
    return (
      (s = oe.compile =
        function (e, t) {
          var n,
            r = [],
            i = [],
            o = S[e + " "]
          if (!o) {
            t || (t = a(e)), (n = t.length)
            while (n--) (o = Ce(t[n]))[b] ? r.push(o) : i.push(o)
            ;(o = S(e, Ee(i, r))).selector = e
          }
          return o
        }),
      (u = oe.select =
        function (e, t, n, i) {
          var o,
            u,
            l,
            c,
            f,
            p = "function" == typeof e && e,
            d = !i && a((e = p.selector || e))
          if (((n = n || []), 1 === d.length)) {
            if (
              (u = d[0] = d[0].slice(0)).length > 2 &&
              "ID" === (l = u[0]).type &&
              9 === t.nodeType &&
              g &&
              r.relative[u[1].type]
            ) {
              if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0])) return n
              p && (t = t.parentNode), (e = e.slice(u.shift().value.length))
            }
            o = V.needsContext.test(e) ? 0 : u.length
            while (o--) {
              if (((l = u[o]), r.relative[(c = l.type)])) break
              if (
                (f = r.find[c]) &&
                (i = f(l.matches[0].replace(Z, ee), (K.test(u[0].type) && ge(t.parentNode)) || t))
              ) {
                if ((u.splice(o, 1), !(e = i.length && ve(u)))) return L.apply(n, i), n
                break
              }
            }
          }
          return (p || s(e, d))(i, t, !g, n, !t || (K.test(e) && ge(t.parentNode)) || t), n
        }),
      (n.sortStable = b.split("").sort(D).join("") === b),
      (n.detectDuplicates = !!f),
      p(),
      (n.sortDetached = ue(function (e) {
        return 1 & e.compareDocumentPosition(d.createElement("fieldset"))
      })),
      ue(function (e) {
        return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href")
      }) ||
        le("type|href|height|width", function (e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }),
      (n.attributes &&
        ue(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          )
        })) ||
        le("value", function (e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue
        }),
      ue(function (e) {
        return null == e.getAttribute("disabled")
      }) ||
        le(P, function (e, t, n) {
          var r
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (r = e.getAttributeNode(t)) && r.specified
              ? r.value
              : null
        }),
      oe
    )
  })(e)
  ;(w.find = E),
    (w.expr = E.selectors),
    (w.expr[":"] = w.expr.pseudos),
    (w.uniqueSort = w.unique = E.uniqueSort),
    (w.text = E.getText),
    (w.isXMLDoc = E.isXML),
    (w.contains = E.contains),
    (w.escapeSelector = E.escape)
  var k = function (e, t, n) {
      var r = [],
        i = void 0 !== n
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && w(e).is(n)) break
          r.push(e)
        }
      return r
    },
    S = function (e, t) {
      for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e)
      return n
    },
    D = w.expr.match.needsContext
  function N(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
  }
  var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i
  function j(e, t, n) {
    return g(t)
      ? w.grep(e, function (e, r) {
          return !!t.call(e, r, e) !== n
        })
      : t.nodeType
      ? w.grep(e, function (e) {
          return (e === t) !== n
        })
      : "string" != typeof t
      ? w.grep(e, function (e) {
          return u.call(t, e) > -1 !== n
        })
      : w.filter(t, e, n)
  }
  ;(w.filter = function (e, t, n) {
    var r = t[0]
    return (
      n && (e = ":not(" + e + ")"),
      1 === t.length && 1 === r.nodeType
        ? w.find.matchesSelector(r, e)
          ? [r]
          : []
        : w.find.matches(
            e,
            w.grep(t, function (e) {
              return 1 === e.nodeType
            })
          )
    )
  }),
    w.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this.length,
          i = this
        if ("string" != typeof e)
          return this.pushStack(
            w(e).filter(function () {
              for (t = 0; t < r; t++) if (w.contains(i[t], this)) return !0
            })
          )
        for (n = this.pushStack([]), t = 0; t < r; t++) w.find(e, i[t], n)
        return r > 1 ? w.uniqueSort(n) : n
      },
      filter: function (e) {
        return this.pushStack(j(this, e || [], !1))
      },
      not: function (e) {
        return this.pushStack(j(this, e || [], !0))
      },
      is: function (e) {
        return !!j(this, "string" == typeof e && D.test(e) ? w(e) : e || [], !1).length
      }
    })
  var q,
    L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/
  ;((w.fn.init = function (e, t, n) {
    var i, o
    if (!e) return this
    if (((n = n || q), "string" == typeof e)) {
      if (
        !(i =
          "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : L.exec(e)) ||
        (!i[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e)
      if (i[1]) {
        if (
          ((t = t instanceof w ? t[0] : t),
          w.merge(this, w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)),
          A.test(i[1]) && w.isPlainObject(t))
        )
          for (i in t) g(this[i]) ? this[i](t[i]) : this.attr(i, t[i])
        return this
      }
      return (o = r.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : g(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(w)
      : w.makeArray(e, this)
  }).prototype = w.fn),
    (q = w(r))
  var H = /^(?:parents|prev(?:Until|All))/,
    O = { children: !0, contents: !0, next: !0, prev: !0 }
  w.fn.extend({
    has: function (e) {
      var t = w(e, this),
        n = t.length
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (w.contains(this, t[e])) return !0
      })
    },
    closest: function (e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = "string" != typeof e && w(e)
      if (!D.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))
            ) {
              o.push(n)
              break
            }
      return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o)
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? u.call(w(e), this[0])
          : u.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1
    },
    add: function (e, t) {
      return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))))
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
    }
  })
  function P(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e
  }
  w.each(
    {
      parent: function (e) {
        var t = e.parentNode
        return t && 11 !== t.nodeType ? t : null
      },
      parents: function (e) {
        return k(e, "parentNode")
      },
      parentsUntil: function (e, t, n) {
        return k(e, "parentNode", n)
      },
      next: function (e) {
        return P(e, "nextSibling")
      },
      prev: function (e) {
        return P(e, "previousSibling")
      },
      nextAll: function (e) {
        return k(e, "nextSibling")
      },
      prevAll: function (e) {
        return k(e, "previousSibling")
      },
      nextUntil: function (e, t, n) {
        return k(e, "nextSibling", n)
      },
      prevUntil: function (e, t, n) {
        return k(e, "previousSibling", n)
      },
      siblings: function (e) {
        return S((e.parentNode || {}).firstChild, e)
      },
      children: function (e) {
        return S(e.firstChild)
      },
      contents: function (e) {
        return N(e, "iframe")
          ? e.contentDocument
          : (N(e, "template") && (e = e.content || e), w.merge([], e.childNodes))
      }
    },
    function (e, t) {
      w.fn[e] = function (n, r) {
        var i = w.map(this, t, n)
        return (
          "Until" !== e.slice(-5) && (r = n),
          r && "string" == typeof r && (i = w.filter(r, i)),
          this.length > 1 && (O[e] || w.uniqueSort(i), H.test(e) && i.reverse()),
          this.pushStack(i)
        )
      }
    }
  )
  var M = /[^\x20\t\r\n\f]+/g
  function R(e) {
    var t = {}
    return (
      w.each(e.match(M) || [], function (e, n) {
        t[n] = !0
      }),
      t
    )
  }
  w.Callbacks = function (e) {
    e = "string" == typeof e ? R(e) : w.extend({}, e)
    var t,
      n,
      r,
      i,
      o = [],
      a = [],
      s = -1,
      u = function () {
        for (i = i || e.once, r = t = !0; a.length; s = -1) {
          n = a.shift()
          while (++s < o.length)
            !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && ((s = o.length), (n = !1))
        }
        e.memory || (n = !1), (t = !1), i && (o = n ? [] : "")
      },
      l = {
        add: function () {
          return (
            o &&
              (n && !t && ((s = o.length - 1), a.push(n)),
              (function t(n) {
                w.each(n, function (n, r) {
                  g(r)
                    ? (e.unique && l.has(r)) || o.push(r)
                    : r && r.length && "string" !== x(r) && t(r)
                })
              })(arguments),
              n && !t && u()),
            this
          )
        },
        remove: function () {
          return (
            w.each(arguments, function (e, t) {
              var n
              while ((n = w.inArray(t, o, n)) > -1) o.splice(n, 1), n <= s && s--
            }),
            this
          )
        },
        has: function (e) {
          return e ? w.inArray(e, o) > -1 : o.length > 0
        },
        empty: function () {
          return o && (o = []), this
        },
        disable: function () {
          return (i = a = []), (o = n = ""), this
        },
        disabled: function () {
          return !o
        },
        lock: function () {
          return (i = a = []), n || t || (o = n = ""), this
        },
        locked: function () {
          return !!i
        },
        fireWith: function (e, n) {
          return i || ((n = [e, (n = n || []).slice ? n.slice() : n]), a.push(n), t || u()), this
        },
        fire: function () {
          return l.fireWith(this, arguments), this
        },
        fired: function () {
          return !!r
        }
      }
    return l
  }
  function I(e) {
    return e
  }
  function W(e) {
    throw e
  }
  function $(e, t, n, r) {
    var i
    try {
      e && g((i = e.promise))
        ? i.call(e).done(t).fail(n)
        : e && g((i = e.then))
        ? i.call(e, t, n)
        : t.apply(void 0, [e].slice(r))
    } catch (e) {
      n.apply(void 0, [e])
    }
  }
  w.extend({
    Deferred: function (t) {
      var n = [
          ["notify", "progress", w.Callbacks("memory"), w.Callbacks("memory"), 2],
          [
            "resolve",
            "done",
            w.Callbacks("once memory"),
            w.Callbacks("once memory"),
            0,
            "resolved"
          ],
          ["reject", "fail", w.Callbacks("once memory"), w.Callbacks("once memory"), 1, "rejected"]
        ],
        r = "pending",
        i = {
          state: function () {
            return r
          },
          always: function () {
            return o.done(arguments).fail(arguments), this
          },
          catch: function (e) {
            return i.then(null, e)
          },
          pipe: function () {
            var e = arguments
            return w
              .Deferred(function (t) {
                w.each(n, function (n, r) {
                  var i = g(e[r[4]]) && e[r[4]]
                  o[r[1]](function () {
                    var e = i && i.apply(this, arguments)
                    e && g(e.promise)
                      ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject)
                      : t[r[0] + "With"](this, i ? [e] : arguments)
                  })
                }),
                  (e = null)
              })
              .promise()
          },
          then: function (t, r, i) {
            var o = 0
            function a(t, n, r, i) {
              return function () {
                var s = this,
                  u = arguments,
                  l = function () {
                    var e, l
                    if (!(t < o)) {
                      if ((e = r.apply(s, u)) === n.promise())
                        throw new TypeError("Thenable self-resolution")
                      ;(l = e && ("object" == typeof e || "function" == typeof e) && e.then),
                        g(l)
                          ? i
                            ? l.call(e, a(o, n, I, i), a(o, n, W, i))
                            : (o++,
                              l.call(e, a(o, n, I, i), a(o, n, W, i), a(o, n, I, n.notifyWith)))
                          : (r !== I && ((s = void 0), (u = [e])), (i || n.resolveWith)(s, u))
                    }
                  },
                  c = i
                    ? l
                    : function () {
                        try {
                          l()
                        } catch (e) {
                          w.Deferred.exceptionHook && w.Deferred.exceptionHook(e, c.stackTrace),
                            t + 1 >= o && (r !== W && ((s = void 0), (u = [e])), n.rejectWith(s, u))
                        }
                      }
                t
                  ? c()
                  : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()),
                    e.setTimeout(c))
              }
            }
            return w
              .Deferred(function (e) {
                n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)),
                  n[1][3].add(a(0, e, g(t) ? t : I)),
                  n[2][3].add(a(0, e, g(r) ? r : W))
              })
              .promise()
          },
          promise: function (e) {
            return null != e ? w.extend(e, i) : i
          }
        },
        o = {}
      return (
        w.each(n, function (e, t) {
          var a = t[2],
            s = t[5]
          ;(i[t[1]] = a.add),
            s &&
              a.add(
                function () {
                  r = s
                },
                n[3 - e][2].disable,
                n[3 - e][3].disable,
                n[0][2].lock,
                n[0][3].lock
              ),
            a.add(t[3].fire),
            (o[t[0]] = function () {
              return o[t[0] + "With"](this === o ? void 0 : this, arguments), this
            }),
            (o[t[0] + "With"] = a.fireWith)
        }),
        i.promise(o),
        t && t.call(o, o),
        o
      )
    },
    when: function (e) {
      var t = arguments.length,
        n = t,
        r = Array(n),
        i = o.call(arguments),
        a = w.Deferred(),
        s = function (e) {
          return function (n) {
            ;(r[e] = this),
              (i[e] = arguments.length > 1 ? o.call(arguments) : n),
              --t || a.resolveWith(r, i)
          }
        }
      if (
        t <= 1 &&
        ($(e, a.done(s(n)).resolve, a.reject, !t), "pending" === a.state() || g(i[n] && i[n].then))
      )
        return a.then()
      while (n--) $(i[n], s(n), a.reject)
      return a.promise()
    }
  })
  var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/
  ;(w.Deferred.exceptionHook = function (t, n) {
    e.console &&
      e.console.warn &&
      t &&
      B.test(t.name) &&
      e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n)
  }),
    (w.readyException = function (t) {
      e.setTimeout(function () {
        throw t
      })
    })
  var F = w.Deferred()
  ;(w.fn.ready = function (e) {
    return (
      F.then(e)["catch"](function (e) {
        w.readyException(e)
      }),
      this
    )
  }),
    w.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        ;(!0 === e ? --w.readyWait : w.isReady) ||
          ((w.isReady = !0), (!0 !== e && --w.readyWait > 0) || F.resolveWith(r, [w]))
      }
    }),
    (w.ready.then = F.then)
  function _() {
    r.removeEventListener("DOMContentLoaded", _), e.removeEventListener("load", _), w.ready()
  }
  "complete" === r.readyState || ("loading" !== r.readyState && !r.documentElement.doScroll)
    ? e.setTimeout(w.ready)
    : (r.addEventListener("DOMContentLoaded", _), e.addEventListener("load", _))
  var z = function (e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n
      if ("object" === x(n)) {
        i = !0
        for (s in n) z(e, t, s, n[s], !0, o, a)
      } else if (
        void 0 !== r &&
        ((i = !0),
        g(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(w(e), n)
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)))
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o
    },
    X = /^-ms-/,
    U = /-([a-z])/g
  function V(e, t) {
    return t.toUpperCase()
  }
  function G(e) {
    return e.replace(X, "ms-").replace(U, V)
  }
  var Y = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
  }
  function Q() {
    this.expando = w.expando + Q.uid++
  }
  ;(Q.uid = 1),
    (Q.prototype = {
      cache: function (e) {
        var t = e[this.expando]
        return (
          t ||
            ((t = {}),
            Y(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))),
          t
        )
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e)
        if ("string" == typeof t) i[G(t)] = n
        else for (r in t) i[G(r)] = t[r]
        return i
      },
      get: function (e, t) {
        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)]
      },
      access: function (e, t, n) {
        return void 0 === t || (t && "string" == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t)
      },
      remove: function (e, t) {
        var n,
          r = e[this.expando]
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t) ? t.map(G) : (t = G(t)) in r ? [t] : t.match(M) || []).length
            while (n--) delete r[t[n]]
          }
          ;(void 0 === t || w.isEmptyObject(r)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando])
        }
      },
      hasData: function (e) {
        var t = e[this.expando]
        return void 0 !== t && !w.isEmptyObject(t)
      }
    })
  var J = new Q(),
    K = new Q(),
    Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    ee = /[A-Z]/g
  function te(e) {
    return (
      "true" === e ||
      ("false" !== e && ("null" === e ? null : e === +e + "" ? +e : Z.test(e) ? JSON.parse(e) : e))
    )
  }
  function ne(e, t, n) {
    var r
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = "data-" + t.replace(ee, "-$&").toLowerCase()),
        "string" == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n = te(n)
        } catch (e) {}
        K.set(e, t, n)
      } else n = void 0
    return n
  }
  w.extend({
    hasData: function (e) {
      return K.hasData(e) || J.hasData(e)
    },
    data: function (e, t, n) {
      return K.access(e, t, n)
    },
    removeData: function (e, t) {
      K.remove(e, t)
    },
    _data: function (e, t, n) {
      return J.access(e, t, n)
    },
    _removeData: function (e, t) {
      J.remove(e, t)
    }
  }),
    w.fn.extend({
      data: function (e, t) {
        var n,
          r,
          i,
          o = this[0],
          a = o && o.attributes
        if (void 0 === e) {
          if (this.length && ((i = K.get(o)), 1 === o.nodeType && !J.get(o, "hasDataAttrs"))) {
            n = a.length
            while (n--)
              a[n] &&
                0 === (r = a[n].name).indexOf("data-") &&
                ((r = G(r.slice(5))), ne(o, r, i[r]))
            J.set(o, "hasDataAttrs", !0)
          }
          return i
        }
        return "object" == typeof e
          ? this.each(function () {
              K.set(this, e)
            })
          : z(
              this,
              function (t) {
                var n
                if (o && void 0 === t) {
                  if (void 0 !== (n = K.get(o, e))) return n
                  if (void 0 !== (n = ne(o, e))) return n
                } else
                  this.each(function () {
                    K.set(this, e, t)
                  })
              },
              null,
              t,
              arguments.length > 1,
              null,
              !0
            )
      },
      removeData: function (e) {
        return this.each(function () {
          K.remove(this, e)
        })
      }
    }),
    w.extend({
      queue: function (e, t, n) {
        var r
        if (e)
          return (
            (t = (t || "fx") + "queue"),
            (r = J.get(e, t)),
            n && (!r || Array.isArray(n) ? (r = J.access(e, t, w.makeArray(n))) : r.push(n)),
            r || []
          )
      },
      dequeue: function (e, t) {
        t = t || "fx"
        var n = w.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = w._queueHooks(e, t),
          a = function () {
            w.dequeue(e, t)
          }
        "inprogress" === i && ((i = n.shift()), r--),
          i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, a, o)),
          !r && o && o.empty.fire()
      },
      _queueHooks: function (e, t) {
        var n = t + "queueHooks"
        return (
          J.get(e, n) ||
          J.access(e, n, {
            empty: w.Callbacks("once memory").add(function () {
              J.remove(e, [t + "queue", n])
            })
          })
        )
      }
    }),
    w.fn.extend({
      queue: function (e, t) {
        var n = 2
        return (
          "string" != typeof e && ((t = e), (e = "fx"), n--),
          arguments.length < n
            ? w.queue(this[0], e)
            : void 0 === t
            ? this
            : this.each(function () {
                var n = w.queue(this, e, t)
                w._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e)
              })
        )
      },
      dequeue: function (e) {
        return this.each(function () {
          w.dequeue(this, e)
        })
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", [])
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = w.Deferred(),
          o = this,
          a = this.length,
          s = function () {
            --r || i.resolveWith(o, [o])
          }
        "string" != typeof e && ((t = e), (e = void 0)), (e = e || "fx")
        while (a--) (n = J.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s))
        return s(), i.promise(t)
      }
    })
  var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
    oe = ["Top", "Right", "Bottom", "Left"],
    ae = function (e, t) {
      return (
        "none" === (e = t || e).style.display ||
        ("" === e.style.display && w.contains(e.ownerDocument, e) && "none" === w.css(e, "display"))
      )
    },
    se = function (e, t, n, r) {
      var i,
        o,
        a = {}
      for (o in t) (a[o] = e.style[o]), (e.style[o] = t[o])
      i = n.apply(e, r || [])
      for (o in t) e.style[o] = a[o]
      return i
    }
  function ue(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function () {
            return r.cur()
          }
        : function () {
            return w.css(e, t, "")
          },
      u = s(),
      l = (n && n[3]) || (w.cssNumber[t] ? "" : "px"),
      c = (w.cssNumber[t] || ("px" !== l && +u)) && ie.exec(w.css(e, t))
    if (c && c[3] !== l) {
      ;(u /= 2), (l = l || c[3]), (c = +u || 1)
      while (a--)
        w.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0), (c /= o)
      ;(c *= 2), w.style(e, t, c + l), (n = n || [])
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    )
  }
  var le = {}
  function ce(e) {
    var t,
      n = e.ownerDocument,
      r = e.nodeName,
      i = le[r]
    return (
      i ||
      ((t = n.body.appendChild(n.createElement(r))),
      (i = w.css(t, "display")),
      t.parentNode.removeChild(t),
      "none" === i && (i = "block"),
      (le[r] = i),
      i)
    )
  }
  function fe(e, t) {
    for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
      (r = e[o]).style &&
        ((n = r.style.display),
        t
          ? ("none" === n && ((i[o] = J.get(r, "display") || null), i[o] || (r.style.display = "")),
            "" === r.style.display && ae(r) && (i[o] = ce(r)))
          : "none" !== n && ((i[o] = "none"), J.set(r, "display", n)))
    for (o = 0; o < a; o++) null != i[o] && (e[o].style.display = i[o])
    return e
  }
  w.fn.extend({
    show: function () {
      return fe(this, !0)
    },
    hide: function () {
      return fe(this)
    },
    toggle: function (e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ae(this) ? w(this).show() : w(this).hide()
          })
    }
  })
  var pe = /^(?:checkbox|radio)$/i,
    de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
    he = /^$|^module$|\/(?:java|ecma)script/i,
    ge = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    }
  ;(ge.optgroup = ge.option),
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
    (ge.th = ge.td)
  function ye(e, t) {
    var n
    return (
      (n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : []),
      void 0 === t || (t && N(e, t)) ? w.merge([e], n) : n
    )
  }
  function ve(e, t) {
    for (var n = 0, r = e.length; n < r; n++)
      J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"))
  }
  var me = /<|&#?\w+;/
  function xe(e, t, n, r, i) {
    for (
      var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length;
      d < h;
      d++
    )
      if ((o = e[d]) || 0 === o)
        if ("object" === x(o)) w.merge(p, o.nodeType ? [o] : o)
        else if (me.test(o)) {
          ;(a = a || f.appendChild(t.createElement("div"))),
            (s = (de.exec(o) || ["", ""])[1].toLowerCase()),
            (u = ge[s] || ge._default),
            (a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2]),
            (c = u[0])
          while (c--) a = a.lastChild
          w.merge(p, a.childNodes), ((a = f.firstChild).textContent = "")
        } else p.push(t.createTextNode(o))
    ;(f.textContent = ""), (d = 0)
    while ((o = p[d++]))
      if (r && w.inArray(o, r) > -1) i && i.push(o)
      else if (
        ((l = w.contains(o.ownerDocument, o)), (a = ye(f.appendChild(o), "script")), l && ve(a), n)
      ) {
        c = 0
        while ((o = a[c++])) he.test(o.type || "") && n.push(o)
      }
    return f
  }
  !(function () {
    var e = r.createDocumentFragment().appendChild(r.createElement("div")),
      t = r.createElement("input")
    t.setAttribute("type", "radio"),
      t.setAttribute("checked", "checked"),
      t.setAttribute("name", "t"),
      e.appendChild(t),
      (h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (e.innerHTML = "<textarea>x</textarea>"),
      (h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue)
  })()
  var be = r.documentElement,
    we = /^key/,
    Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Ce = /^([^.]*)(?:\.(.+)|)/
  function Ee() {
    return !0
  }
  function ke() {
    return !1
  }
  function Se() {
    try {
      return r.activeElement
    } catch (e) {}
  }
  function De(e, t, n, r, i, o) {
    var a, s
    if ("object" == typeof t) {
      "string" != typeof n && ((r = r || n), (n = void 0))
      for (s in t) De(e, s, n, r, t[s], o)
      return e
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ("string" == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = ke
    else if (!i) return e
    return (
      1 === o &&
        ((a = i),
        ((i = function (e) {
          return w().off(e), a.apply(this, arguments)
        }).guid = a.guid || (a.guid = w.guid++))),
      e.each(function () {
        w.event.add(this, t, i, r, n)
      })
    )
  }
  ;(w.event = {
    global: {},
    add: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.get(e)
      if (y) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && w.find.matchesSelector(be, i),
          n.guid || (n.guid = w.guid++),
          (u = y.events) || (u = y.events = {}),
          (a = y.handle) ||
            (a = y.handle =
              function (t) {
                return "undefined" != typeof w && w.event.triggered !== t.type
                  ? w.event.dispatch.apply(e, arguments)
                  : void 0
              }),
          (l = (t = (t || "").match(M) || [""]).length)
        while (l--)
          (d = g = (s = Ce.exec(t[l]) || [])[1]),
            (h = (s[2] || "").split(".").sort()),
            d &&
              ((f = w.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = w.event.special[d] || {}),
              (c = w.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && w.expr.match.needsContext.test(i),
                  namespace: h.join(".")
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(e, r, h, a)) ||
                  (e.addEventListener && e.addEventListener(d, a))),
              f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (w.event.global[d] = !0))
      }
    },
    remove: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.hasData(e) && J.get(e)
      if (y && (u = y.events)) {
        l = (t = (t || "").match(M) || [""]).length
        while (l--)
          if (
            ((s = Ce.exec(t[l]) || []), (d = g = s[1]), (h = (s[2] || "").split(".").sort()), d)
          ) {
            ;(f = w.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")),
              (a = o = p.length)
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                  (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c))
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, y.handle)) ||
                w.removeEvent(e, d, y.handle),
              delete u[d])
          } else for (d in u) w.event.remove(e, d + t[l], n, r, !0)
        w.isEmptyObject(u) && J.remove(e, "handle events")
      }
    },
    dispatch: function (e) {
      var t = w.event.fix(e),
        n,
        r,
        i,
        o,
        a,
        s,
        u = new Array(arguments.length),
        l = (J.get(this, "events") || {})[t.type] || [],
        c = w.event.special[t.type] || {}
      for (u[0] = t, n = 1; n < arguments.length; n++) u[n] = arguments[n]
      if (((t.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, t))) {
        ;(s = w.event.handlers.call(this, t, l)), (n = 0)
        while ((o = s[n++]) && !t.isPropagationStopped()) {
          ;(t.currentTarget = o.elem), (r = 0)
          while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped())
            (t.rnamespace && !t.rnamespace.test(a.namespace)) ||
              ((t.handleObj = a),
              (t.data = a.data),
              void 0 !==
                (i = ((w.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, u)) &&
                !1 === (t.result = i) &&
                (t.preventDefault(), t.stopPropagation()))
        }
        return c.postDispatch && c.postDispatch.call(this, t), t.result
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target
      if (u && l.nodeType && !("click" === e.type && e.button >= 1))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + " ")] &&
                (a[i] = r.needsContext
                  ? w(i, this).index(l) > -1
                  : w.find(i, this, null, [l]).length),
                a[i] && o.push(r)
            o.length && s.push({ elem: l, handlers: o })
          }
      return (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s
    },
    addProp: function (e, t) {
      Object.defineProperty(w.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: g(t)
          ? function () {
              if (this.originalEvent) return t(this.originalEvent)
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[e]
            },
        set: function (t) {
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
          })
        }
      })
    },
    fix: function (e) {
      return e[w.expando] ? e : new w.Event(e)
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          if (this !== Se() && this.focus) return this.focus(), !1
        },
        delegateType: "focusin"
      },
      blur: {
        trigger: function () {
          if (this === Se() && this.blur) return this.blur(), !1
        },
        delegateType: "focusout"
      },
      click: {
        trigger: function () {
          if ("checkbox" === this.type && this.click && N(this, "input")) return this.click(), !1
        },
        _default: function (e) {
          return N(e.target, "a")
        }
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
        }
      }
    }
  }),
    (w.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n)
    }),
    (w.Event = function (e, t) {
      if (!(this instanceof w.Event)) return new w.Event(e, t)
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Ee
              : ke),
          (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && w.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[w.expando] = !0)
    }),
    (w.Event.prototype = {
      constructor: w.Event,
      isDefaultPrevented: ke,
      isPropagationStopped: ke,
      isImmediatePropagationStopped: ke,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent
        ;(this.isDefaultPrevented = Ee), e && !this.isSimulated && e.preventDefault()
      },
      stopPropagation: function () {
        var e = this.originalEvent
        ;(this.isPropagationStopped = Ee), e && !this.isSimulated && e.stopPropagation()
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent
        ;(this.isImmediatePropagationStopped = Ee),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation()
      }
    }),
    w.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button
          return null == e.which && we.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && Te.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which
        }
      },
      w.event.addProp
    ),
    w.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
      },
      function (e, t) {
        w.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function (e) {
            var n,
              r = this,
              i = e.relatedTarget,
              o = e.handleObj
            return (
              (i && (i === r || w.contains(r, i))) ||
                ((e.type = o.origType), (n = o.handler.apply(this, arguments)), (e.type = t)),
              n
            )
          }
        }
      }
    ),
    w.fn.extend({
      on: function (e, t, n, r) {
        return De(this, e, t, n, r)
      },
      one: function (e, t, n, r) {
        return De(this, e, t, n, r, 1)
      },
      off: function (e, t, n) {
        var r, i
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            w(e.delegateTarget).off(
              r.namespace ? r.origType + "." + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          )
        if ("object" == typeof e) {
          for (i in e) this.off(i, t, e[i])
          return this
        }
        return (
          (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = ke),
          this.each(function () {
            w.event.remove(this, e, n, t)
          })
        )
      }
    })
  var Ne =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
    Ae = /<script|<style|<link/i,
    je = /checked\s*(?:[^=]|=\s*.checked.)/i,
    qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g
  function Le(e, t) {
    return N(e, "table") && N(11 !== t.nodeType ? t : t.firstChild, "tr")
      ? w(e).children("tbody")[0] || e
      : e
  }
  function He(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e
  }
  function Oe(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    )
  }
  function Pe(e, t) {
    var n, r, i, o, a, s, u, l
    if (1 === t.nodeType) {
      if (J.hasData(e) && ((o = J.access(e)), (a = J.set(t, o)), (l = o.events))) {
        delete a.handle, (a.events = {})
        for (i in l) for (n = 0, r = l[i].length; n < r; n++) w.event.add(t, i, l[i][n])
      }
      K.hasData(e) && ((s = K.access(e)), (u = w.extend({}, s)), K.set(t, u))
    }
  }
  function Me(e, t) {
    var n = t.nodeName.toLowerCase()
    "input" === n && pe.test(e.type)
      ? (t.checked = e.checked)
      : ("input" !== n && "textarea" !== n) || (t.defaultValue = e.defaultValue)
  }
  function Re(e, t, n, r) {
    t = a.apply([], t)
    var i,
      o,
      s,
      u,
      l,
      c,
      f = 0,
      p = e.length,
      d = p - 1,
      y = t[0],
      v = g(y)
    if (v || (p > 1 && "string" == typeof y && !h.checkClone && je.test(y)))
      return e.each(function (i) {
        var o = e.eq(i)
        v && (t[0] = y.call(this, i, o.html())), Re(o, t, n, r)
      })
    if (
      p &&
      ((i = xe(t, e[0].ownerDocument, !1, e, r)),
      (o = i.firstChild),
      1 === i.childNodes.length && (i = o),
      o || r)
    ) {
      for (u = (s = w.map(ye(i, "script"), He)).length; f < p; f++)
        (l = i),
          f !== d && ((l = w.clone(l, !0, !0)), u && w.merge(s, ye(l, "script"))),
          n.call(e[f], l, f)
      if (u)
        for (c = s[s.length - 1].ownerDocument, w.map(s, Oe), f = 0; f < u; f++)
          (l = s[f]),
            he.test(l.type || "") &&
              !J.access(l, "globalEval") &&
              w.contains(c, l) &&
              (l.src && "module" !== (l.type || "").toLowerCase()
                ? w._evalUrl && w._evalUrl(l.src)
                : m(l.textContent.replace(qe, ""), c, l))
    }
    return e
  }
  function Ie(e, t, n) {
    for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || w.cleanData(ye(r)),
        r.parentNode &&
          (n && w.contains(r.ownerDocument, r) && ve(ye(r, "script")), r.parentNode.removeChild(r))
    return e
  }
  w.extend({
    htmlPrefilter: function (e) {
      return e.replace(Ne, "<$1></$2>")
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        a,
        s = e.cloneNode(!0),
        u = w.contains(e.ownerDocument, e)
      if (!(h.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || w.isXMLDoc(e)))
        for (a = ye(s), r = 0, i = (o = ye(e)).length; r < i; r++) Me(o[r], a[r])
      if (t)
        if (n) for (o = o || ye(e), a = a || ye(s), r = 0, i = o.length; r < i; r++) Pe(o[r], a[r])
        else Pe(e, s)
      return (a = ye(s, "script")).length > 0 && ve(a, !u && ye(e, "script")), s
    },
    cleanData: function (e) {
      for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (Y(n)) {
          if ((t = n[J.expando])) {
            if (t.events)
              for (r in t.events) i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle)
            n[J.expando] = void 0
          }
          n[K.expando] && (n[K.expando] = void 0)
        }
    }
  }),
    w.fn.extend({
      detach: function (e) {
        return Ie(this, e, !0)
      },
      remove: function (e) {
        return Ie(this, e)
      },
      text: function (e) {
        return z(
          this,
          function (e) {
            return void 0 === e
              ? w.text(this)
              : this.empty().each(function () {
                  ;(1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                    (this.textContent = e)
                })
          },
          null,
          e,
          arguments.length
        )
      },
      append: function () {
        return Re(this, arguments, function (e) {
          ;(1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
            Le(this, e).appendChild(e)
        })
      },
      prepend: function () {
        return Re(this, arguments, function (e) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var t = Le(this, e)
            t.insertBefore(e, t.firstChild)
          }
        })
      },
      before: function () {
        return Re(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this)
        })
      },
      after: function () {
        return Re(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
        })
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (w.cleanData(ye(e, !1)), (e.textContent = ""))
        return this
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return w.clone(this, e, t)
          })
        )
      },
      html: function (e) {
        return z(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML
            if (
              "string" == typeof e &&
              !Ae.test(e) &&
              !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = w.htmlPrefilter(e)
              try {
                for (; n < r; n++)
                  1 === (t = this[n] || {}).nodeType && (w.cleanData(ye(t, !1)), (t.innerHTML = e))
                t = 0
              } catch (e) {}
            }
            t && this.empty().append(e)
          },
          null,
          e,
          arguments.length
        )
      },
      replaceWith: function () {
        var e = []
        return Re(
          this,
          arguments,
          function (t) {
            var n = this.parentNode
            w.inArray(this, e) < 0 && (w.cleanData(ye(this)), n && n.replaceChild(t, this))
          },
          e
        )
      }
    }),
    w.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
      },
      function (e, t) {
        w.fn[e] = function (e) {
          for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++)
            (n = a === o ? this : this.clone(!0)), w(i[a])[t](n), s.apply(r, n.get())
          return this.pushStack(r)
        }
      }
    )
  var We = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
    $e = function (t) {
      var n = t.ownerDocument.defaultView
      return (n && n.opener) || (n = e), n.getComputedStyle(t)
    },
    Be = new RegExp(oe.join("|"), "i")
  !(function () {
    function t() {
      if (c) {
        ;(l.style.cssText =
          "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
          (c.style.cssText =
            "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
          be.appendChild(l).appendChild(c)
        var t = e.getComputedStyle(c)
        ;(i = "1%" !== t.top),
          (u = 12 === n(t.marginLeft)),
          (c.style.right = "60%"),
          (s = 36 === n(t.right)),
          (o = 36 === n(t.width)),
          (c.style.position = "absolute"),
          (a = 36 === c.offsetWidth || "absolute"),
          be.removeChild(l),
          (c = null)
      }
    }
    function n(e) {
      return Math.round(parseFloat(e))
    }
    var i,
      o,
      a,
      s,
      u,
      l = r.createElement("div"),
      c = r.createElement("div")
    c.style &&
      ((c.style.backgroundClip = "content-box"),
      (c.cloneNode(!0).style.backgroundClip = ""),
      (h.clearCloneStyle = "content-box" === c.style.backgroundClip),
      w.extend(h, {
        boxSizingReliable: function () {
          return t(), o
        },
        pixelBoxStyles: function () {
          return t(), s
        },
        pixelPosition: function () {
          return t(), i
        },
        reliableMarginLeft: function () {
          return t(), u
        },
        scrollboxSize: function () {
          return t(), a
        }
      }))
  })()
  function Fe(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.style
    return (
      (n = n || $e(e)) &&
        ("" !== (a = n.getPropertyValue(t) || n[t]) ||
          w.contains(e.ownerDocument, e) ||
          (a = w.style(e, t)),
        !h.pixelBoxStyles() &&
          We.test(a) &&
          Be.test(t) &&
          ((r = s.width),
          (i = s.minWidth),
          (o = s.maxWidth),
          (s.minWidth = s.maxWidth = s.width = a),
          (a = n.width),
          (s.width = r),
          (s.minWidth = i),
          (s.maxWidth = o))),
      void 0 !== a ? a + "" : a
    )
  }
  function _e(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments)
        delete this.get
      }
    }
  }
  var ze = /^(none|table(?!-c[ea]).+)/,
    Xe = /^--/,
    Ue = { position: "absolute", visibility: "hidden", display: "block" },
    Ve = { letterSpacing: "0", fontWeight: "400" },
    Ge = ["Webkit", "Moz", "ms"],
    Ye = r.createElement("div").style
  function Qe(e) {
    if (e in Ye) return e
    var t = e[0].toUpperCase() + e.slice(1),
      n = Ge.length
    while (n--) if ((e = Ge[n] + t) in Ye) return e
  }
  function Je(e) {
    var t = w.cssProps[e]
    return t || (t = w.cssProps[e] = Qe(e) || e), t
  }
  function Ke(e, t, n) {
    var r = ie.exec(t)
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t
  }
  function Ze(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
      s = 0,
      u = 0
    if (n === (r ? "border" : "content")) return 0
    for (; a < 4; a += 2)
      "margin" === n && (u += w.css(e, n + oe[a], !0, i)),
        r
          ? ("content" === n && (u -= w.css(e, "padding" + oe[a], !0, i)),
            "margin" !== n && (u -= w.css(e, "border" + oe[a] + "Width", !0, i)))
          : ((u += w.css(e, "padding" + oe[a], !0, i)),
            "padding" !== n
              ? (u += w.css(e, "border" + oe[a] + "Width", !0, i))
              : (s += w.css(e, "border" + oe[a] + "Width", !0, i)))
    return (
      !r &&
        o >= 0 &&
        (u += Math.max(
          0,
          Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5)
        )),
      u
    )
  }
  function et(e, t, n) {
    var r = $e(e),
      i = Fe(e, t, r),
      o = "border-box" === w.css(e, "boxSizing", !1, r),
      a = o
    if (We.test(i)) {
      if (!n) return i
      i = "auto"
    }
    return (
      (a = a && (h.boxSizingReliable() || i === e.style[t])),
      ("auto" === i || (!parseFloat(i) && "inline" === w.css(e, "display", !1, r))) &&
        ((i = e["offset" + t[0].toUpperCase() + t.slice(1)]), (a = !0)),
      (i = parseFloat(i) || 0) + Ze(e, t, n || (o ? "border" : "content"), a, r, i) + "px"
    )
  }
  w.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = Fe(e, "opacity")
            return "" === n ? "1" : n
          }
        }
      }
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: {},
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = G(t),
          u = Xe.test(t),
          l = e.style
        if ((u || (t = Je(s)), (a = w.cssHooks[t] || w.cssHooks[s]), void 0 === n))
          return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t]
        "string" == (o = typeof n) &&
          (i = ie.exec(n)) &&
          i[1] &&
          ((n = ue(e, t, i)), (o = "number")),
          null != n &&
            n === n &&
            ("number" === o && (n += (i && i[3]) || (w.cssNumber[s] ? "" : "px")),
            h.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
            (a && "set" in a && void 0 === (n = a.set(e, n, r))) ||
              (u ? l.setProperty(t, n) : (l[t] = n)))
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        a,
        s = G(t)
      return (
        Xe.test(t) || (t = Je(s)),
        (a = w.cssHooks[t] || w.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)),
        void 0 === i && (i = Fe(e, t, r)),
        "normal" === i && t in Ve && (i = Ve[t]),
        "" === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
      )
    }
  }),
    w.each(["height", "width"], function (e, t) {
      w.cssHooks[t] = {
        get: function (e, n, r) {
          if (n)
            return !ze.test(w.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? et(e, t, r)
              : se(e, Ue, function () {
                  return et(e, t, r)
                })
        },
        set: function (e, n, r) {
          var i,
            o = $e(e),
            a = "border-box" === w.css(e, "boxSizing", !1, o),
            s = r && Ze(e, t, r, a, o)
          return (
            a &&
              h.scrollboxSize() === o.position &&
              (s -= Math.ceil(
                e["offset" + t[0].toUpperCase() + t.slice(1)] -
                  parseFloat(o[t]) -
                  Ze(e, t, "border", !1, o) -
                  0.5
              )),
            s &&
              (i = ie.exec(n)) &&
              "px" !== (i[3] || "px") &&
              ((e.style[t] = n), (n = w.css(e, t))),
            Ke(e, n, s)
          )
        }
      }
    }),
    (w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Fe(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              se(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left
              })) + "px"
        )
    })),
    w.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
      ;(w.cssHooks[e + t] = {
        expand: function (n) {
          for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++)
            i[e + oe[r] + t] = o[r] || o[r - 2] || o[0]
          return i
        }
      }),
        "margin" !== e && (w.cssHooks[e + t].set = Ke)
    }),
    w.fn.extend({
      css: function (e, t) {
        return z(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              a = 0
            if (Array.isArray(t)) {
              for (r = $e(e), i = t.length; a < i; a++) o[t[a]] = w.css(e, t[a], !1, r)
              return o
            }
            return void 0 !== n ? w.style(e, t, n) : w.css(e, t)
          },
          e,
          t,
          arguments.length > 1
        )
      }
    })
  function tt(e, t, n, r, i) {
    return new tt.prototype.init(e, t, n, r, i)
  }
  ;(w.Tween = tt),
    (tt.prototype = {
      constructor: tt,
      init: function (e, t, n, r, i, o) {
        ;(this.elem = e),
          (this.prop = n),
          (this.easing = i || w.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (w.cssNumber[n] ? "" : "px"))
      },
      cur: function () {
        var e = tt.propHooks[this.prop]
        return e && e.get ? e.get(this) : tt.propHooks._default.get(this)
      },
      run: function (e) {
        var t,
          n = tt.propHooks[this.prop]
        return (
          this.options.duration
            ? (this.pos = t =
                w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step && this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : tt.propHooks._default.set(this),
          this
        )
      }
    }),
    (tt.prototype.init.prototype = tt.prototype),
    (tt.propHooks = {
      _default: {
        get: function (e) {
          var t
          return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = w.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0
        },
        set: function (e) {
          w.fx.step[e.prop]
            ? w.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop])
            ? (e.elem[e.prop] = e.now)
            : w.style(e.elem, e.prop, e.now + e.unit)
        }
      }
    }),
    (tt.propHooks.scrollTop = tt.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
      }),
    (w.easing = {
      linear: function (e) {
        return e
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2
      },
      _default: "swing"
    }),
    (w.fx = tt.prototype.init),
    (w.fx.step = {})
  var nt,
    rt,
    it = /^(?:toggle|show|hide)$/,
    ot = /queueHooks$/
  function at() {
    rt &&
      (!1 === r.hidden && e.requestAnimationFrame
        ? e.requestAnimationFrame(at)
        : e.setTimeout(at, w.fx.interval),
      w.fx.tick())
  }
  function st() {
    return (
      e.setTimeout(function () {
        nt = void 0
      }),
      (nt = Date.now())
    )
  }
  function ut(e, t) {
    var n,
      r = 0,
      i = { height: e }
    for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = oe[r])] = i["padding" + n] = e
    return t && (i.opacity = i.width = e), i
  }
  function lt(e, t, n) {
    for (
      var r, i = (pt.tweeners[t] || []).concat(pt.tweeners["*"]), o = 0, a = i.length;
      o < a;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r
  }
  function ct(e, t, n) {
    var r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f = "width" in t || "height" in t,
      p = this,
      d = {},
      h = e.style,
      g = e.nodeType && ae(e),
      y = J.get(e, "fxshow")
    n.queue ||
      (null == (a = w._queueHooks(e, "fx")).unqueued &&
        ((a.unqueued = 0),
        (s = a.empty.fire),
        (a.empty.fire = function () {
          a.unqueued || s()
        })),
      a.unqueued++,
      p.always(function () {
        p.always(function () {
          a.unqueued--, w.queue(e, "fx").length || a.empty.fire()
        })
      }))
    for (r in t)
      if (((i = t[r]), it.test(i))) {
        if ((delete t[r], (o = o || "toggle" === i), i === (g ? "hide" : "show"))) {
          if ("show" !== i || !y || void 0 === y[r]) continue
          g = !0
        }
        d[r] = (y && y[r]) || w.style(e, r)
      }
    if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
      f &&
        1 === e.nodeType &&
        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
        null == (l = y && y.display) && (l = J.get(e, "display")),
        "none" === (c = w.css(e, "display")) &&
          (l
            ? (c = l)
            : (fe([e], !0), (l = e.style.display || l), (c = w.css(e, "display")), fe([e]))),
        ("inline" === c || ("inline-block" === c && null != l)) &&
          "none" === w.css(e, "float") &&
          (u ||
            (p.done(function () {
              h.display = l
            }),
            null == l && ((c = h.display), (l = "none" === c ? "" : c))),
          (h.display = "inline-block"))),
        n.overflow &&
          ((h.overflow = "hidden"),
          p.always(function () {
            ;(h.overflow = n.overflow[0]),
              (h.overflowX = n.overflow[1]),
              (h.overflowY = n.overflow[2])
          })),
        (u = !1)
      for (r in d)
        u ||
          (y ? "hidden" in y && (g = y.hidden) : (y = J.access(e, "fxshow", { display: l })),
          o && (y.hidden = !g),
          g && fe([e], !0),
          p.done(function () {
            g || fe([e]), J.remove(e, "fxshow")
            for (r in d) w.style(e, r, d[r])
          })),
          (u = lt(g ? y[r] : 0, r, p)),
          r in y || ((y[r] = u.start), g && ((u.end = u.start), (u.start = 0)))
    }
  }
  function ft(e, t) {
    var n, r, i, o, a
    for (n in e)
      if (
        ((r = G(n)),
        (i = t[r]),
        (o = e[n]),
        Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
        n !== r && ((e[r] = o), delete e[n]),
        (a = w.cssHooks[r]) && "expand" in a)
      ) {
        ;(o = a.expand(o)), delete e[r]
        for (n in o) n in e || ((e[n] = o[n]), (t[n] = i))
      } else t[r] = i
  }
  function pt(e, t, n) {
    var r,
      i,
      o = 0,
      a = pt.prefilters.length,
      s = w.Deferred().always(function () {
        delete u.elem
      }),
      u = function () {
        if (i) return !1
        for (
          var t = nt || st(),
            n = Math.max(0, l.startTime + l.duration - t),
            r = 1 - (n / l.duration || 0),
            o = 0,
            a = l.tweens.length;
          o < a;
          o++
        )
          l.tweens[o].run(r)
        return (
          s.notifyWith(e, [l, r, n]),
          r < 1 && a ? n : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1)
        )
      },
      l = s.promise({
        elem: e,
        props: w.extend({}, t),
        opts: w.extend(!0, { specialEasing: {}, easing: w.easing._default }, n),
        originalProperties: t,
        originalOptions: n,
        startTime: nt || st(),
        duration: n.duration,
        tweens: [],
        createTween: function (t, n) {
          var r = w.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing)
          return l.tweens.push(r), r
        },
        stop: function (t) {
          var n = 0,
            r = t ? l.tweens.length : 0
          if (i) return this
          for (i = !0; n < r; n++) l.tweens[n].run(1)
          return (
            t ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t])) : s.rejectWith(e, [l, t]),
            this
          )
        }
      }),
      c = l.props
    for (ft(c, l.opts.specialEasing); o < a; o++)
      if ((r = pt.prefilters[o].call(l, e, c, l.opts)))
        return g(r.stop) && (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)), r
    return (
      w.map(c, lt, l),
      g(l.opts.start) && l.opts.start.call(e, l),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always),
      w.fx.timer(w.extend(u, { elem: e, anim: l, queue: l.opts.queue })),
      l
    )
  }
  ;(w.Animation = w.extend(pt, {
    tweeners: {
      "*": [
        function (e, t) {
          var n = this.createTween(e, t)
          return ue(n.elem, e, ie.exec(t), n), n
        }
      ]
    },
    tweener: function (e, t) {
      g(e) ? ((t = e), (e = ["*"])) : (e = e.match(M))
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]), (pt.tweeners[n] = pt.tweeners[n] || []), pt.tweeners[n].unshift(t)
    },
    prefilters: [ct],
    prefilter: function (e, t) {
      t ? pt.prefilters.unshift(e) : pt.prefilters.push(e)
    }
  })),
    (w.speed = function (e, t, n) {
      var r =
        e && "object" == typeof e
          ? w.extend({}, e)
          : {
              complete: n || (!n && t) || (g(e) && e),
              duration: e,
              easing: (n && t) || (t && !g(t) && t)
            }
      return (
        w.fx.off
          ? (r.duration = 0)
          : "number" != typeof r.duration &&
            (r.duration in w.fx.speeds
              ? (r.duration = w.fx.speeds[r.duration])
              : (r.duration = w.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
        (r.old = r.complete),
        (r.complete = function () {
          g(r.old) && r.old.call(this), r.queue && w.dequeue(this, r.queue)
        }),
        r
      )
    }),
    w.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(ae).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r)
      },
      animate: function (e, t, n, r) {
        var i = w.isEmptyObject(e),
          o = w.speed(t, n, r),
          a = function () {
            var t = pt(this, w.extend({}, e), o)
            ;(i || J.get(this, "finish")) && t.stop(!0)
          }
        return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
      },
      stop: function (e, t, n) {
        var r = function (e) {
          var t = e.stop
          delete e.stop, t(n)
        }
        return (
          "string" != typeof e && ((n = t), (t = e), (e = void 0)),
          t && !1 !== e && this.queue(e || "fx", []),
          this.each(function () {
            var t = !0,
              i = null != e && e + "queueHooks",
              o = w.timers,
              a = J.get(this)
            if (i) a[i] && a[i].stop && r(a[i])
            else for (i in a) a[i] && a[i].stop && ot.test(i) && r(a[i])
            for (i = o.length; i--; )
              o[i].elem !== this ||
                (null != e && o[i].queue !== e) ||
                (o[i].anim.stop(n), (t = !1), o.splice(i, 1))
            ;(!t && n) || w.dequeue(this, e)
          })
        )
      },
      finish: function (e) {
        return (
          !1 !== e && (e = e || "fx"),
          this.each(function () {
            var t,
              n = J.get(this),
              r = n[e + "queue"],
              i = n[e + "queueHooks"],
              o = w.timers,
              a = r ? r.length : 0
            for (
              n.finish = !0,
                w.queue(this, e, []),
                i && i.stop && i.stop.call(this, !0),
                t = o.length;
              t--;

            )
              o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1))
            for (t = 0; t < a; t++) r[t] && r[t].finish && r[t].finish.call(this)
            delete n.finish
          })
        )
      }
    }),
    w.each(["toggle", "show", "hide"], function (e, t) {
      var n = w.fn[t]
      w.fn[t] = function (e, r, i) {
        return null == e || "boolean" == typeof e
          ? n.apply(this, arguments)
          : this.animate(ut(t, !0), e, r, i)
      }
    }),
    w.each(
      {
        slideDown: ut("show"),
        slideUp: ut("hide"),
        slideToggle: ut("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" }
      },
      function (e, t) {
        w.fn[e] = function (e, n, r) {
          return this.animate(t, e, n, r)
        }
      }
    ),
    (w.timers = []),
    (w.fx.tick = function () {
      var e,
        t = 0,
        n = w.timers
      for (nt = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1)
      n.length || w.fx.stop(), (nt = void 0)
    }),
    (w.fx.timer = function (e) {
      w.timers.push(e), w.fx.start()
    }),
    (w.fx.interval = 13),
    (w.fx.start = function () {
      rt || ((rt = !0), at())
    }),
    (w.fx.stop = function () {
      rt = null
    }),
    (w.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (w.fn.delay = function (t, n) {
      return (
        (t = w.fx ? w.fx.speeds[t] || t : t),
        (n = n || "fx"),
        this.queue(n, function (n, r) {
          var i = e.setTimeout(n, t)
          r.stop = function () {
            e.clearTimeout(i)
          }
        })
      )
    }),
    (function () {
      var e = r.createElement("input"),
        t = r.createElement("select").appendChild(r.createElement("option"))
      ;(e.type = "checkbox"),
        (h.checkOn = "" !== e.value),
        (h.optSelected = t.selected),
        ((e = r.createElement("input")).value = "t"),
        (e.type = "radio"),
        (h.radioValue = "t" === e.value)
    })()
  var dt,
    ht = w.expr.attrHandle
  w.fn.extend({
    attr: function (e, t) {
      return z(this, w.attr, e, t, arguments.length > 1)
    },
    removeAttr: function (e) {
      return this.each(function () {
        w.removeAttr(this, e)
      })
    }
  }),
    w.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType
        if (3 !== o && 8 !== o && 2 !== o)
          return "undefined" == typeof e.getAttribute
            ? w.prop(e, t, n)
            : ((1 === o && w.isXMLDoc(e)) ||
                (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? dt : void 0)),
              void 0 !== n
                ? null === n
                  ? void w.removeAttr(e, t)
                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ""), n)
                : i && "get" in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = w.find.attr(e, t))
                ? void 0
                : r)
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!h.radioValue && "radio" === t && N(e, "input")) {
              var n = e.value
              return e.setAttribute("type", t), n && (e.value = n), t
            }
          }
        }
      },
      removeAttr: function (e, t) {
        var n,
          r = 0,
          i = t && t.match(M)
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n)
      }
    }),
    (dt = {
      set: function (e, t, n) {
        return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n
      }
    }),
    w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var n = ht[t] || w.find.attr
      ht[t] = function (e, t, r) {
        var i,
          o,
          a = t.toLowerCase()
        return r || ((o = ht[a]), (ht[a] = i), (i = null != n(e, t, r) ? a : null), (ht[a] = o)), i
      }
    })
  var gt = /^(?:input|select|textarea|button)$/i,
    yt = /^(?:a|area)$/i
  w.fn.extend({
    prop: function (e, t) {
      return z(this, w.prop, e, t, arguments.length > 1)
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[w.propFix[e] || e]
      })
    }
  }),
    w.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && w.isXMLDoc(e)) || ((t = w.propFix[t] || t), (i = w.propHooks[t])),
            void 0 !== n
              ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && "get" in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          )
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = w.find.attr(e, "tabindex")
            return t
              ? parseInt(t, 10)
              : gt.test(e.nodeName) || (yt.test(e.nodeName) && e.href)
              ? 0
              : -1
          }
        }
      },
      propFix: { for: "htmlFor", class: "className" }
    }),
    h.optSelected ||
      (w.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode
          return t && t.parentNode && t.parentNode.selectedIndex, null
        },
        set: function (e) {
          var t = e.parentNode
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
      }),
    w.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
      ],
      function () {
        w.propFix[this.toLowerCase()] = this
      }
    )
  function vt(e) {
    return (e.match(M) || []).join(" ")
  }
  function mt(e) {
    return (e.getAttribute && e.getAttribute("class")) || ""
  }
  function xt(e) {
    return Array.isArray(e) ? e : "string" == typeof e ? e.match(M) || [] : []
  }
  w.fn.extend({
    addClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0
      if (g(e))
        return this.each(function (t) {
          w(this).addClass(e.call(this, t, mt(this)))
        })
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
            a = 0
            while ((o = t[a++])) r.indexOf(" " + o + " ") < 0 && (r += o + " ")
            i !== (s = vt(r)) && n.setAttribute("class", s)
          }
      return this
    },
    removeClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0
      if (g(e))
        return this.each(function (t) {
          w(this).removeClass(e.call(this, t, mt(this)))
        })
      if (!arguments.length) return this.attr("class", "")
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
            a = 0
            while ((o = t[a++]))
              while (r.indexOf(" " + o + " ") > -1) r = r.replace(" " + o + " ", " ")
            i !== (s = vt(r)) && n.setAttribute("class", s)
          }
      return this
    },
    toggleClass: function (e, t) {
      var n = typeof e,
        r = "string" === n || Array.isArray(e)
      return "boolean" == typeof t && r
        ? t
          ? this.addClass(e)
          : this.removeClass(e)
        : g(e)
        ? this.each(function (n) {
            w(this).toggleClass(e.call(this, n, mt(this), t), t)
          })
        : this.each(function () {
            var t, i, o, a
            if (r) {
              ;(i = 0), (o = w(this)), (a = xt(e))
              while ((t = a[i++])) o.hasClass(t) ? o.removeClass(t) : o.addClass(t)
            } else (void 0 !== e && "boolean" !== n) || ((t = mt(this)) && J.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : J.get(this, "__className__") || ""))
          })
    },
    hasClass: function (e) {
      var t,
        n,
        r = 0
      t = " " + e + " "
      while ((n = this[r++]))
        if (1 === n.nodeType && (" " + vt(mt(n)) + " ").indexOf(t) > -1) return !0
      return !1
    }
  })
  var bt = /\r/g
  w.fn.extend({
    val: function (e) {
      var t,
        n,
        r,
        i = this[0]
      {
        if (arguments.length)
          return (
            (r = g(e)),
            this.each(function (n) {
              var i
              1 === this.nodeType &&
                (null == (i = r ? e.call(this, n, w(this).val()) : e)
                  ? (i = "")
                  : "number" == typeof i
                  ? (i += "")
                  : Array.isArray(i) &&
                    (i = w.map(i, function (e) {
                      return null == e ? "" : e + ""
                    })),
                ((t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in t &&
                  void 0 !== t.set(this, i, "value")) ||
                  (this.value = i))
            })
          )
        if (i)
          return (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) &&
            "get" in t &&
            void 0 !== (n = t.get(i, "value"))
            ? n
            : "string" == typeof (n = i.value)
            ? n.replace(bt, "")
            : null == n
            ? ""
            : n
      }
    }
  }),
    w.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = w.find.attr(e, "value")
            return null != t ? t : vt(w.text(e))
          }
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !N(n.parentNode, "optgroup"))
              ) {
                if (((t = w(n).val()), a)) return t
                s.push(t)
              }
            return s
          },
          set: function (e, t) {
            var n,
              r,
              i = e.options,
              o = w.makeArray(t),
              a = i.length
            while (a--)
              ((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0)
            return n || (e.selectedIndex = -1), o
          }
        }
      }
    }),
    w.each(["radio", "checkbox"], function () {
      ;(w.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t)) return (e.checked = w.inArray(w(e).val(), t) > -1)
        }
      }),
        h.checkOn ||
          (w.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value
          })
    }),
    (h.focusin = "onfocusin" in e)
  var wt = /^(?:focusinfocus|focusoutblur)$/,
    Tt = function (e) {
      e.stopPropagation()
    }
  w.extend(w.event, {
    trigger: function (t, n, i, o) {
      var a,
        s,
        u,
        l,
        c,
        p,
        d,
        h,
        v = [i || r],
        m = f.call(t, "type") ? t.type : t,
        x = f.call(t, "namespace") ? t.namespace.split(".") : []
      if (
        ((s = h = u = i = i || r),
        3 !== i.nodeType &&
          8 !== i.nodeType &&
          !wt.test(m + w.event.triggered) &&
          (m.indexOf(".") > -1 && ((m = (x = m.split(".")).shift()), x.sort()),
          (c = m.indexOf(":") < 0 && "on" + m),
          (t = t[w.expando] ? t : new w.Event(m, "object" == typeof t && t)),
          (t.isTrigger = o ? 2 : 3),
          (t.namespace = x.join(".")),
          (t.rnamespace = t.namespace
            ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (t.result = void 0),
          t.target || (t.target = i),
          (n = null == n ? [t] : w.makeArray(n, [t])),
          (d = w.event.special[m] || {}),
          o || !d.trigger || !1 !== d.trigger.apply(i, n)))
      ) {
        if (!o && !d.noBubble && !y(i)) {
          for (l = d.delegateType || m, wt.test(l + m) || (s = s.parentNode); s; s = s.parentNode)
            v.push(s), (u = s)
          u === (i.ownerDocument || r) && v.push(u.defaultView || u.parentWindow || e)
        }
        a = 0
        while ((s = v[a++]) && !t.isPropagationStopped())
          (h = s),
            (t.type = a > 1 ? l : d.bindType || m),
            (p = (J.get(s, "events") || {})[t.type] && J.get(s, "handle")) && p.apply(s, n),
            (p = c && s[c]) &&
              p.apply &&
              Y(s) &&
              ((t.result = p.apply(s, n)), !1 === t.result && t.preventDefault())
        return (
          (t.type = m),
          o ||
            t.isDefaultPrevented() ||
            (d._default && !1 !== d._default.apply(v.pop(), n)) ||
            !Y(i) ||
            (c &&
              g(i[m]) &&
              !y(i) &&
              ((u = i[c]) && (i[c] = null),
              (w.event.triggered = m),
              t.isPropagationStopped() && h.addEventListener(m, Tt),
              i[m](),
              t.isPropagationStopped() && h.removeEventListener(m, Tt),
              (w.event.triggered = void 0),
              u && (i[c] = u))),
          t.result
        )
      }
    },
    simulate: function (e, t, n) {
      var r = w.extend(new w.Event(), n, { type: e, isSimulated: !0 })
      w.event.trigger(r, null, t)
    }
  }),
    w.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          w.event.trigger(e, t, this)
        })
      },
      triggerHandler: function (e, t) {
        var n = this[0]
        if (n) return w.event.trigger(e, t, n, !0)
      }
    }),
    h.focusin ||
      w.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
        var n = function (e) {
          w.event.simulate(t, e.target, w.event.fix(e))
        }
        w.event.special[t] = {
          setup: function () {
            var r = this.ownerDocument || this,
              i = J.access(r, t)
            i || r.addEventListener(e, n, !0), J.access(r, t, (i || 0) + 1)
          },
          teardown: function () {
            var r = this.ownerDocument || this,
              i = J.access(r, t) - 1
            i ? J.access(r, t, i) : (r.removeEventListener(e, n, !0), J.remove(r, t))
          }
        }
      })
  var Ct = e.location,
    Et = Date.now(),
    kt = /\?/
  w.parseXML = function (t) {
    var n
    if (!t || "string" != typeof t) return null
    try {
      n = new e.DOMParser().parseFromString(t, "text/xml")
    } catch (e) {
      n = void 0
    }
    return (n && !n.getElementsByTagName("parsererror").length) || w.error("Invalid XML: " + t), n
  }
  var St = /\[\]$/,
    Dt = /\r?\n/g,
    Nt = /^(?:submit|button|image|reset|file)$/i,
    At = /^(?:input|select|textarea|keygen)/i
  function jt(e, t, n, r) {
    var i
    if (Array.isArray(t))
      w.each(t, function (t, i) {
        n || St.test(e)
          ? r(e, i)
          : jt(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r)
      })
    else if (n || "object" !== x(t)) r(e, t)
    else for (i in t) jt(e + "[" + i + "]", t[i], n, r)
  }
  ;(w.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        var n = g(t) ? t() : t
        r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
      }
    if (Array.isArray(e) || (e.jquery && !w.isPlainObject(e)))
      w.each(e, function () {
        i(this.name, this.value)
      })
    else for (n in e) jt(n, e[n], t, i)
    return r.join("&")
  }),
    w.fn.extend({
      serialize: function () {
        return w.param(this.serializeArray())
      },
      serializeArray: function () {
        return this.map(function () {
          var e = w.prop(this, "elements")
          return e ? w.makeArray(e) : this
        })
          .filter(function () {
            var e = this.type
            return (
              this.name &&
              !w(this).is(":disabled") &&
              At.test(this.nodeName) &&
              !Nt.test(e) &&
              (this.checked || !pe.test(e))
            )
          })
          .map(function (e, t) {
            var n = w(this).val()
            return null == n
              ? null
              : Array.isArray(n)
              ? w.map(n, function (e) {
                  return { name: t.name, value: e.replace(Dt, "\r\n") }
                })
              : { name: t.name, value: n.replace(Dt, "\r\n") }
          })
          .get()
      }
    })
  var qt = /%20/g,
    Lt = /#.*$/,
    Ht = /([?&])_=[^&]*/,
    Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    Mt = /^(?:GET|HEAD)$/,
    Rt = /^\/\//,
    It = {},
    Wt = {},
    $t = "*/".concat("*"),
    Bt = r.createElement("a")
  Bt.href = Ct.href
  function Ft(e) {
    return function (t, n) {
      "string" != typeof t && ((n = t), (t = "*"))
      var r,
        i = 0,
        o = t.toLowerCase().match(M) || []
      if (g(n))
        while ((r = o[i++]))
          "+" === r[0]
            ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n))
            : (e[r] = e[r] || []).push(n)
    }
  }
  function _t(e, t, n, r) {
    var i = {},
      o = e === Wt
    function a(s) {
      var u
      return (
        (i[s] = !0),
        w.each(e[s] || [], function (e, s) {
          var l = s(t, n, r)
          return "string" != typeof l || o || i[l]
            ? o
              ? !(u = l)
              : void 0
            : (t.dataTypes.unshift(l), a(l), !1)
        }),
        u
      )
    }
    return a(t.dataTypes[0]) || (!i["*"] && a("*"))
  }
  function zt(e, t) {
    var n,
      r,
      i = w.ajaxSettings.flatOptions || {}
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n])
    return r && w.extend(!0, e, r), e
  }
  function Xt(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.contents,
      u = e.dataTypes
    while ("*" === u[0])
      u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"))
    if (r)
      for (i in s)
        if (s[i] && s[i].test(r)) {
          u.unshift(i)
          break
        }
    if (u[0] in n) o = u[0]
    else {
      for (i in n) {
        if (!u[0] || e.converters[i + " " + u[0]]) {
          o = i
          break
        }
        a || (a = i)
      }
      o = o || a
    }
    if (o) return o !== u[0] && u.unshift(o), n[o]
  }
  function Ut(e, t, n, r) {
    var i,
      o,
      a,
      s,
      u,
      l = {},
      c = e.dataTypes.slice()
    if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a]
    o = c.shift()
    while (o)
      if (
        (e.responseFields[o] && (n[e.responseFields[o]] = t),
        !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
        (u = o),
        (o = c.shift()))
      )
        if ("*" === o) o = u
        else if ("*" !== u && u !== o) {
          if (!(a = l[u + " " + o] || l["* " + o]))
            for (i in l)
              if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                !0 === a ? (a = l[i]) : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]))
                break
              }
          if (!0 !== a)
            if (a && e["throws"]) t = a(t)
            else
              try {
                t = a(t)
              } catch (e) {
                return {
                  state: "parsererror",
                  error: a ? e : "No conversion from " + u + " to " + o
                }
              }
        }
    return { state: "success", data: t }
  }
  w.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Ct.href,
      type: "GET",
      isLocal: Pt.test(Ct.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": $t,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
      responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": JSON.parse,
        "text xml": w.parseXML
      },
      flatOptions: { url: !0, context: !0 }
    },
    ajaxSetup: function (e, t) {
      return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e)
    },
    ajaxPrefilter: Ft(It),
    ajaxTransport: Ft(Wt),
    ajax: function (t, n) {
      "object" == typeof t && ((n = t), (t = void 0)), (n = n || {})
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h = w.ajaxSetup({}, n),
        g = h.context || h,
        y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event,
        v = w.Deferred(),
        m = w.Callbacks("once memory"),
        x = h.statusCode || {},
        b = {},
        T = {},
        C = "canceled",
        E = {
          readyState: 0,
          getResponseHeader: function (e) {
            var t
            if (c) {
              if (!s) {
                s = {}
                while ((t = Ot.exec(a))) s[t[1].toLowerCase()] = t[2]
              }
              t = s[e.toLowerCase()]
            }
            return null == t ? null : t
          },
          getAllResponseHeaders: function () {
            return c ? a : null
          },
          setRequestHeader: function (e, t) {
            return (
              null == c && ((e = T[e.toLowerCase()] = T[e.toLowerCase()] || e), (b[e] = t)), this
            )
          },
          overrideMimeType: function (e) {
            return null == c && (h.mimeType = e), this
          },
          statusCode: function (e) {
            var t
            if (e)
              if (c) E.always(e[E.status])
              else for (t in e) x[t] = [x[t], e[t]]
            return this
          },
          abort: function (e) {
            var t = e || C
            return i && i.abort(t), k(0, t), this
          }
        }
      if (
        (v.promise(E),
        (h.url = ((t || h.url || Ct.href) + "").replace(Rt, Ct.protocol + "//")),
        (h.type = n.method || n.type || h.method || h.type),
        (h.dataTypes = (h.dataType || "*").toLowerCase().match(M) || [""]),
        null == h.crossDomain)
      ) {
        l = r.createElement("a")
        try {
          ;(l.href = h.url),
            (l.href = l.href),
            (h.crossDomain = Bt.protocol + "//" + Bt.host != l.protocol + "//" + l.host)
        } catch (e) {
          h.crossDomain = !0
        }
      }
      if (
        (h.data &&
          h.processData &&
          "string" != typeof h.data &&
          (h.data = w.param(h.data, h.traditional)),
        _t(It, h, n, E),
        c)
      )
        return E
      ;(f = w.event && h.global) && 0 == w.active++ && w.event.trigger("ajaxStart"),
        (h.type = h.type.toUpperCase()),
        (h.hasContent = !Mt.test(h.type)),
        (o = h.url.replace(Lt, "")),
        h.hasContent
          ? h.data &&
            h.processData &&
            0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") &&
            (h.data = h.data.replace(qt, "+"))
          : ((d = h.url.slice(o.length)),
            h.data &&
              (h.processData || "string" == typeof h.data) &&
              ((o += (kt.test(o) ? "&" : "?") + h.data), delete h.data),
            !1 === h.cache &&
              ((o = o.replace(Ht, "$1")), (d = (kt.test(o) ? "&" : "?") + "_=" + Et++ + d)),
            (h.url = o + d)),
        h.ifModified &&
          (w.lastModified[o] && E.setRequestHeader("If-Modified-Since", w.lastModified[o]),
          w.etag[o] && E.setRequestHeader("If-None-Match", w.etag[o])),
        ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) &&
          E.setRequestHeader("Content-Type", h.contentType),
        E.setRequestHeader(
          "Accept",
          h.dataTypes[0] && h.accepts[h.dataTypes[0]]
            ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + $t + "; q=0.01" : "")
            : h.accepts["*"]
        )
      for (p in h.headers) E.setRequestHeader(p, h.headers[p])
      if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c)) return E.abort()
      if (
        ((C = "abort"),
        m.add(h.complete),
        E.done(h.success),
        E.fail(h.error),
        (i = _t(Wt, h, n, E)))
      ) {
        if (((E.readyState = 1), f && y.trigger("ajaxSend", [E, h]), c)) return E
        h.async &&
          h.timeout > 0 &&
          (u = e.setTimeout(function () {
            E.abort("timeout")
          }, h.timeout))
        try {
          ;(c = !1), i.send(b, k)
        } catch (e) {
          if (c) throw e
          k(-1, e)
        }
      } else k(-1, "No Transport")
      function k(t, n, r, s) {
        var l,
          p,
          d,
          b,
          T,
          C = n
        c ||
          ((c = !0),
          u && e.clearTimeout(u),
          (i = void 0),
          (a = s || ""),
          (E.readyState = t > 0 ? 4 : 0),
          (l = (t >= 200 && t < 300) || 304 === t),
          r && (b = Xt(h, E, r)),
          (b = Ut(h, b, E, l)),
          l
            ? (h.ifModified &&
                ((T = E.getResponseHeader("Last-Modified")) && (w.lastModified[o] = T),
                (T = E.getResponseHeader("etag")) && (w.etag[o] = T)),
              204 === t || "HEAD" === h.type
                ? (C = "nocontent")
                : 304 === t
                ? (C = "notmodified")
                : ((C = b.state), (p = b.data), (l = !(d = b.error))))
            : ((d = C), (!t && C) || ((C = "error"), t < 0 && (t = 0))),
          (E.status = t),
          (E.statusText = (n || C) + ""),
          l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]),
          E.statusCode(x),
          (x = void 0),
          f && y.trigger(l ? "ajaxSuccess" : "ajaxError", [E, h, l ? p : d]),
          m.fireWith(g, [E, C]),
          f && (y.trigger("ajaxComplete", [E, h]), --w.active || w.event.trigger("ajaxStop")))
      }
      return E
    },
    getJSON: function (e, t, n) {
      return w.get(e, t, n, "json")
    },
    getScript: function (e, t) {
      return w.get(e, void 0, t, "script")
    }
  }),
    w.each(["get", "post"], function (e, t) {
      w[t] = function (e, n, r, i) {
        return (
          g(n) && ((i = i || r), (r = n), (n = void 0)),
          w.ajax(
            w.extend({ url: e, type: t, dataType: i, data: n, success: r }, w.isPlainObject(e) && e)
          )
        )
      }
    }),
    (w._evalUrl = function (e) {
      return w.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        throws: !0
      })
    }),
    w.fn.extend({
      wrapAll: function (e) {
        var t
        return (
          this[0] &&
            (g(e) && (e = e.call(this[0])),
            (t = w(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                var e = this
                while (e.firstElementChild) e = e.firstElementChild
                return e
              })
              .append(this)),
          this
        )
      },
      wrapInner: function (e) {
        return g(e)
          ? this.each(function (t) {
              w(this).wrapInner(e.call(this, t))
            })
          : this.each(function () {
              var t = w(this),
                n = t.contents()
              n.length ? n.wrapAll(e) : t.append(e)
            })
      },
      wrap: function (e) {
        var t = g(e)
        return this.each(function (n) {
          w(this).wrapAll(t ? e.call(this, n) : e)
        })
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not("body")
            .each(function () {
              w(this).replaceWith(this.childNodes)
            }),
          this
        )
      }
    }),
    (w.expr.pseudos.hidden = function (e) {
      return !w.expr.pseudos.visible(e)
    }),
    (w.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }),
    (w.ajaxSettings.xhr = function () {
      try {
        return new e.XMLHttpRequest()
      } catch (e) {}
    })
  var Vt = { 0: 200, 1223: 204 },
    Gt = w.ajaxSettings.xhr()
  ;(h.cors = !!Gt && "withCredentials" in Gt),
    (h.ajax = Gt = !!Gt),
    w.ajaxTransport(function (t) {
      var n, r
      if (h.cors || (Gt && !t.crossDomain))
        return {
          send: function (i, o) {
            var a,
              s = t.xhr()
            if ((s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields))
              for (a in t.xhrFields) s[a] = t.xhrFields[a]
            t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType),
              t.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest")
            for (a in i) s.setRequestHeader(a, i[a])
            ;(n = function (e) {
              return function () {
                n &&
                  ((n =
                    r =
                    s.onload =
                    s.onerror =
                    s.onabort =
                    s.ontimeout =
                    s.onreadystatechange =
                      null),
                  "abort" === e
                    ? s.abort()
                    : "error" === e
                    ? "number" != typeof s.status
                      ? o(0, "error")
                      : o(s.status, s.statusText)
                    : o(
                        Vt[s.status] || s.status,
                        s.statusText,
                        "text" !== (s.responseType || "text") || "string" != typeof s.responseText
                          ? { binary: s.response }
                          : { text: s.responseText },
                        s.getAllResponseHeaders()
                      ))
              }
            }),
              (s.onload = n()),
              (r = s.onerror = s.ontimeout = n("error")),
              void 0 !== s.onabort
                ? (s.onabort = r)
                : (s.onreadystatechange = function () {
                    4 === s.readyState &&
                      e.setTimeout(function () {
                        n && r()
                      })
                  }),
              (n = n("abort"))
            try {
              s.send((t.hasContent && t.data) || null)
            } catch (e) {
              if (n) throw e
            }
          },
          abort: function () {
            n && n()
          }
        }
    }),
    w.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1)
    }),
    w.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return w.globalEval(e), e
        }
      }
    }),
    w.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
    }),
    w.ajaxTransport("script", function (e) {
      if (e.crossDomain) {
        var t, n
        return {
          send: function (i, o) {
            ;(t = w("<script>")
              .prop({ charset: e.scriptCharset, src: e.url })
              .on(
                "load error",
                (n = function (e) {
                  t.remove(), (n = null), e && o("error" === e.type ? 404 : 200, e.type)
                })
              )),
              r.head.appendChild(t[0])
          },
          abort: function () {
            n && n()
          }
        }
      }
    })
  var Yt = [],
    Qt = /(=)\?(?=&|$)|\?\?/
  w.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = Yt.pop() || w.expando + "_" + Et++
      return (this[e] = !0), e
    }
  }),
    w.ajaxPrefilter("json jsonp", function (t, n, r) {
      var i,
        o,
        a,
        s =
          !1 !== t.jsonp &&
          (Qt.test(t.url)
            ? "url"
            : "string" == typeof t.data &&
              0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") &&
              Qt.test(t.data) &&
              "data")
      if (s || "jsonp" === t.dataTypes[0])
        return (
          (i = t.jsonpCallback = g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
          s
            ? (t[s] = t[s].replace(Qt, "$1" + i))
            : !1 !== t.jsonp && (t.url += (kt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i),
          (t.converters["script json"] = function () {
            return a || w.error(i + " was not called"), a[0]
          }),
          (t.dataTypes[0] = "json"),
          (o = e[i]),
          (e[i] = function () {
            a = arguments
          }),
          r.always(function () {
            void 0 === o ? w(e).removeProp(i) : (e[i] = o),
              t[i] && ((t.jsonpCallback = n.jsonpCallback), Yt.push(i)),
              a && g(o) && o(a[0]),
              (a = o = void 0)
          }),
          "script"
        )
    }),
    (h.createHTMLDocument = (function () {
      var e = r.implementation.createHTMLDocument("").body
      return (e.innerHTML = "<form></form><form></form>"), 2 === e.childNodes.length
    })()),
    (w.parseHTML = function (e, t, n) {
      if ("string" != typeof e) return []
      "boolean" == typeof t && ((n = t), (t = !1))
      var i, o, a
      return (
        t ||
          (h.createHTMLDocument
            ? (((i = (t = r.implementation.createHTMLDocument("")).createElement("base")).href =
                r.location.href),
              t.head.appendChild(i))
            : (t = r)),
        (o = A.exec(e)),
        (a = !n && []),
        o
          ? [t.createElement(o[1])]
          : ((o = xe([e], t, a)), a && a.length && w(a).remove(), w.merge([], o.childNodes))
      )
    }),
    (w.fn.load = function (e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(" ")
      return (
        s > -1 && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
        g(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (i = "POST"),
        a.length > 0 &&
          w
            .ajax({ url: e, type: i || "GET", dataType: "html", data: t })
            .done(function (e) {
              ;(o = arguments), a.html(r ? w("<div>").append(w.parseHTML(e)).find(r) : e)
            })
            .always(
              n &&
                function (e, t) {
                  a.each(function () {
                    n.apply(this, o || [e.responseText, t, e])
                  })
                }
            ),
        this
      )
    }),
    w.each(
      ["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"],
      function (e, t) {
        w.fn[t] = function (e) {
          return this.on(t, e)
        }
      }
    ),
    (w.expr.pseudos.animated = function (e) {
      return w.grep(w.timers, function (t) {
        return e === t.elem
      }).length
    }),
    (w.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c = w.css(e, "position"),
          f = w(e),
          p = {}
        "static" === c && (e.style.position = "relative"),
          (s = f.offset()),
          (o = w.css(e, "top")),
          (u = w.css(e, "left")),
          (l = ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1)
            ? ((a = (r = f.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          g(t) && (t = t.call(e, n, w.extend({}, s))),
          null != t.top && (p.top = t.top - s.top + a),
          null != t.left && (p.left = t.left - s.left + i),
          "using" in t ? t.using.call(e, p) : f.css(p)
      }
    }),
    w.fn.extend({
      offset: function (e) {
        if (arguments.length)
          return void 0 === e
            ? this
            : this.each(function (t) {
                w.offset.setOffset(this, e, t)
              })
        var t,
          n,
          r = this[0]
        if (r)
          return r.getClientRects().length
            ? ((t = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset })
            : { top: 0, left: 0 }
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = { top: 0, left: 0 }
          if ("fixed" === w.css(r, "position")) t = r.getBoundingClientRect()
          else {
            ;(t = this.offset()), (n = r.ownerDocument), (e = r.offsetParent || n.documentElement)
            while (
              e &&
              (e === n.body || e === n.documentElement) &&
              "static" === w.css(e, "position")
            )
              e = e.parentNode
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0)),
              (i.left += w.css(e, "borderLeftWidth", !0)))
          }
          return {
            top: t.top - i.top - w.css(r, "marginTop", !0),
            left: t.left - i.left - w.css(r, "marginLeft", !0)
          }
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var e = this.offsetParent
          while (e && "static" === w.css(e, "position")) e = e.offsetParent
          return e || be
        })
      }
    }),
    w.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
      var n = "pageYOffset" === t
      w.fn[e] = function (r) {
        return z(
          this,
          function (e, r, i) {
            var o
            if ((y(e) ? (o = e) : 9 === e.nodeType && (o = e.defaultView), void 0 === i))
              return o ? o[t] : e[r]
            o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : (e[r] = i)
          },
          e,
          r,
          arguments.length
        )
      }
    }),
    w.each(["top", "left"], function (e, t) {
      w.cssHooks[t] = _e(h.pixelPosition, function (e, n) {
        if (n) return (n = Fe(e, t)), We.test(n) ? w(e).position()[t] + "px" : n
      })
    }),
    w.each({ Height: "height", Width: "width" }, function (e, t) {
      w.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, r) {
        w.fn[r] = function (i, o) {
          var a = arguments.length && (n || "boolean" != typeof i),
            s = n || (!0 === i || !0 === o ? "margin" : "border")
          return z(
            this,
            function (t, n, i) {
              var o
              return y(t)
                ? 0 === r.indexOf("outer")
                  ? t["inner" + e]
                  : t.document.documentElement["client" + e]
                : 9 === t.nodeType
                ? ((o = t.documentElement),
                  Math.max(
                    t.body["scroll" + e],
                    o["scroll" + e],
                    t.body["offset" + e],
                    o["offset" + e],
                    o["client" + e]
                  ))
                : void 0 === i
                ? w.css(t, n, s)
                : w.style(t, n, i, s)
            },
            t,
            a ? i : void 0,
            a
          )
        }
      })
    }),
    w.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function (e, t) {
        w.fn[t] = function (e, n) {
          return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
        }
      }
    ),
    w.fn.extend({
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e)
      }
    }),
    w.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n)
      },
      unbind: function (e, t) {
        return this.off(e, null, t)
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r)
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
      }
    }),
    (w.proxy = function (e, t) {
      var n, r, i
      if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
        return (
          (r = o.call(arguments, 2)),
          (i = function () {
            return e.apply(t || this, r.concat(o.call(arguments)))
          }),
          (i.guid = e.guid = e.guid || w.guid++),
          i
        )
    }),
    (w.holdReady = function (e) {
      e ? w.readyWait++ : w.ready(!0)
    }),
    (w.isArray = Array.isArray),
    (w.parseJSON = JSON.parse),
    (w.nodeName = N),
    (w.isFunction = g),
    (w.isWindow = y),
    (w.camelCase = G),
    (w.type = x),
    (w.now = Date.now),
    (w.isNumeric = function (e) {
      var t = w.type(e)
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return w
      })
  var Jt = e.jQuery,
    Kt = e.$
  return (
    (w.noConflict = function (t) {
      return e.$ === w && (e.$ = Kt), t && e.jQuery === w && (e.jQuery = Jt), w
    }),
    t || (e.jQuery = e.$ = w),
    w
  )
})
/*! jQuery UI - v1.12.1 - 2017-08-10 http://jqueryui.com Includes: effect.js Copyright jQuery Foundation and other contributors; Licensed MIT */
;(function (t) {
  "function" == typeof define && define.amd ? define(["jquery"], t) : t(jQuery)
})(function (t) {
  ;(t.ui = t.ui || {}), (t.ui.version = "1.12.1")
  var e = "ui-effects-",
    i = "ui-effects-style",
    s = "ui-effects-animated",
    n = t
  ;(t.effects = { effect: {} }),
    (function (t, e) {
      function i(t, e, i) {
        var s = u[e.type] || {}
        return null == t
          ? i || !e.def
            ? null
            : e.def
          : ((t = s.floor ? ~~t : parseFloat(t)),
            isNaN(t) ? e.def : s.mod ? (t + s.mod) % s.mod : 0 > t ? 0 : t > s.max ? s.max : t)
      }
      function s(i) {
        var s = h(),
          n = (s._rgba = [])
        return (
          (i = i.toLowerCase()),
          f(l, function (t, o) {
            var a,
              r = o.re.exec(i),
              l = r && o.parse(r),
              h = o.space || "rgba"
            return l
              ? ((a = s[h](l)), (s[c[h].cache] = a[c[h].cache]), (n = s._rgba = a._rgba), !1)
              : e
          }),
          n.length ? ("0,0,0,0" === n.join() && t.extend(n, o.transparent), s) : o[i]
        )
      }
      function n(t, e, i) {
        return (
          (i = (i + 1) % 1),
          1 > 6 * i
            ? t + 6 * (e - t) * i
            : 1 > 2 * i
            ? e
            : 2 > 3 * i
            ? t + 6 * (e - t) * (2 / 3 - i)
            : t
        )
      }
      var o,
        a =
          "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
        r = /^([\-+])=\s*(\d+\.?\d*)/,
        l = [
          {
            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function (t) {
              return [t[1], t[2], t[3], t[4]]
            }
          },
          {
            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function (t) {
              return [2.55 * t[1], 2.55 * t[2], 2.55 * t[3], t[4]]
            }
          },
          {
            re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
            parse: function (t) {
              return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)]
            }
          },
          {
            re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
            parse: function (t) {
              return [
                parseInt(t[1] + t[1], 16),
                parseInt(t[2] + t[2], 16),
                parseInt(t[3] + t[3], 16)
              ]
            }
          },
          {
            re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            space: "hsla",
            parse: function (t) {
              return [t[1], t[2] / 100, t[3] / 100, t[4]]
            }
          }
        ],
        h = (t.Color = function (e, i, s, n) {
          return new t.Color.fn.parse(e, i, s, n)
        }),
        c = {
          rgba: {
            props: {
              red: { idx: 0, type: "byte" },
              green: { idx: 1, type: "byte" },
              blue: { idx: 2, type: "byte" }
            }
          },
          hsla: {
            props: {
              hue: { idx: 0, type: "degrees" },
              saturation: { idx: 1, type: "percent" },
              lightness: { idx: 2, type: "percent" }
            }
          }
        },
        u = {
          byte: { floor: !0, max: 255 },
          percent: { max: 1 },
          degrees: { mod: 360, floor: !0 }
        },
        d = (h.support = {}),
        p = t("<p>")[0],
        f = t.each
      ;(p.style.cssText = "background-color:rgba(1,1,1,.5)"),
        (d.rgba = p.style.backgroundColor.indexOf("rgba") > -1),
        f(c, function (t, e) {
          ;(e.cache = "_" + t), (e.props.alpha = { idx: 3, type: "percent", def: 1 })
        }),
        (h.fn = t.extend(h.prototype, {
          parse: function (n, a, r, l) {
            if (n === e) return (this._rgba = [null, null, null, null]), this
            ;(n.jquery || n.nodeType) && ((n = t(n).css(a)), (a = e))
            var u = this,
              d = t.type(n),
              p = (this._rgba = [])
            return (
              a !== e && ((n = [n, a, r, l]), (d = "array")),
              "string" === d
                ? this.parse(s(n) || o._default)
                : "array" === d
                ? (f(c.rgba.props, function (t, e) {
                    p[e.idx] = i(n[e.idx], e)
                  }),
                  this)
                : "object" === d
                ? (n instanceof h
                    ? f(c, function (t, e) {
                        n[e.cache] && (u[e.cache] = n[e.cache].slice())
                      })
                    : f(c, function (e, s) {
                        var o = s.cache
                        f(s.props, function (t, e) {
                          if (!u[o] && s.to) {
                            if ("alpha" === t || null == n[t]) return
                            u[o] = s.to(u._rgba)
                          }
                          u[o][e.idx] = i(n[t], e, !0)
                        }),
                          u[o] &&
                            0 > t.inArray(null, u[o].slice(0, 3)) &&
                            ((u[o][3] = 1), s.from && (u._rgba = s.from(u[o])))
                      }),
                  this)
                : e
            )
          },
          is: function (t) {
            var i = h(t),
              s = !0,
              n = this
            return (
              f(c, function (t, o) {
                var a,
                  r = i[o.cache]
                return (
                  r &&
                    ((a = n[o.cache] || (o.to && o.to(n._rgba)) || []),
                    f(o.props, function (t, i) {
                      return null != r[i.idx] ? (s = r[i.idx] === a[i.idx]) : e
                    })),
                  s
                )
              }),
              s
            )
          },
          _space: function () {
            var t = [],
              e = this
            return (
              f(c, function (i, s) {
                e[s.cache] && t.push(i)
              }),
              t.pop()
            )
          },
          transition: function (t, e) {
            var s = h(t),
              n = s._space(),
              o = c[n],
              a = 0 === this.alpha() ? h("transparent") : this,
              r = a[o.cache] || o.to(a._rgba),
              l = r.slice()
            return (
              (s = s[o.cache]),
              f(o.props, function (t, n) {
                var o = n.idx,
                  a = r[o],
                  h = s[o],
                  c = u[n.type] || {}
                null !== h &&
                  (null === a
                    ? (l[o] = h)
                    : (c.mod &&
                        (h - a > c.mod / 2 ? (a += c.mod) : a - h > c.mod / 2 && (a -= c.mod)),
                      (l[o] = i((h - a) * e + a, n))))
              }),
              this[n](l)
            )
          },
          blend: function (e) {
            if (1 === this._rgba[3]) return this
            var i = this._rgba.slice(),
              s = i.pop(),
              n = h(e)._rgba
            return h(
              t.map(i, function (t, e) {
                return (1 - s) * n[e] + s * t
              })
            )
          },
          toRgbaString: function () {
            var e = "rgba(",
              i = t.map(this._rgba, function (t, e) {
                return null == t ? (e > 2 ? 1 : 0) : t
              })
            return 1 === i[3] && (i.pop(), (e = "rgb(")), e + i.join() + ")"
          },
          toHslaString: function () {
            var e = "hsla(",
              i = t.map(this.hsla(), function (t, e) {
                return (
                  null == t && (t = e > 2 ? 1 : 0), e && 3 > e && (t = Math.round(100 * t) + "%"), t
                )
              })
            return 1 === i[3] && (i.pop(), (e = "hsl(")), e + i.join() + ")"
          },
          toHexString: function (e) {
            var i = this._rgba.slice(),
              s = i.pop()
            return (
              e && i.push(~~(255 * s)),
              "#" +
                t
                  .map(i, function (t) {
                    return (t = (t || 0).toString(16)), 1 === t.length ? "0" + t : t
                  })
                  .join("")
            )
          },
          toString: function () {
            return 0 === this._rgba[3] ? "transparent" : this.toRgbaString()
          }
        })),
        (h.fn.parse.prototype = h.fn),
        (c.hsla.to = function (t) {
          if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]]
          var e,
            i,
            s = t[0] / 255,
            n = t[1] / 255,
            o = t[2] / 255,
            a = t[3],
            r = Math.max(s, n, o),
            l = Math.min(s, n, o),
            h = r - l,
            c = r + l,
            u = 0.5 * c
          return (
            (e =
              l === r
                ? 0
                : s === r
                ? (60 * (n - o)) / h + 360
                : n === r
                ? (60 * (o - s)) / h + 120
                : (60 * (s - n)) / h + 240),
            (i = 0 === h ? 0 : 0.5 >= u ? h / c : h / (2 - c)),
            [Math.round(e) % 360, i, u, null == a ? 1 : a]
          )
        }),
        (c.hsla.from = function (t) {
          if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]]
          var e = t[0] / 360,
            i = t[1],
            s = t[2],
            o = t[3],
            a = 0.5 >= s ? s * (1 + i) : s + i - s * i,
            r = 2 * s - a
          return [
            Math.round(255 * n(r, a, e + 1 / 3)),
            Math.round(255 * n(r, a, e)),
            Math.round(255 * n(r, a, e - 1 / 3)),
            o
          ]
        }),
        f(c, function (s, n) {
          var o = n.props,
            a = n.cache,
            l = n.to,
            c = n.from
          ;(h.fn[s] = function (s) {
            if ((l && !this[a] && (this[a] = l(this._rgba)), s === e)) return this[a].slice()
            var n,
              r = t.type(s),
              u = "array" === r || "object" === r ? s : arguments,
              d = this[a].slice()
            return (
              f(o, function (t, e) {
                var s = u["object" === r ? t : e.idx]
                null == s && (s = d[e.idx]), (d[e.idx] = i(s, e))
              }),
              c ? ((n = h(c(d))), (n[a] = d), n) : h(d)
            )
          }),
            f(o, function (e, i) {
              h.fn[e] ||
                (h.fn[e] = function (n) {
                  var o,
                    a = t.type(n),
                    l = "alpha" === e ? (this._hsla ? "hsla" : "rgba") : s,
                    h = this[l](),
                    c = h[i.idx]
                  return "undefined" === a
                    ? c
                    : ("function" === a && ((n = n.call(this, c)), (a = t.type(n))),
                      null == n && i.empty
                        ? this
                        : ("string" === a &&
                            ((o = r.exec(n)),
                            o && (n = c + parseFloat(o[2]) * ("+" === o[1] ? 1 : -1))),
                          (h[i.idx] = n),
                          this[l](h)))
                })
            })
        }),
        (h.hook = function (e) {
          var i = e.split(" ")
          f(i, function (e, i) {
            ;(t.cssHooks[i] = {
              set: function (e, n) {
                var o,
                  a,
                  r = ""
                if ("transparent" !== n && ("string" !== t.type(n) || (o = s(n)))) {
                  if (((n = h(o || n)), !d.rgba && 1 !== n._rgba[3])) {
                    for (
                      a = "backgroundColor" === i ? e.parentNode : e;
                      ("" === r || "transparent" === r) && a && a.style;

                    )
                      try {
                        ;(r = t.css(a, "backgroundColor")), (a = a.parentNode)
                      } catch (l) {}
                    n = n.blend(r && "transparent" !== r ? r : "_default")
                  }
                  n = n.toRgbaString()
                }
                try {
                  e.style[i] = n
                } catch (l) {}
              }
            }),
              (t.fx.step[i] = function (e) {
                e.colorInit || ((e.start = h(e.elem, i)), (e.end = h(e.end)), (e.colorInit = !0)),
                  t.cssHooks[i].set(e.elem, e.start.transition(e.end, e.pos))
              })
          })
        }),
        h.hook(a),
        (t.cssHooks.borderColor = {
          expand: function (t) {
            var e = {}
            return (
              f(["Top", "Right", "Bottom", "Left"], function (i, s) {
                e["border" + s + "Color"] = t
              }),
              e
            )
          }
        }),
        (o = t.Color.names =
          {
            aqua: "#00ffff",
            black: "#000000",
            blue: "#0000ff",
            fuchsia: "#ff00ff",
            gray: "#808080",
            green: "#008000",
            lime: "#00ff00",
            maroon: "#800000",
            navy: "#000080",
            olive: "#808000",
            purple: "#800080",
            red: "#ff0000",
            silver: "#c0c0c0",
            teal: "#008080",
            white: "#ffffff",
            yellow: "#ffff00",
            transparent: [null, null, null, 0],
            _default: "#ffffff"
          })
    })(n),
    (function () {
      function e(e) {
        var i,
          s,
          n = e.ownerDocument.defaultView
            ? e.ownerDocument.defaultView.getComputedStyle(e, null)
            : e.currentStyle,
          o = {}
        if (n && n.length && n[0] && n[n[0]])
          for (s = n.length; s--; )
            (i = n[s]), "string" == typeof n[i] && (o[t.camelCase(i)] = n[i])
        else for (i in n) "string" == typeof n[i] && (o[i] = n[i])
        return o
      }
      function i(e, i) {
        var s,
          n,
          a = {}
        for (s in i)
          (n = i[s]),
            e[s] !== n && (o[s] || ((t.fx.step[s] || !isNaN(parseFloat(n))) && (a[s] = n)))
        return a
      }
      var s = ["add", "remove", "toggle"],
        o = {
          border: 1,
          borderBottom: 1,
          borderColor: 1,
          borderLeft: 1,
          borderRight: 1,
          borderTop: 1,
          borderWidth: 1,
          margin: 1,
          padding: 1
        }
      t.each(
        ["borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle"],
        function (e, i) {
          t.fx.step[i] = function (t) {
            ;(("none" !== t.end && !t.setAttr) || (1 === t.pos && !t.setAttr)) &&
              (n.style(t.elem, i, t.end), (t.setAttr = !0))
          }
        }
      ),
        t.fn.addBack ||
          (t.fn.addBack = function (t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
          }),
        (t.effects.animateClass = function (n, o, a, r) {
          var l = t.speed(o, a, r)
          return this.queue(function () {
            var o,
              a = t(this),
              r = a.attr("class") || "",
              h = l.children ? a.find("*").addBack() : a
            ;(h = h.map(function () {
              var i = t(this)
              return { el: i, start: e(this) }
            })),
              (o = function () {
                t.each(s, function (t, e) {
                  n[e] && a[e + "Class"](n[e])
                })
              }),
              o(),
              (h = h.map(function () {
                return (this.end = e(this.el[0])), (this.diff = i(this.start, this.end)), this
              })),
              a.attr("class", r),
              (h = h.map(function () {
                var e = this,
                  i = t.Deferred(),
                  s = t.extend({}, l, {
                    queue: !1,
                    complete: function () {
                      i.resolve(e)
                    }
                  })
                return this.el.animate(this.diff, s), i.promise()
              })),
              t.when.apply(t, h.get()).done(function () {
                o(),
                  t.each(arguments, function () {
                    var e = this.el
                    t.each(this.diff, function (t) {
                      e.css(t, "")
                    })
                  }),
                  l.complete.call(a[0])
              })
          })
        }),
        t.fn.extend({
          addClass: (function (e) {
            return function (i, s, n, o) {
              return s
                ? t.effects.animateClass.call(this, { add: i }, s, n, o)
                : e.apply(this, arguments)
            }
          })(t.fn.addClass),
          removeClass: (function (e) {
            return function (i, s, n, o) {
              return arguments.length > 1
                ? t.effects.animateClass.call(this, { remove: i }, s, n, o)
                : e.apply(this, arguments)
            }
          })(t.fn.removeClass),
          toggleClass: (function (e) {
            return function (i, s, n, o, a) {
              return "boolean" == typeof s || void 0 === s
                ? n
                  ? t.effects.animateClass.call(this, s ? { add: i } : { remove: i }, n, o, a)
                  : e.apply(this, arguments)
                : t.effects.animateClass.call(this, { toggle: i }, s, n, o)
            }
          })(t.fn.toggleClass),
          switchClass: function (e, i, s, n, o) {
            return t.effects.animateClass.call(this, { add: i, remove: e }, s, n, o)
          }
        })
    })(),
    (function () {
      function n(e, i, s, n) {
        return (
          t.isPlainObject(e) && ((i = e), (e = e.effect)),
          (e = { effect: e }),
          null == i && (i = {}),
          t.isFunction(i) && ((n = i), (s = null), (i = {})),
          ("number" == typeof i || t.fx.speeds[i]) && ((n = s), (s = i), (i = {})),
          t.isFunction(s) && ((n = s), (s = null)),
          i && t.extend(e, i),
          (s = s || i.duration),
          (e.duration = t.fx.off
            ? 0
            : "number" == typeof s
            ? s
            : s in t.fx.speeds
            ? t.fx.speeds[s]
            : t.fx.speeds._default),
          (e.complete = n || i.complete),
          e
        )
      }
      function o(e) {
        return !e || "number" == typeof e || t.fx.speeds[e]
          ? !0
          : "string" != typeof e || t.effects.effect[e]
          ? t.isFunction(e)
            ? !0
            : "object" != typeof e || e.effect
            ? !1
            : !0
          : !0
      }
      function a(t, e) {
        var i = e.outerWidth(),
          s = e.outerHeight(),
          n =
            /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
          o = n.exec(t) || ["", 0, i, s, 0]
        return {
          top: parseFloat(o[1]) || 0,
          right: "auto" === o[2] ? i : parseFloat(o[2]),
          bottom: "auto" === o[3] ? s : parseFloat(o[3]),
          left: parseFloat(o[4]) || 0
        }
      }
      t.expr &&
        t.expr.filters &&
        t.expr.filters.animated &&
        (t.expr.filters.animated = (function (e) {
          return function (i) {
            return !!t(i).data(s) || e(i)
          }
        })(t.expr.filters.animated)),
        t.uiBackCompat !== !1 &&
          t.extend(t.effects, {
            save: function (t, i) {
              for (var s = 0, n = i.length; n > s; s++)
                null !== i[s] && t.data(e + i[s], t[0].style[i[s]])
            },
            restore: function (t, i) {
              for (var s, n = 0, o = i.length; o > n; n++)
                null !== i[n] && ((s = t.data(e + i[n])), t.css(i[n], s))
            },
            setMode: function (t, e) {
              return "toggle" === e && (e = t.is(":hidden") ? "show" : "hide"), e
            },
            createWrapper: function (e) {
              if (e.parent().is(".ui-effects-wrapper")) return e.parent()
              var i = { width: e.outerWidth(!0), height: e.outerHeight(!0), float: e.css("float") },
                s = t("<div></div>").addClass("ui-effects-wrapper").css({
                  fontSize: "100%",
                  background: "transparent",
                  border: "none",
                  margin: 0,
                  padding: 0
                }),
                n = { width: e.width(), height: e.height() },
                o = document.activeElement
              try {
                o.id
              } catch (a) {
                o = document.body
              }
              return (
                e.wrap(s),
                (e[0] === o || t.contains(e[0], o)) && t(o).trigger("focus"),
                (s = e.parent()),
                "static" === e.css("position")
                  ? (s.css({ position: "relative" }), e.css({ position: "relative" }))
                  : (t.extend(i, { position: e.css("position"), zIndex: e.css("z-index") }),
                    t.each(["top", "left", "bottom", "right"], function (t, s) {
                      ;(i[s] = e.css(s)), isNaN(parseInt(i[s], 10)) && (i[s] = "auto")
                    }),
                    e.css({
                      position: "relative",
                      top: 0,
                      left: 0,
                      right: "auto",
                      bottom: "auto"
                    })),
                e.css(n),
                s.css(i).show()
              )
            },
            removeWrapper: function (e) {
              var i = document.activeElement
              return (
                e.parent().is(".ui-effects-wrapper") &&
                  (e.parent().replaceWith(e),
                  (e[0] === i || t.contains(e[0], i)) && t(i).trigger("focus")),
                e
              )
            }
          }),
        t.extend(t.effects, {
          version: "1.12.1",
          define: function (e, i, s) {
            return (
              s || ((s = i), (i = "effect")),
              (t.effects.effect[e] = s),
              (t.effects.effect[e].mode = i),
              s
            )
          },
          scaledDimensions: function (t, e, i) {
            if (0 === e) return { height: 0, width: 0, outerHeight: 0, outerWidth: 0 }
            var s = "horizontal" !== i ? (e || 100) / 100 : 1,
              n = "vertical" !== i ? (e || 100) / 100 : 1
            return {
              height: t.height() * n,
              width: t.width() * s,
              outerHeight: t.outerHeight() * n,
              outerWidth: t.outerWidth() * s
            }
          },
          clipToBox: function (t) {
            return {
              width: t.clip.right - t.clip.left,
              height: t.clip.bottom - t.clip.top,
              left: t.clip.left,
              top: t.clip.top
            }
          },
          unshift: function (t, e, i) {
            var s = t.queue()
            e > 1 && s.splice.apply(s, [1, 0].concat(s.splice(e, i))), t.dequeue()
          },
          saveStyle: function (t) {
            t.data(i, t[0].style.cssText)
          },
          restoreStyle: function (t) {
            ;(t[0].style.cssText = t.data(i) || ""), t.removeData(i)
          },
          mode: function (t, e) {
            var i = t.is(":hidden")
            return (
              "toggle" === e && (e = i ? "show" : "hide"),
              (i ? "hide" === e : "show" === e) && (e = "none"),
              e
            )
          },
          getBaseline: function (t, e) {
            var i, s
            switch (t[0]) {
              case "top":
                i = 0
                break
              case "middle":
                i = 0.5
                break
              case "bottom":
                i = 1
                break
              default:
                i = t[0] / e.height
            }
            switch (t[1]) {
              case "left":
                s = 0
                break
              case "center":
                s = 0.5
                break
              case "right":
                s = 1
                break
              default:
                s = t[1] / e.width
            }
            return { x: s, y: i }
          },
          createPlaceholder: function (i) {
            var s,
              n = i.css("position"),
              o = i.position()
            return (
              i
                .css({
                  marginTop: i.css("marginTop"),
                  marginBottom: i.css("marginBottom"),
                  marginLeft: i.css("marginLeft"),
                  marginRight: i.css("marginRight")
                })
                .outerWidth(i.outerWidth())
                .outerHeight(i.outerHeight()),
              /^(static|relative)/.test(n) &&
                ((n = "absolute"),
                (s = t("<" + i[0].nodeName + ">")
                  .insertAfter(i)
                  .css({
                    display: /^(inline|ruby)/.test(i.css("display")) ? "inline-block" : "block",
                    visibility: "hidden",
                    marginTop: i.css("marginTop"),
                    marginBottom: i.css("marginBottom"),
                    marginLeft: i.css("marginLeft"),
                    marginRight: i.css("marginRight"),
                    float: i.css("float")
                  })
                  .outerWidth(i.outerWidth())
                  .outerHeight(i.outerHeight())
                  .addClass("ui-effects-placeholder")),
                i.data(e + "placeholder", s)),
              i.css({ position: n, left: o.left, top: o.top }),
              s
            )
          },
          removePlaceholder: function (t) {
            var i = e + "placeholder",
              s = t.data(i)
            s && (s.remove(), t.removeData(i))
          },
          cleanUp: function (e) {
            t.effects.restoreStyle(e), t.effects.removePlaceholder(e)
          },
          setTransition: function (e, i, s, n) {
            return (
              (n = n || {}),
              t.each(i, function (t, i) {
                var o = e.cssUnit(i)
                o[0] > 0 && (n[i] = o[0] * s + o[1])
              }),
              n
            )
          }
        }),
        t.fn.extend({
          effect: function () {
            function e(e) {
              function n() {
                l.removeData(s), t.effects.cleanUp(l), "hide" === i.mode && l.hide(), r()
              }
              function r() {
                t.isFunction(h) && h.call(l[0]), t.isFunction(e) && e()
              }
              var l = t(this)
              ;(i.mode = u.shift()),
                t.uiBackCompat === !1 || a
                  ? "none" === i.mode
                    ? (l[c](), r())
                    : o.call(l[0], i, n)
                  : (l.is(":hidden") ? "hide" === c : "show" === c)
                  ? (l[c](), r())
                  : o.call(l[0], i, r)
            }
            var i = n.apply(this, arguments),
              o = t.effects.effect[i.effect],
              a = o.mode,
              r = i.queue,
              l = r || "fx",
              h = i.complete,
              c = i.mode,
              u = [],
              d = function (e) {
                var i = t(this),
                  n = t.effects.mode(i, c) || a
                i.data(s, !0),
                  u.push(n),
                  a && ("show" === n || (n === a && "hide" === n)) && i.show(),
                  (a && "none" === n) || t.effects.saveStyle(i),
                  t.isFunction(e) && e()
              }
            return t.fx.off || !o
              ? c
                ? this[c](i.duration, h)
                : this.each(function () {
                    h && h.call(this)
                  })
              : r === !1
              ? this.each(d).each(e)
              : this.queue(l, d).queue(l, e)
          },
          show: (function (t) {
            return function (e) {
              if (o(e)) return t.apply(this, arguments)
              var i = n.apply(this, arguments)
              return (i.mode = "show"), this.effect.call(this, i)
            }
          })(t.fn.show),
          hide: (function (t) {
            return function (e) {
              if (o(e)) return t.apply(this, arguments)
              var i = n.apply(this, arguments)
              return (i.mode = "hide"), this.effect.call(this, i)
            }
          })(t.fn.hide),
          toggle: (function (t) {
            return function (e) {
              if (o(e) || "boolean" == typeof e) return t.apply(this, arguments)
              var i = n.apply(this, arguments)
              return (i.mode = "toggle"), this.effect.call(this, i)
            }
          })(t.fn.toggle),
          cssUnit: function (e) {
            var i = this.css(e),
              s = []
            return (
              t.each(["em", "px", "%", "pt"], function (t, e) {
                i.indexOf(e) > 0 && (s = [parseFloat(i), e])
              }),
              s
            )
          },
          cssClip: function (t) {
            return t
              ? this.css(
                  "clip",
                  "rect(" + t.top + "px " + t.right + "px " + t.bottom + "px " + t.left + "px)"
                )
              : a(this.css("clip"), this)
          },
          transfer: function (e, i) {
            var s = t(this),
              n = t(e.to),
              o = "fixed" === n.css("position"),
              a = t("body"),
              r = o ? a.scrollTop() : 0,
              l = o ? a.scrollLeft() : 0,
              h = n.offset(),
              c = {
                top: h.top - r,
                left: h.left - l,
                height: n.innerHeight(),
                width: n.innerWidth()
              },
              u = s.offset(),
              d = t("<div class='ui-effects-transfer'></div>")
                .appendTo("body")
                .addClass(e.className)
                .css({
                  top: u.top - r,
                  left: u.left - l,
                  height: s.innerHeight(),
                  width: s.innerWidth(),
                  position: o ? "fixed" : "absolute"
                })
                .animate(c, e.duration, e.easing, function () {
                  d.remove(), t.isFunction(i) && i()
                })
          }
        }),
        (t.fx.step.clip = function (e) {
          e.clipInit ||
            ((e.start = t(e.elem).cssClip()),
            "string" == typeof e.end && (e.end = a(e.end, e.elem)),
            (e.clipInit = !0)),
            t(e.elem).cssClip({
              top: e.pos * (e.end.top - e.start.top) + e.start.top,
              right: e.pos * (e.end.right - e.start.right) + e.start.right,
              bottom: e.pos * (e.end.bottom - e.start.bottom) + e.start.bottom,
              left: e.pos * (e.end.left - e.start.left) + e.start.left
            })
        })
    })(),
    (function () {
      var e = {}
      t.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (t, i) {
        e[i] = function (e) {
          return Math.pow(e, t + 2)
        }
      }),
        t.extend(e, {
          Sine: function (t) {
            return 1 - Math.cos((t * Math.PI) / 2)
          },
          Circ: function (t) {
            return 1 - Math.sqrt(1 - t * t)
          },
          Elastic: function (t) {
            return 0 === t || 1 === t
              ? t
              : -Math.pow(2, 8 * (t - 1)) * Math.sin(((80 * (t - 1) - 7.5) * Math.PI) / 15)
          },
          Back: function (t) {
            return t * t * (3 * t - 2)
          },
          Bounce: function (t) {
            for (var e, i = 4; ((e = Math.pow(2, --i)) - 1) / 11 > t; );
            return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2)
          }
        }),
        t.each(e, function (e, i) {
          ;(t.easing["easeIn" + e] = i),
            (t.easing["easeOut" + e] = function (t) {
              return 1 - i(1 - t)
            }),
            (t.easing["easeInOut" + e] = function (t) {
              return 0.5 > t ? i(2 * t) / 2 : 1 - i(-2 * t + 2) / 2
            })
        })
    })(),
    t.effects
})
// Cart.js version: 0.4.1 author: Gavin Ballard license: MIT
;(function () {
  function t(t, i, s, h) {
    return new e(t, i, s, h)
  }
  function e(t, e, s, h) {
    ;(this.options = h || {}),
      (this.options.adapters = this.options.adapters || {}),
      (this.obj = t),
      (this.keypath = e),
      (this.callback = s),
      (this.objectPath = []),
      this.parse(),
      i((this.target = this.realize())) && this.set(!0, this.key, this.target, this.callback)
  }
  function i(t) {
    return "object" == typeof t && null !== t
  }
  function s(t) {
    throw new Error("[sightglass] " + t)
  }
  ;(t.adapters = {}),
    (e.tokenize = function (t, e, i) {
      var s,
        h,
        a = [],
        o = { i: i, path: "" }
      for (s = 0; s < t.length; s++)
        (h = t.charAt(s)), ~e.indexOf(h) ? (a.push(o), (o = { i: h, path: "" })) : (o.path += h)
      return a.push(o), a
    }),
    (e.prototype.parse = function () {
      var i,
        h,
        a = this.interfaces()
      a.length || s("Must define at least one adapter interface."),
        ~a.indexOf(this.keypath[0])
          ? ((i = this.keypath[0]), (h = this.keypath.substr(1)))
          : (void 0 === (i = this.options.root || t.root) &&
              s("Must define a default root adapter."),
            (h = this.keypath)),
        (this.tokens = e.tokenize(h, a, i)),
        (this.key = this.tokens.pop())
    }),
    (e.prototype.realize = function () {
      var t,
        e = this.obj,
        s = !1
      return (
        this.tokens.forEach(function (h, a) {
          i(e)
            ? (void 0 !== this.objectPath[a]
                ? e !== (t = this.objectPath[a]) &&
                  (this.set(!1, h, t, this.update.bind(this)),
                  this.set(!0, h, e, this.update.bind(this)),
                  (this.objectPath[a] = e))
                : (this.set(!0, h, e, this.update.bind(this)), (this.objectPath[a] = e)),
              (e = this.get(h, e)))
            : (!1 === s && (s = a),
              (t = this.objectPath[a]) && this.set(!1, h, t, this.update.bind(this)))
        }, this),
        !1 !== s && this.objectPath.splice(s),
        e
      )
    }),
    (e.prototype.update = function () {
      var t, e
      ;(t = this.realize()) !== this.target &&
        (i(this.target) && this.set(!1, this.key, this.target, this.callback),
        i(t) && this.set(!0, this.key, t, this.callback),
        (e = this.value()),
        (this.target = t),
        this.value() !== e && this.callback())
    }),
    (e.prototype.value = function () {
      if (i(this.target)) return this.get(this.key, this.target)
    }),
    (e.prototype.setValue = function (t) {
      i(this.target) && this.adapter(this.key).set(this.target, this.key.path, t)
    }),
    (e.prototype.get = function (t, e) {
      return this.adapter(t).get(e, t.path)
    }),
    (e.prototype.set = function (t, e, i, s) {
      var h = t ? "observe" : "unobserve"
      this.adapter(e)[h](i, e.path, s)
    }),
    (e.prototype.interfaces = function () {
      var e = Object.keys(this.options.adapters)
      return (
        Object.keys(t.adapters).forEach(function (t) {
          ~e.indexOf(t) || e.push(t)
        }),
        e
      )
    }),
    (e.prototype.adapter = function (e) {
      return this.options.adapters[e.i] || t.adapters[e.i]
    }),
    (e.prototype.unobserve = function () {
      var t
      this.tokens.forEach(function (e, i) {
        ;(t = this.objectPath[i]) && this.set(!1, e, t, this.update.bind(this))
      }, this),
        i(this.target) && this.set(!1, this.key, this.target, this.callback)
    }),
    "undefined" != typeof module && module.exports
      ? (module.exports = t)
      : "function" == typeof define && define.amd
      ? define([], function () {
          return (this.sightglass = t)
        })
      : (this.sightglass = t)
}).call(this)
// Rivets.js version: 0.8.1 author: Michael Richards license: MIT
;(function () {
  var t,
    e,
    i,
    n,
    r = function (t, e) {
      return function () {
        return t.apply(e, arguments)
      }
    },
    s = [].slice,
    o = {}.hasOwnProperty,
    u = function (t, e) {
      for (var i in e) o.call(e, i) && (t[i] = e[i])
      function n() {
        this.constructor = t
      }
      return (n.prototype = e.prototype), (t.prototype = new n()), (t.__super__ = e.prototype), t
    },
    l =
      [].indexOf ||
      function (t) {
        for (var e = 0, i = this.length; e < i; e++) if (e in this && this[e] === t) return e
        return -1
      }
  ;(t = {
    options: ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler"],
    extensions: ["binders", "formatters", "components", "adapters"],
    public: {
      binders: {},
      components: {},
      formatters: {},
      adapters: {},
      prefix: "rv",
      templateDelimiters: ["{", "}"],
      rootInterface: ".",
      preloadData: !0,
      handler: function (t, e, i) {
        return this.call(t, e, i.view.models)
      },
      configure: function (e) {
        var i, n, r, s
        null == e && (e = {})
        for (r in e)
          if (
            ((s = e[r]),
            "binders" === r || "components" === r || "formatters" === r || "adapters" === r)
          )
            for (n in s) (i = s[n]), (t[r][n] = i)
          else t.public[r] = s
      },
      bind: function (e, i, n) {
        var r
        return null == i && (i = {}), null == n && (n = {}), (r = new t.View(e, i, n)).bind(), r
      },
      init: function (e, i, n) {
        var r, s
        return (
          null == n && (n = {}),
          null == i && (i = document.createElement("div")),
          (e = t.public.components[e]),
          (i.innerHTML = e.template.call(this, i)),
          (r = e.initialize.call(this, i, n)),
          (s = new t.View(i, r)).bind(),
          s
        )
      }
    }
  }),
    window.jQuery || window.$
      ? ((n = "on" in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"]),
        (e = n[0]),
        (i = n[1]),
        (t.Util = {
          bindEvent: function (t, i, n) {
            return jQuery(t)[e](i, n)
          },
          unbindEvent: function (t, e, n) {
            return jQuery(t)[i](e, n)
          },
          getInputValue: function (t) {
            var e
            return "checkbox" === (e = jQuery(t)).attr("type") ? e.is(":checked") : e.val()
          }
        }))
      : (t.Util = {
          bindEvent:
            "addEventListener" in window
              ? function (t, e, i) {
                  return t.addEventListener(e, i, !1)
                }
              : function (t, e, i) {
                  return t.attachEvent("on" + e, i)
                },
          unbindEvent:
            "removeEventListener" in window
              ? function (t, e, i) {
                  return t.removeEventListener(e, i, !1)
                }
              : function (t, e, i) {
                  return t.detachEvent("on" + e, i)
                },
          getInputValue: function (t) {
            var e, i, n, r
            if ("checkbox" === t.type) return t.checked
            if ("select-multiple" === t.type) {
              for (r = [], i = 0, n = t.length; i < n; i++) (e = t[i]).selected && r.push(e.value)
              return r
            }
            return t.value
          }
        }),
    (t.TypeParser = (function () {
      function t() {}
      return (
        (t.types = { primitive: 0, keypath: 1 }),
        (t.parse = function (t) {
          return /^'.*'$|^".*"$/.test(t)
            ? { type: this.types.primitive, value: t.slice(1, -1) }
            : "true" === t
            ? { type: this.types.primitive, value: !0 }
            : "false" === t
            ? { type: this.types.primitive, value: !1 }
            : "null" === t
            ? { type: this.types.primitive, value: null }
            : "undefined" === t
            ? { type: this.types.primitive, value: void 0 }
            : !1 === isNaN(Number(t))
            ? { type: this.types.primitive, value: Number(t) }
            : { type: this.types.keypath, value: t }
        }),
        t
      )
    })()),
    (t.TextTemplateParser = (function () {
      function t() {}
      return (
        (t.types = { text: 0, binding: 1 }),
        (t.parse = function (t, e) {
          var i, n, r, s, o, u, l
          for (u = [], s = t.length, i = 0, n = 0; n < s; ) {
            if ((i = t.indexOf(e[0], n)) < 0) {
              u.push({ type: this.types.text, value: t.slice(n) })
              break
            }
            if (
              (i > 0 && n < i && u.push({ type: this.types.text, value: t.slice(n, i) }),
              (n = i + e[0].length),
              (i = t.indexOf(e[1], n)) < 0)
            ) {
              ;(o = t.slice(n - e[1].length)),
                (null != (r = u[u.length - 1]) ? r.type : void 0) === this.types.text
                  ? (r.value += o)
                  : u.push({ type: this.types.text, value: o })
              break
            }
            ;(l = t.slice(n, i).trim()),
              u.push({ type: this.types.binding, value: l }),
              (n = i + e[1].length)
          }
          return u
        }),
        t
      )
    })()),
    (t.View = (function () {
      function e(e, i, n) {
        var s, o, u, l, h, a, p, d, c, f, b, v, y
        for (
          this.els = e,
            this.models = i,
            null == n && (n = {}),
            this.update = r(this.update, this),
            this.publish = r(this.publish, this),
            this.sync = r(this.sync, this),
            this.unbind = r(this.unbind, this),
            this.bind = r(this.bind, this),
            this.select = r(this.select, this),
            this.traverse = r(this.traverse, this),
            this.build = r(this.build, this),
            this.buildBinding = r(this.buildBinding, this),
            this.bindingRegExp = r(this.bindingRegExp, this),
            this.options = r(this.options, this),
            this.els.jquery || this.els instanceof Array || (this.els = [this.els]),
            h = 0,
            p = (c = t.extensions).length;
          h < p;
          h++
        ) {
          if (((this[(o = c[h])] = {}), n[o])) {
            f = n[o]
            for (s in f) (u = f[s]), (this[o][s] = u)
          }
          b = t.public[o]
          for (s in b) (u = b[s]), null == (l = this[o])[s] && (l[s] = u)
        }
        for (a = 0, d = (v = t.options).length; a < d; a++)
          this[(o = v[a])] = null != (y = n[o]) ? y : t.public[o]
        this.build()
      }
      return (
        (e.prototype.options = function () {
          var e, i, n, r, s
          for (i = {}, n = 0, r = (s = t.extensions.concat(t.options)).length; n < r; n++)
            i[(e = s[n])] = this[e]
          return i
        }),
        (e.prototype.bindingRegExp = function () {
          return new RegExp("^" + this.prefix + "-")
        }),
        (e.prototype.buildBinding = function (e, i, n, r) {
          var s, o, u, l, h, a, p
          return (
            (h = {}),
            (p = (function () {
              var t, e, i, n
              for (n = [], t = 0, e = (i = r.split("|")).length; t < e; t++)
                (a = i[t]), n.push(a.trim())
              return n
            })()),
            (l = (s = (function () {
              var t, e, i, n
              for (n = [], t = 0, e = (i = p.shift().split("<")).length; t < e; t++)
                (o = i[t]), n.push(o.trim())
              return n
            })()).shift()),
            (h.formatters = p),
            (u = s.shift()) && (h.dependencies = u.split(/\s+/)),
            this.bindings.push(new t[e](this, i, n, l, h))
          )
        }),
        (e.prototype.build = function () {
          var e, i, n, r, s, o
          for (
            this.bindings = [],
              o = this,
              i = function (e) {
                var n, r, s, u, l, h, a, p, d, c, f, b, v, y
                if (3 === e.nodeType) {
                  if (
                    ((l = t.TextTemplateParser),
                    (s = o.templateDelimiters) &&
                      (p = l.parse(e.data, s)).length &&
                      (1 !== p.length || p[0].type !== l.types.text))
                  ) {
                    for (d = 0, f = p.length; d < f; d++)
                      (a = p[d]),
                        (h = document.createTextNode(a.value)),
                        e.parentNode.insertBefore(h, e),
                        1 === a.type && o.buildBinding("TextBinding", h, null, a.value)
                    e.parentNode.removeChild(e)
                  }
                } else 1 === e.nodeType && (n = o.traverse(e))
                if (!n) {
                  for (
                    y = [],
                      c = 0,
                      b = (v = (function () {
                        var t, i, n, r
                        for (r = [], t = 0, i = (n = e.childNodes).length; t < i; t++)
                          (u = n[t]), r.push(u)
                        return r
                      })()).length;
                    c < b;
                    c++
                  )
                    (r = v[c]), y.push(i(r))
                  return y
                }
              },
              n = 0,
              r = (s = this.els).length;
            n < r;
            n++
          )
            (e = s[n]), i(e)
          this.bindings.sort(function (t, e) {
            var i, n
            return (
              ((null != (i = e.binder) ? i.priority : void 0) || 0) -
              ((null != (n = t.binder) ? n.priority : void 0) || 0)
            )
          })
        }),
        (e.prototype.traverse = function (e) {
          var i, n, r, s, o, u, l, h, a, p, d, c, f, b, v
          for (
            s = this.bindingRegExp(),
              o = "SCRIPT" === e.nodeName || "STYLE" === e.nodeName,
              a = 0,
              d = (f = e.attributes).length;
            a < d;
            a++
          )
            if (((i = f[a]), s.test(i.name))) {
              if (((l = i.name.replace(s, "")), !(r = this.binders[l]))) {
                b = this.binders
                for (u in b)
                  (h = b[u]),
                    "*" !== u &&
                      -1 !== u.indexOf("*") &&
                      new RegExp("^" + u.replace(/\*/g, ".+") + "$").test(l) &&
                      (r = h)
              }
              r || (r = this.binders["*"]), r.block && ((o = !0), (n = [i]))
            }
          for (p = 0, c = (v = n || e.attributes).length; p < c; p++)
            (i = v[p]),
              s.test(i.name) &&
                ((l = i.name.replace(s, "")), this.buildBinding("Binding", e, l, i.value))
          return (
            o ||
              ((l = e.nodeName.toLowerCase()),
              this.components[l] &&
                !e._bound &&
                (this.bindings.push(new t.ComponentBinding(this, e, l)), (o = !0))),
            o
          )
        }),
        (e.prototype.select = function (t) {
          var e, i, n, r, s
          for (s = [], i = 0, n = (r = this.bindings).length; i < n; i++) t((e = r[i])) && s.push(e)
          return s
        }),
        (e.prototype.bind = function () {
          var t, e, i, n, r
          for (r = [], e = 0, i = (n = this.bindings).length; e < i; e++)
            (t = n[e]), r.push(t.bind())
          return r
        }),
        (e.prototype.unbind = function () {
          var t, e, i, n, r
          for (r = [], e = 0, i = (n = this.bindings).length; e < i; e++)
            (t = n[e]), r.push(t.unbind())
          return r
        }),
        (e.prototype.sync = function () {
          var t, e, i, n, r
          for (r = [], e = 0, i = (n = this.bindings).length; e < i; e++)
            (t = n[e]), r.push("function" == typeof t.sync ? t.sync() : void 0)
          return r
        }),
        (e.prototype.publish = function () {
          var t, e, i, n, r
          for (
            r = [],
              e = 0,
              i = (n = this.select(function (t) {
                var e
                return null != (e = t.binder) ? e.publishes : void 0
              })).length;
            e < i;
            e++
          )
            (t = n[e]), r.push(t.publish())
          return r
        }),
        (e.prototype.update = function (t) {
          var e, i, n, r, s, o, u
          null == t && (t = {})
          for (i in t) (n = t[i]), (this.models[i] = n)
          for (u = [], r = 0, s = (o = this.bindings).length; r < s; r++)
            (e = o[r]), u.push("function" == typeof e.update ? e.update(t) : void 0)
          return u
        }),
        e
      )
    })()),
    (t.Binding = (function () {
      function e(t, e, i, n, s) {
        ;(this.view = t),
          (this.el = e),
          (this.type = i),
          (this.keypath = n),
          (this.options = null != s ? s : {}),
          (this.getValue = r(this.getValue, this)),
          (this.update = r(this.update, this)),
          (this.unbind = r(this.unbind, this)),
          (this.bind = r(this.bind, this)),
          (this.publish = r(this.publish, this)),
          (this.sync = r(this.sync, this)),
          (this.set = r(this.set, this)),
          (this.eventHandler = r(this.eventHandler, this)),
          (this.formattedValue = r(this.formattedValue, this)),
          (this.parseTarget = r(this.parseTarget, this)),
          (this.observe = r(this.observe, this)),
          (this.setBinder = r(this.setBinder, this)),
          (this.formatters = this.options.formatters || []),
          (this.dependencies = []),
          (this.formatterObservers = {}),
          (this.model = void 0),
          this.setBinder()
      }
      return (
        (e.prototype.setBinder = function () {
          var t, e, i
          if (!(this.binder = this.view.binders[this.type])) {
            i = this.view.binders
            for (t in i)
              (e = i[t]),
                "*" !== t &&
                  -1 !== t.indexOf("*") &&
                  new RegExp("^" + t.replace(/\*/g, ".+") + "$").test(this.type) &&
                  ((this.binder = e),
                  (this.args = new RegExp("^" + t.replace(/\*/g, "(.+)") + "$").exec(this.type)),
                  this.args.shift())
          }
          if (
            (this.binder || (this.binder = this.view.binders["*"]), this.binder instanceof Function)
          )
            return (this.binder = { routine: this.binder })
        }),
        (e.prototype.observe = function (e, i, n) {
          return t.sightglass(e, i, n, {
            root: this.view.rootInterface,
            adapters: this.view.adapters
          })
        }),
        (e.prototype.parseTarget = function () {
          var e
          return 0 === (e = t.TypeParser.parse(this.keypath)).type
            ? (this.value = e.value)
            : ((this.observer = this.observe(this.view.models, this.keypath, this.sync)),
              (this.model = this.observer.target))
        }),
        (e.prototype.formattedValue = function (e) {
          var i, n, r, o, u, l, h, a, p, d, c, f, b, v
          for (o = d = 0, f = (v = this.formatters).length; d < f; o = ++d) {
            for (
              u = v[o],
                l = (r = u.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g)).shift(),
                u = this.view.formatters[l],
                a = [],
                i = c = 0,
                b = (r = (function () {
                  var e, i, s
                  for (s = [], e = 0, i = r.length; e < i; e++)
                    (n = r[e]), s.push(t.TypeParser.parse(n))
                  return s
                })()).length;
              c < b;
              i = ++c
            )
              (n = r[i]),
                a.push(
                  0 === n.type
                    ? n.value
                    : ((p = this.formatterObservers)[o] || (p[o] = {}),
                      (h = this.formatterObservers[o][i]) ||
                        ((h = this.observe(this.view.models, n.value, this.sync)),
                        (this.formatterObservers[o][i] = h)),
                      h.value())
                )
            ;(null != u ? u.read : void 0) instanceof Function
              ? (e = u.read.apply(u, [e].concat(s.call(a))))
              : u instanceof Function && (e = u.apply(null, [e].concat(s.call(a))))
          }
          return e
        }),
        (e.prototype.eventHandler = function (t) {
          var e, i
          return (
            (i = (e = this).view.handler),
            function (n) {
              return i.call(t, this, n, e)
            }
          )
        }),
        (e.prototype.set = function (t) {
          var e
          return (
            (t =
              t instanceof Function && !this.binder.function
                ? this.formattedValue(t.call(this.model))
                : this.formattedValue(t)),
            null != (e = this.binder.routine) ? e.call(this, this.el, t) : void 0
          )
        }),
        (e.prototype.sync = function () {
          var t, e
          return this.set(
            function () {
              var i, n, r, s, o, u, l
              if (this.observer) {
                if (this.model !== this.observer.target) {
                  for (i = 0, r = (o = this.dependencies).length; i < r; i++) (e = o[i]).unobserve()
                  if (
                    ((this.dependencies = []),
                    null != (this.model = this.observer.target) &&
                      (null != (u = this.options.dependencies) ? u.length : void 0))
                  )
                    for (n = 0, s = (l = this.options.dependencies).length; n < s; n++)
                      (t = l[n]),
                        (e = this.observe(this.model, t, this.sync)),
                        this.dependencies.push(e)
                }
                return this.observer.value()
              }
              return this.value
            }.call(this)
          )
        }),
        (e.prototype.publish = function () {
          var t, e, i, n, r, o, u, l
          if (this.observer) {
            for (
              i = this.getValue(this.el),
                n = 0,
                r = (o = this.formatters.slice(0).reverse()).length;
              n < r;
              n++
            )
              (e = (t = o[n].split(/\s+/)).shift()),
                (null != (u = this.view.formatters[e]) ? u.publish : void 0) &&
                  (i = (l = this.view.formatters[e]).publish.apply(l, [i].concat(s.call(t))))
            return this.observer.setValue(i)
          }
        }),
        (e.prototype.bind = function () {
          var t, e, i, n, r, s, o
          if (
            (this.parseTarget(),
            null != (r = this.binder.bind) && r.call(this, this.el),
            null != this.model && (null != (s = this.options.dependencies) ? s.length : void 0))
          )
            for (i = 0, n = (o = this.options.dependencies).length; i < n; i++)
              (t = o[i]), (e = this.observe(this.model, t, this.sync)), this.dependencies.push(e)
          if (this.view.preloadData) return this.sync()
        }),
        (e.prototype.unbind = function () {
          var t, e, i, n, r, s, o, u, l
          for (
            null != (s = this.binder.unbind) && s.call(this, this.el),
              null != (o = this.observer) && o.unobserve(),
              n = 0,
              r = (u = this.dependencies).length;
            n < r;
            n++
          )
            u[n].unobserve()
          ;(this.dependencies = []), (l = this.formatterObservers)
          for (i in l) {
            e = l[i]
            for (t in e) e[t].unobserve()
          }
          return (this.formatterObservers = {})
        }),
        (e.prototype.update = function (t) {
          var e, i
          return (
            null == t && (t = {}),
            (this.model = null != (e = this.observer) ? e.target : void 0),
            null != (i = this.binder.update) ? i.call(this, t) : void 0
          )
        }),
        (e.prototype.getValue = function (e) {
          return this.binder && null != this.binder.getValue
            ? this.binder.getValue.call(this, e)
            : t.Util.getInputValue(e)
        }),
        e
      )
    })()),
    (t.ComponentBinding = (function (e) {
      function i(t, e, i) {
        var n, s, o, u, h, a, p
        for (
          this.view = t,
            this.el = e,
            this.type = i,
            this.unbind = r(this.unbind, this),
            this.bind = r(this.bind, this),
            this.locals = r(this.locals, this),
            this.component = this.view.components[this.type],
            this.static = {},
            this.observers = {},
            this.upstreamObservers = {},
            s = t.bindingRegExp(),
            u = 0,
            h = (a = this.el.attributes || []).length;
          u < h;
          u++
        )
          (n = a[u]),
            s.test(n.name) ||
              ((o = this.camelCase(n.name)),
              l.call(null != (p = this.component.static) ? p : [], o) >= 0
                ? (this.static[o] = n.value)
                : (this.observers[o] = n.value))
      }
      return (
        u(i, e),
        (i.prototype.sync = function () {}),
        (i.prototype.update = function () {}),
        (i.prototype.publish = function () {}),
        (i.prototype.locals = function () {
          var t, e, i, n, r, s
          ;(i = {}), (r = this.static)
          for (t in r) (n = r[t]), (i[t] = n)
          s = this.observers
          for (t in s) (e = s[t]), (i[t] = e.value())
          return i
        }),
        (i.prototype.camelCase = function (t) {
          return t.replace(/-([a-z])/g, function (t) {
            return t[1].toUpperCase()
          })
        }),
        (i.prototype.bind = function () {
          var e, i, n, r, s, o, u, l, h, a, p, d, c, f, b, v, y, g, m, w, k
          if (!this.bound) {
            f = this.observers
            for (i in f)
              (n = f[i]),
                (this.observers[i] = this.observe(
                  this.view.models,
                  n,
                  (function (t) {
                    return function (e) {
                      return function () {
                        return (t.componentView.models[e] = t.observers[e].value())
                      }
                    }
                  })(this).call(this, i)
                ))
            this.bound = !0
          }
          if (null != this.componentView) return this.componentView.bind()
          for (
            this.el.innerHTML = this.component.template.call(this),
              u = this.component.initialize.call(this, this.el, this.locals()),
              this.el._bound = !0,
              o = {},
              a = 0,
              d = (b = t.extensions).length;
            a < d;
            a++
          ) {
            if (((o[(s = b[a])] = {}), this.component[s])) {
              v = this.component[s]
              for (e in v) (l = v[e]), (o[s][e] = l)
            }
            y = this.view[s]
            for (e in y) (l = y[e]), null == (h = o[s])[e] && (h[e] = l)
          }
          for (p = 0, c = (g = t.options).length; p < c; p++)
            o[(s = g[p])] = null != (m = this.component[s]) ? m : this.view[s]
          ;(this.componentView = new t.View(this.el, u, o)),
            this.componentView.bind(),
            (w = this.observers),
            (k = [])
          for (i in w)
            (r = w[i]),
              k.push(
                (this.upstreamObservers[i] = this.observe(
                  this.componentView.models,
                  i,
                  (function (t) {
                    return function (e, i) {
                      return function () {
                        return i.setValue(t.componentView.models[e])
                      }
                    }
                  })(this).call(this, i, r)
                ))
              )
          return k
        }),
        (i.prototype.unbind = function () {
          var t, e, i, n
          e = this.upstreamObservers
          for (t in e) e[t].unobserve()
          i = this.observers
          for (t in i) i[t].unobserve()
          return null != (n = this.componentView) ? n.unbind.call(this) : void 0
        }),
        i
      )
    })(t.Binding)),
    (t.TextBinding = (function (t) {
      function e(t, e, i, n, s) {
        ;(this.view = t),
          (this.el = e),
          (this.type = i),
          (this.keypath = n),
          (this.options = null != s ? s : {}),
          (this.sync = r(this.sync, this)),
          (this.formatters = this.options.formatters || []),
          (this.dependencies = []),
          (this.formatterObservers = {})
      }
      return (
        u(e, t),
        (e.prototype.binder = {
          routine: function (t, e) {
            return (t.data = null != e ? e : "")
          }
        }),
        (e.prototype.sync = function () {
          return e.__super__.sync.apply(this, arguments)
        }),
        e
      )
    })(t.Binding)),
    (t.public.binders.text = function (t, e) {
      return null != t.textContent
        ? (t.textContent = null != e ? e : "")
        : (t.innerText = null != e ? e : "")
    }),
    (t.public.binders.html = function (t, e) {
      return (t.innerHTML = null != e ? e : "")
    }),
    (t.public.binders.show = function (t, e) {
      return (t.style.display = e ? "" : "none")
    }),
    (t.public.binders.hide = function (t, e) {
      return (t.style.display = e ? "none" : "")
    }),
    (t.public.binders.enabled = function (t, e) {
      return (t.disabled = !e)
    }),
    (t.public.binders.disabled = function (t, e) {
      return (t.disabled = !!e)
    }),
    (t.public.binders["style-*"] = function (t, e) {
      t.style.setProperty(this.args[0], e)
    }),
    (t.public.binders["background-image"] = function (t, e) {
      t.style.backgroundImage = "url('" + e + "')"
    }),
    (t.public.binders.checked = {
      publishes: !0,
      priority: 2e3,
      bind: function (e) {
        return t.Util.bindEvent(e, "change", this.publish)
      },
      unbind: function (e) {
        return t.Util.unbindEvent(e, "change", this.publish)
      },
      routine: function (t, e) {
        var i
        return "radio" === t.type
          ? (t.checked =
              (null != (i = t.value) ? i.toString() : void 0) ===
              (null != e ? e.toString() : void 0))
          : (t.checked = !!e)
      }
    }),
    (t.public.binders.unchecked = {
      publishes: !0,
      priority: 2e3,
      bind: function (e) {
        return t.Util.bindEvent(e, "change", this.publish)
      },
      unbind: function (e) {
        return t.Util.unbindEvent(e, "change", this.publish)
      },
      routine: function (t, e) {
        var i
        return "radio" === t.type
          ? (t.checked =
              (null != (i = t.value) ? i.toString() : void 0) !==
              (null != e ? e.toString() : void 0))
          : (t.checked = !e)
      }
    }),
    (t.public.binders.value = {
      publishes: !0,
      priority: 3e3,
      bind: function (e) {
        if ("INPUT" !== e.tagName || "radio" !== e.type)
          return (
            (this.event = "SELECT" === e.tagName ? "change" : "input"),
            t.Util.bindEvent(e, this.event, this.publish)
          )
      },
      unbind: function (e) {
        if ("INPUT" !== e.tagName || "radio" !== e.type)
          return t.Util.unbindEvent(e, this.event, this.publish)
      },
      routine: function (t, e) {
        var i, n, r, s, o, u, h
        if ("INPUT" === t.tagName && "radio" === t.type) return t.setAttribute("value", e)
        if (null != window.jQuery) {
          if (
            ((t = jQuery(t)),
            (null != e ? e.toString() : void 0) !== (null != (s = t.val()) ? s.toString() : void 0))
          )
            return t.val(null != e ? e : "")
        } else if ("select-multiple" === t.type) {
          if (null != e) {
            for (h = [], n = 0, r = t.length; n < r; n++)
              (i = t[n]), h.push((i.selected = ((o = i.value), l.call(e, o) >= 0)))
            return h
          }
        } else if (
          (null != e ? e.toString() : void 0) !== (null != (u = t.value) ? u.toString() : void 0)
        )
          return (t.value = null != e ? e : "")
      }
    }),
    (t.public.binders.if = {
      block: !0,
      priority: 4e3,
      bind: function (t) {
        var e, i
        if (null == this.marker)
          return (
            (e = [this.view.prefix, this.type].join("-").replace("--", "-")),
            (i = t.getAttribute(e)),
            (this.marker = document.createComment(" rivets: " + this.type + " " + i + " ")),
            (this.bound = !1),
            t.removeAttribute(e),
            t.parentNode.insertBefore(this.marker, t),
            t.parentNode.removeChild(t)
          )
      },
      unbind: function () {
        var t
        return null != (t = this.nested) ? t.unbind() : void 0
      },
      routine: function (e, i) {
        var n, r, s, o
        if (!!i == !this.bound) {
          if (i) {
            ;(s = {}), (o = this.view.models)
            for (n in o) (r = o[n]), (s[n] = r)
            return (
              (this.nested || (this.nested = new t.View(e, s, this.view.options()))).bind(),
              this.marker.parentNode.insertBefore(e, this.marker.nextSibling),
              (this.bound = !0)
            )
          }
          return e.parentNode.removeChild(e), this.nested.unbind(), (this.bound = !1)
        }
      },
      update: function (t) {
        var e
        return null != (e = this.nested) ? e.update(t) : void 0
      }
    }),
    (t.public.binders.unless = {
      block: !0,
      priority: 4e3,
      bind: function (e) {
        return t.public.binders.if.bind.call(this, e)
      },
      unbind: function () {
        return t.public.binders.if.unbind.call(this)
      },
      routine: function (e, i) {
        return t.public.binders.if.routine.call(this, e, !i)
      },
      update: function (e) {
        return t.public.binders.if.update.call(this, e)
      }
    }),
    (t.public.binders["on-*"] = {
      function: !0,
      priority: 1e3,
      unbind: function (e) {
        if (this.handler) return t.Util.unbindEvent(e, this.args[0], this.handler)
      },
      routine: function (e, i) {
        return (
          this.handler && t.Util.unbindEvent(e, this.args[0], this.handler),
          t.Util.bindEvent(e, this.args[0], (this.handler = this.eventHandler(i)))
        )
      }
    }),
    (t.public.binders["each-*"] = {
      block: !0,
      priority: 4e3,
      bind: function (t) {
        var e, i, n, r
        if (null == this.marker)
          (e = [this.view.prefix, this.type].join("-").replace("--", "-")),
            (this.marker = document.createComment(" rivets: " + this.type + " ")),
            (this.iterated = []),
            t.removeAttribute(e),
            t.parentNode.insertBefore(this.marker, t),
            t.parentNode.removeChild(t)
        else for (i = 0, n = (r = this.iterated).length; i < n; i++) r[i].bind()
      },
      unbind: function (t) {
        var e, i, n, r, s
        if (null != this.iterated) {
          for (s = [], i = 0, n = (r = this.iterated).length; i < n; i++)
            (e = r[i]), s.push(e.unbind())
          return s
        }
      },
      routine: function (e, i) {
        var n, r, s, o, u, l, h, a, p, d, c, f, b, v, y, g, m, w, k, x
        if (((l = this.args[0]), (i = i || []), this.iterated.length > i.length))
          for (c = 0, v = (m = Array(this.iterated.length - i.length)).length; c < v; c++)
            m[c], (d = this.iterated.pop()).unbind(), this.marker.parentNode.removeChild(d.els[0])
        for (s = f = 0, y = i.length; f < y; s = ++f)
          if (((u = i[s]), ((r = { index: s })[l] = u), null == this.iterated[s])) {
            w = this.view.models
            for (o in w) (u = w[o]), null == r[o] && (r[o] = u)
            ;(a = this.iterated.length
              ? this.iterated[this.iterated.length - 1].els[0]
              : this.marker),
              ((h = this.view.options()).preloadData = !0),
              (p = e.cloneNode(!0)),
              (d = new t.View(p, r, h)).bind(),
              this.iterated.push(d),
              this.marker.parentNode.insertBefore(p, a.nextSibling)
          } else this.iterated[s].models[l] !== u && this.iterated[s].update(r)
        if ("OPTION" === e.nodeName) {
          for (x = [], b = 0, g = (k = this.view.bindings).length; b < g; b++)
            (n = k[b]).el === this.marker.parentNode && "value" === n.type
              ? x.push(n.sync())
              : x.push(void 0)
          return x
        }
      },
      update: function (t) {
        var e, i, n, r, s, o, u, l
        e = {}
        for (i in t) (n = t[i]), i !== this.args[0] && (e[i] = n)
        for (l = [], s = 0, o = (u = this.iterated).length; s < o; s++)
          (r = u[s]), l.push(r.update(e))
        return l
      }
    }),
    (t.public.binders["class-*"] = function (t, e) {
      var i
      if (!e == (-1 !== (i = " " + t.className + " ").indexOf(" " + this.args[0] + " ")))
        return (t.className = e
          ? t.className + " " + this.args[0]
          : i.replace(" " + this.args[0] + " ", " ").trim())
    }),
    (t.public.binders["*"] = function (t, e) {
      return null != e ? t.setAttribute(this.type, e) : t.removeAttribute(this.type)
    }),
    (t.public.adapters["."] = {
      id: "_rv",
      counter: 0,
      weakmap: {},
      weakReference: function (t) {
        var e, i, n
        return (
          t.hasOwnProperty(this.id) ||
            ((e = this.counter++), Object.defineProperty(t, this.id, { value: e })),
          (i = this.weakmap)[(n = t[this.id])] || (i[n] = { callbacks: {} })
        )
      },
      cleanupWeakReference: function (t, e) {
        if (!(Object.keys(t.callbacks).length || (t.pointers && Object.keys(t.pointers).length)))
          return delete this.weakmap[e]
      },
      stubFunction: function (t, e) {
        var i, n, r
        return (
          (n = t[e]),
          (i = this.weakReference(t)),
          (r = this.weakmap),
          (t[e] = function () {
            var e, s, o, u, l, h, a, p, d
            ;(o = n.apply(t, arguments)), (h = i.pointers)
            for (s in h)
              for (
                e = h[s],
                  u = 0,
                  l = (d = null != (a = null != (p = r[s]) ? p.callbacks[e] : void 0) ? a : [])
                    .length;
                u < l;
                u++
              )
                (0, d[u])()
            return o
          })
        )
      },
      observeMutations: function (t, e, i) {
        var n, r, s, o, u, h
        if (Array.isArray(t)) {
          if (null == (s = this.weakReference(t)).pointers)
            for (
              s.pointers = {},
                u = 0,
                h = (r = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"]).length;
              u < h;
              u++
            )
              (n = r[u]), this.stubFunction(t, n)
          if ((null == (o = s.pointers)[e] && (o[e] = []), l.call(s.pointers[e], i) < 0))
            return s.pointers[e].push(i)
        }
      },
      unobserveMutations: function (t, e, i) {
        var n, r, s
        if (
          Array.isArray(t) &&
          null != t[this.id] &&
          (r = this.weakmap[t[this.id]]) &&
          (s = r.pointers[e])
        )
          return (
            (n = s.indexOf(i)) >= 0 && s.splice(n, 1),
            s.length || delete r.pointers[e],
            this.cleanupWeakReference(r, t[this.id])
          )
      },
      observe: function (t, e, i) {
        var n, r, s, o
        return (
          null == (n = this.weakReference(t).callbacks)[e] &&
            ((n[e] = []),
            (null != (r = Object.getOwnPropertyDescriptor(t, e)) ? r.get : void 0) ||
              (null != r ? r.set : void 0) ||
              ((s = t[e]),
              Object.defineProperty(t, e, {
                enumerable: !0,
                get: function () {
                  return s
                },
                set:
                  ((o = this),
                  function (r) {
                    var u, h, a, p
                    if (
                      r !== s &&
                      (o.unobserveMutations(s, t[o.id], e), (s = r), (u = o.weakmap[t[o.id]]))
                    ) {
                      if ((n = u.callbacks)[e])
                        for (h = 0, a = (p = n[e].slice()).length; h < a; h++)
                          (i = p[h]), l.call(n[e], i) >= 0 && i()
                      return o.observeMutations(r, t[o.id], e)
                    }
                  })
              }))),
          l.call(n[e], i) < 0 && n[e].push(i),
          this.observeMutations(t[e], t[this.id], e)
        )
      },
      unobserve: function (t, e, i) {
        var n, r, s
        if ((s = this.weakmap[t[this.id]]) && (n = s.callbacks[e]))
          return (
            (r = n.indexOf(i)) >= 0 && (n.splice(r, 1), n.length || delete s.callbacks[e]),
            this.unobserveMutations(t[e], t[this.id], e),
            this.cleanupWeakReference(s, t[this.id])
          )
      },
      get: function (t, e) {
        return t[e]
      },
      set: function (t, e, i) {
        return (t[e] = i)
      }
    }),
    (t.factory = function (e) {
      return (t.sightglass = e), (t.public._ = t), t.public
    }),
    "object" == typeof ("undefined" != typeof module && null !== module ? module.exports : void 0)
      ? (module.exports = t.factory(require("sightglass")))
      : "function" == typeof define && define.amd
      ? define(["sightglass"], function (e) {
          return (this.rivets = t.factory(e))
        })
      : (this.rivets = t.factory(sightglass))
}).call(this)
;(function () {
  var $document,
    Cart,
    CartJS,
    Item,
    processing,
    queue,
    __bind = function (fn, me) {
      return function () {
        return fn.apply(me, arguments)
      }
    }
  Cart = (function () {
    function Cart() {
      this.update = __bind(this.update, this)
    }

    Cart.prototype.update = function (cart) {
      var item, key, value
      for (key in cart) {
        value = cart[key]
        if (key !== "items") {
          this[key] = value
        }
      }
      return (this.items = (function () {
        var _i, _len, _ref, _results
        _ref = cart.items
        _results = []
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          item = _ref[_i]
          _results.push(new Item(item))
        }
        return _results
      })())
    }

    return Cart
  })()

  Item = (function () {
    function Item(item) {
      this.propertyArray = __bind(this.propertyArray, this)
      this.update = __bind(this.update, this)
      this.update(item)
    }

    Item.prototype.update = function (item) {
      var key, value
      for (key in item) {
        value = item[key]
        if (key !== "properties") {
          this[key] = value
        }
      }
      return (this.properties = CartJS.Utils.extend({}, item.properties))
    }

    Item.prototype.propertyArray = function () {
      var name, value, _ref, _results
      _ref = this.properties
      _results = []
      for (name in _ref) {
        value = _ref[name]
        _results.push({
          name: name,
          value: value
        })
      }
      return _results
    }

    return Item
  })()

  CartJS = {
    settings: {
      debug: false,
      dataAPI: true,
      requestBodyClass: null,
      rivetsModels: {},
      currency: null,
      moneyFormat: null,
      moneyWithCurrencyFormat: null,
      weightUnit: "g",
      weightPrecision: 0
    },
    cart: new Cart()
  }

  CartJS.init = function (cart, settings) {
    if (settings == null) {
      settings = {}
    }
    CartJS.configure(settings)
    CartJS.Utils.log("Initialising CartJS.")
    CartJS.cart.update(cart)
    if (CartJS.settings.dataAPI) {
      CartJS.Utils.log('"dataAPI" setting is true, initialising Data API.')
      CartJS.Data.init()
    }
    if (CartJS.settings.requestBodyClass) {
      CartJS.Utils.log('"requestBodyClass" set, adding event listeners.')
      jQuery(document).on("cart.requestStarted", function () {
        return jQuery("body").addClass(CartJS.settings.requestBodyClass)
      })
      jQuery(document).on("cart.requestComplete", function () {
        return jQuery("body").removeClass(CartJS.settings.requestBodyClass)
      })
    }
    CartJS.Rivets.init()
    return jQuery(document).trigger("cart.ready", [CartJS.cart])
  }

  CartJS.configure = function (settings) {
    if (settings == null) {
      settings = {}
    }
    return CartJS.Utils.extend(CartJS.settings, settings)
  }

  if (window.console == null) {
    window.console = {}
    window.console.log = function () {}
  }

  CartJS.Utils = {
    log: function () {
      return CartJS.Utils.console(console.log, arguments)
    },
    error: function () {
      return CartJS.Utils.console(console.error, arguments)
    },
    console: function (method, args) {
      if (CartJS.settings.debug && typeof console !== "undefined" && console !== null) {
        args = Array.prototype.slice.call(args)
        args.unshift("[CartJS]:")
        return method.apply(console, args)
      }
    },
    wrapKeys: function (obj, type, override) {
      var key, value, wrapped
      if (type == null) {
        type = "properties"
      }
      wrapped = {}
      for (key in obj) {
        value = obj[key]
        wrapped["" + type + "[" + key + "]"] = override != null ? override : value
      }
      return wrapped
    },
    unwrapKeys: function (obj, type, override) {
      var key, unwrapped, unwrappedKey, value
      if (type == null) {
        type = "properties"
      }
      unwrapped = {}
      for (key in obj) {
        value = obj[key]
        unwrappedKey = key.replace("" + type + "[", "").replace("]", "")
        unwrapped[unwrappedKey] = override != null ? override : value
      }
      return unwrapped
    },
    extend: function (object, properties) {
      var key, val
      for (key in properties) {
        val = properties[key]
        object[key] = val
      }
      return object
    },
    clone: function (object) {
      var key, newInstance
      if (object == null || typeof object !== "object") {
        return object
      }
      newInstance = new object.constructor()
      for (key in object) {
        newInstance[key] = clone(object[key])
      }
      return newInstance
    },
    isArray:
      Array.isArray ||
      function (value) {
        return {}.toString.call(value) === "[object Array]"
      },
    ensureArray: function (value) {
      if (CartJS.Utils.isArray(value)) {
        return value
      }
      if (value != null) {
        return [value]
      } else {
        return []
      }
    },
    formatMoney: function (value, format, formatName, currency) {
      var _ref, _ref1
      if (currency == null) {
        currency = ""
      }
      if (!currency) {
        currency = CartJS.settings.currency
      }
      if (window.Currency != null && currency !== CartJS.settings.currency) {
        value = Currency.convert(value, CartJS.settings.currency, currency)
        if (
          ((_ref = window.Currency) != null ? _ref.moneyFormats : void 0) != null &&
          currency in window.Currency.moneyFormats
        ) {
          format = window.Currency.moneyFormats[currency][formatName]
        }
      }
      if (((_ref1 = window.Shopify) != null ? _ref1.formatMoney : void 0) != null) {
        return Shopify.formatMoney(value, format)
      } else {
        return value
      }
    },
    getSizedImageUrl: function (src, size) {
      var _ref, _ref1
      if (
        ((_ref = window.Shopify) != null
          ? (_ref1 = _ref.Image) != null
            ? _ref1.getSizedImageUrl
            : void 0
          : void 0) != null
      ) {
        if (src) {
          return Shopify.Image.getSizedImageUrl(src, size)
        } else {
          return Shopify.Image.getSizedImageUrl(
            "https://cdn.shopify.com/s/images/admin/no-image-.gif",
            size
          ).replace("-_", "-")
        }
      } else {
        if (src) {
          return src
        } else {
          return "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
        }
      }
    }
  }

  queue = []

  processing = false

  CartJS.Queue = {
    add: function (url, data, options) {
      var request
      if (options == null) {
        options = {}
      }
      request = {
        url: url,
        data: data,
        type: options.type || "POST",
        dataType: options.dataType || "json",
        success: CartJS.Utils.ensureArray(options.success),
        error: CartJS.Utils.ensureArray(options.error),
        complete: CartJS.Utils.ensureArray(options.complete)
      }
      if (options.updateCart) {
        request.success.push(CartJS.cart.update)
      }
      queue.push(request)
      if (processing) {
        return
      }
      jQuery(document).trigger("cart.requestStarted", [CartJS.cart])
      return CartJS.Queue.process()
    },
    process: function () {
      var params
      if (!queue.length) {
        processing = false
        jQuery(document).trigger("cart.requestComplete", [CartJS.cart])
        return
      }
      processing = true
      params = queue.shift()
      params.complete = CartJS.Queue.process
      return jQuery.ajax(params)
    }
  }

  CartJS.Core = {
    getCart: function (options) {
      if (options == null) {
        options = {}
      }
      options.type = "GET"
      options.updateCart = true
      return CartJS.Queue.add("/cart.js", {}, options)
    },
    addItem: function (id, quantity, properties, options) {
      var data
      if (quantity == null) {
        quantity = 1
      }
      if (properties == null) {
        properties = {}
      }
      if (options == null) {
        options = {}
      }
      data = CartJS.Utils.wrapKeys(properties)
      data.id = id
      data.quantity = quantity
      CartJS.Queue.add("/cart/add.js", data, options)
      return CartJS.Core.getCart()
    },
    updateItem: function (line, quantity, properties, options) {
      var data
      if (properties == null) {
        properties = {}
      }
      if (options == null) {
        options = {}
      }
      data = CartJS.Utils.wrapKeys(properties)
      data.line = line
      if (quantity != null) {
        data.quantity = quantity
      }
      options.updateCart = true
      return CartJS.Queue.add("/cart/change.js", data, options)
    },
    removeItem: function (line, options) {
      if (options == null) {
        options = {}
      }
      return CartJS.Core.updateItem(line, 0, {}, options)
    },
    updateItemById: function (id, quantity, properties, options) {
      var data
      if (properties == null) {
        properties = {}
      }
      if (options == null) {
        options = {}
      }
      data = CartJS.Utils.wrapKeys(properties)
      data.id = id
      if (quantity != null) {
        data.quantity = quantity
      }
      options.updateCart = true
      return CartJS.Queue.add("/cart/change.js", data, options)
    },
    updateItemQuantitiesById: function (updates, options) {
      if (updates == null) {
        updates = {}
      }
      if (options == null) {
        options = {}
      }
      options.updateCart = true
      return CartJS.Queue.add(
        "/cart/update.js",
        {
          updates: updates
        },
        options
      )
    },
    removeItemById: function (id, options) {
      var data
      if (options == null) {
        options = {}
      }
      data = {
        id: id,
        quantity: 0
      }
      options.updateCart = true
      return CartJS.Queue.add("/cart/change.js", data, options)
    },
    clear: function (options) {
      if (options == null) {
        options = {}
      }
      options.updateCart = true
      return CartJS.Queue.add("/cart/clear.js", {}, options)
    },
    getAttribute: function (attributeName, defaultValue) {
      if (attributeName in CartJS.cart.attributes) {
        return CartJS.cart.attributes[attributeName]
      } else {
        return defaultValue
      }
    },
    setAttribute: function (attributeName, value, options) {
      var attributes
      if (options == null) {
        options = {}
      }
      attributes = {}
      attributes[attributeName] = value
      return CartJS.Core.setAttributes(attributes, options)
    },
    getAttributes: function () {
      return CartJS.cart.attributes
    },
    setAttributes: function (attributes, options) {
      if (attributes == null) {
        attributes = {}
      }
      if (options == null) {
        options = {}
      }
      options.updateCart = true
      return CartJS.Queue.add(
        "/cart/update.js",
        CartJS.Utils.wrapKeys(attributes, "attributes"),
        options
      )
    },
    clearAttributes: function (options) {
      if (options == null) {
        options = {}
      }
      options.updateCart = true
      return CartJS.Queue.add(
        "/cart/update.js",
        CartJS.Utils.wrapKeys(CartJS.Core.getAttributes(), "attributes", ""),
        options
      )
    },
    getNote: function () {
      return CartJS.cart.note
    },
    setNote: function (note, options) {
      if (options == null) {
        options = {}
      }
      options.updateCart = true
      return CartJS.Queue.add(
        "/cart/update.js",
        {
          note: note
        },
        options
      )
    }
  }

  $document = null

  CartJS.Data = {
    init: function () {
      $document = jQuery(document)
      CartJS.Data.setEventListeners("on")
      return CartJS.Data.render(null, CartJS.cart)
    },
    destroy: function () {
      return CartJS.Data.setEventListeners("off")
    },
    setEventListeners: function (method) {
      $document[method]("click", "[data-cart-add]", CartJS.Data.add)
      $document[method]("click", "[data-cart-remove]", CartJS.Data.remove)
      $document[method]("click", "[data-cart-remove-id]", CartJS.Data.removeById)
      $document[method]("click", "[data-cart-update]", CartJS.Data.update)
      $document[method]("click", "[data-cart-update-id]", CartJS.Data.updateById)
      $document[method]("click", "[data-cart-clear]", CartJS.Data.clear)
      $document[method]("change", "[data-cart-toggle]", CartJS.Data.toggle)
      $document[method]("change", "[data-cart-toggle-attribute]", CartJS.Data.toggleAttribute)
      $document[method]("submit", "[data-cart-submit]", CartJS.Data.submit)
      return $document[method]("cart.requestComplete", CartJS.Data.render)
    },
    add: function (e) {
      var $this
      e.preventDefault()
      $this = jQuery(this)
      return CartJS.Core.addItem($this.attr("data-cart-add"), $this.attr("data-cart-quantity"))
    },
    remove: function (e) {
      var $this
      e.preventDefault()
      $this = jQuery(this)
      return CartJS.Core.removeItem($this.attr("data-cart-remove"))
    },
    removeById: function (e) {
      var $this
      e.preventDefault()
      $this = jQuery(this)
      return CartJS.Core.removeItemById($this.attr("data-cart-remove-id"))
    },
    update: function (e) {
      var $this
      e.preventDefault()
      $this = jQuery(this)
      return CartJS.Core.updateItem(
        $this.attr("data-cart-update"),
        $this.attr("data-cart-quantity")
      )
    },
    updateById: function (e) {
      var $this
      e.preventDefault()
      $this = jQuery(this)
      return CartJS.Core.updateItemById(
        $this.attr("data-cart-update-id"),
        $this.attr("data-cart-quantity")
      )
    },
    clear: function (e) {
      e.preventDefault()
      return CartJS.Core.clear()
    },
    toggle: function (e) {
      var $input, id
      $input = jQuery(this)
      id = $input.attr("data-cart-toggle")
      if ($input.is(":checked")) {
        return CartJS.Core.addItem(id)
      } else {
        return CartJS.Core.removeItemById(id)
      }
    },
    toggleAttribute: function (e) {
      var $input, attribute
      $input = jQuery(this)
      attribute = $input.attr("data-cart-toggle-attribute")
      return CartJS.Core.setAttribute(attribute, $input.is(":checked") ? "Yes" : "")
    },
    submit: function (e) {
      var dataArray, id, properties, quantity
      e.preventDefault()
      dataArray = jQuery(this).serializeArray()
      id = void 0
      quantity = void 0
      properties = {}
      jQuery.each(dataArray, function (i, item) {
        if (item.name === "id") {
          return (id = item.value)
        } else if (item.name === "quantity") {
          return (quantity = item.value)
        } else if (item.name.match(/^properties\[\w+\]$/)) {
          return (properties[item.name] = item.value)
        }
      })
      return CartJS.Core.addItem(id, quantity, CartJS.Utils.unwrapKeys(properties))
    },
    render: function (e, cart) {
      var context
      context = {
        item_count: cart.item_count,
        total_price: cart.total_price,
        total_price_money: CartJS.Utils.formatMoney(
          cart.total_price,
          CartJS.settings.moneyFormat,
          "money_format",
          (typeof Currency !== "undefined" && Currency !== null
            ? Currency.currentCurrency
            : void 0) != null
            ? Currency.currentCurrency
            : void 0
        ),
        total_price_money_with_currency: CartJS.Utils.formatMoney(
          cart.total_price,
          CartJS.settings.moneyWithCurrencyFormat,
          "money_with_currency_format",
          (typeof Currency !== "undefined" && Currency !== null
            ? Currency.currentCurrency
            : void 0) != null
            ? Currency.currentCurrency
            : void 0
        )
      }

      return jQuery("[data-cart-render]").each(function () {
        var $this
        $this = jQuery(this)
        return $this.html(context[$this.attr("data-cart-render")])
      })
    }
  }

  if ("rivets" in window) {
    CartJS.Rivets = {
      model: null,
      boundViews: [],
      init: function () {
        return CartJS.Rivets.bindViews()
      },
      destroy: function () {
        return CartJS.Rivets.unbindViews()
      },
      bindViews: function () {
        CartJS.Utils.log("Rivets.js is present, binding views.")
        CartJS.Rivets.unbindViews()
        CartJS.Rivets.model = CartJS.Utils.extend(
          {
            cart: CartJS.cart
          },
          CartJS.settings.rivetsModels
        )
        if (window.Currency != null) {
          CartJS.Rivets.model.Currency = window.Currency
        }
        return jQuery("[data-cart-view]").each(function () {
          var view
          view = rivets.bind(jQuery(this), CartJS.Rivets.model)
          return CartJS.Rivets.boundViews.push(view)
        })
      },
      unbindViews: function () {
        var view, _i, _len, _ref
        _ref = CartJS.Rivets.boundViews
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          view = _ref[_i]
          view.unbind()
        }
        return (CartJS.Rivets.boundViews = [])
      }
    }
    rivets.formatters.eq = function (a, b) {
      return a === b
    }
    rivets.formatters.includes = function (a, b) {
      return a.indexOf(b) >= 0
    }
    rivets.formatters.match = function (a, regexp, flags) {
      return a.match(new RegExp(regexp, flags))
    }
    rivets.formatters.lt = function (a, b) {
      return a < b
    }
    rivets.formatters.gt = function (a, b) {
      return a > b
    }
    rivets.formatters.not = function (a) {
      return !a
    }
    rivets.formatters.empty = function (a) {
      return !a.length
    }
    rivets.formatters.plus = function (a, b) {
      return parseInt(a) + parseInt(b)
    }
    rivets.formatters.minus = function (a, b) {
      return parseInt(a) - parseInt(b)
    }
    rivets.formatters.times = function (a, b) {
      return a * b
    }
    rivets.formatters.divided_by = function (a, b) {
      return a / b
    }
    rivets.formatters.modulo = function (a, b) {
      return a % b
    }
    rivets.formatters.prepend = function (a, b) {
      return b + a
    }
    rivets.formatters.append = function (a, b) {
      return a + b
    }
    rivets.formatters.slice = function (value, start, end) {
      return value.slice(start, end)
    }
    rivets.formatters.pluralize = function (input, singular, plural) {
      if (plural == null) {
        plural = singular + "s"
      }
      if (CartJS.Utils.isArray(input)) {
        input = input.length
      }
      if (input === 1) {
        return singular
      } else {
        return plural
      }
    }
    rivets.formatters.array_element = function (array, index) {
      return array[index]
    }
    rivets.formatters.array_first = function (array) {
      return array[0]
    }
    rivets.formatters.array_last = function (array) {
      return array[array.length - 1]
    }
    rivets.formatters.array_lengnth_greater_than_two = function (array) {
      return Array.isArray(array) && array.length > 2
    }
    rivets.formatters.and = function (value, args) {
      return value && args
    }
    rivets.formatters.money = function (value, currency) {
      return CartJS.Utils.formatMoney(value, CartJS.settings.moneyFormat, "money_format", currency)
    }
    rivets.formatters.money_with_currency = function (value, currency) {
      return CartJS.Utils.formatMoney(
        value,
        CartJS.settings.moneyWithCurrencyFormat,
        "money_with_currency_format",
        currency
      )
    }
    rivets.formatters.weight = function (grams) {
      switch (CartJS.settings.weightUnit) {
        case "kg":
          return (grams / 1000).toFixed(CartJS.settings.weightPrecision)
        case "oz":
          return (grams * 0.035274).toFixed(CartJS.settings.weightPrecision)
        case "lb":
          return (grams * 0.00220462).toFixed(CartJS.settings.weightPrecision)
        default:
          return grams.toFixed(CartJS.settings.weightPrecision)
      }
    }
    rivets.formatters.weight_with_unit = function (grams) {
      return rivets.formatters.weight(grams) + CartJS.settings.weightUnit
    }
    rivets.formatters.product_image_size = function (src, size) {
      return CartJS.Utils.getSizedImageUrl(src, size)
    }
    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency
    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit
    rivets.formatters.productImageSize = rivets.formatters.product_image_size
  } else {
    CartJS.Rivets = {
      init: function () {},
      destroy: function () {}
    }
  }

  CartJS.factory = function (exports) {
    exports.init = CartJS.init
    exports.configure = CartJS.configure
    exports.cart = CartJS.cart
    exports.settings = CartJS.settings
    exports.getCart = CartJS.Core.getCart
    exports.addItem = CartJS.Core.addItem
    exports.updateItem = CartJS.Core.updateItem
    exports.updateItemById = CartJS.Core.updateItemById
    exports.updateItemQuantitiesById = CartJS.Core.updateItemQuantitiesById
    exports.removeItem = CartJS.Core.removeItem
    exports.removeItemById = CartJS.Core.removeItemById
    exports.clear = CartJS.Core.clear
    exports.getAttribute = CartJS.Core.getAttribute
    exports.setAttribute = CartJS.Core.setAttribute
    exports.getAttributes = CartJS.Core.getAttributes
    exports.setAttributes = CartJS.Core.setAttributes
    exports.clearAttributes = CartJS.Core.clearAttributes
    exports.getNote = CartJS.Core.getNote
    exports.setNote = CartJS.Core.setNote
    return (exports.render = CartJS.Data.render)
  }

  if (typeof exports === "object") {
    CartJS.factory(exports)
  } else if (typeof define === "function" && define.amd) {
    define(["exports"], function (exports) {
      CartJS.factory((this.CartJS = exports))
      return exports
    })
  } else {
    CartJS.factory((this.CartJS = {}))
  }
}).call(this)
;("use strict")
/* ===== Product Add to Cart =============================== */

$(document).on("change", "#monogram-this-item", function () {
  if (this.checked == true) {
    if ($(".pickletter2").html() == "") {
      $("#pick-letter").clone().appendTo(".pickletter2")
      $("#pick-letter").clone().appendTo(".pickletter3")
      $(".pickletter1").html($(".pickletter3").html())
      $(".pickletter2 .monolbl").html("Second Letter")
      $(".pickletter3 .monolbl").html("Third Letter")
      $(".pick-letter.monogram").show()
    }
  } else {
    $(".pickletter2").html(""), $(".pickletter3").html("")
  }
})

$(document).on("change", "#monogram-this-item-mobile", function () {
  if (this.checked == true) {
    if ($(".pickletter2").html() == "") {
      $("#pick-letter").clone().appendTo(".pickletter2"),
        $("#pick-letter").clone().appendTo(".pickletter3"),
        $(".pickletter2 .monolbl").html("Second Letter"),
        $(".pickletter3 .monolbl").html("Third Letter"),
        $(".pickletter11 ul.dd-options li:nth-child(2)").last().hide(),
        $(".pick-letter.monogram").show()
    }
  } else {
    $(".pickletter2").html(""), $(".pickletter3").html("")
  }
})

$(document).on("click", ".pickletter1 .dd-selected", function () {
  $(".pickletter1 .dd-options").show()
  $(".pickletter1 .dd-pointer").addClass("dd-pointer-up")
})
$(document).on("click", ".pickletter1 .dd-options li", function () {
  $(this).find("a").addClass("dd-option-selected")
  $(".pickletter1 .dd-selected").html($(this).find("a").html())
  $(".pickletter1 .dd-selected-value").val($(this).find("a").find("input").val())
})

$(document).on("click", ".pickletter2 .dd-selected", function () {
  $(".pickletter2 .dd-options").show()
  $(".pickletter2 .dd-pointer").addClass("dd-pointer-up")
})

$(document).on("click", ".pickletter2 .dd-options li", function () {
  $(this).find("a").addClass("dd-option-selected")
  $(".pickletter2 .dd-selected").html($(this).find("a").html())
})
$(document).on("click", ".pickletter3 .dd-selected", function () {
  $(".pickletter3 .dd-options").show()
  $(".pickletter3 .dd-pointer").addClass("dd-pointer-up")
})
$(document).on("click", ".pickletter3 .dd-options li", function () {
  $(this).find("a").addClass("dd-option-selected")
  $(".pickletter3 .dd-selected").html($(this).find("a").html())
})

$(document).on("click", ".js-product-add-to-cart", function () {
  console.clear()
  if ($(this).text() == "Select Size" || $(this).text() == "Select Length") {
    return false
  }
  var letter1 = $(".pickletter1 .dd-select").find("input").val()
  if (letter1 == "" || letter1 == undefined) {
    var letter1 = $(".pickletter11 .dd-select").find("input").val()
    if (letter1 == "" || letter1 == undefined) {
      letter1 = $(".dd-selected-value").val()
    }
  }

  var letter2 = $(".pickletter2 .dd-selected").find("input").val()
  var letter3 = $(".pickletter3 .dd-selected").find("input").val()
  if (letter1 == "" || letter1 == undefined) {
    letter1 = ""
  }
  if (letter2 == "" || letter2 == undefined) {
    letter2 = ""
  }
  if (letter3 == "" || letter3 == undefined) {
    letter3 = ""
  }
  /* ISQ END HERE */

  var variantID = $(this).attr("data-variant-id")
  var variantProperties = {}
  var checked = false
  jQuery('input[type="checkbox"]').each(function (index) {
    if (jQuery(this).prop("checked") && jQuery(this).attr("id") == "monogram-this-item") {
      checked = true
    }
  })
  if (checked == true) {
    selectedLetter = letter1 + " " + letter2 + " " + letter3
    variantProperties = { "Monogram this item": "yes", "Pick your letter": selectedLetter }
  }
  //Validation form Mobile View
  if ($(".product-shop .monogramThreeLettersInput").length > 0) {
    if (
      $(".product-shop .monogramThreeLettersInput").val().length < 2 ||
      $(".product-shop .monogramThreeLettersInput").val().length > 4
    ) {
      $(".product-shop .threemonoerror").html("Please enter 2 - 4 letters")
      $(".product-shop .monogramThreeLettersInput").addClass("error")
      return false
    } else if (
      $(".product-shop .monogramThreeLettersInput").val().length >= 2 &&
      $(".product-shop .monogramThreeLettersInput").val().length <= 4
    ) {
      $(".product-shop .monogramThreeLettersInput").removeClass("error")
      $(".product-shop .threemonoerror").html("")
      //variantProperties = {"Monogram this item": "yes","Pick your letter": $("#threelettermonogram").val() };
      variantProperties = { Monogram: $(".product-shop .monogramThreeLettersInput").val() }
    }

    if ($(".product-shop .petNameInput").val().length == 0) {
      $(".product-shop .pet1error").html("Enter your pet name and image above")
      //console.log('no name');
      return false
    }
  }

  // Pet Properties
  // template.suffix == "image-upload-nameField"
  if ($(".product-shop #pet-name-input").length > 0) {
    var ImageURL = ""
    $(".product-shop #pet-image-upload input[type=hidden]").each(function () {
      if ($(this).val().includes("https://upload.cloudlift.app")) {
        ImageURL = $(this).val()
      }
    })
    if (ImageURL == "") {
      $(".product-shop #pet-error").html("Enter your image above")
      return false
    }
    if (ImageURL != "") {
      $(".product-shop #pet-error").html("")
      variantProperties["Pet Image"] = ImageURL
    }
    if ($(".product-shop #pet-name-input").val().length === 0) {
      $(".product-shop #pet-error").html("Enter your pet name above")
      return false
    }
    if ($(".product-shop #pet-name-input").val().length > 0) {
      $(".product-shop #pet-error").html("")
      variantProperties["Pet Name"] = $(".product-shop #pet-name-input").val()
    }
  } else if ($(".product-shop #pet-image-upload").length > 0) {
    // template.suffix == "image-upload"
    var ImageURL = ""
    $(".product-shop #pet-image-upload input[type=hidden]").each(function () {
      if ($(this).val().includes("https://upload.cloudlift.app")) {
        ImageURL = $(this).val()
      }
    })
    if (ImageURL == "") {
      $(".product-shop #pet-error").html("Enter your image above")
      return false
    }
    if (ImageURL != "") {
      $(".product-shop #pet-error").html("")
      variantProperties["Pet Image"] = ImageURL
    }
  }

  // Custom Bridal
  if ($(".product-shop .customBridalInput").val()) {
    variantProperties["Custom Embroidery"] = $(".product-shop .customBridalInput").val()
  }

  var res = ""
  var propertynm = ""
  var propertyval = JSON.stringify(variantProperties)
  propertyval = propertyval.replace("}", "")
  if ($(this).hasClass("finalSale")) {
    if (propertyval.length > 1) {
      propertyval = propertyval + ',"NOTE": "FINAL SALE"}'
      variantProperties = JSON.parse(propertyval)
    } else {
      variantProperties = { NOTE: "FINAL SALE" }
    }
  }
  if ($(this).hasClass("preorder")) {
    var dataTxt = $(this).attr("data-preorder-note")

    if (propertynm != "" && dataTxt != null) {
      propertyval = propertyval + ',"NOTE":"' + dataTxt + '"}'
      variantProperties = JSON.parse(propertyval)
    } else if (propertynm == "" && dataTxt != null) {
      propertyval = '{"NOTE":"' + dataTxt + '"}'
      variantProperties = JSON.parse(propertyval)
    } else {
      variantProperties = { NOTE: dataTxt }
    }
  }
  console.log(variantProperties)
  CartJS.addItem(variantID, 1, variantProperties, {
    success: function (data, textStatus, jqXHR) {
      //Open Mini Cart
      window.setTimeout(function () {
        $("body").addClass("mini-cart-open")
      }, 1000)
    },

    error: function (jqXHR, textStatus, errorThrown) {
      $(".product-shop-option-name").addClass("highlight")
    }
  })

  setTimeout(function () {
    $("#mini-cart-title-id").focus()
    //console.log('focus changed?');
  }, 1800)
})

$(document).on("click", ".js-product-custom-cta", function () {
  const relevantProduct = document.querySelector(
    `[data-product-for-cta="${this.getAttribute("data-product-id")}"]`
  )
  if (relevantProduct) {
    if (relevantProduct.getAttribute("data-custom-cta")) {
      window.open(relevantProduct.getAttribute("data-custom-cta"))
    }
  }
})
/** Copyright:   Matthieu Riolo <advise@ocsource.ch> Website:     http://www.ocsource.ch/ License:     <see file /License> Created:     2014-11-05 Repository:  https://github.com/matthieuriolo/rivetsjs-stdlib */
;(function (root, factory) {
  if (typeof exports === "object") {
    // CommonJS
    module.exports = factory(require("rivets"), require("moment"))
  } else if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(["rivets", "moment"], factory)
  } else {
    // Browser globals
    factory(root.rivets, root.moment)
  }
})(this, function (rivets, moment) {
  rivets.stdlib = {
    defaultPrecision: 2,
    defaultThousandSeparator: "'",
    defaultDecimalSeparator: ".",

    defaultDateFormat: "YYYY-MM-DD",
    defaultTimeFormat: "HH:mm:ss",
    defaultDatetimeFormat: "YYYY-MM-DD HH:mm:ss"
  }
  rivets.formatters.imageSize = function (src, size) {
    return src.replace(/\.jpg|\.png|\.gif|\.jpeg/gi, function (match) {
      return "_" + size + match
    })
  }
  rivets.formatters.log = function (target) {
    return console.log(target)
  }

  rivets.formatters.default = function (target, val) {
    return !rivets.formatters.isEmpty(target) ? target : val
  }

  rivets.formatters.add = function (target, val) {
    return target + val
  }

  rivets.formatters.sub = function (target, val) {
    return target - val
  }

  rivets.formatters.map = function (target, obj, prop) {
    var args = Array.prototype.slice.call(arguments)
    args.splice(1, 2)
    return obj[prop].apply(obj, args)
  }

  rivets.formatters.isBoolean = function (target) {
    return typeof target == "boolean"
  }

  rivets.formatters.isNumeric = function (target) {
    return !isNaN(target)
  }

  rivets.formatters.isNaN = function (target) {
    if (rivets.formatters.isArray(target)) return true
    return isNaN(target)
  }
  rivets.formatters.isInteger = function (n) {
    return n === +n && n === (n | 0)
  }

  rivets.formatters.isFloat = function (n) {
    return Infinity !== n && n === +n && n !== (n | 0)
  }

  rivets.formatters.isNumber = function (target) {
    return rivets.formatters.isFloat(target) || rivets.formatters.isInteger(target)
  }

  rivets.formatters.isObject = function (target) {
    return (
      rivets.formatters.toBoolean(target) &&
      typeof target == "object" &&
      !rivets.formatters.isArray(target)
    )
  }

  rivets.formatters.isFunction = function (target) {
    return typeof target == "function"
  }

  rivets.formatters.isArray = function (target) {
    return rivets.formatters.isFunction(Array.isArray)
      ? Array.isArray(target)
      : target instanceof Array
  }

  rivets.formatters.isString = function (target) {
    return typeof target == "string" || target instanceof String
  }

  rivets.formatters.isInfinity = function (target) {
    return target === Infinity
  }
  rivets.formatters.toBoolean = function (target) {
    return !!target
  }

  rivets.formatters.toInteger = function (target) {
    var ret = parseInt(target * 1, 10)
    return isNaN(ret) ? 0 : ret
  }

  rivets.formatters.toFloat = function (target) {
    var ret = parseFloat(target * 1.0)
    return isNaN(ret) ? 0.0 : ret
  }

  rivets.formatters.toDecimal = function (target) {
    var retI = rivets.formatters.toInteger(target * 1)
    var retF = rivets.formatters.toFloat(target)
    return retI == retF ? retI : retF
  }

  rivets.formatters.toArray = function (target) {
    if (rivets.formatters.isArray(target)) {
      return target
    } else if (rivets.formatters.isObject(target)) {
      return rivets.formatters.values(target)
    }

    return [target]
  }

  rivets.formatters.toString = function (target) {
    return target ? target.toString() : ""
  }

  rivets.formatters.integer = {
    read: function (target) {
      return rivets.formatters.toInteger(target)
    },

    publish: function (target) {
      return rivets.formatters.toInteger(target)
    }
  }

  /* Math functions */
  rivets.formatters.sum = function (target, val) {
    return 1 * target + 1 * val
  }

  rivets.formatters.substract = function (target, val) {
    return 1 * target - 1 * val
  }

  rivets.formatters.multiply = function (target, val) {
    return 1 * target * (1 * val)
  }
  rivets.formatters.divide = function (target, val) {
    return (1 * target) / (1 * val)
  }

  rivets.formatters.min = function () {
    return Math.min.apply(Math, arguments)
  }

  rivets.formatters.max = function () {
    return Math.max.apply(Math, arguments)
  }

  rivets.formatters.isEqual = function (target, val) {
    return target === val
  }

  rivets.formatters.isNotEqual = function (target, val) {
    return target !== val
  }

  rivets.formatters.isLess = function (target, val) {
    return target * 1 < val * 1
  }

  rivets.formatters.isGreater = function (target, val) {
    return target * 1 > val * 1
  }

  rivets.formatters.isLessEqual = function (target, val) {
    return target * 1 <= val * 1
  }

  rivets.formatters.isGreaterEqual = function (target, val) {
    return target * 1 >= val * 1
  }

  /* logical functions */
  rivets.formatters.or = function () {
    for (var i = 0; i < arguments.length; i++) {
      if (rivets.formatters.toBoolean(arguments[i])) {
        return true
      }
    }
    return false
  }

  rivets.formatters.and = function () {
    for (var i = 0; i < arguments.length; i++) {
      if (!rivets.formatters.toBoolean(arguments[i])) {
        return false
      }
    }

    return true
  }

  rivets.formatters.negate = function (target) {
    return !rivets.formatters.toBoolean(target)
  }

  rivets.formatters.if = function (target, trueCase, falseCase) {
    return rivets.formatters.toBoolean(target) ? trueCase : falseCase
  }

  /* number functions */
  rivets.formatters.numberFormat = function (
    target,
    precision,
    decimalSeparator,
    thousandSeparator
  ) {
    target = rivets.formatters.isNumber(target) ? target : rivets.formatters.toDecimal(target)

    if (!rivets.formatters.isInteger(precision)) precision = rivets.stdlib.defaultPrecision
    if (!decimalSeparator) decimalSeparator = rivets.stdlib.defaultDecimalSeparator
    if (!thousandSeparator) thousandSeparator = rivets.stdlib.defaultThousandSeparator
    var ret = (+(Math.round(+(Math.abs(target) + "e" + precision)) + "e" + -precision)).toFixed(
      precision
    )
    if (target < 0) ret = "-" + ret
    ret = ret.split(".")
    if (ret.length == 2) {
      return ret[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator) + decimalSeparator + ret[1]
    }

    return ret[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)
  }
  /* date functions */

  rivets.formatters.date = function (target) {
    return moment(target).format(rivets.stdlib.defaultDateFormat)
  }

  rivets.formatters.time = function (target) {
    return moment(target).format(rivets.stdlib.defaultTimeFormat)
  }

  rivets.formatters.datetime = function (target) {
    return moment(target).format(rivets.stdlib.defaultDatetimeFormat)
  }

  rivets.formatters.toTimestamp = function (target) {
    return moment(target).format("X")
  }

  rivets.formatters.toDate = function (target) {
    return moment.unix(target).toDate()
  }

  rivets.formatters.toMoment = function (target) {
    return moment(target)
  }

  /**  The date formatter returns a formatted date string according to the moment.js
   * formatting syntax.  ```html <span rv-value="model:date | date 'dddd, MMMM Do'"></span> @see {@link http://momentjs.com/docs/#/displaying} for format options. */
  rivets.formatters.dateFormat = function (target, val) {
    return moment(target).format(val)
  }

  /* object functions */

  rivets.formatters.pairs = function (target) {
    return Object.keys(target).map(function (key) {
      return {
        object: target,
        property: key,
        value: target[key]
      }
    })
  }

  rivets.formatters.keys = function (target) {
    return Object.keys(target)
  }

  rivets.formatters.values = function (target) {
    return Object.keys(target).map(function (key) {
      return target[key]
    })
  }

  /* string functions */

  rivets.formatters.stringFormat = function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var offset = target.indexOf("%s")
      if (offset === -1) {
        break
      }

      target = target.slice(0, offset) + arguments[i] + target.slice(offset + 2)
    }

    return target
  }

  rivets.formatters.split = function (target, val) {
    return target.split(val)
  }

  rivets.formatters.removeAfterPipe = function (target) {
    return target.substring(0, target.indexOf("|") - 1)
  }
  rivets.formatters.removeBeforePipe = function (target) {
    return target.substring(target.indexOf("|") + 1)
  }

  rivets.formatters.lower = function (target) {
    return target.toLowerCase()
  }

  rivets.formatters.upper = function (target) {
    return target.toUpperCase()
  }

  rivets.formatters.capitalize = function (target) {
    target = rivets.formatters.toString(target)
    return target
      .split(" ")
      .map(function (seq) {
        return seq
          .split("-")
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1)
          })
          .join("-")
      })
      .join(" ")
  }

  /* string&array functions */
  rivets.formatters.contains = function (target, val) {
    return target.indexOf(val) !== -1
  }

  rivets.formatters.doesNotContain = function (target, val) {
    return rivets.formatters.negate(rivets.formatters.contains(target, val))
  }

  rivets.formatters.prettyPrint = function (target) {
    return JSON.stringify(target, null, 2)
  }

  rivets.formatters.isEmpty = function (target) {
    if (!rivets.formatters.toBoolean(target)) return true
    return rivets.formatters.toArray(target).length === 0
  }

  /* array formatters */

  rivets.formatters.length = function (target) {
    if (rivets.formatters.isString(target)) return target.length
    return rivets.formatters.toArray(target).length
  }

  rivets.formatters.join = function (target, val) {
    return rivets.formatters.toArray(target).join(val)
  }

  /* functions formatters */

  rivets.formatters.wrap = function (target) {
    var args = Array.prototype.slice.call(arguments)
    args.splice(0, 1)

    return function (evt) {
      var cpy = args.slice()
      Array.prototype.push.apply(cpy, Array.prototype.slice.call(arguments))
      return target.apply(this, cpy)
    }
  }

  rivets.formatters.delay = function (target, ts) {
    var self = this
    return function () {
      setTimeout(function () {
        target.apply(self, arguments)
      }, ts)
    }
  }

  rivets.formatters.preventDefault = function (target) {
    var self = this
    return function (evt) {
      evt.preventDefault()
      target.call(self, evt)
      return false
    }
  }

  /* basic bindings for rivets */
  rivets.binders.width = function (el, value) {
    el.style.width = value
  }

  rivets.binders.height = function (el, value) {
    el.style.height = value
  }
  /* extra bind-type for rivets - we may need a better solution than that one */
  rivets.binders.template = {
    block: true,
    bind: function () {
      this.subviews = []
    },

    unbind: function (el) {
      this.subviews.forEach(function (el) {
        el.unbind()
      })
    },

    routine: function (el, value) {
      var self = this

      //kill old data
      this.subviews.forEach(function (el) {
        el.unbind()
      })
      this.subviews = []

      //set new value
      $(el).html(value)

      //make subhtml binding capable
      var options = {
        binders: this.view.binders,
        formatters: this.view.formatters,
        adapters: this.view.adapters,
        config: this.view.config
      }

      var models = {}
      for (var k in self.view.models) {
        models[k] = self.view.models[k]
      }

      $(el)
        .children()
        .each(function () {
          var v = new rivets._.View(this, models) ///rivets.bind(this, models)
          v.bind()
          self.subviews.push(v)
        })
    },

    update: function (models) {
      this.subviews.forEach(function (el) {
        el.update(models)
      })
    }
  }

  /* formatter shortcuts */
  rivets.formatters.eq = rivets.formatters.isEqual
  rivets.formatters.ne = function (target, val) {
    return rivets.formatters.negate(rivets.formatters.isEqual(target, val))
  }

  rivets.formatters.lt = rivets.formatters.isLess
  rivets.formatters.gt = rivets.formatters.isGreater

  rivets.formatters.le = rivets.formatters.isLessEqual
  rivets.formatters.lte = rivets.formatters.isLessEqual

  rivets.formatters.ge = rivets.formatters.isGreaterEqual
  rivets.formatters.gte = rivets.formatters.isGreaterEqual
  rivets.formatters.prv = rivets.formatters.preventDefault
  rivets.formatters.inject = rivets.formatters.stringFormat
  rivets.formatters.format = rivets.formatters.dateFormat
  rivets.formatters.len = rivets.formatters.length
  rivets.formatters.def = rivets.formatters.default
  rivets.formatters.neg = rivets.formatters.negate

  rivets.formatters.date = rivets.formatters.dateFormat

  rivets.formatters.stringify = rivets.formatters.prettyPrint
  rivets.formatters.int = rivets.formatters.integer

  // backwards compatibility
  rivets.formatters.isLower = rivets.formatters.isLess
  rivets.formatters.isLowerEqual = rivets.formatters.isLessEqual
})
var Shopify = Shopify || {}

// -------- Money format handler --------------------------------------------
Shopify.money_format = "${{amount}}"
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "")
  }
  var value = ""
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  var formatString = format || this.money_format

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ",")
    decimal = defaultOption(decimal, ".")

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : ""

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2)
      break
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0)
      break
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",")
      break
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",")
      break
  }

  return formatString.replace(placeholderRegex, value)
}

// -------------- Image.switchImage helps to switch variant images on variant selection -------------------------
Shopify.Image = {
  preload: function (images, size) {
    for (var i = 0; i < images.length; i++) {
      var image = images[i]

      this.loadImage(this.getSizedImageUrl(image, size))
    }
  },

  loadImage: function (path) {
    new Image().src = path
  },

  switchImage: function (image, element, callback) {
    if (!image || !element) {
      return
    }

    var size = this.imageSize(element.src)
    var imageUrl = this.getSizedImageUrl(image.src, size)

    if (callback) {
      callback(imageUrl, image, element)
    } else {
      element.src = imageUrl
    }
  },

  imageSize: function (src) {
    var match = src.match(
      /_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./
    )

    if (match != null) {
      return match[1]
    } else {
      return null
    }
  },

  getSizedImageUrl: function (src, size) {
    if (size == null) {
      return src
    }

    if (size == "master") {
      return this.removeProtocol(src)
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i)

    if (match != null) {
      var prefix = src.split(match[0])
      var suffix = match[0]

      return this.removeProtocol(prefix[0] + "_" + size + suffix)
    } else {
      return null
    }
  },

  removeProtocol: function (path) {
    return path.replace(/http(s)?:/, "")
  }
}

var _extends =
    Object.assign ||
    function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e]
        for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o])
      }
      return t
    },
  _typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (t) {
          return typeof t
        }
      : function (t) {
          return t &&
            "function" == typeof Symbol &&
            t.constructor === Symbol &&
            t !== Symbol.prototype
            ? "symbol"
            : typeof t
        }
!(function (t, e) {
  "object" === ("undefined" == typeof exports ? "undefined" : _typeof(exports)) &&
  "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : (t.LazyLoad = e())
})(this, function () {
  "use strict"
  function t(t, e, n) {
    var o = e._settings
    ;(!n && i(t)) ||
      (C(o.callback_enter, t),
      R.indexOf(t.tagName) > -1 && (N(t, e), I(t, o.class_loading)),
      E(t, e),
      a(t),
      C(o.callback_set, t))
  }
  var e = {
      elements_selector: "img",
      container: document,
      threshold: 300,
      thresholds: null,
      data_src: "src",
      data_srcset: "srcset",
      data_sizes: "sizes",
      data_bg: "bg",
      class_loading: "loading",
      class_loaded: "loaded",
      class_error: "error",
      load_delay: 0,
      callback_load: null,
      callback_error: null,
      callback_set: null,
      callback_enter: null,
      callback_finish: null,
      to_webp: !1
    },
    n = function (t) {
      return _extends({}, e, t)
    },
    o = function (t, e) {
      return t.getAttribute("data-" + e)
    },
    r = function (t, e, n) {
      var o = "data-" + e
      null !== n ? t.setAttribute(o, n) : t.removeAttribute(o)
    },
    a = function (t) {
      return r(t, "was-processed", "true")
    },
    i = function (t) {
      return "true" === o(t, "was-processed")
    },
    s = function (t, e) {
      return r(t, "ll-timeout", e)
    },
    c = function (t) {
      return o(t, "ll-timeout")
    },
    l = function (t) {
      return t.filter(function (t) {
        return !i(t)
      })
    },
    u = function (t, e) {
      return t.filter(function (t) {
        return t !== e
      })
    },
    d = function (t, e) {
      var n,
        o = new t(e)
      try {
        n = new CustomEvent("LazyLoad::Initialized", { detail: { instance: o } })
      } catch (t) {
        ;(n = document.createEvent("CustomEvent")).initCustomEvent(
          "LazyLoad::Initialized",
          !1,
          !1,
          { instance: o }
        )
      }
      window.dispatchEvent(n)
    },
    f = function (t, e) {
      return e ? t.replace(/\.(jpe?g|png)/gi, ".webp") : t
    },
    _ = "undefined" != typeof window,
    v = (_ && !("onscroll" in window)) || /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),
    g = _ && "IntersectionObserver" in window,
    h = _ && "classList" in document.createElement("p"),
    b =
      _ &&
      (function () {
        var t = document.createElement("canvas")
        return (
          !(!t.getContext || !t.getContext("2d")) &&
          0 === t.toDataURL("image/webp").indexOf("data:image/webp")
        )
      })(),
    m = function (t, e, n, r) {
      for (var a, i = 0; (a = t.children[i]); i += 1)
        if ("SOURCE" === a.tagName) {
          var s = o(a, n)
          p(a, e, s, r)
        }
    },
    p = function (t, e, n, o) {
      n && t.setAttribute(e, f(n, o))
    },
    y = function (t, e) {
      var n = b && e.to_webp,
        r = o(t, e.data_src),
        a = o(t, e.data_bg)
      if (r) {
        var i = f(r, n)
        t.style.backgroundImage = 'url("' + i + '")'
      }
      if (a) {
        var s = f(a, n)
        t.style.backgroundImage = s
      }
    },
    w = {
      IMG: function (t, e) {
        var n = b && e.to_webp,
          r = e.data_srcset,
          a = t.parentNode
        a && "PICTURE" === a.tagName && m(a, "srcset", r, n)
        var i = o(t, e.data_sizes)
        p(t, "sizes", i)
        var s = o(t, r)
        p(t, "srcset", s, n)
        var c = o(t, e.data_src)
        p(t, "src", c, n)
      },
      IFRAME: function (t, e) {
        var n = o(t, e.data_src)
        p(t, "src", n)
      },
      VIDEO: function (t, e) {
        var n = e.data_src,
          r = o(t, n)
        m(t, "src", n), p(t, "src", r), t.load()
      }
    },
    E = function (t, e) {
      var n = e._settings,
        o = t.tagName,
        r = w[o]
      if (r) return r(t, n), e._updateLoadingCount(1), void (e._elements = u(e._elements, t))
      y(t, n)
    },
    I = function (t, e) {
      h ? t.classList.add(e) : (t.className += (t.className ? " " : "") + e)
    },
    L = function (t, e) {
      h
        ? t.classList.remove(e)
        : (t.className = t.className
            .replace(new RegExp("(^|\\s+)" + e + "(\\s+|$)"), " ")
            .replace(/^\s+/, "")
            .replace(/\s+$/, ""))
    },
    C = function (t, e) {
      t && t(e)
    },
    O = function (t, e, n) {
      t.addEventListener(e, n)
    },
    k = function (t, e, n) {
      t.removeEventListener(e, n)
    },
    x = function (t, e, n) {
      O(t, "load", e), O(t, "loadeddata", e), O(t, "error", n)
    },
    A = function (t, e, n) {
      k(t, "load", e), k(t, "loadeddata", e), k(t, "error", n)
    },
    z = function (t, e, n) {
      var o = n._settings,
        r = e ? o.class_loaded : o.class_error,
        a = e ? o.callback_load : o.callback_error,
        i = t.target
      L(i, o.class_loading), I(i, r), C(a, i), n._updateLoadingCount(-1)
    },
    N = function (t, e) {
      var n = function n(r) {
          z(r, !0, e), A(t, n, o)
        },
        o = function o(r) {
          z(r, !1, e), A(t, n, o)
        }
      x(t, n, o)
    },
    R = ["IMG", "IFRAME", "VIDEO"],
    S = function (e, n, o) {
      t(e, o), n.unobserve(e)
    },
    M = function (t) {
      var e = c(t)
      e && (clearTimeout(e), s(t, null))
    },
    j = function (t, e, n) {
      var o = n._settings.load_delay,
        r = c(t)
      r ||
        ((r = setTimeout(function () {
          S(t, e, n), M(t)
        }, o)),
        s(t, r))
    },
    D = function (t) {
      return t.isIntersecting || t.intersectionRatio > 0
    },
    T = function (t) {
      return {
        root: t.container === document ? null : t.container,
        rootMargin: t.thresholds || t.threshold + "px"
      }
    },
    U = function (t, e) {
      ;(this._settings = n(t)), this._setObserver(), (this._loadingCount = 0), this.update(e)
    }
  return (
    (U.prototype = {
      _manageIntersection: function (t) {
        var e = this._observer,
          n = this._settings.load_delay,
          o = t.target
        n ? (D(t) ? j(o, e, this) : M(o)) : D(t) && S(o, e, this)
      },
      _onIntersection: function (t) {
        t.forEach(this._manageIntersection.bind(this))
      },
      _setObserver: function () {
        g &&
          (this._observer = new IntersectionObserver(
            this._onIntersection.bind(this),
            T(this._settings)
          ))
      },
      _updateLoadingCount: function (t) {
        ;(this._loadingCount += t),
          0 === this._elements.length &&
            0 === this._loadingCount &&
            C(this._settings.callback_finish)
      },
      update: function (t) {
        var e = this,
          n = this._settings,
          o = t || n.container.querySelectorAll(n.elements_selector)
        ;(this._elements = l(Array.prototype.slice.call(o))),
          !v && this._observer
            ? this._elements.forEach(function (t) {
                e._observer.observe(t)
              })
            : this.loadAll()
      },
      destroy: function () {
        var t = this
        this._observer &&
          (this._elements.forEach(function (e) {
            t._observer.unobserve(e)
          }),
          (this._observer = null)),
          (this._elements = null),
          (this._settings = null)
      },
      load: function (e, n) {
        t(e, this, n)
      },
      loadAll: function () {
        var t = this
        this._elements.forEach(function (e) {
          t.load(e)
        })
      }
    }),
    _ &&
      (function (t, e) {
        if (e)
          if (e.length) for (var n, o = 0; (n = e[o]); o += 1) d(t, n)
          else d(t, e)
      })(U, window.lazyLoadOptions),
    U
  )
})
//# sourceMappingURL=lazyload.min.js.map

var VHChromeFix = function (selectors) {
  var self = this
  var userAgent = navigator.userAgent.toLowerCase()
  var isAndroidChrome = /chrome/.test(userAgent) && /android/.test(userAgent)
  var isIOSChrome = /crios/.test(userAgent)

  if (isAndroidChrome || isIOSChrome) {
    // If we detected Chrome on Android or iOS
    // Cache elements and trigger fix on init
    this.getElements(selectors)
    this.fixAll()

    // Cache window dimensions
    this.windowWidth = window.innerWidth
    this.windowHeight = window.innerHeight

    window.addEventListener("resize", function () {
      // Both width and height changed (orientation change) This is a hack, as Android when eyboard pops up Triggers orientation change
      if (self.windowWidth !== window.innerWidth && self.windowHeight !== window.innerHeight) {
        self.windowWidth = window.innerWidth
        self.windowHeight = window.innerHeight
        self.fixAll()
      }
    })
  }
}
VHChromeFix.prototype.getElements = function (selectors) {
  this.elements = []
  // Convert selectors to array if they are not
  selectors = this.isArray(selectors) ? selectors : [selectors]

  for (var i = 0; i < selectors.length; i++) {
    // Get all elements for selector
    var selector = selectors[i].selector
    var elements = document.querySelectorAll(selector)

    // Go through all elements for one selector to filter them
    for (var j = 0; j < elements.length; j++) {
      this.elements.push({
        domElement: elements[j],
        vh: selectors[i].vh
      })
    }
  }
}

VHChromeFix.prototype.isArray = function (array) {
  return Object.prototype.toString.call(array) === "[object Array]"
}

VHChromeFix.prototype.fixAll = function () {
  for (var i = 0; i < this.elements.length; i++) {
    var element = this.elements[i]
    element.domElement.style.height = (window.innerHeight * element.vh) / 100 + "px"
  }
}

/** scrolldir - Vertical scroll direction in CSS @version v1.2.17 * @link https://github.com/dollarshaveclub/scrolldir.git * @author Patrick Fisher <patrick@pwfisher.com> @license MIT **/
!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? e()
    : "function" == typeof define && define.amd
    ? define(e)
    : e()
})(0, function () {
  "use strict"
  function t() {
    var t = o.scrollY || o.pageYOffset,
      e = l.timeStamp,
      i = "down" === d ? Math.max : Math.min,
      p = f.offsetHeight - o.innerHeight
    if (
      ((t = Math.max(0, t)),
      (t = Math.min(p, t)),
      c.unshift({ y: t, t: e }),
      c.pop(),
      t === i(m, t))
    )
      return (v = e), void (m = t)
    var b = e - u
    if (b > v) {
      m = t
      for (var w = 0; w < a && c[w] && !(c[w].t < b); w += 1) m = i(m, c[w].y)
    }
    Math.abs(t - m) > s &&
      ((m = t), (v = e), (d = "down" === d ? "up" : "down"), n.setAttribute(r, d))
  }
  function e(e) {
    return (l = e), o.requestAnimationFrame(t)
  }
  var i = { el: document.documentElement, win: window, attribute: "data-scrolldir", dir: "down" },
    n = void 0,
    o = void 0,
    r = void 0,
    d = void 0,
    f = document.body,
    a = 32,
    u = 512,
    s = 64,
    c = Array(a),
    l = void 0,
    m = void 0,
    v = 0
  !(function (t) {
    ;(n = (t && t.el) || i.el),
      (o = (t && t.win) || i.win),
      (r = (t && t.attribute) || i.attribute),
      (d = (t && t.direction) || i.dir),
      t && !0 === t.off
        ? (n.setAttribute(r, "off"), o.removeEventListener("scroll", e))
        : ((m = o.scrollY || o.pageYOffset), n.setAttribute(r, d), o.addEventListener("scroll", e))
  })()
})
/*! waitForImages jQuery Plugin 2018-02-13 */
!(function (a) {
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "object" == typeof exports
    ? (module.exports = a(require("jquery")))
    : a(jQuery)
})(function (a) {
  var b = "waitForImages",
    c = (function (a) {
      return a.srcset && a.sizes
    })(new Image())
  ;(a.waitForImages = {
    hasImageProperties: [
      "backgroundImage",
      "listStyleImage",
      "borderImage",
      "borderCornerImage",
      "cursor"
    ],
    hasImageAttributes: ["srcset"]
  }),
    (a.expr.pseudos["has-src"] = function (b) {
      return a(b).is('img[src][src!=""]')
    }),
    (a.expr.pseudos.uncached = function (b) {
      return !!a(b).is(":has-src") && !b.complete
    }),
    (a.fn.waitForImages = function () {
      var d,
        e,
        f,
        g = 0,
        h = 0,
        i = a.Deferred(),
        j = this,
        k = [],
        l = a.waitForImages.hasImageProperties || [],
        m = a.waitForImages.hasImageAttributes || [],
        n = /url\(\s*(['"]?)(.*?)\1\s*\)/g
      if (
        (a.isPlainObject(arguments[0])
          ? ((f = arguments[0].waitForAll), (e = arguments[0].each), (d = arguments[0].finished))
          : 1 === arguments.length && "boolean" === a.type(arguments[0])
          ? (f = arguments[0])
          : ((d = arguments[0]), (e = arguments[1]), (f = arguments[2])),
        (d = d || a.noop),
        (e = e || a.noop),
        (f = !!f),
        !a.isFunction(d) || !a.isFunction(e))
      )
        throw new TypeError("An invalid callback was supplied.")
      return (
        this.each(function () {
          var b = a(this)
          f
            ? b
                .find("*")
                .addBack()
                .each(function () {
                  var b = a(this)
                  b.is("img:has-src") &&
                    !b.is("[srcset]") &&
                    k.push({ src: b.attr("src"), element: b[0] }),
                    a.each(l, function (a, c) {
                      var d,
                        e = b.css(c)
                      if (!e) return !0
                      for (; (d = n.exec(e)); ) k.push({ src: d[2], element: b[0] })
                    }),
                    a.each(m, function (a, c) {
                      var d = b.attr(c)
                      return (
                        !d ||
                        void k.push({ src: b.attr("src"), srcset: b.attr("srcset"), element: b[0] })
                      )
                    })
                })
            : b.find("img:has-src").each(function () {
                k.push({ src: this.src, element: this })
              })
        }),
        (g = k.length),
        (h = 0),
        0 === g && (d.call(j), i.resolveWith(j)),
        a.each(k, function (f, k) {
          var l = new Image(),
            m = "load." + b + " error." + b
          a(l).one(m, function b(c) {
            var f = [h, g, "load" == c.type]
            if ((h++, e.apply(k.element, f), i.notifyWith(k.element, f), a(this).off(m, b), h == g))
              return d.call(j[0]), i.resolveWith(j[0]), !1
          }),
            c && k.srcset && ((l.srcset = k.srcset), (l.sizes = k.sizes)),
            (l.src = k.src)
        }),
        i.promise()
      )
    })
})
// jQuery RoyalSlider plugin. (c) Dmitry Semenov http://dimsemenov.com jquery.royalslider v9.5.9
;(function (l) {
  function v(b, e) {
    var d,
      a = this,
      c = window.navigator,
      g = c.userAgent.toLowerCase()
    a.uid = l.rsModules.uid++
    a.ns = ".rs" + a.uid
    var f = document.createElement("div").style,
      h = ["webkit", "Moz", "ms", "O"],
      k = "",
      m = 0
    for (d = 0; d < h.length; d++) {
      var p = h[d]
      !k && p + "Transform" in f && (k = p)
      p = p.toLowerCase()
      window.requestAnimationFrame ||
        ((window.requestAnimationFrame = window[p + "RequestAnimationFrame"]),
        (window.cancelAnimationFrame =
          window[p + "CancelAnimationFrame"] || window[p + "CancelRequestAnimationFrame"]))
    }
    window.requestAnimationFrame ||
      (window.requestAnimationFrame = function (a, b) {
        var c = new Date().getTime(),
          d = Math.max(0, 16 - (c - m)),
          f = window.setTimeout(function () {
            a(c + d)
          }, d)
        m = c + d
        return f
      })
    window.cancelAnimationFrame ||
      (window.cancelAnimationFrame = function (a) {
        clearTimeout(a)
      })
    a.isIPAD = g.match(/(ipad)/)
    a.isIOS = a.isIPAD || g.match(/(iphone|ipod)/)
    d = (function (a) {
      a =
        /(chrome)[ \/]([\w.]+)/.exec(a) ||
        /(webkit)[ \/]([\w.]+)/.exec(a) ||
        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a) ||
        /(msie) ([\w.]+)/.exec(a) ||
        (0 > a.indexOf("compatible") && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a)) ||
        []
      return { browser: a[1] || "", version: a[2] || "0" }
    })(g)
    h = {}
    d.browser && ((h[d.browser] = !0), (h.version = d.version))
    h.chrome && (h.webkit = !0)
    a._browser = h
    a.isAndroid = -1 < g.indexOf("android")
    a.slider = l(b)
    a.ev = l(a)
    a._doc = l(document)
    a.st = l.extend({}, l.fn.royalSlider.defaults, e)
    a._currAnimSpeed = a.st.transitionSpeed
    a._minPosOffset = 0
    !a.st.allowCSS3 ||
      (h.webkit && !a.st.allowCSS3OnWebkit) ||
      ((d = k + (k ? "T" : "t")),
      (a._useCSS3Transitions = d + "ransform" in f && d + "ransition" in f),
      a._useCSS3Transitions && (a._use3dTransform = k + (k ? "P" : "p") + "erspective" in f))
    k = k.toLowerCase()
    a._vendorPref = "-" + k + "-"
    a._slidesHorizontal = "vertical" === a.st.slidesOrientation ? !1 : !0
    a._reorderProp = a._slidesHorizontal ? "left" : "top"
    a._sizeProp = a._slidesHorizontal ? "width" : "height"
    a._prevNavItemId = -1
    a._isMove = "fade" === a.st.transitionType ? !1 : !0
    a._isMove || ((a.st.sliderDrag = !1), (a._fadeZIndex = 10))
    a._opacityCSS = "z-index:0; display:none; opacity:0;"
    a._newSlideId = 0
    a._sPosition = 0
    a._nextSlidePos = 0
    l.each(l.rsModules, function (b, c) {
      "uid" !== b && c.call(a)
    })
    a.slides = []
    a._idCount = 0
    ;(a.st.slides ? l(a.st.slides) : a.slider.children().detach()).each(function () {
      a._parseNode(this, !0)
    })
    a.st.randomizeSlides &&
      a.slides.sort(function () {
        return 0.5 - Math.random()
      })
    a.numSlides = a.slides.length
    a._refreshNumPreloadImages()
    a.st.startSlideId
      ? a.st.startSlideId > a.numSlides - 1 && (a.st.startSlideId = a.numSlides - 1)
      : (a.st.startSlideId = 0)
    a._newSlideId = a.staticSlideId = a.currSlideId = a._realId = a.st.startSlideId
    a.currSlide = a.slides[a.currSlideId]
    a._accelerationPos = 0
    a.pointerMultitouch = !1
    a.slider.addClass((a._slidesHorizontal ? "rsHor" : "rsVer") + (a._isMove ? "" : " rsFade"))
    f = '<div class="rsOverflow"><div class="rsContainer">'
    a.slidesSpacing = a.st.slidesSpacing
    a._slideSize = (a._slidesHorizontal ? a.slider.width() : a.slider.height()) + a.st.slidesSpacing
    a._preload = 0 < a._numPreloadImages
    1 >= a.numSlides && (a._loop = !1)
    a._loopHelpers = a._loop && a._isMove ? (2 === a.numSlides ? 1 : 2) : 0
    a._maxImages = 6 > a.numSlides ? a.numSlides : 6
    a._currBlockIndex = 0
    a._idOffset = 0
    a.slidesJQ = []
    for (d = 0; d < a.numSlides; d++)
      a.slidesJQ.push(
        l(
          '<div style="' +
            (a._isMove ? "" : d !== a.currSlideId ? a._opacityCSS : "z-index:0;") +
            '" class="rsSlide "></div>'
        )
      )
    a._sliderOverflow = f = l(f + "</div></div>")
    k = function (b, c, d, f, e) {
      a._downEvent = b + c
      a._moveEvent = b + d
      a._upEvent = b + f
      e && (a._cancelEvent = b + e)
    }
    d = c.pointerEnabled
    a.pointerEnabled = d || c.msPointerEnabled
    a.pointerEnabled
      ? ((a.hasTouch = !1),
        (a._lastItemFriction = 0.2),
        (a.pointerMultitouch = 1 < c[(d ? "m" : "msM") + "axTouchPoints"]),
        d
          ? k("pointer", "down", "move", "up", "cancel")
          : k("MSPointer", "Down", "Move", "Up", "Cancel"))
      : (a.isIOS
          ? (a._downEvent = a._moveEvent = a._upEvent = a._cancelEvent = "")
          : k("mouse", "down", "move", "up"),
        "ontouchstart" in window || "createTouch" in document
          ? ((a.hasTouch = !0),
            (a._downEvent += " touchstart"),
            (a._moveEvent += " touchmove"),
            (a._upEvent += " touchend"),
            (a._cancelEvent += " touchcancel"),
            (a._lastItemFriction = 0.5),
            a.st.sliderTouch && (a._hasDrag = !0))
          : ((a.hasTouch = !1), (a._lastItemFriction = 0.2)))
    a.st.sliderDrag &&
      ((a._hasDrag = !0),
      h.msie || h.opera
        ? (a._grabCursor = a._grabbingCursor = "move")
        : h.mozilla
        ? ((a._grabCursor = "-moz-grab"), (a._grabbingCursor = "-moz-grabbing"))
        : h.webkit &&
          -1 != c.platform.indexOf("Mac") &&
          ((a._grabCursor = "-webkit-grab"), (a._grabbingCursor = "-webkit-grabbing")),
      a._setGrabCursor())
    a.slider.html(f)
    a._controlsContainer = a.st.controlsInside ? a._sliderOverflow : a.slider
    a._slidesContainer = a._sliderOverflow.children(".rsContainer")
    a.pointerEnabled &&
      a._slidesContainer.css(
        (d ? "" : "-ms-") + "touch-action",
        a._slidesHorizontal ? "pan-y" : "pan-x"
      )
    a._preloader = l('<div class="rsPreloader"></div>')
    c = a._slidesContainer.children(".rsSlide")
    a._currHolder = a.slidesJQ[a.currSlideId]
    a._selectedSlideHolder = 0
    a._eventCallbacks = {
      dragStart: function (b) {
        a._onDragStart(b)
      },
      dragStartThumb: function (b) {
        a._onDragStart(b, !0)
      },
      touchmoveFix: function () {}
    }
    a._useCSS3Transitions
      ? ((a._TP = "transition-property"),
        (a._TD = "transition-duration"),
        (a._TTF = "transition-timing-function"),
        (a._yProp = a._xProp = a._vendorPref + "transform"),
        a._use3dTransform
          ? (h.webkit && !h.chrome && a.slider.addClass("rsWebkit3d"),
            (a._tPref1 = "translate3d("),
            (a._tPref2 = "px, "),
            (a._tPref3 = "px, 0px)"))
          : ((a._tPref1 = "translate("), (a._tPref2 = "px, "), (a._tPref3 = "px)")),
        a._isMove
          ? (a._slidesContainer[a._vendorPref + a._TP] = a._vendorPref + "transform")
          : ((h = {}),
            (h[a._vendorPref + a._TP] = "opacity"),
            (h[a._vendorPref + a._TD] = a.st.transitionSpeed + "ms"),
            (h[a._vendorPref + a._TTF] = a.st.css3easeInOut),
            c.css(h)))
      : ((a._xProp = "left"), (a._yProp = "top"))
    a._slidesHorizontal && a.slider.css("touch-action", "pan-y")
    var n
    l(window).on("resize" + a.ns, function () {
      n && clearTimeout(n)
      n = setTimeout(function () {
        a.updateSliderSize()
      }, 50)
    })
    a.ev.trigger("rsAfterPropsSetup")
    a.updateSliderSize()
    a.st.keyboardNavEnabled && a._bindKeyboardNav()
    a.st.arrowsNavHideOnTouch && (a.hasTouch || a.pointerMultitouch) && (a.st.arrowsNav = !1)
    a.st.arrowsNav &&
      ((c = a._controlsContainer),
      l(
        '<div class="rsArrow rsArrowLeft"><div class="rsArrowIcn"></div></div><div class="rsArrow rsArrowRight"><div class="rsArrowIcn"></div></div>'
      ).appendTo(c),
      (a._arrowLeft = c.children(".rsArrowLeft").click(function (b) {
        b.preventDefault()
        a.prev()
      })),
      (a._arrowRight = c.children(".rsArrowRight").click(function (b) {
        b.preventDefault()
        a.next()
      })),
      a.st.arrowsNavAutoHide &&
        !a.hasTouch &&
        (a._arrowLeft.addClass("rsHidden"),
        a._arrowRight.addClass("rsHidden"),
        c.one("mousemove.arrowshover", function () {
          a._arrowLeft.removeClass("rsHidden")
          a._arrowRight.removeClass("rsHidden")
        }),
        c.hover(
          function () {
            a._arrowsAutoHideLocked ||
              (a._arrowLeft.removeClass("rsHidden"), a._arrowRight.removeClass("rsHidden"))
          },
          function () {
            a._arrowsAutoHideLocked ||
              (a._arrowLeft.addClass("rsHidden"), a._arrowRight.addClass("rsHidden"))
          }
        )),
      a.ev.on("rsOnUpdateNav", function () {
        a._updateArrowsNav()
      }),
      a._updateArrowsNav())
    ;(a.hasTouch && a.st.sliderTouch) || (!a.hasTouch && a.st.sliderDrag)
      ? (a._bindPassiveEvent(a._slidesContainer[0], a._downEvent, a._eventCallbacks.dragStart, !1),
        a._bindPassiveEvent(a.slider[0], a._moveEvent, a._eventCallbacks.touchmoveFix, !1))
      : (a.dragSuccess = !1)
    var r = ["rsPlayBtnIcon", "rsPlayBtn", "rsCloseVideoBtn", "rsCloseVideoIcn"]
    a._slidesContainer
      .click(function (b) {
        if (!a.dragSuccess) {
          var c = l(b.target).attr("class")
          if (-1 !== l.inArray(c, r) && a.toggleVideo()) return !1
          if (a.st.navigateByClick && !a._blockActions) {
            if (l(b.target).closest(".rsNoDrag", a._currHolder).length) return !0
            a._mouseNext(b)
          }
          a.ev.trigger("rsSlideClick", b)
        }
      })
      .on("click.rs", "a", function (b) {
        if (a.dragSuccess) return !1
        a._blockActions = !0
        setTimeout(function () {
          a._blockActions = !1
        }, 3)
      })
    a.ev.trigger("rsAfterInit")
  }
  l.rsModules || (l.rsModules = { uid: 0 })
  v.prototype = {
    constructor: v,
    _mouseNext: function (b) {
      b = b[this._slidesHorizontal ? "pageX" : "pageY"] - this._sliderOffset
      b >= this._nextSlidePos ? this.next() : 0 > b && this.prev()
    },
    _refreshNumPreloadImages: function () {
      var b = this.st.numImagesToPreload
      if ((this._loop = this.st.loop))
        2 === this.numSlides
          ? ((this._loop = !1), (this.st.loopRewind = !0))
          : 2 > this.numSlides && (this.st.loopRewind = this._loop = !1)
      this._loop &&
        0 < b &&
        (4 >= this.numSlides
          ? (b = 1)
          : this.st.numImagesToPreload > (this.numSlides - 1) / 2 &&
            (b = Math.floor((this.numSlides - 1) / 2)))
      this._numPreloadImages = b
    },
    _parseNode: function (b, e) {
      function d(b, d) {
        d ? c.images.push(b.attr(d)) : c.images.push(b.text())
        if (g) {
          g = !1
          c.caption = "src" === d ? b.attr("alt") : b.contents()
          c.image = c.images[0]
          c.videoURL = b.attr("data-rsVideo")
          var f = b.attr("data-rsw"),
            e = b.attr("data-rsh")
          "undefined" !== typeof f && !1 !== f && "undefined" !== typeof e && !1 !== e
            ? ((c.iW = parseInt(f, 10)), (c.iH = parseInt(e, 10)))
            : a.st.imgWidth && a.st.imgHeight && ((c.iW = a.st.imgWidth), (c.iH = a.st.imgHeight))
        }
      }
      var a = this,
        c = {},
        g = !0
      b = l(b)
      a._currContent = b
      a.ev.trigger("rsBeforeParseNode", [b, c])
      if (!c.stopParsing) {
        b = a._currContent
        c.id = a._idCount
        c.contentAdded = !1
        a._idCount++
        c.images = []
        c.isBig = !1
        if (!c.hasCover) {
          if (b.hasClass("rsImg")) {
            var f = b
            var h = !0
          } else (f = b.find(".rsImg")), f.length && (h = !0)
          h
            ? ((c.bigImage = f.eq(0).attr("data-rsBigImg")),
              f.each(function () {
                var a = l(this)
                a.is("a") ? d(a, "href") : a.is("img") ? d(a, "src") : d(a)
              }))
            : b.is("img") && (b.addClass("rsImg rsMainSlideImage"), d(b, "src"))
        }
        f = b.find(".rsCaption")
        f.length && (c.caption = f.remove())
        c.content = b
        a.ev.trigger("rsAfterParseNode", [b, c])
        e && a.slides.push(c)
        0 === c.images.length &&
          ((c.isLoaded = !0), (c.isRendered = !1), (c.isLoading = !1), (c.images = null))
        return c
      }
    },
    _bindKeyboardNav: function () {
      var b = this,
        e,
        d,
        a = function (a) {
          37 === a ? b.prev() : 39 === a && b.next()
        }
      b._doc
        .on("keydown" + b.ns, function (c) {
          if (!b.st.keyboardNavEnabled) return !0
          if (!(b._isDragging || ((d = c.keyCode), (37 !== d && 39 !== d) || e))) {
            if (
              document.activeElement &&
              /(INPUT|SELECT|TEXTAREA)/i.test(document.activeElement.tagName)
            )
              return !0
            b.isFullscreen && c.preventDefault()
            a(d)
            e = setInterval(function () {
              a(d)
            }, 700)
          }
        })
        .on("keyup" + b.ns, function (a) {
          e && (clearInterval(e), (e = null))
        })
    },
    goTo: function (b, e) {
      b !== this.currSlideId && this._moveTo(b, this.st.transitionSpeed, !0, !e)
    },
    destroy: function (b) {
      this.ev.trigger("rsBeforeDestroy")
      this._doc.off("keydown" + this.ns + " keyup" + this.ns)
      this._eventCallbacks.dragMove &&
        (this._unbindPassiveEvent(document, this._moveEvent, this._eventCallbacks.dragMove, !0),
        this._unbindPassiveEvent(document, this._upEvent, this._eventCallbacks.dragRelease, !0))
      this._eventCallbacks.downEvent &&
        (this._unbindPassiveEvent(
          this._slidesContainer[0],
          this._downEvent,
          this._eventCallbacks.dragStart,
          !1
        ),
        this._unbindPassiveEvent(
          this.slider[0],
          this._moveEvent,
          this._eventCallbacks.touchmoveFix,
          !1
        ))
      this._slidesContainer.off(this._downEvent + " click")
      this.slider.data("royalSlider", null)
      l.removeData(this.slider, "royalSlider")
      l(window).off("resize" + this.ns)
      this.loadingTimeout && clearTimeout(this.loadingTimeout)
      b && this.slider.remove()
      this.ev = this.slider = this.slides = null
    },
    _updateBlocksContent: function (b, e) {
      function d(d, e, g) {
        d.isAdded
          ? (a(e, d), c(e, d))
          : (g || (g = f.slidesJQ[e]),
            d.holder ? (g = d.holder) : ((g = f.slidesJQ[e] = l(g)), (d.holder = g)),
            (d.appendOnLoaded = !1),
            c(e, d, g),
            a(e, d),
            f._addBlockToContainer(d, g, b),
            (d.isAdded = !0))
      }
      function a(a, c) {
        c.contentAdded || (f.setItemHtml(c, b), b || (c.contentAdded = !0))
      }
      function c(a, b, c) {
        f._isMove &&
          (c || (c = f.slidesJQ[a]), c.css(f._reorderProp, (a + f._idOffset + x) * f._slideSize))
      }
      function g(a) {
        if (m) {
          if (a > p - 1) return g(a - p)
          if (0 > a) return g(p + a)
        }
        return a
      }
      var f = this,
        h,
        k,
        m = f._loop,
        p = f.numSlides
      if (!isNaN(e)) return g(e)
      var n = f.currSlideId,
        r = b
          ? Math.abs(f._prevSlideId - f.currSlideId) >= f.numSlides - 1
            ? 0
            : 1
          : f._numPreloadImages,
        t = Math.min(2, r),
        w = !1,
        u = !1
      for (k = n; k < n + 1 + t; k++) {
        var q = g(k)
        if ((h = f.slides[q]) && (!h.isAdded || !h.positionSet)) {
          w = !0
          break
        }
      }
      for (k = n - 1; k > n - 1 - t; k--)
        if (((q = g(k)), (h = f.slides[q]) && (!h.isAdded || !h.positionSet))) {
          u = !0
          break
        }
      if (w)
        for (k = n; k < n + r + 1; k++) {
          q = g(k)
          var x = Math.floor((f._realId - (n - k)) / f.numSlides) * f.numSlides
          ;(h = f.slides[q]) && d(h, q)
        }
      if (u)
        for (k = n - 1; k > n - 1 - r; k--)
          (q = g(k)), (x = Math.floor((f._realId - (n - k)) / p) * p), (h = f.slides[q]) && d(h, q)
      if (!b)
        for (t = g(n - r), n = g(n + r), r = t > n ? 0 : t, k = 0; k < p; k++)
          (t > n && k > t - 1) ||
            !(k < r || k > n) ||
            ((h = f.slides[k]) && h.holder && (h.holder.detach(), (h.isAdded = !1)))
    },
    setItemHtml: function (b, e) {
      var d = this,
        a = function () {
          if (!b.images) (b.isRendered = !0), (b.isLoaded = !0), (b.isLoading = !1), f(!0)
          else if (!b.isLoading) {
            if (b.content.hasClass("rsImg")) {
              var a = b.content
              var e = !0
            } else a = b.content.find(".rsImg:not(img)")
            a &&
              !a.is("img") &&
              a.each(function () {
                var a = l(this),
                  c = '<img class="rsImg" src="' + (a.is("a") ? a.attr("href") : a.text()) + '" />'
                e ? (b.content = l(c)) : a.replaceWith(c)
              })
            a = e ? b.content : b.content.find("img.rsImg")
            k()
            a.eq(0).addClass("rsMainSlideImage")
            b.iW && b.iH && (b.isLoaded || d._resizeImage(b), f())
            b.isLoading = !0
            if (b.isBig)
              l("<img />")
                .on("load.rs error.rs", function (a) {
                  l(this).off("load.rs error.rs")
                  c([this], !0)
                })
                .attr("src", b.image)
            else {
              b.loaded = []
              b.numStartedLoad = 0
              a = function (a) {
                l(this).off("load.rs error.rs")
                b.loaded.push(this)
                b.loaded.length === b.numStartedLoad && c(b.loaded, !1)
              }
              for (var g = 0; g < b.images.length; g++) {
                var h = l("<img />")
                b.numStartedLoad++
                h.on("load.rs error.rs", a).attr("src", b.images[g])
              }
            }
          }
        },
        c = function (a, c) {
          if (a.length) {
            var d = a[0]
            if (c !== b.isBig) (d = b.holder.children()) && 1 < d.length && m()
            else if (b.iW && b.iH) g()
            else if (((b.iW = d.width), (b.iH = d.height), b.iW && b.iH)) g()
            else {
              var e = new Image()
              e.onload = function () {
                e.width
                  ? ((b.iW = e.width), (b.iH = e.height), g())
                  : setTimeout(function () {
                      e.width && ((b.iW = e.width), (b.iH = e.height))
                      g()
                    }, 1e3)
              }
              e.src = d.src
            }
          } else g()
        },
        g = function () {
          b.isLoaded = !0
          b.isLoading = !1
          f()
          m()
          h()
        },
        f = function () {
          if (!b.isAppended && d.ev) {
            var a = d.st.visibleNearby,
              c = b.id - d._newSlideId
            e ||
              b.appendOnLoaded ||
              !d.st.fadeinLoadedSlide ||
              (0 !== c && (!(a || d._isAnimating || d._isDragging) || (-1 !== c && 1 !== c))) ||
              ((a = { visibility: "visible", opacity: 0 }),
              (a[d._vendorPref + "transition"] = "opacity 400ms ease-in-out"),
              b.content.css(a),
              setTimeout(function () {
                b.content.css("opacity", 1)
              }, 16))
            b.holder.find(".rsPreloader").length
              ? b.holder.append(b.content)
              : b.holder.html(b.content)
            b.isAppended = !0
            b.isLoaded && (d._resizeImage(b), h())
            b.sizeReady ||
              ((b.sizeReady = !0),
              setTimeout(function () {
                d.ev.trigger("rsMaybeSizeReady", b)
              }, 100))
          }
        },
        h = function () {
          !b.loadedTriggered &&
            d.ev &&
            ((b.isLoaded = b.loadedTriggered = !0),
            b.holder.trigger("rsAfterContentSet"),
            d.ev.trigger("rsAfterContentSet", b))
        },
        k = function () {
          d.st.usePreloader && b.holder.html(d._preloader.clone())
        },
        m = function (a) {
          d.st.usePreloader && ((a = b.holder.find(".rsPreloader")), a.length && a.remove())
        }
      b.isLoaded
        ? f()
        : e
        ? !d._isMove && b.images && b.iW && b.iH
          ? a()
          : ((b.holder.isWaiting = !0), k(), (b.holder.slideId = -99))
        : a()
    },
    _addBlockToContainer: function (b, e, d) {
      this._slidesContainer.append(b.holder)
      b.appendOnLoaded = !1
    },
    _onDragStart: function (b, e) {
      var d = this,
        a = "touchstart" === b.type
      d._isTouchGesture = a
      d.ev.trigger("rsDragStart")
      if (l(b.target).closest(".rsNoDrag", d._currHolder).length) return (d.dragSuccess = !1), !0
      !e && d._isAnimating && ((d._wasAnimating = !0), d._stopAnimation())
      d.dragSuccess = !1
      if (d._isDragging) a && (d._multipleTouches = !0)
      else {
        a && (d._multipleTouches = !1)
        d._setGrabbingCursor()
        if (a) {
          var c = b.touches
          if (c && 0 < c.length) {
            var g = c[0]
            1 < c.length && (d._multipleTouches = !0)
          } else return
        } else b.preventDefault(), (g = b)
        d._isDragging = !0
        d._eventCallbacks.dragMove &&
          (d._unbindPassiveEvent(document, d._moveEvent, d._eventCallbacks.dragMove, !0),
          d._unbindPassiveEvent(document, d._upEvent, d._eventCallbacks.dragRelease, !0))
        d._eventCallbacks.dragMove = function (a) {
          d._onDragMove(a, e)
        }
        d._eventCallbacks.dragRelease = function (a) {
          d._onDragRelease(a, e)
        }
        d._bindPassiveEvent(document, d._moveEvent, d._eventCallbacks.dragMove, !0)
        d._bindPassiveEvent(document, d._upEvent, d._eventCallbacks.dragRelease, !0)
        d._currMoveAxis = ""
        d._hasMoved = !1
        d._pageX = g.pageX
        d._pageY = g.pageY
        d._startPagePos = d._accelerationPos = (e ? d._thumbsHorizontal : d._slidesHorizontal)
          ? g.pageX
          : g.pageY
        d._horDir = 0
        d._verDir = 0
        d._currRenderPosition = e ? d._thumbsPosition : d._sPosition
        d._startTime = new Date().getTime()
        if (a)
          d._sliderOverflow.on(d._cancelEvent, function (a) {
            d._onDragRelease(a, e)
          })
      }
    },
    _renderMovement: function (b, e) {
      if (this._checkedAxis) {
        var d = this._renderMoveTime,
          a = b.pageX - this._pageX,
          c = b.pageY - this._pageY,
          g = this._currRenderPosition + a,
          f = this._currRenderPosition + c,
          h = e ? this._thumbsHorizontal : this._slidesHorizontal
        g = h ? g : f
        f = this._currMoveAxis
        this._hasMoved = !0
        this._pageX = b.pageX
        this._pageY = b.pageY
        "x" === f && 0 !== a
          ? (this._horDir = 0 < a ? 1 : -1)
          : "y" === f && 0 !== c && (this._verDir = 0 < c ? 1 : -1)
        f = h ? this._pageX : this._pageY
        a = h ? a : c
        e
          ? g > this._thumbsMinPosition
            ? (g = this._currRenderPosition + a * this._lastItemFriction)
            : g < this._thumbsMaxPosition &&
              (g = this._currRenderPosition + a * this._lastItemFriction)
          : this._loop ||
            (0 >= this.currSlideId &&
              0 < f - this._startPagePos &&
              (g = this._currRenderPosition + a * this._lastItemFriction),
            this.currSlideId >= this.numSlides - 1 &&
              0 > f - this._startPagePos &&
              (g = this._currRenderPosition + a * this._lastItemFriction))
        this._currRenderPosition = g
        200 < d - this._startTime && ((this._startTime = d), (this._accelerationPos = f))
        e
          ? this._setThumbsPosition(this._currRenderPosition)
          : this._isMove && this._setPosition(this._currRenderPosition)
      }
    },
    _onDragMove: function (b, e) {
      var d = this,
        a = "touchmove" === b.type
      if (!d._isTouchGesture || a) {
        if (a) {
          if (d._lockAxis) return
          var c = b.touches
          if (c) {
            if (1 < c.length) return
            var g = c[0]
          } else return
        } else g = b
        d._hasMoved ||
          (d._useCSS3Transitions &&
            (e ? d._thumbsContainer : d._slidesContainer).css(d._vendorPref + d._TD, "0s"),
          (function h() {
            d._isDragging &&
              ((d._animFrame = requestAnimationFrame(h)),
              d._renderMoveEvent && d._renderMovement(d._renderMoveEvent, e))
          })())
        if (d._checkedAxis)
          b.preventDefault(), (d._renderMoveTime = new Date().getTime()), (d._renderMoveEvent = g)
        else if (
          ((c = e ? d._thumbsHorizontal : d._slidesHorizontal),
          (g = Math.abs(g.pageX - d._pageX) - Math.abs(g.pageY - d._pageY) - (c ? -7 : 7)),
          7 < g)
        ) {
          if (c) b.preventDefault(), (d._currMoveAxis = "x")
          else if (a) {
            d._completeGesture(b)
            return
          }
          d._checkedAxis = !0
        } else if (-7 > g) {
          if (!c) b.preventDefault(), (d._currMoveAxis = "y")
          else if (a) {
            d._completeGesture(b)
            return
          }
          d._checkedAxis = !0
        }
      }
    },
    _completeGesture: function (b, e) {
      this._lockAxis = !0
      this._hasMoved = this._isDragging = !1
      this._onDragRelease(b)
    },
    _onDragRelease: function (b, e) {
      function d(a) {
        return 100 > a ? 100 : 500 < a ? 500 : a
      }
      function a(a, b) {
        if (c._isMove || e)
          (u = (-c._realId - c._idOffset) * c._slideSize),
            (g = Math.abs(c._sPosition - u)),
            (c._currAnimSpeed = g / b),
            a && (c._currAnimSpeed += 250),
            (c._currAnimSpeed = d(c._currAnimSpeed)),
            c._animateTo(u, !1)
      }
      var c = this,
        g
      var f = -1 < b.type.indexOf("touch")
      if (!c._isTouchGesture || f)
        if (
          ((c._isTouchGesture = !1),
          c.ev.trigger("rsDragRelease"),
          (c._renderMoveEvent = null),
          (c._isDragging = !1),
          (c._lockAxis = !1),
          (c._checkedAxis = !1),
          (c._renderMoveTime = 0),
          cancelAnimationFrame(c._animFrame),
          c._hasMoved &&
            (e
              ? c._setThumbsPosition(c._currRenderPosition)
              : c._isMove && c._setPosition(c._currRenderPosition)),
          c._eventCallbacks.dragMove &&
            (c._unbindPassiveEvent(document, c._moveEvent, c._eventCallbacks.dragMove, !0),
            c._unbindPassiveEvent(document, c._upEvent, c._eventCallbacks.dragRelease, !0)),
          f && c._sliderOverflow.off(c._cancelEvent),
          c._setGrabCursor(),
          !c._hasMoved && !c._multipleTouches && e && c._thumbsEnabled)
        ) {
          var h = l(b.target).closest(".rsNavItem")
          h.length && c.goTo(h.index())
        } else {
          h = e ? c._thumbsHorizontal : c._slidesHorizontal
          if (!c._hasMoved || ("y" === c._currMoveAxis && h) || ("x" === c._currMoveAxis && !h))
            if (!e && c._wasAnimating) {
              c._wasAnimating = !1
              if (c.st.navigateByClick) {
                c._mouseNext(b)
                c.dragSuccess = !0
                return
              }
              c.dragSuccess = !0
            } else {
              c._wasAnimating = !1
              c.dragSuccess = !1
              return
            }
          else c.dragSuccess = !0
          c._wasAnimating = !1
          c._currMoveAxis = ""
          var k = c.st.minSlideOffset
          f = f ? b.changedTouches[0] : b
          var m = h ? f.pageX : f.pageY,
            p = c._startPagePos,
            n = c.currSlideId,
            r = c.numSlides,
            t = h ? c._horDir : c._verDir,
            v = c._loop
          f = m - c._accelerationPos
          h = new Date().getTime() - c._startTime
          h = Math.abs(f) / h
          if (0 === t || 1 >= r) a(!0, h)
          else {
            if (!v && !e)
              if (0 >= n) {
                if (0 < t) {
                  a(!0, h)
                  return
                }
              } else if (n >= r - 1 && 0 > t) {
                a(!0, h)
                return
              }
            if (e) {
              var u = c._thumbsPosition
              if (u > c._thumbsMinPosition) u = c._thumbsMinPosition
              else if (u < c._thumbsMaxPosition) u = c._thumbsMaxPosition
              else {
                m = (h * h) / 0.006
                var q = -c._thumbsPosition
                p = c._thumbsContainerSize - c._thumbsViewportSize + c._thumbsPosition
                0 < f && m > q
                  ? ((q += c._thumbsViewportSize / (15 / ((m / h) * 0.003))),
                    (h = (h * q) / m),
                    (m = q))
                  : 0 > f &&
                    m > p &&
                    ((p += c._thumbsViewportSize / (15 / ((m / h) * 0.003))),
                    (h = (h * p) / m),
                    (m = p))
                q = Math.max(Math.round(h / 0.003), 50)
                u += m * (0 > f ? -1 : 1)
                if (u > c._thumbsMinPosition) {
                  c._animateThumbsTo(u, q, !0, c._thumbsMinPosition, 200)
                  return
                }
                if (u < c._thumbsMaxPosition) {
                  c._animateThumbsTo(u, q, !0, c._thumbsMaxPosition, 200)
                  return
                }
              }
              c._animateThumbsTo(u, q, !0)
            } else
              (q = function (a) {
                var b = Math.floor(a / c._slideSize)
                a - b * c._slideSize > k && b++
                return b
              }),
                p + k < m
                  ? 0 > t
                    ? a(!1, h)
                    : ((q = q(m - p)),
                      c._moveTo(
                        c.currSlideId - q,
                        d(
                          Math.abs(c._sPosition - (-c._realId - c._idOffset + q) * c._slideSize) / h
                        ),
                        !1,
                        !0,
                        !0
                      ))
                  : p - k > m
                  ? 0 < t
                    ? a(!1, h)
                    : ((q = q(p - m)),
                      c._moveTo(
                        c.currSlideId + q,
                        d(
                          Math.abs(c._sPosition - (-c._realId - c._idOffset - q) * c._slideSize) / h
                        ),
                        !1,
                        !0,
                        !0
                      ))
                  : a(!1, h)
          }
        }
    },
    _setPosition: function (b) {
      b = this._sPosition = b
      this._useCSS3Transitions
        ? this._slidesContainer.css(
            this._xProp,
            this._tPref1 +
              (this._slidesHorizontal ? b + this._tPref2 + 0 : 0 + this._tPref2 + b) +
              this._tPref3
          )
        : this._slidesContainer.css(this._slidesHorizontal ? this._xProp : this._yProp, b)
    },
    updateSliderSize: function (b) {
      if (this.slider) {
        if (this.st.autoScaleSlider) {
          var e = this.st.autoScaleSliderWidth,
            d = this.st.autoScaleSliderHeight
          if (this.st.autoScaleHeight) {
            var a = this.slider.width()
            a != this.width && (this.slider.css("height", (d / e) * a), (a = this.slider.width()))
            var c = this.slider.height()
          } else
            (c = this.slider.height()),
              c != this.height &&
                (this.slider.css("width", (e / d) * c), (c = this.slider.height())),
              (a = this.slider.width())
        } else (a = this.slider.width()), (c = this.slider.height())
        if (b || a != this.width || c != this.height) {
          this.width = a
          this.height = c
          this._wrapWidth = a
          this._wrapHeight = c
          this.ev.trigger("rsBeforeSizeSet")
          this.ev.trigger("rsAfterSizePropSet")
          this._sliderOverflow.css({ width: this._wrapWidth, height: this._wrapHeight })
          this._slideSize =
            (this._slidesHorizontal ? this._wrapWidth : this._wrapHeight) + this.st.slidesSpacing
          this._imagePadding = this.st.imageScalePadding
          for (a = 0; a < this.slides.length; a++)
            (b = this.slides[a]),
              (b.positionSet = !1),
              b && b.images && b.isLoaded && ((b.isRendered = !1), this._resizeImage(b))
          if (this._cloneHolders)
            for (a = 0; a < this._cloneHolders.length; a++)
              (b = this._cloneHolders[a]),
                b.holder.css(this._reorderProp, (b.id + this._idOffset) * this._slideSize)
          this._updateBlocksContent()
          this._isMove &&
            (this._useCSS3Transitions &&
              this._slidesContainer.css(this._vendorPref + "transition-duration", "0s"),
            this._setPosition((-this._realId - this._idOffset) * this._slideSize))
          this.ev.trigger("rsOnUpdateNav")
        }
        this._sliderOffset = this._sliderOverflow.offset()
        this._sliderOffset = this._sliderOffset[this._reorderProp]
      }
    },
    appendSlide: function (b, e) {
      var d = this._parseNode(b)
      if (isNaN(e) || e > this.numSlides) e = this.numSlides
      this.slides.splice(e, 0, d)
      this.slidesJQ.splice(
        e,
        0,
        l(
          '<div style="' +
            (this._isMove ? "position:absolute;" : this._opacityCSS) +
            '" class="rsSlide"></div>'
        )
      )
      e <= this.currSlideId && this.currSlideId++
      this.ev.trigger("rsOnAppendSlide", [d, e])
      this._refreshSlides(e)
      e === this.currSlideId && this.ev.trigger("rsAfterSlideChange")
    },
    removeSlide: function (b) {
      var e = this.slides[b]
      e &&
        (e.holder && e.holder.remove(),
        b < this.currSlideId && this.currSlideId--,
        this.slides.splice(b, 1),
        this.slidesJQ.splice(b, 1),
        this.ev.trigger("rsOnRemoveSlide", [b]),
        this._refreshSlides(b),
        b === this.currSlideId && this.ev.trigger("rsAfterSlideChange"))
    },
    _refreshSlides: function (b) {
      var e = this
      b = e.numSlides
      b = 0 >= e._realId ? 0 : Math.floor(e._realId / b)
      e.numSlides = e.slides.length
      0 === e.numSlides
        ? ((e.currSlideId = e._idOffset = e._realId = 0), (e.currSlide = e._oldHolder = null))
        : (e._realId = b * e.numSlides + e.currSlideId)
      for (b = 0; b < e.numSlides; b++) e.slides[b].id = b
      e.currSlide = e.slides[e.currSlideId]
      e._currHolder = e.slidesJQ[e.currSlideId]
      e.currSlideId >= e.numSlides ? e.goTo(e.numSlides - 1) : 0 > e.currSlideId && e.goTo(0)
      e._refreshNumPreloadImages()
      e._isMove && e._slidesContainer.css(e._vendorPref + e._TD, "0ms")
      e._refreshSlidesTimeout && clearTimeout(e._refreshSlidesTimeout)
      e._refreshSlidesTimeout = setTimeout(function () {
        e._isMove && e._setPosition((-e._realId - e._idOffset) * e._slideSize)
        e._updateBlocksContent()
        e._isMove || e._currHolder.css({ display: "block", opacity: 1 })
      }, 14)
      e.ev.trigger("rsOnUpdateNav")
    },
    _setGrabCursor: function () {
      this._hasDrag &&
        this._isMove &&
        (this._grabCursor
          ? this._sliderOverflow.css("cursor", this._grabCursor)
          : (this._sliderOverflow.removeClass("grabbing-cursor"),
            this._sliderOverflow.addClass("grab-cursor")))
    },
    _setGrabbingCursor: function () {
      this._hasDrag &&
        this._isMove &&
        (this._grabbingCursor
          ? this._sliderOverflow.css("cursor", this._grabbingCursor)
          : (this._sliderOverflow.removeClass("grab-cursor"),
            this._sliderOverflow.addClass("grabbing-cursor")))
    },
    next: function (b) {
      this._moveTo("next", this.st.transitionSpeed, !0, !b)
    },
    prev: function (b) {
      this._moveTo("prev", this.st.transitionSpeed, !0, !b)
    },
    _moveTo: function (b, e, d, a, c) {
      var g = this
      g.ev.trigger("rsBeforeMove", [b, a])
      var f =
        "next" === b ? g.currSlideId + 1 : "prev" === b ? g.currSlideId - 1 : (b = parseInt(b, 10))
      if (!g._loop) {
        if (0 > f) {
          g._doBackAndForthAnim("left", !a)
          return
        }
        if (f >= g.numSlides) {
          g._doBackAndForthAnim("right", !a)
          return
        }
      }
      g._isAnimating && (g._stopAnimation(!0), (d = !1))
      var h = f - g.currSlideId
      f = g._prevSlideId = g.currSlideId
      var k = g.currSlideId + h
      a = g._realId
      var m
      g._loop ? ((k = g._updateBlocksContent(!1, k)), (a += h)) : (a = k)
      g._newSlideId = k
      g._oldHolder = g.slidesJQ[g.currSlideId]
      g._realId = a
      g.currSlideId = g._newSlideId
      g.currSlide = g.slides[g.currSlideId]
      g._currHolder = g.slidesJQ[g.currSlideId]
      k = g.st.slidesDiff
      var l = 0 < h
      h = Math.abs(h)
      var n = Math.floor(f / g._numPreloadImages),
        r = Math.floor((f + (l ? k : -k)) / g._numPreloadImages)
      n =
        (l ? Math.max(n, r) : Math.min(n, r)) * g._numPreloadImages +
        (l ? g._numPreloadImages - 1 : 0)
      n > g.numSlides - 1 ? (n = g.numSlides - 1) : 0 > n && (n = 0)
      f = l ? n - f : f - n
      f > g._numPreloadImages && (f = g._numPreloadImages)
      if (h > f + k)
        for (g._idOffset += (h - (f + k)) * (l ? -1 : 1), e *= 1.4, f = 0; f < g.numSlides; f++)
          g.slides[f].positionSet = !1
      g._currAnimSpeed = e
      g._updateBlocksContent(!0)
      c || (m = !0)
      var t = (-a - g._idOffset) * g._slideSize
      m
        ? setTimeout(function () {
            g._isWorking = !1
            g._animateTo(t, b, !1, d)
            g.ev.trigger("rsOnUpdateNav")
          }, 0)
        : (g._animateTo(t, b, !1, d), g.ev.trigger("rsOnUpdateNav"))
    },
    _updateArrowsNav: function () {
      this.st.arrowsNav &&
        (1 >= this.numSlides
          ? (this._arrowLeft.css("display", "none"), this._arrowRight.css("display", "none"))
          : (this._arrowLeft.css("display", "block"),
            this._arrowRight.css("display", "block"),
            this._loop ||
              this.st.loopRewind ||
              (0 === this.currSlideId
                ? this._arrowLeft.addClass("rsArrowDisabled")
                : this._arrowLeft.removeClass("rsArrowDisabled"),
              this.currSlideId === this.numSlides - 1
                ? this._arrowRight.addClass("rsArrowDisabled")
                : this._arrowRight.removeClass("rsArrowDisabled"))))
    },
    _animateTo: function (b, e, d, a, c) {
      function g() {
        var a
        k &&
          (a = k.data("rsTimeout")) &&
          (k !== m && k.css({ opacity: 0, display: "none", zIndex: 0 }),
          clearTimeout(a),
          k.data("rsTimeout", ""))
        if ((a = m.data("rsTimeout"))) clearTimeout(a), m.data("rsTimeout", "")
      }
      var f = this,
        h = {}
      isNaN(f._currAnimSpeed) && (f._currAnimSpeed = 400)
      f._sPosition = f._currRenderPosition = b
      f.ev.trigger("rsBeforeAnimStart")
      if (f._useCSS3Transitions)
        if (f._isMove)
          (f._currAnimSpeed = parseInt(f._currAnimSpeed, 10)),
            (d = f._vendorPref + f._TTF),
            (h[f._vendorPref + f._TD] = f._currAnimSpeed + "ms"),
            (h[d] = a ? l.rsCSS3Easing[f.st.easeInOut] : l.rsCSS3Easing[f.st.easeOut]),
            f._slidesContainer.css(h),
            a || !f.hasTouch
              ? setTimeout(function () {
                  f._setPosition(b)
                }, 5)
              : f._setPosition(b)
        else {
          f._currAnimSpeed = f.st.transitionSpeed
          var k = f._oldHolder
          var m = f._currHolder
          m.data("rsTimeout") && m.css("opacity", 0)
          g()
          k &&
            k.data(
              "rsTimeout",
              setTimeout(function () {
                h[f._vendorPref + f._TD] = "0ms"
                h.zIndex = 0
                h.display = "none"
                k.data("rsTimeout", "")
                k.css(h)
                setTimeout(function () {
                  k.css("opacity", 0)
                }, 16)
              }, f._currAnimSpeed + 60)
            )
          h.display = "block"
          h.zIndex = f._fadeZIndex
          h.opacity = 0
          h[f._vendorPref + f._TD] = "0ms"
          h[f._vendorPref + f._TTF] = l.rsCSS3Easing[f.st.easeInOut]
          m.css(h)
          m.data(
            "rsTimeout",
            setTimeout(function () {
              m.css(f._vendorPref + f._TD, f._currAnimSpeed + "ms")
              m.data(
                "rsTimeout",
                setTimeout(function () {
                  m.css("opacity", 1)
                  m.data("rsTimeout", "")
                }, 20)
              )
            }, 20)
          )
        }
      else
        f._isMove
          ? ((h[f._slidesHorizontal ? f._xProp : f._yProp] = b + "px"),
            f._slidesContainer.animate(h, f._currAnimSpeed, a ? f.st.easeInOut : f.st.easeOut))
          : ((k = f._oldHolder),
            (m = f._currHolder),
            m.stop(!0, !0).css({ opacity: 0, display: "block", zIndex: f._fadeZIndex }),
            (f._currAnimSpeed = f.st.transitionSpeed),
            m.animate({ opacity: 1 }, f._currAnimSpeed, f.st.easeInOut),
            g(),
            k &&
              k.data(
                "rsTimeout",
                setTimeout(function () {
                  k.stop(!0, !0).css({ opacity: 0, display: "none", zIndex: 0 })
                }, f._currAnimSpeed + 60)
              ))
      f._isAnimating = !0
      f.loadingTimeout && clearTimeout(f.loadingTimeout)
      f.loadingTimeout = c
        ? setTimeout(function () {
            f.loadingTimeout = null
            c.call()
          }, f._currAnimSpeed + 60)
        : setTimeout(function () {
            f.loadingTimeout = null
            f._animationComplete(e)
          }, f._currAnimSpeed + 60)
    },
    _stopAnimation: function (b) {
      this._isAnimating = !1
      clearTimeout(this.loadingTimeout)
      if (this._isMove)
        if (!this._useCSS3Transitions)
          this._slidesContainer.stop(!0),
            (this._sPosition = parseInt(
              this._slidesContainer.css(this._slidesHorizontal ? this._xProp : this._yProp),
              10
            ))
        else {
          if (!b) {
            b = this._sPosition
            var e = (this._currRenderPosition = this._getTransformProp())
            this._slidesContainer.css(this._vendorPref + this._TD, "0ms")
            b !== e && this._setPosition(e)
          }
        }
      else 20 < this._fadeZIndex ? (this._fadeZIndex = 10) : this._fadeZIndex++
    },
    _getTransformProp: function () {
      var b = window
          .getComputedStyle(this._slidesContainer.get(0), null)
          .getPropertyValue(this._vendorPref + "transform")
          .replace(/^matrix\(/i, "")
          .split(/, |\)$/g),
        e = 0 === b[0].indexOf("matrix3d")
      return parseInt(b[this._slidesHorizontal ? (e ? 12 : 4) : e ? 13 : 5], 10)
    },
    _getCSS3Prop: function (b, e) {
      return this._useCSS3Transitions
        ? this._tPref1 + (e ? b + this._tPref2 + 0 : 0 + this._tPref2 + b) + this._tPref3
        : b
    },
    _animationComplete: function (b) {
      this._isMove || (this._currHolder.css("z-index", 0), (this._fadeZIndex = 10))
      this._isAnimating = !1
      this.staticSlideId = this.currSlideId
      this._updateBlocksContent()
      this._slidesMoved = !1
      this.ev.trigger("rsAfterSlideChange")
    },
    _doBackAndForthAnim: function (b, e) {
      var d = this,
        a = (-d._realId - d._idOffset) * d._slideSize
      if (0 !== d.numSlides && !d._isAnimating)
        if (d.st.loopRewind) d.goTo("left" === b ? d.numSlides - 1 : 0, e)
        else if (d._isMove) {
          d._currAnimSpeed = 200
          var c = function () {
            d._isAnimating = !1
          }
          d._animateTo(a + ("left" === b ? 30 : -30), "", !1, !0, function () {
            d._isAnimating = !1
            d._animateTo(a, "", !1, !0, c)
          })
        }
    },
    _detectPassiveSupport: function () {
      var b = this
      if (!b._passiveChecked) {
        b._passiveChecked = !0
        b._passiveParam = !1
        try {
          var e = Object.defineProperty({}, "passive", {
            get: function () {
              b._passiveParam = { passive: !1 }
            }
          })
          window.addEventListener("testPassive", null, e)
          window.removeEventListener("testPassive", null, e)
        } catch (d) {}
      }
    },
    _bindPassiveEvent: function (b, e, d, a) {
      this._detectPassiveSupport()
      e = e.split(" ")
      for (var c = 0; c < e.length; c++)
        e[c] && 2 < e[c].length && b.addEventListener(e[c], d, a ? this._passiveParam : !1)
    },
    _unbindPassiveEvent: function (b, e, d, a) {
      this._detectPassiveSupport()
      e = e.split(" ")
      for (var c = 0; c < e.length; c++)
        e[c] && 2 < e[c].length && b.removeEventListener(e[c], d, a ? this._passiveParam : !1)
    },
    _resizeImage: function (b, e) {
      if (!b.isRendered) {
        var d = b.content,
          a = "rsMainSlideImage",
          c = l.isFunction(this.st.imageAlignCenter)
            ? this.st.imageAlignCenter(b)
            : this.st.imageAlignCenter,
          g = l.isFunction(this.st.imageScaleMode)
            ? this.st.imageScaleMode(b)
            : this.st.imageScaleMode
        if (b.videoURL)
          if (((a = "rsVideoContainer"), "fill" !== g)) var f = !0
          else {
            var h = d
            h.hasClass(a) || (h = h.find("." + a))
            h.css({ width: "100%", height: "100%" })
            a = "rsMainSlideImage"
          }
        d.hasClass(a) || (d = d.find("." + a))
        if (d) {
          var k = b.iW,
            m = b.iH
          b.isRendered = !0
          if ("none" !== g || c) {
            a = "fill" !== g ? this._imagePadding : 0
            h = this._wrapWidth - 2 * a
            var p = this._wrapHeight - 2 * a,
              n = {}
            "fit-if-smaller" === g && (k > h || m > p) && (g = "fit")
            if ("fill" === g || "fit" === g) {
              var r = h / k
              var t = p / m
              r = "fill" == g ? (r > t ? r : t) : "fit" == g ? (r < t ? r : t) : 1
              k = Math.ceil(k * r, 10)
              m = Math.ceil(m * r, 10)
            }
            "none" !== g &&
              ((n.width = k),
              (n.height = m),
              f && d.find(".rsImg").css({ width: "100%", height: "100%" }))
            c &&
              ((n.marginLeft = Math.floor((h - k) / 2) + a),
              (n.marginTop = Math.floor((p - m) / 2) + a))
            d.css(n)
          }
        }
      }
    }
  }
  l.rsProto = v.prototype
  l.fn.royalSlider = function (b) {
    var e = arguments
    return this.each(function () {
      var d = l(this)
      if ("object" !== typeof b && b) {
        if ((d = d.data("royalSlider")) && d[b])
          return d[b].apply(d, Array.prototype.slice.call(e, 1))
      } else d.data("royalSlider") || d.data("royalSlider", new v(d, b))
    })
  }
  l.fn.royalSlider.defaults = {
    slidesSpacing: 8,
    startSlideId: 0,
    loop: !1,
    loopRewind: !1,
    numImagesToPreload: 4,
    fadeinLoadedSlide: !0,
    slidesOrientation: "horizontal",
    transitionType: "move",
    transitionSpeed: 600,
    controlNavigation: "bullets",
    controlsInside: !0,
    arrowsNav: !0,
    arrowsNavAutoHide: !0,
    navigateByClick: !0,
    randomizeSlides: !1,
    sliderDrag: !0,
    sliderTouch: !0,
    keyboardNavEnabled: !1,
    fadeInAfterLoaded: !0,
    allowCSS3: !0,
    allowCSS3OnWebkit: !0,
    addActiveClass: !1,
    autoHeight: !1,
    easeOut: "easeOutSine",
    easeInOut: "easeInOutSine",
    minSlideOffset: 10,
    imageScaleMode: "fit-if-smaller",
    imageAlignCenter: !0,
    imageScalePadding: 4,
    usePreloader: !0,
    autoScaleSlider: !1,
    autoScaleSliderWidth: 800,
    autoScaleSliderHeight: 400,
    autoScaleHeight: !0,
    arrowsNavHideOnTouch: !1,
    globalCaption: !1,
    slidesDiff: 2
  }
  l.rsCSS3Easing = {
    easeOutSine: "cubic-bezier(0.390, 0.575, 0.565, 1.000)",
    easeInOutSine: "cubic-bezier(0.445, 0.050, 0.550, 0.950)"
  }
  l.extend(jQuery.easing, {
    easeInOutSine: function (b, e, d, a, c) {
      return (-a / 2) * (Math.cos((Math.PI * e) / c) - 1) + d
    },
    easeOutSine: function (b, e, d, a, c) {
      return a * Math.sin((e / c) * (Math.PI / 2)) + d
    },
    easeOutCubic: function (b, e, d, a, c) {
      return a * ((e = e / c - 1) * e * e + 1) + d
    }
  })
})(jQuery, window)
// jquery.rs.bullets v1.0.1
;(function (c) {
  c.extend(c.rsProto, {
    _initBullets: function () {
      var a = this
      "bullets" === a.st.controlNavigation &&
        (a.ev.one("rsAfterPropsSetup", function () {
          a._controlNavEnabled = !0
          a.slider.addClass("rsWithBullets")
          for (var b = '<div class="rsNav rsBullets">', e = 0; e < a.numSlides; e++)
            b += '<div class="rsNavItem rsBullet"><span></span></div>'
          a._controlNav = b = c(b + "</div>")
          a._controlNavItems = b.appendTo(a.slider).children()
          a._controlNav.on("click.rs", ".rsNavItem", function (b) {
            a._thumbsDrag || a.goTo(c(this).index())
          })
        }),
        a.ev.on("rsOnAppendSlide", function (b, c, d) {
          d >= a.numSlides
            ? a._controlNav.append('<div class="rsNavItem rsBullet"><span></span></div>')
            : a._controlNavItems.eq(d).before('<div class="rsNavItem rsBullet"><span></span></div>')
          a._controlNavItems = a._controlNav.children()
        }),
        a.ev.on("rsOnRemoveSlide", function (b, c) {
          var d = a._controlNavItems.eq(c)
          d && d.length && (d.remove(), (a._controlNavItems = a._controlNav.children()))
        }),
        a.ev.on("rsOnUpdateNav", function () {
          var b = a.currSlideId
          a._prevNavItem && a._prevNavItem.removeClass("rsNavSelected")
          b = a._controlNavItems.eq(b)
          b.addClass("rsNavSelected")
          a._prevNavItem = b
        }))
    }
  })
  c.rsModules.bullets = c.rsProto._initBullets
})(jQuery) // jquery.rs.thumbnails v1.0.9
;(function (g) {
  g.extend(g.rsProto, {
    _initThumbs: function () {
      var a = this
      "thumbnails" === a.st.controlNavigation &&
        ((a._thumbsDefaults = {
          drag: !0,
          touch: !0,
          orientation: "horizontal",
          navigation: !0,
          arrows: !0,
          arrowLeft: null,
          arrowRight: null,
          spacing: 4,
          arrowsAutoHide: !1,
          appendSpan: !1,
          transitionSpeed: 600,
          autoCenter: !0,
          fitInViewport: !0,
          firstMargin: !0,
          paddingTop: 0,
          paddingBottom: 0
        }),
        (a.st.thumbs = g.extend({}, a._thumbsDefaults, a.st.thumbs)),
        (a._firstThumbMoved = !0),
        !1 === a.st.thumbs.firstMargin
          ? (a.st.thumbs.firstMargin = 0)
          : !0 === a.st.thumbs.firstMargin && (a.st.thumbs.firstMargin = a.st.thumbs.spacing),
        a.ev.on("rsBeforeParseNode", function (a, b, c) {
          b = g(b)
          c.thumbnail = b.find(".rsTmb").remove()
          c.thumbnail.length
            ? (c.thumbnail = g(document.createElement("div")).append(c.thumbnail).html())
            : ((c.thumbnail = b.attr("data-rsTmb")),
              c.thumbnail || (c.thumbnail = b.find(".rsImg").attr("data-rsTmb")),
              (c.thumbnail = c.thumbnail ? '<img src="' + c.thumbnail + '"/>' : ""))
        }),
        a.ev.one("rsAfterPropsSetup", function () {
          a._createThumbs()
        }),
        (a._prevNavItem = null),
        a.ev.on("rsOnUpdateNav", function () {
          var d = g(a._controlNavItems[a.currSlideId])
          d !== a._prevNavItem &&
            (a._prevNavItem &&
              (a._prevNavItem.removeClass("rsNavSelected"), (a._prevNavItem = null)),
            a._thumbsNavigation && a._setCurrentThumb(a.currSlideId),
            (a._prevNavItem = d.addClass("rsNavSelected")))
        }),
        a.ev.on("rsOnAppendSlide", function (d, b, c) {
          d =
            "<div" +
            a._thumbsMargin +
            ' class="rsNavItem rsThumb">' +
            a._addThumbHTML +
            b.thumbnail +
            "</div>"
          a._useCSS3Transitions &&
            a._thumbsContainer.css(a._vendorPref + "transition-duration", "0ms")
          c >= a.numSlides ? a._thumbsContainer.append(d) : a._controlNavItems.eq(c).before(d)
          a._controlNavItems = a._thumbsContainer.children()
          a.updateThumbsSize(!0)
        }),
        a.ev.on("rsOnRemoveSlide", function (d, b) {
          var c = a._controlNavItems.eq(b)
          c &&
            (a._useCSS3Transitions &&
              a._thumbsContainer.css(a._vendorPref + "transition-duration", "0ms"),
            c.remove(),
            (a._controlNavItems = a._thumbsContainer.children()),
            a.updateThumbsSize(!0))
        }))
    },
    _createThumbs: function () {
      var a = this,
        d = "rsThumbs",
        b = a.st.thumbs,
        c = "",
        f,
        e = b.spacing
      a._controlNavEnabled = !0
      a._thumbsHorizontal = "vertical" === b.orientation ? !1 : !0
      a._thumbsMargin = f = e
        ? ' style="margin-' + (a._thumbsHorizontal ? "right" : "bottom") + ":" + e + 'px;"'
        : ""
      a._thumbsPosition = 0
      a._isThumbsAnimating = !1
      a._thumbsDrag = !1
      a._thumbsNavigation = !1
      a._thumbsArrows = b.arrows && b.navigation
      var h = a._thumbsHorizontal ? "Hor" : "Ver"
      a.slider.addClass("rsWithThumbs rsWithThumbs" + h)
      c += '<div class="rsNav rsThumbs rsThumbs' + h + '"><div class="' + d + 'Container">'
      a._addThumbHTML = b.appendSpan ? '<span class="thumbIco"></span>' : ""
      for (var k = 0; k < a.numSlides; k++)
        (h = a.slides[k]),
          (c +=
            "<div" + f + ' class="rsNavItem rsThumb">' + h.thumbnail + a._addThumbHTML + "</div>")
      c = g(c + "</div></div>")
      f = {}
      b.paddingTop && (f[a._thumbsHorizontal ? "paddingTop" : "paddingLeft"] = b.paddingTop)
      b.paddingBottom &&
        (f[a._thumbsHorizontal ? "paddingBottom" : "paddingRight"] = b.paddingBottom)
      c.css(f)
      a._thumbsContainer = g(c).find("." + d + "Container")
      a._thumbsArrows &&
        ((d += "Arrow"),
        b.arrowLeft
          ? (a._thumbsArrowLeft = b.arrowLeft)
          : ((a._thumbsArrowLeft = g(
              '<div class="' + d + " " + d + 'Left"><div class="' + d + 'Icn"></div></div>'
            )),
            c.append(a._thumbsArrowLeft)),
        b.arrowRight
          ? (a._thumbsArrowRight = b.arrowRight)
          : ((a._thumbsArrowRight = g(
              '<div class="' + d + " " + d + 'Right"><div class="' + d + 'Icn"></div></div>'
            )),
            c.append(a._thumbsArrowRight)),
        a._thumbsArrowLeft.click(function () {
          var b =
            (Math.floor(a._thumbsPosition / a._thumbSize) + a._visibleThumbsPerView) *
              a._thumbSize +
            a.st.thumbs.firstMargin
          a._animateThumbsTo(b > a._thumbsMinPosition ? a._thumbsMinPosition : b)
        }),
        a._thumbsArrowRight.click(function () {
          var b =
            (Math.floor(a._thumbsPosition / a._thumbSize) - a._visibleThumbsPerView) *
              a._thumbSize +
            a.st.thumbs.firstMargin
          a._animateThumbsTo(b < a._thumbsMaxPosition ? a._thumbsMaxPosition : b)
        }),
        b.arrowsAutoHide &&
          !a.hasTouch &&
          (a._thumbsArrowLeft.css("opacity", 0),
          a._thumbsArrowRight.css("opacity", 0),
          c.one("mousemove.rsarrowshover", function () {
            a._thumbsNavigation &&
              (a._thumbsArrowLeft.css("opacity", 1), a._thumbsArrowRight.css("opacity", 1))
          }),
          c.hover(
            function () {
              a._thumbsNavigation &&
                (a._thumbsArrowLeft.css("opacity", 1), a._thumbsArrowRight.css("opacity", 1))
            },
            function () {
              a._thumbsNavigation &&
                (a._thumbsArrowLeft.css("opacity", 0), a._thumbsArrowRight.css("opacity", 0))
            }
          )))
      a._controlNav = c
      a._controlNavItems = a._thumbsContainer.children()
      a.msEnabled &&
        a.st.thumbs.navigation &&
        a._thumbsContainer.css("-ms-touch-action", a._thumbsHorizontal ? "pan-y" : "pan-x")
      a.slider.append(c)
      a._thumbsEnabled = !0
      a._thumbsSpacing = e
      b.navigation &&
        a._useCSS3Transitions &&
        a._thumbsContainer.css(a._vendorPref + "transition-property", a._vendorPref + "transform")
      a._controlNav.on("click.rs", ".rsNavItem", function (b) {
        a._thumbsDrag || a.goTo(g(this).index())
      })
      a.ev.off("rsBeforeSizeSet.thumbs").on("rsBeforeSizeSet.thumbs", function () {
        a._realWrapSize = a._thumbsHorizontal ? a._wrapHeight : a._wrapWidth
        a.updateThumbsSize(!0)
      })
      a.ev.off("rsAutoHeightChange.thumbs").on("rsAutoHeightChange.thumbs", function (b, c) {
        a.updateThumbsSize(!0, c)
      })
    },
    updateThumbsSize: function (a, d) {
      var b = this._controlNavItems.first(),
        c = {},
        f = this._controlNavItems.length
      this._thumbSize =
        (this._thumbsHorizontal ? b.outerWidth() : b.outerHeight()) + this._thumbsSpacing
      this._thumbsContainerSize = f * this._thumbSize - this._thumbsSpacing
      c[this._thumbsHorizontal ? "width" : "height"] =
        this._thumbsContainerSize + this._thumbsSpacing
      this._thumbsViewportSize = this._thumbsHorizontal
        ? this._controlNav.width()
        : void 0 !== d
        ? d
        : this._controlNav.height()
      this._thumbsEnabled &&
        (this.isFullscreen || this.st.thumbs.fitInViewport) &&
        (this._thumbsHorizontal
          ? (this._wrapHeight = this._realWrapSize - this._controlNav.outerHeight())
          : (this._wrapWidth = this._realWrapSize - this._controlNav.outerWidth()))
      this._thumbsViewportSize &&
        ((this._thumbsMaxPosition =
          -(this._thumbsContainerSize - this._thumbsViewportSize) - this.st.thumbs.firstMargin),
        (this._thumbsMinPosition = this.st.thumbs.firstMargin),
        (this._visibleThumbsPerView = Math.floor(this._thumbsViewportSize / this._thumbSize)),
        this._thumbsContainerSize < this._thumbsViewportSize
          ? (this.st.thumbs.autoCenter
              ? this._setThumbsPosition((this._thumbsViewportSize - this._thumbsContainerSize) / 2)
              : this._setThumbsPosition(this._thumbsMinPosition),
            this.st.thumbs.arrows &&
              this._thumbsArrowLeft &&
              (this._thumbsArrowLeft.addClass("rsThumbsArrowDisabled"),
              this._thumbsArrowRight.addClass("rsThumbsArrowDisabled")),
            (this._thumbsDrag = this._thumbsNavigation = !1),
            this._unbindPassiveEvent(
              this._controlNav[0],
              this._downEvent,
              this._eventCallbacks.dragStartThumb,
              !1
            ))
          : this.st.thumbs.navigation &&
            !this._thumbsNavigation &&
            ((this._thumbsNavigation = !0),
            (!this.hasTouch && this.st.thumbs.drag) || (this.hasTouch && this.st.thumbs.touch)) &&
            ((this._thumbsDrag = !0),
            this._bindPassiveEvent(
              this._controlNav[0],
              this._downEvent,
              this._eventCallbacks.dragStartThumb,
              !1
            )),
        this._thumbsContainer.css(c),
        a && d && this._setCurrentThumb(this.currSlideId, !0))
    },
    setThumbsOrientation: function (a, d) {
      this._thumbsEnabled &&
        ((this.st.thumbs.orientation = a),
        this._controlNav.remove(),
        this.slider.removeClass("rsWithThumbsHor rsWithThumbsVer"),
        this._createThumbs(),
        this._unbindPassiveEvent(
          this._controlNav[0],
          this._downEvent,
          this._eventCallbacks.dragStartThumb,
          !1
        ),
        d || this.updateSliderSize(!0))
    },
    _setThumbsPosition: function (a) {
      this._thumbsPosition = a
      this._useCSS3Transitions
        ? this._thumbsContainer.css(
            this._xProp,
            this._tPref1 +
              (this._thumbsHorizontal ? a + this._tPref2 + 0 : 0 + this._tPref2 + a) +
              this._tPref3
          )
        : this._thumbsContainer.css(this._thumbsHorizontal ? this._xProp : this._yProp, a)
    },
    _animateThumbsTo: function (a, d, b, c, f) {
      var e = this
      if (e._thumbsNavigation) {
        d || (d = e.st.thumbs.transitionSpeed)
        e._thumbsPosition = a
        e._thumbsAnimTimeout && clearTimeout(e._thumbsAnimTimeout)
        e._isThumbsAnimating && (e._useCSS3Transitions || e._thumbsContainer.stop(), (b = !0))
        var h = {}
        e._isThumbsAnimating = !0
        e._useCSS3Transitions
          ? ((h[e._vendorPref + "transition-duration"] = d + "ms"),
            (h[e._vendorPref + "transition-timing-function"] = b
              ? g.rsCSS3Easing[e.st.easeOut]
              : g.rsCSS3Easing[e.st.easeInOut]),
            e._thumbsContainer.css(h),
            e._setThumbsPosition(a))
          : ((h[e._thumbsHorizontal ? e._xProp : e._yProp] = a + "px"),
            e._thumbsContainer.animate(h, d, b ? "easeOutCubic" : e.st.easeInOut))
        c && (e._thumbsPosition = c)
        e._updateThumbsArrows()
        e._thumbsAnimTimeout = setTimeout(function () {
          e._isThumbsAnimating = !1
          f && (e._animateThumbsTo(c, f, !0), (f = null))
        }, d)
      }
    },
    _updateThumbsArrows: function () {
      this._thumbsArrows &&
        (this._thumbsPosition === this._thumbsMinPosition
          ? this._thumbsArrowLeft.addClass("rsThumbsArrowDisabled")
          : this._thumbsArrowLeft.removeClass("rsThumbsArrowDisabled"),
        this._thumbsPosition === this._thumbsMaxPosition
          ? this._thumbsArrowRight.addClass("rsThumbsArrowDisabled")
          : this._thumbsArrowRight.removeClass("rsThumbsArrowDisabled"))
    },
    _setCurrentThumb: function (a, d) {
      var b = 0,
        c =
          a * this._thumbSize + 2 * this._thumbSize - this._thumbsSpacing + this._thumbsMinPosition
      if (this._thumbsNavigation) {
        this._firstThumbMoved && ((d = !0), (this._firstThumbMoved = !1))
        if (c + this._thumbsPosition > this._thumbsViewportSize) {
          a === this.numSlides - 1 && (b = 1)
          var f = -a + this._visibleThumbsPerView - 2 + b
          f =
            f * this._thumbSize +
            (this._thumbsViewportSize % this._thumbSize) +
            this._thumbsSpacing -
            this._thumbsMinPosition
        } else
          0 !== a
            ? (a - 1) * this._thumbSize <= -this._thumbsPosition + this._thumbsMinPosition &&
              a - 1 <= this.numSlides - this._visibleThumbsPerView &&
              (f = (-a + 1) * this._thumbSize + this._thumbsMinPosition)
            : (f = this._thumbsMinPosition)
        f !== this._thumbsPosition &&
          ((b = void 0 === f ? this._thumbsPosition : f),
          b > this._thumbsMinPosition
            ? this._setThumbsPosition(this._thumbsMinPosition)
            : b < this._thumbsMaxPosition
            ? this._setThumbsPosition(this._thumbsMaxPosition)
            : void 0 !== f && (d ? this._setThumbsPosition(f) : this._animateThumbsTo(f)))
        this._updateThumbsArrows()
      }
    }
  })
  g.rsModules.thumbnails = g.rsProto._initThumbs
})(jQuery) // jquery.rs.tabs v1.0.2
;(function (e) {
  e.extend(e.rsProto, {
    _initTabs: function () {
      var a = this
      "tabs" === a.st.controlNavigation &&
        (a.ev.on("rsBeforeParseNode", function (a, d, b) {
          d = e(d)
          b.thumbnail = d.find(".rsTmb").remove()
          b.thumbnail.length
            ? (b.thumbnail = e(document.createElement("div")).append(b.thumbnail).html())
            : ((b.thumbnail = d.attr("data-rsTmb")),
              b.thumbnail || (b.thumbnail = d.find(".rsImg").attr("data-rsTmb")),
              (b.thumbnail = b.thumbnail ? '<img src="' + b.thumbnail + '"/>' : ""))
        }),
        a.ev.one("rsAfterPropsSetup", function () {
          a._createTabs()
        }),
        a.ev.on("rsOnAppendSlide", function (c, d, b) {
          b >= a.numSlides
            ? a._controlNav.append('<div class="rsNavItem rsTab">' + d.thumbnail + "</div>")
            : a._controlNavItems
                .eq(b)
                .before('<div class="rsNavItem rsTab">' + item.thumbnail + "</div>")
          a._controlNavItems = a._controlNav.children()
        }),
        a.ev.on("rsOnRemoveSlide", function (c, d) {
          var b = a._controlNavItems.eq(d)
          b && (b.remove(), (a._controlNavItems = a._controlNav.children()))
        }),
        a.ev.on("rsOnUpdateNav", function () {
          var c = a.currSlideId
          a._prevNavItem && a._prevNavItem.removeClass("rsNavSelected")
          c = a._controlNavItems.eq(c)
          c.addClass("rsNavSelected")
          a._prevNavItem = c
        }))
    },
    _createTabs: function () {
      var a = this
      a._controlNavEnabled = !0
      var c = '<div class="rsNav rsTabs">'
      for (var d = 0; d < a.numSlides; d++)
        c += '<div class="rsNavItem rsTab">' + a.slides[d].thumbnail + "</div>"
      c = e(c + "</div>")
      a._controlNav = c
      a._controlNavItems = c.children(".rsNavItem")
      a.slider.append(c)
      a._controlNav.click(function (b) {
        b = e(b.target).closest(".rsNavItem")
        b.length && a.goTo(b.index())
      })
    }
  })
  e.rsModules.tabs = e.rsProto._initTabs
})(jQuery) // jquery.rs.fullscreen v1.0.6
;(function (c) {
  c.extend(c.rsProto, {
    _initFullscreen: function () {
      var a = this
      a._fullscreenDefaults = {
        enabled: !1,
        keyboardNav: !0,
        buttonFS: !0,
        nativeFS: !1,
        doubleTap: !0
      }
      a.st.fullscreen = c.extend({}, a._fullscreenDefaults, a.st.fullscreen)
      if (a.st.fullscreen.enabled)
        a.ev.one("rsBeforeSizeSet", function () {
          a._setupFullscreen()
        })
    },
    _setupFullscreen: function () {
      var a = this
      a._fsKeyboard = !a.st.keyboardNavEnabled && a.st.fullscreen.keyboardNav
      if (a.st.fullscreen.nativeFS) {
        var b = {
            supportsFullScreen: !1,
            isFullScreen: function () {
              return !1
            },
            requestFullScreen: function () {},
            cancelFullScreen: function () {},
            fullScreenEventName: "",
            prefix: ""
          },
          d = ["webkit", "moz", "o", "ms", "khtml"]
        if ("undefined" != typeof document.cancelFullScreen) b.supportsFullScreen = !0
        else
          for (var e = 0, f = d.length; e < f; e++)
            if (
              ((b.prefix = d[e]), "undefined" != typeof document[b.prefix + "CancelFullScreen"])
            ) {
              b.supportsFullScreen = !0
              break
            }
        b.supportsFullScreen
          ? ((a.nativeFS = !0),
            (b.fullScreenEventName = b.prefix + "fullscreenchange" + a.ns),
            (b.isFullScreen = function () {
              switch (this.prefix) {
                case "":
                  return document.fullScreen
                case "webkit":
                  return document.webkitIsFullScreen
                default:
                  return document[this.prefix + "FullScreen"]
              }
            }),
            (b.requestFullScreen = function (a) {
              return "" === this.prefix
                ? a.requestFullScreen()
                : a[this.prefix + "RequestFullScreen"]()
            }),
            (b.cancelFullScreen = function (a) {
              return "" === this.prefix
                ? document.cancelFullScreen()
                : document[this.prefix + "CancelFullScreen"]()
            }),
            (a._fullScreenApi = b))
          : (a._fullScreenApi = !1)
      }
      a.st.fullscreen.buttonFS &&
        (a._fsBtn = c('<div class="rsFullscreenBtn"><div class="rsFullscreenIcn"></div></div>')
          .appendTo(a._controlsContainer)
          .on("click.rs", function () {
            a.isFullscreen ? a.exitFullscreen() : a.enterFullscreen()
          }))
    },
    enterFullscreen: function (a) {
      var b = this
      if (b._fullScreenApi)
        if (a) b._fullScreenApi.requestFullScreen(c("html")[0])
        else {
          b._doc.on(b._fullScreenApi.fullScreenEventName, function (a) {
            b._fullScreenApi.isFullScreen() ? b.enterFullscreen(!0) : b.exitFullscreen(!0)
          })
          b._fullScreenApi.requestFullScreen(c("html")[0])
          return
        }
      if (!b._isFullscreenUpdating) {
        b._isFullscreenUpdating = !0
        b._doc.on("keyup" + b.ns + "fullscreen", function (a) {
          27 === a.keyCode && b.exitFullscreen()
        })
        b._fsKeyboard && b._bindKeyboardNav()
        a = c(window)
        b._fsScrollTopOnEnter = a.scrollTop()
        b._fsScrollLeftOnEnter = a.scrollLeft()
        b._htmlStyle = c("html").attr("style")
        b._bodyStyle = c("body").attr("style")
        b._sliderStyle = b.slider.attr("style")
        c("body, html").css({
          overflow: "hidden",
          height: "100%",
          width: "100%",
          margin: "0",
          padding: "0"
        })
        b.slider.addClass("rsFullscreen")
        var d
        for (d = 0; d < b.numSlides; d++)
          (a = b.slides[d]),
            (a.isRendered = !1),
            a.bigImage &&
              ((a.isBig = !0),
              (a.isMedLoaded = a.isLoaded),
              (a.isMedLoading = a.isLoading),
              (a.medImage = a.image),
              (a.medIW = a.iW),
              (a.medIH = a.iH),
              (a.slideId = -99),
              a.bigImage !== a.medImage && (a.sizeType = "big"),
              (a.isLoaded = a.isBigLoaded),
              (a.isLoading = !1),
              (a.image = a.bigImage),
              (a.images[0] = a.bigImage),
              (a.iW = a.bigIW),
              (a.iH = a.bigIH),
              (a.isAppended = a.contentAdded = !1),
              b._updateItemSrc(a))
        b.isFullscreen = !0
        b._isFullscreenUpdating = !1
        b.updateSliderSize()
        b.ev.trigger("rsEnterFullscreen")
      }
    },
    exitFullscreen: function (a) {
      var b = this
      if (b._fullScreenApi) {
        if (!a) {
          b._fullScreenApi.cancelFullScreen(c("html")[0])
          return
        }
        b._doc.off(b._fullScreenApi.fullScreenEventName)
      }
      if (!b._isFullscreenUpdating) {
        b._isFullscreenUpdating = !0
        b._doc.off("keyup" + b.ns + "fullscreen")
        b._fsKeyboard && b._doc.off("keydown" + b.ns)
        c("html").attr("style", b._htmlStyle || "")
        c("body").attr("style", b._bodyStyle || "")
        var d
        for (d = 0; d < b.numSlides; d++)
          (a = b.slides[d]),
            (a.isRendered = !1),
            a.bigImage &&
              ((a.isBig = !1),
              (a.slideId = -99),
              (a.isBigLoaded = a.isLoaded),
              (a.isBigLoading = a.isLoading),
              (a.bigImage = a.image),
              (a.bigIW = a.iW),
              (a.bigIH = a.iH),
              (a.isLoaded = a.isMedLoaded),
              (a.isLoading = !1),
              (a.image = a.medImage),
              (a.images[0] = a.medImage),
              (a.iW = a.medIW),
              (a.iH = a.medIH),
              (a.isAppended = a.contentAdded = !1),
              b._updateItemSrc(a, !0),
              a.bigImage !== a.medImage && (a.sizeType = "med"))
        b.isFullscreen = !1
        a = c(window)
        a.scrollTop(b._fsScrollTopOnEnter)
        a.scrollLeft(b._fsScrollLeftOnEnter)
        b._isFullscreenUpdating = !1
        b.slider.removeClass("rsFullscreen")
        b.updateSliderSize()
        setTimeout(function () {
          b.updateSliderSize()
        }, 1)
        b.ev.trigger("rsExitFullscreen")
      }
    },
    _updateItemSrc: function (a, b) {
      var d =
        a.isLoaded || a.isLoading
          ? '<img class="rsImg rsMainSlideImage" src="' + a.image + '"/>'
          : '<a class="rsImg rsMainSlideImage" href="' + a.image + '"></a>'
      a.content.hasClass("rsImg")
        ? (a.content = c(d))
        : a.content.find(".rsImg").eq(0).replaceWith(d)
      a.isLoaded || a.isLoading || !a.holder || a.holder.html(a.content)
    }
  })
  c.rsModules.fullscreen = c.rsProto._initFullscreen
})(jQuery) // jquery.rs.autoplay v1.0.5
;(function (b) {
  b.extend(b.rsProto, {
    _initAutoplay: function () {
      var a = this,
        d
      a._autoPlayDefaults = { enabled: !1, stopAtAction: !0, pauseOnHover: !0, delay: 2e3 }
      !a.st.autoPlay && a.st.autoplay && (a.st.autoPlay = a.st.autoplay)
      a.st.autoPlay = b.extend({}, a._autoPlayDefaults, a.st.autoPlay)
      a.st.autoPlay.enabled &&
        (a.ev.on("rsBeforeParseNode", function (a, c, f) {
          c = b(c)
          if ((d = c.attr("data-rsDelay"))) f.customDelay = parseInt(d, 10)
        }),
        a.ev.one("rsAfterInit", function () {
          a._setupAutoPlay()
        }),
        a.ev.on("rsBeforeDestroy", function () {
          a.stopAutoPlay()
          a.slider.off("mouseenter mouseleave")
          b(window).off("blur" + a.ns + " focus" + a.ns)
        }))
    },
    _setupAutoPlay: function () {
      var a = this
      a.startAutoPlay()
      a.ev.on("rsAfterContentSet", function (b, e) {
        a._isDragging || a._isAnimating || !a._autoPlayEnabled || e !== a.currSlide || a._play()
      })
      a.ev.on("rsDragRelease", function () {
        a._autoPlayEnabled && a._autoPlayPaused && ((a._autoPlayPaused = !1), a._play())
      })
      a.ev.on("rsAfterSlideChange", function () {
        a._autoPlayEnabled &&
          a._autoPlayPaused &&
          ((a._autoPlayPaused = !1), a.currSlide.isLoaded && a._play())
      })
      a.ev.on("rsDragStart", function () {
        a._autoPlayEnabled &&
          (a.st.autoPlay.stopAtAction ? a.stopAutoPlay() : ((a._autoPlayPaused = !0), a._pause()))
      })
      a.ev.on("rsBeforeMove", function (b, e, c) {
        a._autoPlayEnabled &&
          (c && a.st.autoPlay.stopAtAction
            ? a.stopAutoPlay()
            : ((a._autoPlayPaused = !0), a._pause()))
      })
      a._pausedByVideo = !1
      a.ev.on("rsVideoStop", function () {
        a._autoPlayEnabled && ((a._pausedByVideo = !1), a._play())
      })
      a.ev.on("rsVideoPlay", function () {
        a._autoPlayEnabled && ((a._autoPlayPaused = !1), a._pause(), (a._pausedByVideo = !0))
      })
      b(window)
        .on("blur" + a.ns, function () {
          a._autoPlayEnabled && ((a._autoPlayPaused = !0), a._pause())
        })
        .on("focus" + a.ns, function () {
          a._autoPlayEnabled && a._autoPlayPaused && ((a._autoPlayPaused = !1), a._play())
        })
      a.st.autoPlay.pauseOnHover &&
        ((a._pausedByHover = !1),
        a.slider.hover(
          function () {
            a._autoPlayEnabled && ((a._autoPlayPaused = !1), a._pause(), (a._pausedByHover = !0))
          },
          function () {
            a._autoPlayEnabled && ((a._pausedByHover = !1), a._play())
          }
        ))
    },
    toggleAutoPlay: function () {
      this._autoPlayEnabled ? this.stopAutoPlay() : this.startAutoPlay()
    },
    startAutoPlay: function () {
      this._autoPlayEnabled = !0
      this.currSlide.isLoaded && this._play()
    },
    stopAutoPlay: function () {
      this._pausedByVideo = this._pausedByHover = this._autoPlayPaused = this._autoPlayEnabled = !1
      this._pause()
    },
    _play: function () {
      var a = this
      a._pausedByHover ||
        a._pausedByVideo ||
        ((a._autoPlayRunning = !0),
        a._autoPlayTimeout && clearTimeout(a._autoPlayTimeout),
        (a._autoPlayTimeout = setTimeout(
          function () {
            if (!a._loop && !a.st.loopRewind) {
              var b = !0
              a.st.loopRewind = !0
            }
            a.next(!0)
            b && (a.st.loopRewind = !1)
          },
          a.currSlide.customDelay ? a.currSlide.customDelay : a.st.autoPlay.delay
        )))
    },
    _pause: function () {
      this._pausedByHover ||
        this._pausedByVideo ||
        ((this._autoPlayRunning = !1),
        this._autoPlayTimeout &&
          (clearTimeout(this._autoPlayTimeout), (this._autoPlayTimeout = null)))
    }
  })
  b.rsModules.autoplay = b.rsProto._initAutoplay
})(jQuery) // jquery.rs.video v1.1.3
;(function (f) {
  f.extend(f.rsProto, {
    _initVideo: function () {
      var a = this
      a._videoDefaults = {
        autoHideArrows: !0,
        autoHideControlNav: !1,
        autoHideBlocks: !1,
        autoHideCaption: !1,
        disableCSS3inFF: !0,
        youTubeCode:
          '<iframe src="https://www.youtube.com/embed/%id%?rel=1&showinfo=0&autoplay=1&wmode=transparent" frameborder="no"></iframe>',
        vimeoCode:
          '<iframe src="https://player.vimeo.com/video/%id%?byline=0&portrait=0&autoplay=1" frameborder="no" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
      }
      a.st.video = f.extend({}, a._videoDefaults, a.st.video)
      a.ev.on("rsBeforeSizeSet", function () {
        a._isVideoPlaying &&
          setTimeout(function () {
            var b = a._currHolder
            b = b.hasClass("rsVideoContainer") ? b : b.find(".rsVideoContainer")
            a._videoFrameHolder && a._videoFrameHolder.css({ width: b.width(), height: b.height() })
          }, 32)
      })
      var d = a._browser.mozilla
      a.ev.on("rsAfterParseNode", function (b, c, e) {
        b = f(c)
        if (e.videoURL) {
          a.st.video.disableCSS3inFF && d && (a._useCSS3Transitions = a._use3dTransform = !1)
          c = f('<div class="rsVideoContainer"></div>')
          var g = f(
            '<div class="rsBtnCenterer"><div class="rsPlayBtn"><div class="rsPlayBtnIcon"></div></div></div>'
          )
          b.hasClass("rsImg")
            ? (e.content = c.append(b).append(g))
            : e.content.find(".rsImg").wrap(c).after(g)
        }
      })
      a.ev.on("rsAfterSlideChange", function () {
        a.stopVideo()
      })
    },
    toggleVideo: function () {
      return this._isVideoPlaying ? this.stopVideo() : this.playVideo()
    },
    playVideo: function () {
      var a = this
      if (!a._isVideoPlaying) {
        var d = a.currSlide
        if (!d.videoURL) return !1
        a._playingVideoSlide = d
        var b = (a._currVideoContent = d.content)
        d = d.videoURL
        var c
        if (d.match(/youtu\.be/i) || d.match(/youtube\.com/i)) {
          var e = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&\?]*).*/
          ;(e = d.match(e)) && 11 == e[2].length && (c = e[2])
          void 0 !== c && (a._videoFrameHolder = a.st.video.youTubeCode.replace("%id%", c))
        } else
          d.match(/vimeo\.com/i) &&
            ((e = /(www\.)?vimeo.com\/(\d+)($|\/)/),
            (e = d.match(e)) && (c = e[2]),
            void 0 !== c && (a._videoFrameHolder = a.st.video.vimeoCode.replace("%id%", c)))
        a.videoObj = f(a._videoFrameHolder)
        a.ev.trigger("rsOnCreateVideoElement", [d])
        a.videoObj.length &&
          ((a._videoFrameHolder = f(
            '<div class="rsVideoFrameHolder"><div class="rsPreloader"></div><div class="rsCloseVideoBtn"><div class="rsCloseVideoIcn"></div></div></div>'
          )),
          a._videoFrameHolder.find(".rsPreloader").after(a.videoObj),
          (b = b.hasClass("rsVideoContainer") ? b : b.find(".rsVideoContainer")),
          a._videoFrameHolder
            .css({ width: b.width(), height: b.height() })
            .find(".rsCloseVideoBtn")
            .off("click.rsv")
            .on("click.rsv", function (b) {
              a.stopVideo()
              b.preventDefault()
              b.stopPropagation()
              return !1
            }),
          b.append(a._videoFrameHolder),
          a.isIPAD && b.addClass("rsIOSVideo"),
          a._toggleHiddenClass(!1),
          setTimeout(function () {
            a._videoFrameHolder.addClass("rsVideoActive")
          }, 10),
          a.ev.trigger("rsVideoPlay"),
          (a._isVideoPlaying = !0))
        return !0
      }
      return !1
    },
    stopVideo: function () {
      var a = this
      return a._isVideoPlaying
        ? (a.isIPAD && a.slider.find(".rsCloseVideoBtn").remove(),
          a._toggleHiddenClass(!0),
          setTimeout(function () {
            a.ev.trigger("rsOnDestroyVideoElement", [a.videoObj])
            var d = a._videoFrameHolder.find("iframe")
            if (d.length)
              try {
                d.attr("src", "")
              } catch (b) {}
            a._videoFrameHolder.remove()
            a._videoFrameHolder = null
          }, 16),
          a.ev.trigger("rsVideoStop"),
          (a._isVideoPlaying = !1),
          !0)
        : !1
    },
    _toggleHiddenClass: function (a, d) {
      var b = [],
        c = this.st.video
      c.autoHideArrows &&
        (this._arrowLeft &&
          (b.push(this._arrowLeft, this._arrowRight), (this._arrowsAutoHideLocked = !a)),
        this._fsBtn && b.push(this._fsBtn))
      c.autoHideControlNav && this._controlNav && b.push(this._controlNav)
      c.autoHideBlocks &&
        this._playingVideoSlide.animBlocks &&
        b.push(this._playingVideoSlide.animBlocks)
      c.autoHideCaption && this.globalCaption && b.push(this.globalCaption)
      this.slider[a ? "removeClass" : "addClass"]("rsVideoPlaying")
      if (b.length)
        for (c = 0; c < b.length; c++) a ? b[c].removeClass("rsHidden") : b[c].addClass("rsHidden")
    }
  })
  f.rsModules.video = f.rsProto._initVideo
})(jQuery) // jquery.rs.animated-blocks v1.0.7
;(function (k) {
  k.extend(k.rsProto, {
    _initAnimatedBlocks: function () {
      function m() {
        var f = a.currSlide
        if (a.currSlide && a.currSlide.isLoaded && a._slideWithBlocks !== f) {
          if (0 < a._animatedBlockTimeouts.length) {
            for (b = 0; b < a._animatedBlockTimeouts.length; b++)
              clearTimeout(a._animatedBlockTimeouts[b])
            a._animatedBlockTimeouts = []
          }
          if (0 < a._blockAnimProps.length) {
            var g
            for (b = 0; b < a._blockAnimProps.length; b++)
              if ((g = a._blockAnimProps[b]))
                a._useCSS3Transitions
                  ? (g.block.css(a._vendorPref + a._TD, "0s"), g.block.css(g.css))
                  : g.block.stop(!0).css(g.css),
                  (a._slideWithBlocks = null),
                  (f.animBlocksDisplayed = !1)
            a._blockAnimProps = []
          }
          f.animBlocks &&
            ((f.animBlocksDisplayed = !0), (a._slideWithBlocks = f), a._animateBlocks(f.animBlocks))
        }
      }
      var a = this,
        b
      a._blockDefaults = {
        fadeEffect: !0,
        moveEffect: "top",
        moveOffset: 20,
        speed: 400,
        easing: "easeOutSine",
        delay: 200
      }
      a.st.block = k.extend({}, a._blockDefaults, a.st.block)
      a._blockAnimProps = []
      a._animatedBlockTimeouts = []
      a.ev.on("rsAfterInit", function () {
        m()
      })
      a.ev.on("rsBeforeParseNode", function (a, b, d) {
        b = k(b)
        d.animBlocks = b.find(".rsABlock").css("display", "none")
        d.animBlocks.length ||
          (b.hasClass("rsABlock") ? (d.animBlocks = b.css("display", "none")) : (d.animBlocks = !1))
      })
      a.ev.on("rsAfterContentSet", function (b, g) {
        g.id === a.slides[a.currSlideId].id &&
          setTimeout(
            function () {
              m()
            },
            a.st.fadeinLoadedSlide ? 300 : 0
          )
      })
      a.ev.on("rsAfterSlideChange", function () {
        m()
      })
    },
    _updateAnimBlockProps: function (k, a) {
      setTimeout(function () {
        k.css(a)
      }, 6)
    },
    _animateBlocks: function (m) {
      var a = this,
        b,
        f,
        g,
        d,
        h,
        e,
        n
      a._animatedBlockTimeouts = []
      m.each(function (m) {
        b = k(this)
        f = {}
        g = {}
        d = null
        var c = b.attr("data-move-offset")
        c = c ? parseInt(c, 10) : a.st.block.moveOffset
        if (
          0 < c &&
          ((e = b.data("move-effect"))
            ? ((e = e.toLowerCase()),
              "none" === e
                ? (e = !1)
                : "left" !== e &&
                  "top" !== e &&
                  "bottom" !== e &&
                  "right" !== e &&
                  ((e = a.st.block.moveEffect), "none" === e && (e = !1)))
            : (e = a.st.block.moveEffect),
          e && "none" !== e)
        ) {
          var p = "right" === e || "left" === e ? !0 : !1
          n = !1
          if (a._useCSS3Transitions) {
            var l = 0
            h = a._xProp
          } else
            p
              ? isNaN(parseInt(b.css("right"), 10))
                ? (h = "left")
                : ((h = "right"), (n = !0))
              : isNaN(parseInt(b.css("bottom"), 10))
              ? (h = "top")
              : ((h = "bottom"), (n = !0)),
              (h = "margin-" + h),
              n && (c = -c),
              a._useCSS3Transitions
                ? (l = parseInt(b.css(h), 10))
                : ((l = b.data("rs-start-move-prop")),
                  void 0 === l &&
                    ((l = parseInt(b.css(h), 10)),
                    isNaN(l) && (l = 0),
                    b.data("rs-start-move-prop", l)))
          g[h] = a._getCSS3Prop("top" === e || "left" === e ? l - c : l + c, p)
          f[h] = a._getCSS3Prop(l, p)
        }
        c = b.attr("data-fade-effect")
        if (!c) c = a.st.block.fadeEffect
        else if ("none" === c.toLowerCase() || "false" === c.toLowerCase()) c = !1
        c && ((g.opacity = 0), (f.opacity = 1))
        if (c || e)
          (d = {}),
            (d.hasFade = !!c),
            e && ((d.moveProp = h), (d.hasMove = !0)),
            (d.speed = b.data("speed")),
            isNaN(d.speed) && (d.speed = a.st.block.speed),
            (d.easing = b.data("easing")),
            d.easing || (d.easing = a.st.block.easing),
            (d.css3Easing = k.rsCSS3Easing[d.easing]),
            (d.delay = b.data("delay")),
            isNaN(d.delay) && (d.delay = a.st.block.delay * m)
        c = {}
        a._useCSS3Transitions && (c[a._vendorPref + a._TD] = "0ms")
        c.moveProp = f.moveProp
        c.opacity = f.opacity
        c.display = "none"
        a._blockAnimProps.push({ block: b, css: c })
        a._updateAnimBlockProps(b, g)
        a._animatedBlockTimeouts.push(
          setTimeout(
            (function (b, d, c, e) {
              return function () {
                b.css("display", "block")
                if (c) {
                  var f = {}
                  if (a._useCSS3Transitions) {
                    var g = ""
                    c.hasMove && (g += c.moveProp)
                    c.hasFade && (c.hasMove && (g += ", "), (g += "opacity"))
                    f[a._vendorPref + a._TP] = g
                    f[a._vendorPref + a._TD] = c.speed + "ms"
                    f[a._vendorPref + a._TTF] = c.css3Easing
                    b.css(f)
                    setTimeout(function () {
                      b.css(d)
                    }, 24)
                  } else
                    setTimeout(function () {
                      b.animate(d, c.speed, c.easing)
                    }, 16)
                }
                delete a._animatedBlockTimeouts[e]
              }
            })(b, f, d, m),
            6 >= d.delay ? 12 : d.delay
          )
        )
      })
    }
  })
  k.rsModules.animatedBlocks = k.rsProto._initAnimatedBlocks
})(jQuery) // jquery.rs.auto-height v1.0.3
;(function (b) {
  b.extend(b.rsProto, {
    _initAutoHeight: function () {
      var a = this
      if (a.st.autoHeight) {
        var b,
          c,
          e,
          f = !0,
          d = function (d) {
            e = a.slides[a.currSlideId]
            ;(b = e.holder) &&
              (c = b.height()) &&
              void 0 !== c &&
              c > (a.st.minAutoHeight || 30) &&
              ((a._wrapHeight = c),
              a._useCSS3Transitions || !d
                ? a._sliderOverflow.css("height", c)
                : a._sliderOverflow.stop(!0, !0).animate({ height: c }, a.st.transitionSpeed),
              a.ev.trigger("rsAutoHeightChange", c),
              f &&
                (a._useCSS3Transitions &&
                  setTimeout(function () {
                    a._sliderOverflow.css(
                      a._vendorPref + "transition",
                      "height " + a.st.transitionSpeed + "ms ease-in-out"
                    )
                  }, 16),
                (f = !1)))
          }
        a.ev.on("rsMaybeSizeReady.rsAutoHeight", function (a, b) {
          e === b && d()
        })
        a.ev.on("rsAfterContentSet.rsAutoHeight", function (a, b) {
          e === b && d()
        })
        a.slider.addClass("rsAutoHeight")
        a.ev.one("rsAfterInit", function () {
          setTimeout(function () {
            d(!1)
            setTimeout(function () {
              a.slider.append('<div style="clear:both; float: none;"></div>')
            }, 16)
          }, 16)
        })
        a.ev.on("rsBeforeAnimStart", function () {
          d(!0)
        })
        a.ev.on("rsBeforeSizeSet", function () {
          setTimeout(function () {
            d(!1)
          }, 16)
        })
      }
    }
  })
  b.rsModules.autoHeight = b.rsProto._initAutoHeight
})(jQuery) // jquery.rs.global-caption v1.0.1
;(function (b) {
  b.extend(b.rsProto, {
    _initGlobalCaption: function () {
      var a = this
      a.st.globalCaption &&
        (a.ev.on("rsAfterInit", function () {
          a.globalCaption = b('<div class="rsGCaption"></div>').appendTo(
            a.st.globalCaptionInside ? a._sliderOverflow : a.slider
          )
          a.globalCaption.html(a.currSlide.caption || "")
        }),
        a.ev.on("rsBeforeAnimStart", function () {
          a.globalCaption.html(a.currSlide.caption || "")
        }))
    }
  })
  b.rsModules.globalCaption = b.rsProto._initGlobalCaption
})(jQuery) // jquery.rs.active-class v1.0.1
;(function (c) {
  c.rsProto._initActiveClass = function () {
    var b,
      a = this
    if (a.st.addActiveClass)
      a.ev.on("rsOnUpdateNav", function () {
        b && clearTimeout(b)
        b = setTimeout(function () {
          a._oldHolder && a._oldHolder.removeClass("rsActiveSlide")
          a._currHolder && a._currHolder.addClass("rsActiveSlide")
          b = null
        }, 50)
      })
  }
  c.rsModules.activeClass = c.rsProto._initActiveClass
})(jQuery)
// jquery.rs.deeplinking v1.0.6 + jQuery hashchange plugin v1.3 Copyright (c) 2010 Ben Alman
;(function (b) {
  b.extend(b.rsProto, {
    _initDeeplinking: function () {
      var a = this,
        h,
        d,
        f
      a._hashDefaults = { enabled: !1, change: !1, prefix: "" }
      a.st.deeplinking = b.extend({}, a._hashDefaults, a.st.deeplinking)
      if (a.st.deeplinking.enabled) {
        var e = a.st.deeplinking.change,
          c = a.st.deeplinking.prefix,
          k = "#" + c,
          g = function () {
            var a = window.location.hash
            return a && 0 < a.indexOf(c) && ((a = parseInt(a.substring(k.length), 10)), 0 <= a)
              ? a - 1
              : -1
          },
          l = g()
        ;-1 !== l && (a.st.startSlideId = l)
        e &&
          (b(window).on("hashchange" + a.ns, function (b) {
            h || ((b = g()), 0 > b || (b > a.numSlides - 1 && (b = a.numSlides - 1), a.goTo(b)))
          }),
          a.ev.on("rsBeforeAnimStart", function () {
            d && clearTimeout(d)
            f && clearTimeout(f)
          }),
          a.ev.on("rsAfterSlideChange", function () {
            d && clearTimeout(d)
            f && clearTimeout(f)
            f = setTimeout(function () {
              h = !0
              window.location.replace(
                ("" + window.location).split("#")[0] + k + (a.currSlideId + 1)
              )
              d = setTimeout(function () {
                h = !1
                d = null
              }, 60)
            }, 400)
          }))
        a.ev.on("rsBeforeDestroy", function () {
          d = f = null
          e && b(window).off("hashchange" + a.ns)
        })
      }
    }
  })
  b.rsModules.deeplinking = b.rsProto._initDeeplinking
})(jQuery)
;(function (b, a, h) {
  function d(a) {
    a = a || location.href
    return "#" + a.replace(/^[^#]*#?(.*)$/, "$1")
  }
  ;("$:nomunge")
  var f = document,
    e = b.event.special,
    c = f.documentMode,
    k = "onhashchange" in a && (c === h || 7 < c)
  b.fn.hashchange = function (a) {
    return a ? this.bind("hashchange", a) : this.trigger("hashchange")
  }
  b.fn.hashchange.delay = 50
  e.hashchange = b.extend(e.hashchange, {
    setup: function () {
      if (k) return !1
      b(g.start)
    },
    teardown: function () {
      if (k) return !1
      b(g.stop)
    }
  })
  var g = (function () {
    function l() {
      var f = d(),
        e = p(g)
      f !== g
        ? (m((g = f), e), b(a).trigger("hashchange"))
        : e !== g && (location.href = location.href.replace(/#.*/, "") + e)
      c = setTimeout(l, b.fn.hashchange.delay)
    }
    var e = {},
      c,
      g = d(),
      n = function (a) {
        return a
      },
      m = n,
      p = n
    e.start = function () {
      c || l()
    }
    e.stop = function () {
      c && clearTimeout(c)
      c = h
    }
    a.attachEvent &&
      !a.addEventListener &&
      !k &&
      (function () {
        var a, c
        e.start = function () {
          a ||
            ((c = (c = b.fn.hashchange.src) && c + d()),
            (a = b('<iframe tabindex="-1" title="empty"/>')
              .hide()
              .one("load", function () {
                c || m(d())
                l()
              })
              .attr("src", c || "javascript:0")
              .insertAfter("body")[0].contentWindow),
            (f.onpropertychange = function () {
              try {
                "title" === event.propertyName && (a.document.title = f.title)
              } catch (q) {}
            }))
        }
        e.stop = n
        p = function () {
          return d(a.location.href)
        }
        m = function (c, e) {
          var d = a.document,
            g = b.fn.hashchange.domain
          c !== e &&
            ((d.title = f.title),
            d.open(),
            g && d.write('<script>document.domain="' + g + '"\x3c/script>'),
            d.close(),
            (a.location.hash = c))
        }
      })()
    return e
  })()
})(jQuery, this) // jquery.rs.visible-nearby v1.0.2
;(function (d) {
  d.rsProto._initVisibleNearby = function () {
    var a = this
    a.st.visibleNearby &&
      a.st.visibleNearby.enabled &&
      ((a._vnDefaults = {
        enabled: !0,
        centerArea: 0.6,
        center: !0,
        breakpoint: 0,
        breakpointCenterArea: 0.8,
        hiddenOverflow: !0,
        navigateByCenterClick: !1
      }),
      (a.st.visibleNearby = d.extend({}, a._vnDefaults, a.st.visibleNearby)),
      a.ev.one("rsAfterPropsSetup", function () {
        a._sliderVisibleNearbyWrap = a._sliderOverflow
          .css("overflow", "visible")
          .wrap('<div class="rsVisibleNearbyWrap"></div>')
          .parent()
        a.st.visibleNearby.hiddenOverflow || a._sliderVisibleNearbyWrap.css("overflow", "visible")
        a._controlsContainer = a.st.controlsInside ? a._sliderVisibleNearbyWrap : a.slider
      }),
      a.ev.on("rsAfterSizePropSet", function () {
        var c = a.st.visibleNearby
        var b = c.breakpoint && a.width < c.breakpoint ? c.breakpointCenterArea : c.centerArea
        a._slidesHorizontal
          ? ((a._wrapWidth *= b),
            a._sliderVisibleNearbyWrap.css({ height: a._wrapHeight, width: a._wrapWidth / b }),
            (a._minPosOffset = (a._wrapWidth * (1 - b)) / 2 / b))
          : ((a._wrapHeight *= b),
            a._sliderVisibleNearbyWrap.css({ height: a._wrapHeight / b, width: a._wrapWidth }),
            (a._minPosOffset = (a._wrapHeight * (1 - b)) / 2 / b))
        c.navigateByCenterClick ||
          (a._nextSlidePos = a._slidesHorizontal ? a._wrapWidth : a._wrapHeight)
        c.center &&
          a._sliderOverflow.css("margin-" + (a._slidesHorizontal ? "left" : "top"), a._minPosOffset)
      }))
  }
  d.rsModules.visibleNearby = d.rsProto._initVisibleNearby
})(jQuery)
/** Owl Carousel v2.3.4 Copyright 2013-2018 David Deutsch Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE */
!(function (a, b, c, d) {
  function e(b, c) {
    ;(this.settings = null),
      (this.options = a.extend({}, e.Defaults, c)),
      (this.$element = a(b)),
      (this._handlers = {}),
      (this._plugins = {}),
      (this._supress = {}),
      (this._current = null),
      (this._speed = null),
      (this._coordinates = []),
      (this._breakpoint = null),
      (this._width = null),
      (this._items = []),
      (this._clones = []),
      (this._mergers = []),
      (this._widths = []),
      (this._invalidated = {}),
      (this._pipe = []),
      (this._drag = {
        time: null,
        target: null,
        pointer: null,
        stage: { start: null, current: null },
        direction: null
      }),
      (this._states = {
        current: {},
        tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] }
      }),
      a.each(
        ["onResize", "onThrottledResize"],
        a.proxy(function (b, c) {
          this._handlers[c] = a.proxy(this[c], this)
        }, this)
      ),
      a.each(
        e.Plugins,
        a.proxy(function (a, b) {
          this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this)
        }, this)
      ),
      a.each(
        e.Workers,
        a.proxy(function (b, c) {
          this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) })
        }, this)
      ),
      this.setup(),
      this.initialize()
  }
  ;(e.Defaults = {
    items: 3,
    loop: !1,
    center: !1,
    rewind: !1,
    checkVisibility: !0,
    mouseDrag: !0,
    touchDrag: !0,
    pullDrag: !0,
    freeDrag: !1,
    margin: 0,
    stagePadding: 0,
    merge: !1,
    mergeFit: !0,
    autoWidth: !1,
    startPosition: 0,
    rtl: !1,
    smartSpeed: 250,
    fluidSpeed: !1,
    dragEndSpeed: !1,
    responsive: {},
    responsiveRefreshRate: 200,
    responsiveBaseElement: b,
    fallbackEasing: "swing",
    slideTransition: "",
    info: !1,
    nestedItemSelector: !1,
    itemElement: "div",
    stageElement: "div",
    refreshClass: "owl-refresh",
    loadedClass: "owl-loaded",
    loadingClass: "owl-loading",
    rtlClass: "owl-rtl",
    responsiveClass: "owl-responsive",
    dragClass: "owl-drag",
    itemClass: "owl-item",
    stageClass: "owl-stage",
    stageOuterClass: "owl-stage-outer",
    grabClass: "owl-grab"
  }),
    (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
    (e.Type = { Event: "event", State: "state" }),
    (e.Plugins = {}),
    (e.Workers = [
      {
        filter: ["width", "settings"],
        run: function () {
          this._width = this.$element.width()
        }
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          a.current = this._items && this._items[this.relative(this._current)]
        }
      },
      {
        filter: ["items", "settings"],
        run: function () {
          this.$stage.children(".cloned").remove()
        }
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this.settings.margin || "",
            c = !this.settings.autoWidth,
            d = this.settings.rtl,
            e = { width: "auto", "margin-left": d ? b : "", "margin-right": d ? "" : b }
          !c && this.$stage.children().css(e), (a.css = e)
        }
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
            c = null,
            d = this._items.length,
            e = !this.settings.autoWidth,
            f = []
          for (a.items = { merge: !1, width: b }; d--; )
            (c = this._mergers[d]),
              (c = (this.settings.mergeFit && Math.min(c, this.settings.items)) || c),
              (a.items.merge = c > 1 || a.items.merge),
              (f[d] = e ? b * c : this._items[d].width())
          this._widths = f
        }
      },
      {
        filter: ["items", "settings"],
        run: function () {
          var b = [],
            c = this._items,
            d = this.settings,
            e = Math.max(2 * d.items, 4),
            f = 2 * Math.ceil(c.length / 2),
            g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
            h = "",
            i = ""
          for (g /= 2; g > 0; )
            b.push(this.normalize(b.length / 2, !0)),
              (h += c[b[b.length - 1]][0].outerHTML),
              b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)),
              (i = c[b[b.length - 1]][0].outerHTML + i),
              (g -= 1)
          ;(this._clones = b),
            a(h).addClass("cloned").appendTo(this.$stage),
            a(i).addClass("cloned").prependTo(this.$stage)
        }
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          for (
            var a = this.settings.rtl ? 1 : -1,
              b = this._clones.length + this._items.length,
              c = -1,
              d = 0,
              e = 0,
              f = [];
            ++c < b;

          )
            (d = f[c - 1] || 0),
              (e = this._widths[this.relative(c)] + this.settings.margin),
              f.push(d + e * a)
          this._coordinates = f
        }
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          var a = this.settings.stagePadding,
            b = this._coordinates,
            c = {
              width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
              "padding-left": a || "",
              "padding-right": a || ""
            }
          this.$stage.css(c)
        }
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this._coordinates.length,
            c = !this.settings.autoWidth,
            d = this.$stage.children()
          if (c && a.items.merge)
            for (; b--; ) (a.css.width = this._widths[this.relative(b)]), d.eq(b).css(a.css)
          else c && ((a.css.width = a.items.width), d.css(a.css))
        }
      },
      {
        filter: ["items"],
        run: function () {
          this._coordinates.length < 1 && this.$stage.removeAttr("style")
        }
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          ;(a.current = a.current ? this.$stage.children().index(a.current) : 0),
            (a.current = Math.max(this.minimum(), Math.min(this.maximum(), a.current))),
            this.reset(a.current)
        }
      },
      {
        filter: ["position"],
        run: function () {
          this.animate(this.coordinates(this._current))
        }
      },
      {
        filter: ["width", "position", "items", "settings"],
        run: function () {
          var a,
            b,
            c,
            d,
            e = this.settings.rtl ? 1 : -1,
            f = 2 * this.settings.stagePadding,
            g = this.coordinates(this.current()) + f,
            h = g + this.width() * e,
            i = []
          for (c = 0, d = this._coordinates.length; c < d; c++)
            (a = this._coordinates[c - 1] || 0),
              (b = Math.abs(this._coordinates[c]) + f * e),
              ((this.op(a, "<=", g) && this.op(a, ">", h)) ||
                (this.op(b, "<", g) && this.op(b, ">", h))) &&
                i.push(c)
          this.$stage.children(".active").removeClass("active"),
            this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass("active"),
            this.$stage.children(".center").removeClass("center"),
            this.settings.center && this.$stage.children().eq(this.current()).addClass("center")
        }
      }
    ]),
    (e.prototype.initializeStage = function () {
      ;(this.$stage = this.$element.find("." + this.settings.stageClass)),
        this.$stage.length ||
          (this.$element.addClass(this.options.loadingClass),
          (this.$stage = a("<" + this.settings.stageElement + ">", {
            class: this.settings.stageClass
          }).wrap(a("<div/>", { class: this.settings.stageOuterClass }))),
          this.$element.append(this.$stage.parent()))
    }),
    (e.prototype.initializeItems = function () {
      var b = this.$element.find(".owl-item")
      if (b.length)
        return (
          (this._items = b.get().map(function (b) {
            return a(b)
          })),
          (this._mergers = this._items.map(function () {
            return 1
          })),
          void this.refresh()
        )
      this.replace(this.$element.children().not(this.$stage.parent())),
        this.isVisible() ? this.refresh() : this.invalidate("width"),
        this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)
    }),
    (e.prototype.initialize = function () {
      if (
        (this.enter("initializing"),
        this.trigger("initialize"),
        this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
        this.settings.autoWidth && !this.is("pre-loading"))
      ) {
        var a, b, c
        ;(a = this.$element.find("img")),
          (b = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d),
          (c = this.$element.children(b).width()),
          a.length && c <= 0 && this.preloadAutoWidthImages(a)
      }
      this.initializeStage(),
        this.initializeItems(),
        this.registerEventHandlers(),
        this.leave("initializing"),
        this.trigger("initialized")
    }),
    (e.prototype.isVisible = function () {
      return !this.settings.checkVisibility || this.$element.is(":visible")
    }),
    (e.prototype.setup = function () {
      var b = this.viewport(),
        c = this.options.responsive,
        d = -1,
        e = null
      c
        ? (a.each(c, function (a) {
            a <= b && a > d && (d = Number(a))
          }),
          (e = a.extend({}, this.options, c[d])),
          "function" == typeof e.stagePadding && (e.stagePadding = e.stagePadding()),
          delete e.responsive,
          e.responsiveClass &&
            this.$element.attr(
              "class",
              this.$element
                .attr("class")
                .replace(
                  new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"),
                  "$1" + d
                )
            ))
        : (e = a.extend({}, this.options)),
        this.trigger("change", { property: { name: "settings", value: e } }),
        (this._breakpoint = d),
        (this.settings = e),
        this.invalidate("settings"),
        this.trigger("changed", { property: { name: "settings", value: this.settings } })
    }),
    (e.prototype.optionsLogic = function () {
      this.settings.autoWidth && ((this.settings.stagePadding = !1), (this.settings.merge = !1))
    }),
    (e.prototype.prepare = function (b) {
      var c = this.trigger("prepare", { content: b })
      return (
        c.data ||
          (c.data = a("<" + this.settings.itemElement + "/>")
            .addClass(this.options.itemClass)
            .append(b)),
        this.trigger("prepared", { content: c.data }),
        c.data
      )
    }),
    (e.prototype.update = function () {
      for (
        var b = 0,
          c = this._pipe.length,
          d = a.proxy(function (a) {
            return this[a]
          }, this._invalidated),
          e = {};
        b < c;

      )
        (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) &&
          this._pipe[b].run(e),
          b++
      ;(this._invalidated = {}), !this.is("valid") && this.enter("valid")
    }),
    (e.prototype.width = function (a) {
      switch ((a = a || e.Width.Default)) {
        case e.Width.Inner:
        case e.Width.Outer:
          return this._width
        default:
          return this._width - 2 * this.settings.stagePadding + this.settings.margin
      }
    }),
    (e.prototype.refresh = function () {
      this.enter("refreshing"),
        this.trigger("refresh"),
        this.setup(),
        this.optionsLogic(),
        this.$element.addClass(this.options.refreshClass),
        this.update(),
        this.$element.removeClass(this.options.refreshClass),
        this.leave("refreshing"),
        this.trigger("refreshed")
    }),
    (e.prototype.onThrottledResize = function () {
      b.clearTimeout(this.resizeTimer),
        (this.resizeTimer = b.setTimeout(
          this._handlers.onResize,
          this.settings.responsiveRefreshRate
        ))
    }),
    (e.prototype.onResize = function () {
      return (
        !!this._items.length &&
        this._width !== this.$element.width() &&
        !!this.isVisible() &&
        (this.enter("resizing"),
        this.trigger("resize").isDefaultPrevented()
          ? (this.leave("resizing"), !1)
          : (this.invalidate("width"),
            this.refresh(),
            this.leave("resizing"),
            void this.trigger("resized")))
      )
    }),
    (e.prototype.registerEventHandlers = function () {
      a.support.transition &&
        this.$stage.on(a.support.transition.end + ".owl.core", a.proxy(this.onTransitionEnd, this)),
        !1 !== this.settings.responsive && this.on(b, "resize", this._handlers.onThrottledResize),
        this.settings.mouseDrag &&
          (this.$element.addClass(this.options.dragClass),
          this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)),
          this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
            return !1
          })),
        this.settings.touchDrag &&
          (this.$stage.on("touchstart.owl.core", a.proxy(this.onDragStart, this)),
          this.$stage.on("touchcancel.owl.core", a.proxy(this.onDragEnd, this)))
    }),
    (e.prototype.onDragStart = function (b) {
      var d = null
      3 !== b.which &&
        (a.support.transform
          ? ((d = this.$stage
              .css("transform")
              .replace(/.*\(|\)| /g, "")
              .split(",")),
            (d = { x: d[16 === d.length ? 12 : 4], y: d[16 === d.length ? 13 : 5] }))
          : ((d = this.$stage.position()),
            (d = {
              x: this.settings.rtl
                ? d.left + this.$stage.width() - this.width() + this.settings.margin
                : d.left,
              y: d.top
            })),
        this.is("animating") &&
          (a.support.transform ? this.animate(d.x) : this.$stage.stop(),
          this.invalidate("position")),
        this.$element.toggleClass(this.options.grabClass, "mousedown" === b.type),
        this.speed(0),
        (this._drag.time = new Date().getTime()),
        (this._drag.target = a(b.target)),
        (this._drag.stage.start = d),
        (this._drag.stage.current = d),
        (this._drag.pointer = this.pointer(b)),
        a(c).on("mouseup.owl.core touchend.owl.core", a.proxy(this.onDragEnd, this)),
        a(c).one(
          "mousemove.owl.core touchmove.owl.core",
          a.proxy(function (b) {
            var d = this.difference(this._drag.pointer, this.pointer(b))
            a(c).on("mousemove.owl.core touchmove.owl.core", a.proxy(this.onDragMove, this)),
              (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) ||
                (b.preventDefault(), this.enter("dragging"), this.trigger("drag"))
          }, this)
        ))
    }),
    (e.prototype.onDragMove = function (a) {
      var b = null,
        c = null,
        d = null,
        e = this.difference(this._drag.pointer, this.pointer(a)),
        f = this.difference(this._drag.stage.start, e)
      this.is("dragging") &&
        (a.preventDefault(),
        this.settings.loop
          ? ((b = this.coordinates(this.minimum())),
            (c = this.coordinates(this.maximum() + 1) - b),
            (f.x = ((((f.x - b) % c) + c) % c) + b))
          : ((b = this.settings.rtl
              ? this.coordinates(this.maximum())
              : this.coordinates(this.minimum())),
            (c = this.settings.rtl
              ? this.coordinates(this.minimum())
              : this.coordinates(this.maximum())),
            (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
            (f.x = Math.max(Math.min(f.x, b + d), c + d))),
        (this._drag.stage.current = f),
        this.animate(f.x))
    }),
    (e.prototype.onDragEnd = function (b) {
      var d = this.difference(this._drag.pointer, this.pointer(b)),
        e = this._drag.stage.current,
        f = (d.x > 0) ^ this.settings.rtl ? "left" : "right"
      a(c).off(".owl.core"),
        this.$element.removeClass(this.options.grabClass),
        ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
          (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
          this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
          this.invalidate("position"),
          this.update(),
          (this._drag.direction = f),
          (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
            this._drag.target.one("click.owl.core", function () {
              return !1
            })),
        this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"))
    }),
    (e.prototype.closest = function (b, c) {
      var e = -1,
        f = 30,
        g = this.width(),
        h = this.coordinates()
      return (
        this.settings.freeDrag ||
          a.each(
            h,
            a.proxy(function (a, i) {
              return (
                "left" === c && b > i - f && b < i + f
                  ? (e = a)
                  : "right" === c && b > i - g - f && b < i - g + f
                  ? (e = a + 1)
                  : this.op(b, "<", i) &&
                    this.op(b, ">", h[a + 1] !== d ? h[a + 1] : i - g) &&
                    (e = "left" === c ? a + 1 : a),
                -1 === e
              )
            }, this)
          ),
        this.settings.loop ||
          (this.op(b, ">", h[this.minimum()])
            ? (e = b = this.minimum())
            : this.op(b, "<", h[this.maximum()]) && (e = b = this.maximum())),
        e
      )
    }),
    (e.prototype.animate = function (b) {
      var c = this.speed() > 0
      this.is("animating") && this.onTransitionEnd(),
        c && (this.enter("animating"), this.trigger("translate")),
        a.support.transform3d && a.support.transition
          ? this.$stage.css({
              transform: "translate3d(" + b + "px,0px,0px)",
              transition:
                this.speed() / 1e3 +
                "s" +
                (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
            })
          : c
          ? this.$stage.animate(
              { left: b + "px" },
              this.speed(),
              this.settings.fallbackEasing,
              a.proxy(this.onTransitionEnd, this)
            )
          : this.$stage.css({ left: b + "px" })
    }),
    (e.prototype.is = function (a) {
      return this._states.current[a] && this._states.current[a] > 0
    }),
    (e.prototype.current = function (a) {
      if (a === d) return this._current
      if (0 === this._items.length) return d
      if (((a = this.normalize(a)), this._current !== a)) {
        var b = this.trigger("change", { property: { name: "position", value: a } })
        b.data !== d && (a = this.normalize(b.data)),
          (this._current = a),
          this.invalidate("position"),
          this.trigger("changed", { property: { name: "position", value: this._current } })
      }
      return this._current
    }),
    (e.prototype.invalidate = function (b) {
      return (
        "string" === a.type(b) &&
          ((this._invalidated[b] = !0), this.is("valid") && this.leave("valid")),
        a.map(this._invalidated, function (a, b) {
          return b
        })
      )
    }),
    (e.prototype.reset = function (a) {
      ;(a = this.normalize(a)) !== d &&
        ((this._speed = 0),
        (this._current = a),
        this.suppress(["translate", "translated"]),
        this.animate(this.coordinates(a)),
        this.release(["translate", "translated"]))
    }),
    (e.prototype.normalize = function (a, b) {
      var c = this._items.length,
        e = b ? 0 : this._clones.length
      return (
        !this.isNumeric(a) || c < 1
          ? (a = d)
          : (a < 0 || a >= c + e) && (a = ((((a - e / 2) % c) + c) % c) + e / 2),
        a
      )
    }),
    (e.prototype.relative = function (a) {
      return (a -= this._clones.length / 2), this.normalize(a, !0)
    }),
    (e.prototype.maximum = function (a) {
      var b,
        c,
        d,
        e = this.settings,
        f = this._coordinates.length
      if (e.loop) f = this._clones.length / 2 + this._items.length - 1
      else if (e.autoWidth || e.merge) {
        if ((b = this._items.length))
          for (
            c = this._items[--b].width(), d = this.$element.width();
            b-- && !((c += this._items[b].width() + this.settings.margin) > d);

          );
        f = b + 1
      } else f = e.center ? this._items.length - 1 : this._items.length - e.items
      return a && (f -= this._clones.length / 2), Math.max(f, 0)
    }),
    (e.prototype.minimum = function (a) {
      return a ? 0 : this._clones.length / 2
    }),
    (e.prototype.items = function (a) {
      return a === d ? this._items.slice() : ((a = this.normalize(a, !0)), this._items[a])
    }),
    (e.prototype.mergers = function (a) {
      return a === d ? this._mergers.slice() : ((a = this.normalize(a, !0)), this._mergers[a])
    }),
    (e.prototype.clones = function (b) {
      var c = this._clones.length / 2,
        e = c + this._items.length,
        f = function (a) {
          return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2
        }
      return b === d
        ? a.map(this._clones, function (a, b) {
            return f(b)
          })
        : a.map(this._clones, function (a, c) {
            return a === b ? f(c) : null
          })
    }),
    (e.prototype.speed = function (a) {
      return a !== d && (this._speed = a), this._speed
    }),
    (e.prototype.coordinates = function (b) {
      var c,
        e = 1,
        f = b - 1
      return b === d
        ? a.map(
            this._coordinates,
            a.proxy(function (a, b) {
              return this.coordinates(b)
            }, this)
          )
        : (this.settings.center
            ? (this.settings.rtl && ((e = -1), (f = b + 1)),
              (c = this._coordinates[b]),
              (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e))
            : (c = this._coordinates[f] || 0),
          (c = Math.ceil(c)))
    }),
    (e.prototype.duration = function (a, b, c) {
      return 0 === c
        ? 0
        : Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed)
    }),
    (e.prototype.to = function (a, b) {
      var c = this.current(),
        d = null,
        e = a - this.relative(c),
        f = (e > 0) - (e < 0),
        g = this._items.length,
        h = this.minimum(),
        i = this.maximum()
      this.settings.loop
        ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g),
          (a = c + e),
          (d = ((((a - h) % g) + g) % g) + h) !== a &&
            d - e <= i &&
            d - e > 0 &&
            ((c = d - e), (a = d), this.reset(c)))
        : this.settings.rewind
        ? ((i += 1), (a = ((a % i) + i) % i))
        : (a = Math.max(h, Math.min(i, a))),
        this.speed(this.duration(c, a, b)),
        this.current(a),
        this.isVisible() && this.update()
    }),
    (e.prototype.next = function (a) {
      ;(a = a || !1), this.to(this.relative(this.current()) + 1, a)
    }),
    (e.prototype.prev = function (a) {
      ;(a = a || !1), this.to(this.relative(this.current()) - 1, a)
    }),
    (e.prototype.onTransitionEnd = function (a) {
      if (
        a !== d &&
        (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))
      )
        return !1
      this.leave("animating"), this.trigger("translated")
    }),
    (e.prototype.viewport = function () {
      var d
      return (
        this.options.responsiveBaseElement !== b
          ? (d = a(this.options.responsiveBaseElement).width())
          : b.innerWidth
          ? (d = b.innerWidth)
          : c.documentElement && c.documentElement.clientWidth
          ? (d = c.documentElement.clientWidth)
          : console.warn("Can not detect viewport width."),
        d
      )
    }),
    (e.prototype.replace = function (b) {
      this.$stage.empty(),
        (this._items = []),
        b && (b = b instanceof jQuery ? b : a(b)),
        this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)),
        b
          .filter(function () {
            return 1 === this.nodeType
          })
          .each(
            a.proxy(function (a, b) {
              ;(b = this.prepare(b)),
                this.$stage.append(b),
                this._items.push(b),
                this._mergers.push(
                  1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1
                )
            }, this)
          ),
        this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
        this.invalidate("items")
    }),
    (e.prototype.add = function (b, c) {
      var e = this.relative(this._current)
      ;(c = c === d ? this._items.length : this.normalize(c, !0)),
        (b = b instanceof jQuery ? b : a(b)),
        this.trigger("add", { content: b, position: c }),
        (b = this.prepare(b)),
        0 === this._items.length || c === this._items.length
          ? (0 === this._items.length && this.$stage.append(b),
            0 !== this._items.length && this._items[c - 1].after(b),
            this._items.push(b),
            this._mergers.push(
              1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1
            ))
          : (this._items[c].before(b),
            this._items.splice(c, 0, b),
            this._mergers.splice(
              c,
              0,
              1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1
            )),
        this._items[e] && this.reset(this._items[e].index()),
        this.invalidate("items"),
        this.trigger("added", { content: b, position: c })
    }),
    (e.prototype.remove = function (a) {
      ;(a = this.normalize(a, !0)) !== d &&
        (this.trigger("remove", { content: this._items[a], position: a }),
        this._items[a].remove(),
        this._items.splice(a, 1),
        this._mergers.splice(a, 1),
        this.invalidate("items"),
        this.trigger("removed", { content: null, position: a }))
    }),
    (e.prototype.preloadAutoWidthImages = function (b) {
      b.each(
        a.proxy(function (b, c) {
          this.enter("pre-loading"),
            (c = a(c)),
            a(new Image())
              .one(
                "load",
                a.proxy(function (a) {
                  c.attr("src", a.target.src),
                    c.css("opacity", 1),
                    this.leave("pre-loading"),
                    !this.is("pre-loading") && !this.is("initializing") && this.refresh()
                }, this)
              )
              .attr("src", c.attr("src") || c.attr("data-src") || c.attr("data-src-retina"))
        }, this)
      )
    }),
    (e.prototype.destroy = function () {
      this.$element.off(".owl.core"),
        this.$stage.off(".owl.core"),
        a(c).off(".owl.core"),
        !1 !== this.settings.responsive &&
          (b.clearTimeout(this.resizeTimer),
          this.off(b, "resize", this._handlers.onThrottledResize))
      for (var d in this._plugins) this._plugins[d].destroy()
      this.$stage.children(".cloned").remove(),
        this.$stage.unwrap(),
        this.$stage.children().contents().unwrap(),
        this.$stage.children().unwrap(),
        this.$stage.remove(),
        this.$element
          .removeClass(this.options.refreshClass)
          .removeClass(this.options.loadingClass)
          .removeClass(this.options.loadedClass)
          .removeClass(this.options.rtlClass)
          .removeClass(this.options.dragClass)
          .removeClass(this.options.grabClass)
          .attr(
            "class",
            this.$element
              .attr("class")
              .replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")
          )
          .removeData("owl.carousel")
    }),
    (e.prototype.op = function (a, b, c) {
      var d = this.settings.rtl
      switch (b) {
        case "<":
          return d ? a > c : a < c
        case ">":
          return d ? a < c : a > c
        case ">=":
          return d ? a <= c : a >= c
        case "<=":
          return d ? a >= c : a <= c
      }
    }),
    (e.prototype.on = function (a, b, c, d) {
      a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c)
    }),
    (e.prototype.off = function (a, b, c, d) {
      a.removeEventListener
        ? a.removeEventListener(b, c, d)
        : a.detachEvent && a.detachEvent("on" + b, c)
    }),
    (e.prototype.trigger = function (b, c, d, f, g) {
      var h = { item: { count: this._items.length, index: this.current() } },
        i = a.camelCase(
          a
            .grep(["on", b, d], function (a) {
              return a
            })
            .join("-")
            .toLowerCase()
        ),
        j = a.Event(
          [b, "owl", d || "carousel"].join(".").toLowerCase(),
          a.extend({ relatedTarget: this }, h, c)
        )
      return (
        this._supress[b] ||
          (a.each(this._plugins, function (a, b) {
            b.onTrigger && b.onTrigger(j)
          }),
          this.register({ type: e.Type.Event, name: b }),
          this.$element.trigger(j),
          this.settings && "function" == typeof this.settings[i] && this.settings[i].call(this, j)),
        j
      )
    }),
    (e.prototype.enter = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b] === d && (this._states.current[b] = 0), this._states.current[b]++
        }, this)
      )
    }),
    (e.prototype.leave = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b]--
        }, this)
      )
    }),
    (e.prototype.register = function (b) {
      if (b.type === e.Type.Event) {
        if (
          (a.event.special[b.name] || (a.event.special[b.name] = {}), !a.event.special[b.name].owl)
        ) {
          var c = a.event.special[b.name]._default
          ;(a.event.special[b.name]._default = function (a) {
            return !c || !c.apply || (a.namespace && -1 !== a.namespace.indexOf("owl"))
              ? a.namespace && a.namespace.indexOf("owl") > -1
              : c.apply(this, arguments)
          }),
            (a.event.special[b.name].owl = !0)
        }
      } else
        b.type === e.Type.State &&
          (this._states.tags[b.name]
            ? (this._states.tags[b.name] = this._states.tags[b.name].concat(b.tags))
            : (this._states.tags[b.name] = b.tags),
          (this._states.tags[b.name] = a.grep(
            this._states.tags[b.name],
            a.proxy(function (c, d) {
              return a.inArray(c, this._states.tags[b.name]) === d
            }, this)
          )))
    }),
    (e.prototype.suppress = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          this._supress[b] = !0
        }, this)
      )
    }),
    (e.prototype.release = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          delete this._supress[b]
        }, this)
      )
    }),
    (e.prototype.pointer = function (a) {
      var c = { x: null, y: null }
      return (
        (a = a.originalEvent || a || b.event),
        (a =
          a.touches && a.touches.length
            ? a.touches[0]
            : a.changedTouches && a.changedTouches.length
            ? a.changedTouches[0]
            : a),
        a.pageX ? ((c.x = a.pageX), (c.y = a.pageY)) : ((c.x = a.clientX), (c.y = a.clientY)),
        c
      )
    }),
    (e.prototype.isNumeric = function (a) {
      return !isNaN(parseFloat(a))
    }),
    (e.prototype.difference = function (a, b) {
      return { x: a.x - b.x, y: a.y - b.y }
    }),
    (a.fn.owlCarousel = function (b) {
      var c = Array.prototype.slice.call(arguments, 1)
      return this.each(function () {
        var d = a(this),
          f = d.data("owl.carousel")
        f ||
          ((f = new e(this, "object" == typeof b && b)),
          d.data("owl.carousel", f),
          a.each(
            ["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"],
            function (b, c) {
              f.register({ type: e.Type.Event, name: c }),
                f.$element.on(
                  c + ".owl.carousel.core",
                  a.proxy(function (a) {
                    a.namespace &&
                      a.relatedTarget !== this &&
                      (this.suppress([c]),
                      f[c].apply(this, [].slice.call(arguments, 1)),
                      this.release([c]))
                  }, f)
                )
            }
          )),
          "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c)
      })
    }),
    (a.fn.owlCarousel.Constructor = e)
})(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      ;(this._core = b),
        (this._interval = null),
        (this._visible = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoRefresh && this.watch()
          }, this)
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers)
    }
    ;(e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
      (e.prototype.watch = function () {
        this._interval ||
          ((this._visible = this._core.isVisible()),
          (this._interval = b.setInterval(
            a.proxy(this.refresh, this),
            this._core.settings.autoRefreshInterval
          )))
      }),
      (e.prototype.refresh = function () {
        this._core.isVisible() !== this._visible &&
          ((this._visible = !this._visible),
          this._core.$element.toggleClass("owl-hidden", !this._visible),
          this._visible && this._core.invalidate("width") && this._core.refresh())
      }),
      (e.prototype.destroy = function () {
        var a, c
        b.clearInterval(this._interval)
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a])
        for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null)
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e)
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      ;(this._core = b),
        (this._loaded = []),
        (this._handlers = {
          "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (
            b
          ) {
            if (
              b.namespace &&
              this._core.settings &&
              this._core.settings.lazyLoad &&
              ((b.property && "position" == b.property.name) || "initialized" == b.type)
            ) {
              var c = this._core.settings,
                e = (c.center && Math.ceil(c.items / 2)) || c.items,
                f = (c.center && -1 * e) || 0,
                g =
                  (b.property && b.property.value !== d ? b.property.value : this._core.current()) +
                  f,
                h = this._core.clones().length,
                i = a.proxy(function (a, b) {
                  this.load(b)
                }, this)
              for (
                c.lazyLoadEager > 0 &&
                ((e += c.lazyLoadEager), c.loop && ((g -= c.lazyLoadEager), e++));
                f++ < e;

              )
                this.load(h / 2 + this._core.relative(g)),
                  h && a.each(this._core.clones(this._core.relative(g)), i),
                  g++
            }
          },
          this)
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers)
    }
    ;(e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
      (e.prototype.load = function (c) {
        var d = this._core.$stage.children().eq(c),
          e = d && d.find(".owl-lazy")
        !e ||
          a.inArray(d.get(0), this._loaded) > -1 ||
          (e.each(
            a.proxy(function (c, d) {
              var e,
                f = a(d),
                g =
                  (b.devicePixelRatio > 1 && f.attr("data-src-retina")) ||
                  f.attr("data-src") ||
                  f.attr("data-srcset")
              this._core.trigger("load", { element: f, url: g }, "lazy"),
                f.is("img")
                  ? f
                      .one(
                        "load.owl.lazy",
                        a.proxy(function () {
                          f.css("opacity", 1),
                            this._core.trigger("loaded", { element: f, url: g }, "lazy")
                        }, this)
                      )
                      .attr("src", g)
                  : f.is("source")
                  ? f
                      .one(
                        "load.owl.lazy",
                        a.proxy(function () {
                          this._core.trigger("loaded", { element: f, url: g }, "lazy")
                        }, this)
                      )
                      .attr("srcset", g)
                  : ((e = new Image()),
                    (e.onload = a.proxy(function () {
                      f.css({ "background-image": 'url("' + g + '")', opacity: "1" }),
                        this._core.trigger("loaded", { element: f, url: g }, "lazy")
                    }, this)),
                    (e.src = g))
            }, this)
          ),
          this._loaded.push(d.get(0)))
      }),
      (e.prototype.destroy = function () {
        var a, b
        for (a in this.handlers) this._core.$element.off(a, this.handlers[a])
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Lazy = e)
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (c) {
      ;(this._core = c),
        (this._previousHeight = null),
        (this._handlers = {
          "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoHeight && this.update()
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              "position" === a.property.name &&
              this.update()
          }, this),
          "loaded.owl.lazy": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              a.element.closest("." + this._core.settings.itemClass).index() ===
                this._core.current() &&
              this.update()
          }, this)
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        (this._intervalId = null)
      var d = this
      a(b).on("load", function () {
        d._core.settings.autoHeight && d.update()
      }),
        a(b).resize(function () {
          d._core.settings.autoHeight &&
            (null != d._intervalId && clearTimeout(d._intervalId),
            (d._intervalId = setTimeout(function () {
              d.update()
            }, 250)))
        })
    }
    ;(e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
      (e.prototype.update = function () {
        var b = this._core._current,
          c = b + this._core.settings.items,
          d = this._core.settings.lazyLoad,
          e = this._core.$stage.children().toArray().slice(b, c),
          f = [],
          g = 0
        a.each(e, function (b, c) {
          f.push(a(c).height())
        }),
          (g = Math.max.apply(null, f)),
          g <= 1 && d && this._previousHeight && (g = this._previousHeight),
          (this._previousHeight = g),
          this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass)
      }),
      (e.prototype.destroy = function () {
        var a, b
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a])
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e)
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      ;(this._core = b),
        (this._videos = {}),
        (this._playing = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.register({ type: "state", name: "playing", tags: ["interacting"] })
          }, this),
          "resize.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault()
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.is("resizing") &&
              this._core.$stage.find(".cloned .owl-video-frame").remove()
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "position" === a.property.name && this._playing && this.stop()
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content).find(".owl-video")
              c.length && (c.css("display", "none"), this.fetch(c, a(b.content)))
            }
          }, this)
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        this._core.$element.on(
          "click.owl.video",
          ".owl-video-play-icon",
          a.proxy(function (a) {
            this.play(a)
          }, this)
        )
    }
    ;(e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
      (e.prototype.fetch = function (a, b) {
        var c = (function () {
            return a.attr("data-vimeo-id") ? "vimeo" : a.attr("data-vzaar-id") ? "vzaar" : "youtube"
          })(),
          d = a.attr("data-vimeo-id") || a.attr("data-youtube-id") || a.attr("data-vzaar-id"),
          e = a.attr("data-width") || this._core.settings.videoWidth,
          f = a.attr("data-height") || this._core.settings.videoHeight,
          g = a.attr("href")
        if (!g) throw new Error("Missing video URL.")
        if (
          ((d = g.match(
            /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
          )),
          d[3].indexOf("youtu") > -1)
        )
          c = "youtube"
        else if (d[3].indexOf("vimeo") > -1) c = "vimeo"
        else {
          if (!(d[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.")
          c = "vzaar"
        }
        ;(d = d[6]),
          (this._videos[g] = { type: c, id: d, width: e, height: f }),
          b.attr("data-video", g),
          this.thumbnail(a, this._videos[g])
      }),
      (e.prototype.thumbnail = function (b, c) {
        var d,
          e,
          f,
          g = c.width && c.height ? "width:" + c.width + "px;height:" + c.height + "px;" : "",
          h = b.find("img"),
          i = "src",
          j = "",
          k = this._core.settings,
          l = function (c) {
            ;(e = '<div class="owl-video-play-icon"></div>'),
              (d = k.lazyLoad
                ? a("<div/>", { class: "owl-video-tn " + j, srcType: c })
                : a("<div/>", {
                    class: "owl-video-tn",
                    style: "opacity:1;background-image:url(" + c + ")"
                  })),
              b.after(d),
              b.after(e)
          }
        if (
          (b.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })),
          this._core.settings.lazyLoad && ((i = "data-src"), (j = "owl-lazy")),
          h.length)
        )
          return l(h.attr(i)), h.remove(), !1
        "youtube" === c.type
          ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"), l(f))
          : "vimeo" === c.type
          ? a.ajax({
              type: "GET",
              url: "//vimeo.com/api/v2/video/" + c.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (a) {
                ;(f = a[0].thumbnail_large), l(f)
              }
            })
          : "vzaar" === c.type &&
            a.ajax({
              type: "GET",
              url: "//vzaar.com/api/videos/" + c.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (a) {
                ;(f = a.framegrab_url), l(f)
              }
            })
      }),
      (e.prototype.stop = function () {
        this._core.trigger("stop", null, "video"),
          this._playing.find(".owl-video-frame").remove(),
          this._playing.removeClass("owl-video-playing"),
          (this._playing = null),
          this._core.leave("playing"),
          this._core.trigger("stopped", null, "video")
      }),
      (e.prototype.play = function (b) {
        var c,
          d = a(b.target),
          e = d.closest("." + this._core.settings.itemClass),
          f = this._videos[e.attr("data-video")],
          g = f.width || "100%",
          h = f.height || this._core.$stage.height()
        this._playing ||
          (this._core.enter("playing"),
          this._core.trigger("play", null, "video"),
          (e = this._core.items(this._core.relative(e.index()))),
          this._core.reset(e.index()),
          (c = a(
            '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'
          )),
          c.attr("height", h),
          c.attr("width", g),
          "youtube" === f.type
            ? c.attr("src", "//www.youtube.com/embed/" + f.id + "?autoplay=1&rel=0&v=" + f.id)
            : "vimeo" === f.type
            ? c.attr("src", "//player.vimeo.com/video/" + f.id + "?autoplay=1")
            : "vzaar" === f.type &&
              c.attr("src", "//view.vzaar.com/" + f.id + "/player?autoplay=true"),
          a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),
          (this._playing = e.addClass("owl-video-playing")))
      }),
      (e.prototype.isInFullScreen = function () {
        var b = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement
        return b && a(b).parent().hasClass("owl-video-frame")
      }),
      (e.prototype.destroy = function () {
        var a, b
        this._core.$element.off("click.owl.video")
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a])
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Video = e)
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      ;(this.core = b),
        (this.core.options = a.extend({}, e.Defaults, this.core.options)),
        (this.swapping = !0),
        (this.previous = d),
        (this.next = d),
        (this.handlers = {
          "change.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" == a.property.name &&
              ((this.previous = this.core.current()), (this.next = a.property.value))
          }, this),
          "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function (a) {
            a.namespace && (this.swapping = "translated" == a.type)
          }, this),
          "translate.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this.swapping &&
              (this.core.options.animateOut || this.core.options.animateIn) &&
              this.swap()
          }, this)
        }),
        this.core.$element.on(this.handlers)
    }
    ;(e.Defaults = { animateOut: !1, animateIn: !1 }),
      (e.prototype.swap = function () {
        if (1 === this.core.settings.items && a.support.animation && a.support.transition) {
          this.core.speed(0)
          var b,
            c = a.proxy(this.clear, this),
            d = this.core.$stage.children().eq(this.previous),
            e = this.core.$stage.children().eq(this.next),
            f = this.core.settings.animateIn,
            g = this.core.settings.animateOut
          this.core.current() !== this.previous &&
            (g &&
              ((b = this.core.coordinates(this.previous) - this.core.coordinates(this.next)),
              d
                .one(a.support.animation.end, c)
                .css({ left: b + "px" })
                .addClass("animated owl-animated-out")
                .addClass(g)),
            f && e.one(a.support.animation.end, c).addClass("animated owl-animated-in").addClass(f))
        }
      }),
      (e.prototype.clear = function (b) {
        a(b.target)
          .css({ left: "" })
          .removeClass("animated owl-animated-out owl-animated-in")
          .removeClass(this.core.settings.animateIn)
          .removeClass(this.core.settings.animateOut),
          this.core.onTransitionEnd()
      }),
      (e.prototype.destroy = function () {
        var a, b
        for (a in this.handlers) this.core.$element.off(a, this.handlers[a])
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Animate = e)
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      ;(this._core = b),
        (this._call = null),
        (this._time = 0),
        (this._timeout = 0),
        (this._paused = !0),
        (this._handlers = {
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "settings" === a.property.name
              ? this._core.settings.autoplay
                ? this.play()
                : this.stop()
              : a.namespace && "position" === a.property.name && this._paused && (this._time = 0)
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoplay && this.play()
          }, this),
          "play.owl.autoplay": a.proxy(function (a, b, c) {
            a.namespace && this.play(b, c)
          }, this),
          "stop.owl.autoplay": a.proxy(function (a) {
            a.namespace && this.stop()
          }, this),
          "mouseover.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
          }, this),
          "mouseleave.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
          }, this),
          "touchstart.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
          }, this),
          "touchend.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause && this.play()
          }, this)
        }),
        this._core.$element.on(this._handlers),
        (this._core.options = a.extend({}, e.Defaults, this._core.options))
    }
    ;(e.Defaults = {
      autoplay: !1,
      autoplayTimeout: 5e3,
      autoplayHoverPause: !1,
      autoplaySpeed: !1
    }),
      (e.prototype._next = function (d) {
        ;(this._call = b.setTimeout(
          a.proxy(this._next, this, d),
          this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
        )),
          this._core.is("interacting") ||
            c.hidden ||
            this._core.next(d || this._core.settings.autoplaySpeed)
      }),
      (e.prototype.read = function () {
        return new Date().getTime() - this._time
      }),
      (e.prototype.play = function (c, d) {
        var e
        this._core.is("rotating") || this._core.enter("rotating"),
          (c = c || this._core.settings.autoplayTimeout),
          (e = Math.min(this._time % (this._timeout || c), c)),
          this._paused
            ? ((this._time = this.read()), (this._paused = !1))
            : b.clearTimeout(this._call),
          (this._time += (this.read() % c) - e),
          (this._timeout = c),
          (this._call = b.setTimeout(a.proxy(this._next, this, d), c - e))
      }),
      (e.prototype.stop = function () {
        this._core.is("rotating") &&
          ((this._time = 0),
          (this._paused = !0),
          b.clearTimeout(this._call),
          this._core.leave("rotating"))
      }),
      (e.prototype.pause = function () {
        this._core.is("rotating") &&
          !this._paused &&
          ((this._time = this.read()), (this._paused = !0), b.clearTimeout(this._call))
      }),
      (e.prototype.destroy = function () {
        var a, b
        this.stop()
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a])
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
      }),
      (a.fn.owlCarousel.Constructor.Plugins.autoplay = e)
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict"
    var e = function (b) {
      ;(this._core = b),
        (this._initialized = !1),
        (this._pages = []),
        (this._controls = {}),
        (this._templates = []),
        (this.$element = this._core.$element),
        (this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }),
        (this._handlers = {
          "prepared.owl.carousel": a.proxy(function (b) {
            b.namespace &&
              this._core.settings.dotsData &&
              this._templates.push(
                '<div class="' +
                  this._core.settings.dotClass +
                  '">' +
                  a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") +
                  "</div>"
              )
          }, this),
          "added.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 0, this._templates.pop())
          }, this),
          "remove.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1)
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "position" == a.property.name && this.draw()
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              !this._initialized &&
              (this._core.trigger("initialize", null, "navigation"),
              this.initialize(),
              this.update(),
              this.draw(),
              (this._initialized = !0),
              this._core.trigger("initialized", null, "navigation"))
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._initialized &&
              (this._core.trigger("refresh", null, "navigation"),
              this.update(),
              this.draw(),
              this._core.trigger("refreshed", null, "navigation"))
          }, this)
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers)
    }
    ;(e.Defaults = {
      nav: !1,
      navText: [
        '<span aria-label="Previous">&#x2039;</span>',
        '<span aria-label="Next">&#x203a;</span>'
      ],
      navSpeed: !1,
      navElement: 'button type="button" role="presentation"',
      navContainer: !1,
      navContainerClass: "owl-nav",
      navClass: ["owl-prev", "owl-next"],
      slideBy: 1,
      dotClass: "owl-dot",
      dotsClass: "owl-dots",
      dots: !0,
      dotsEach: !1,
      dotsData: !1,
      dotsSpeed: !1,
      dotsContainer: !1
    }),
      (e.prototype.initialize = function () {
        var b,
          c = this._core.settings
        ;(this._controls.$relative = (
          c.navContainer
            ? a(c.navContainer)
            : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)
        ).addClass("disabled")),
          (this._controls.$previous = a("<" + c.navElement + ">")
            .addClass(c.navClass[0])
            .html(c.navText[0])
            .prependTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.prev(c.navSpeed)
              }, this)
            )),
          (this._controls.$next = a("<" + c.navElement + ">")
            .addClass(c.navClass[1])
            .html(c.navText[1])
            .appendTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.next(c.navSpeed)
              }, this)
            )),
          c.dotsData ||
            (this._templates = [
              a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")
            ]),
          (this._controls.$absolute = (
            c.dotsContainer
              ? a(c.dotsContainer)
              : a("<div>").addClass(c.dotsClass).appendTo(this.$element)
          ).addClass("disabled")),
          this._controls.$absolute.on(
            "click",
            "button",
            a.proxy(function (b) {
              var d = a(b.target).parent().is(this._controls.$absolute)
                ? a(b.target).index()
                : a(b.target).parent().index()
              b.preventDefault(), this.to(d, c.dotsSpeed)
            }, this)
          )
        for (b in this._overrides) this._core[b] = a.proxy(this[b], this)
      }),
      (e.prototype.destroy = function () {
        var a, b, c, d, e
        e = this._core.settings
        for (a in this._handlers) this.$element.off(a, this._handlers[a])
        for (b in this._controls)
          "$relative" === b && e.navContainer
            ? this._controls[b].html("")
            : this._controls[b].remove()
        for (d in this.overides) this._core[d] = this._overrides[d]
        for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null)
      }),
      (e.prototype.update = function () {
        var a,
          b,
          c,
          d = this._core.clones().length / 2,
          e = d + this._core.items().length,
          f = this._core.maximum(!0),
          g = this._core.settings,
          h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items
        if (
          ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)),
          g.dots || "page" == g.slideBy)
        )
          for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
            if (b >= h || 0 === b) {
              if (
                (this._pages.push({ start: Math.min(f, a - d), end: a - d + h - 1 }),
                Math.min(f, a - d) === f)
              )
                break
              ;(b = 0), ++c
            }
            b += this._core.mergers(this._core.relative(a))
          }
      }),
      (e.prototype.draw = function () {
        var b,
          c = this._core.settings,
          d = this._core.items().length <= c.items,
          e = this._core.relative(this._core.current()),
          f = c.loop || c.rewind
        this._controls.$relative.toggleClass("disabled", !c.nav || d),
          c.nav &&
            (this._controls.$previous.toggleClass("disabled", !f && e <= this._core.minimum(!0)),
            this._controls.$next.toggleClass("disabled", !f && e >= this._core.maximum(!0))),
          this._controls.$absolute.toggleClass("disabled", !c.dots || d),
          c.dots &&
            ((b = this._pages.length - this._controls.$absolute.children().length),
            c.dotsData && 0 !== b
              ? this._controls.$absolute.html(this._templates.join(""))
              : b > 0
              ? this._controls.$absolute.append(new Array(b + 1).join(this._templates[0]))
              : b < 0 && this._controls.$absolute.children().slice(b).remove(),
            this._controls.$absolute.find(".active").removeClass("active"),
            this._controls.$absolute
              .children()
              .eq(a.inArray(this.current(), this._pages))
              .addClass("active"))
      }),
      (e.prototype.onTrigger = function (b) {
        var c = this._core.settings
        b.page = {
          index: a.inArray(this.current(), this._pages),
          count: this._pages.length,
          size: c && (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items)
        }
      }),
      (e.prototype.current = function () {
        var b = this._core.relative(this._core.current())
        return a
          .grep(
            this._pages,
            a.proxy(function (a, c) {
              return a.start <= b && a.end >= b
            }, this)
          )
          .pop()
      }),
      (e.prototype.getPosition = function (b) {
        var c,
          d,
          e = this._core.settings
        return (
          "page" == e.slideBy
            ? ((c = a.inArray(this.current(), this._pages)),
              (d = this._pages.length),
              b ? ++c : --c,
              (c = this._pages[((c % d) + d) % d].start))
            : ((c = this._core.relative(this._core.current())),
              (d = this._core.items().length),
              b ? (c += e.slideBy) : (c -= e.slideBy)),
          c
        )
      }),
      (e.prototype.next = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b)
      }),
      (e.prototype.prev = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b)
      }),
      (e.prototype.to = function (b, c, d) {
        var e
        !d && this._pages.length
          ? ((e = this._pages.length),
            a.proxy(this._overrides.to, this._core)(this._pages[((b % e) + e) % e].start, c))
          : a.proxy(this._overrides.to, this._core)(b, c)
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Navigation = e)
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict"
    var e = function (c) {
      ;(this._core = c),
        (this._hashes = {}),
        (this.$element = this._core.$element),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (c) {
            c.namespace &&
              "URLHash" === this._core.settings.startPosition &&
              a(b).trigger("hashchange.owl.navigation")
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash")
              if (!c) return
              this._hashes[c] = b.content
            }
          }, this),
          "changed.owl.carousel": a.proxy(function (c) {
            if (c.namespace && "position" === c.property.name) {
              var d = this._core.items(this._core.relative(this._core.current())),
                e = a
                  .map(this._hashes, function (a, b) {
                    return a === d ? b : null
                  })
                  .join()
              if (!e || b.location.hash.slice(1) === e) return
              b.location.hash = e
            }
          }, this)
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers),
        a(b).on(
          "hashchange.owl.navigation",
          a.proxy(function (a) {
            var c = b.location.hash.substring(1),
              e = this._core.$stage.children(),
              f = this._hashes[c] && e.index(this._hashes[c])
            f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), !1, !0)
          }, this)
        )
    }
    ;(e.Defaults = { URLhashListener: !1 }),
      (e.prototype.destroy = function () {
        var c, d
        a(b).off("hashchange.owl.navigation")
        for (c in this._handlers) this._core.$element.off(c, this._handlers[c])
        for (d in Object.getOwnPropertyNames(this)) "function" != typeof this[d] && (this[d] = null)
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Hash = e)
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    function e(b, c) {
      var e = !1,
        f = b.charAt(0).toUpperCase() + b.slice(1)
      return (
        a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
          if (g[b] !== d) return (e = !c || b), !1
        }),
        e
      )
    }
    function f(a) {
      return e(a, !0)
    }
    var g = a("<support>").get(0).style,
      h = "Webkit Moz O ms".split(" "),
      i = {
        transition: {
          end: {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd",
            transition: "transitionend"
          }
        },
        animation: {
          end: {
            WebkitAnimation: "webkitAnimationEnd",
            MozAnimation: "animationend",
            OAnimation: "oAnimationEnd",
            animation: "animationend"
          }
        }
      },
      j = {
        csstransforms: function () {
          return !!e("transform")
        },
        csstransforms3d: function () {
          return !!e("perspective")
        },
        csstransitions: function () {
          return !!e("transition")
        },
        cssanimations: function () {
          return !!e("animation")
        }
      }
    j.csstransitions() &&
      ((a.support.transition = new String(f("transition"))),
      (a.support.transition.end = i.transition.end[a.support.transition])),
      j.cssanimations() &&
        ((a.support.animation = new String(f("animation"))),
        (a.support.animation.end = i.animation.end[a.support.animation])),
      j.csstransforms() &&
        ((a.support.transform = new String(f("transform"))),
        (a.support.transform3d = j.csstransforms3d()))
  })(window.Zepto || window.jQuery, window, document)
/*** @license* Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE */
;(function () {
  function n(n, t, r) {
    switch (r.length) {
      case 0:
        return n.call(t)
      case 1:
        return n.call(t, r[0])
      case 2:
        return n.call(t, r[0], r[1])
      case 3:
        return n.call(t, r[0], r[1], r[2])
    }
    return n.apply(t, r)
  }
  function t(n, t, r, e) {
    for (var u = -1, i = null == n ? 0 : n.length; ++u < i; ) {
      var o = n[u]
      t(e, o, r(o), n)
    }
    return e
  }
  function r(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e && false !== t(n[r], r, n); );
    return n
  }
  function e(n, t) {
    for (var r = null == n ? 0 : n.length; r-- && false !== t(n[r], r, n); );
    return n
  }
  function u(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e; ) if (!t(n[r], r, n)) return false
    return true
  }
  function i(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length, u = 0, i = []; ++r < e; ) {
      var o = n[r]
      t(o, r, n) && (i[u++] = o)
    }
    return i
  }
  function o(n, t) {
    return !(null == n || !n.length) && -1 < v(n, t, 0)
  }
  function f(n, t, r) {
    for (var e = -1, u = null == n ? 0 : n.length; ++e < u; ) if (r(t, n[e])) return true
    return false
  }
  function c(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length, u = Array(e); ++r < e; ) u[r] = t(n[r], r, n)
    return u
  }
  function a(n, t) {
    for (var r = -1, e = t.length, u = n.length; ++r < e; ) n[u + r] = t[r]
    return n
  }
  function l(n, t, r, e) {
    var u = -1,
      i = null == n ? 0 : n.length
    for (e && i && (r = n[++u]); ++u < i; ) r = t(r, n[u], u, n)
    return r
  }
  function s(n, t, r, e) {
    var u = null == n ? 0 : n.length
    for (e && u && (r = n[--u]); u--; ) r = t(r, n[u], u, n)
    return r
  }
  function h(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e; ) if (t(n[r], r, n)) return true
    return false
  }
  function p(n, t, r) {
    var e
    return (
      r(n, function (n, r, u) {
        if (t(n, r, u)) return (e = r), false
      }),
      e
    )
  }
  function _(n, t, r, e) {
    var u = n.length
    for (r += e ? 1 : -1; e ? r-- : ++r < u; ) if (t(n[r], r, n)) return r
    return -1
  }
  function v(n, t, r) {
    if (t === t)
      n: {
        --r
        for (var e = n.length; ++r < e; )
          if (n[r] === t) {
            n = r
            break n
          }
        n = -1
      }
    else n = _(n, d, r)
    return n
  }
  function g(n, t, r, e) {
    --r
    for (var u = n.length; ++r < u; ) if (e(n[r], t)) return r
    return -1
  }
  function d(n) {
    return n !== n
  }
  function y(n, t) {
    var r = null == n ? 0 : n.length
    return r ? m(n, t) / r : F
  }
  function b(n) {
    return function (t) {
      return null == t ? T : t[n]
    }
  }
  function x(n) {
    return function (t) {
      return null == n ? T : n[t]
    }
  }
  function j(n, t, r, e, u) {
    return (
      u(n, function (n, u, i) {
        r = e ? ((e = false), n) : t(r, n, u, i)
      }),
      r
    )
  }
  function w(n, t) {
    var r = n.length
    for (n.sort(t); r--; ) n[r] = n[r].c
    return n
  }
  function m(n, t) {
    for (var r, e = -1, u = n.length; ++e < u; ) {
      var i = t(n[e])
      i !== T && (r = r === T ? i : r + i)
    }
    return r
  }
  function A(n, t) {
    for (var r = -1, e = Array(n); ++r < n; ) e[r] = t(r)
    return e
  }
  function E(n, t) {
    return c(t, function (t) {
      return [t, n[t]]
    })
  }
  function k(n) {
    return function (t) {
      return n(t)
    }
  }
  function S(n, t) {
    return c(t, function (t) {
      return n[t]
    })
  }
  function O(n, t) {
    return n.has(t)
  }
  function I(n, t) {
    for (var r = -1, e = n.length; ++r < e && -1 < v(t, n[r], 0); );
    return r
  }
  function R(n, t) {
    for (var r = n.length; r-- && -1 < v(t, n[r], 0); );
    return r
  }
  function z(n) {
    return "\\" + Un[n]
  }
  function W(n) {
    var t = -1,
      r = Array(n.size)
    return (
      n.forEach(function (n, e) {
        r[++t] = [e, n]
      }),
      r
    )
  }
  function B(n, t) {
    return function (r) {
      return n(t(r))
    }
  }
  function L(n, t) {
    for (var r = -1, e = n.length, u = 0, i = []; ++r < e; ) {
      var o = n[r]
      ;(o !== t && "__lodash_placeholder__" !== o) ||
        ((n[r] = "__lodash_placeholder__"), (i[u++] = r))
    }
    return i
  }
  function U(n) {
    var t = -1,
      r = Array(n.size)
    return (
      n.forEach(function (n) {
        r[++t] = n
      }),
      r
    )
  }
  function C(n) {
    var t = -1,
      r = Array(n.size)
    return (
      n.forEach(function (n) {
        r[++t] = [n, n]
      }),
      r
    )
  }
  function D(n) {
    if (Rn.test(n)) {
      for (var t = (On.lastIndex = 0); On.test(n); ) ++t
      n = t
    } else n = Qn(n)
    return n
  }
  function M(n) {
    return Rn.test(n) ? n.match(On) || [] : n.split("")
  }
  var T,
    $ = 1 / 0,
    F = NaN,
    N = [
      ["ary", 128],
      ["bind", 1],
      ["bindKey", 2],
      ["curry", 8],
      ["curryRight", 16],
      ["flip", 512],
      ["partial", 32],
      ["partialRight", 64],
      ["rearg", 256]
    ],
    P = /\b__p\+='';/g,
    Z = /\b(__p\+=)''\+/g,
    q = /(__e\(.*?\)|\b__t\))\+'';/g,
    V = /&(?:amp|lt|gt|quot|#39);/g,
    K = /[&<>"']/g,
    G = RegExp(V.source),
    H = RegExp(K.source),
    J = /<%-([\s\S]+?)%>/g,
    Y = /<%([\s\S]+?)%>/g,
    Q = /<%=([\s\S]+?)%>/g,
    X = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    nn = /^\w*$/,
    tn =
      /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    rn = /[\\^$.*+?()[\]{}|]/g,
    en = RegExp(rn.source),
    un = /^\s+|\s+$/g,
    on = /^\s+/,
    fn = /\s+$/,
    cn = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    an = /\{\n\/\* \[wrapped with (.+)\] \*/,
    ln = /,? & /,
    sn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
    hn = /\\(\\)?/g,
    pn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
    _n = /\w*$/,
    vn = /^[-+]0x[0-9a-f]+$/i,
    gn = /^0b[01]+$/i,
    dn = /^\[object .+?Constructor\]$/,
    yn = /^0o[0-7]+$/i,
    bn = /^(?:0|[1-9]\d*)$/,
    xn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
    jn = /($^)/,
    wn = /['\n\r\u2028\u2029\\]/g,
    mn =
      "[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",
    An =
      "(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])" +
      mn,
    En =
      "(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",
    kn = RegExp("['\u2019]", "g"),
    Sn = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g"),
    On = RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|" + En + mn, "g"),
    In = RegExp(
      [
        "[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+",
        An
      ].join("|"),
      "g"
    ),
    Rn = RegExp(
      "[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"
    ),
    zn = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
    Wn =
      "Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(
        " "
      ),
    Bn = {}
  ;(Bn["[object Float32Array]"] =
    Bn["[object Float64Array]"] =
    Bn["[object Int8Array]"] =
    Bn["[object Int16Array]"] =
    Bn["[object Int32Array]"] =
    Bn["[object Uint8Array]"] =
    Bn["[object Uint8ClampedArray]"] =
    Bn["[object Uint16Array]"] =
    Bn["[object Uint32Array]"] =
      true),
    (Bn["[object Arguments]"] =
      Bn["[object Array]"] =
      Bn["[object ArrayBuffer]"] =
      Bn["[object Boolean]"] =
      Bn["[object DataView]"] =
      Bn["[object Date]"] =
      Bn["[object Error]"] =
      Bn["[object Function]"] =
      Bn["[object Map]"] =
      Bn["[object Number]"] =
      Bn["[object Object]"] =
      Bn["[object RegExp]"] =
      Bn["[object Set]"] =
      Bn["[object String]"] =
      Bn["[object WeakMap]"] =
        false)
  var Ln = {}
  ;(Ln["[object Arguments]"] =
    Ln["[object Array]"] =
    Ln["[object ArrayBuffer]"] =
    Ln["[object DataView]"] =
    Ln["[object Boolean]"] =
    Ln["[object Date]"] =
    Ln["[object Float32Array]"] =
    Ln["[object Float64Array]"] =
    Ln["[object Int8Array]"] =
    Ln["[object Int16Array]"] =
    Ln["[object Int32Array]"] =
    Ln["[object Map]"] =
    Ln["[object Number]"] =
    Ln["[object Object]"] =
    Ln["[object RegExp]"] =
    Ln["[object Set]"] =
    Ln["[object String]"] =
    Ln["[object Symbol]"] =
    Ln["[object Uint8Array]"] =
    Ln["[object Uint8ClampedArray]"] =
    Ln["[object Uint16Array]"] =
    Ln["[object Uint32Array]"] =
      true),
    (Ln["[object Error]"] = Ln["[object Function]"] = Ln["[object WeakMap]"] = false)
  var Un = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" },
    Cn = parseFloat,
    Dn = parseInt,
    Mn = typeof global == "object" && global && global.Object === Object && global,
    Tn = typeof self == "object" && self && self.Object === Object && self,
    $n = Mn || Tn || Function("return this")(),
    Fn = typeof exports == "object" && exports && !exports.nodeType && exports,
    Nn = Fn && typeof module == "object" && module && !module.nodeType && module,
    Pn = Nn && Nn.exports === Fn,
    Zn = Pn && Mn.process,
    qn = (function () {
      try {
        var n = Nn && Nn.f && Nn.f("util").types
        return n ? n : Zn && Zn.binding && Zn.binding("util")
      } catch (n) {}
    })(),
    Vn = qn && qn.isArrayBuffer,
    Kn = qn && qn.isDate,
    Gn = qn && qn.isMap,
    Hn = qn && qn.isRegExp,
    Jn = qn && qn.isSet,
    Yn = qn && qn.isTypedArray,
    Qn = b("length"),
    Xn = x({
      "\xc0": "A",
      "\xc1": "A",
      "\xc2": "A",
      "\xc3": "A",
      "\xc4": "A",
      "\xc5": "A",
      "\xe0": "a",
      "\xe1": "a",
      "\xe2": "a",
      "\xe3": "a",
      "\xe4": "a",
      "\xe5": "a",
      "\xc7": "C",
      "\xe7": "c",
      "\xd0": "D",
      "\xf0": "d",
      "\xc8": "E",
      "\xc9": "E",
      "\xca": "E",
      "\xcb": "E",
      "\xe8": "e",
      "\xe9": "e",
      "\xea": "e",
      "\xeb": "e",
      "\xcc": "I",
      "\xcd": "I",
      "\xce": "I",
      "\xcf": "I",
      "\xec": "i",
      "\xed": "i",
      "\xee": "i",
      "\xef": "i",
      "\xd1": "N",
      "\xf1": "n",
      "\xd2": "O",
      "\xd3": "O",
      "\xd4": "O",
      "\xd5": "O",
      "\xd6": "O",
      "\xd8": "O",
      "\xf2": "o",
      "\xf3": "o",
      "\xf4": "o",
      "\xf5": "o",
      "\xf6": "o",
      "\xf8": "o",
      "\xd9": "U",
      "\xda": "U",
      "\xdb": "U",
      "\xdc": "U",
      "\xf9": "u",
      "\xfa": "u",
      "\xfb": "u",
      "\xfc": "u",
      "\xdd": "Y",
      "\xfd": "y",
      "\xff": "y",
      "\xc6": "Ae",
      "\xe6": "ae",
      "\xde": "Th",
      "\xfe": "th",
      "\xdf": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010a": "C",
      "\u010c": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010b": "c",
      "\u010d": "c",
      "\u010e": "D",
      "\u0110": "D",
      "\u010f": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011a": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011b": "e",
      "\u011c": "G",
      "\u011e": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011d": "g",
      "\u011f": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012a": "I",
      "\u012c": "I",
      "\u012e": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012b": "i",
      "\u012d": "i",
      "\u012f": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013b": "L",
      "\u013d": "L",
      "\u013f": "L",
      "\u0141": "L",
      "\u013a": "l",
      "\u013c": "l",
      "\u013e": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014a": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014b": "n",
      "\u014c": "O",
      "\u014e": "O",
      "\u0150": "O",
      "\u014d": "o",
      "\u014f": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015a": "S",
      "\u015c": "S",
      "\u015e": "S",
      "\u0160": "S",
      "\u015b": "s",
      "\u015d": "s",
      "\u015f": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016a": "U",
      "\u016c": "U",
      "\u016e": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016b": "u",
      "\u016d": "u",
      "\u016f": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017b": "Z",
      "\u017d": "Z",
      "\u017a": "z",
      "\u017c": "z",
      "\u017e": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017f": "s"
    }),
    nt = x({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }),
    tt = x({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }),
    rt = (function x(mn) {
      function An(n) {
        if (du(n) && !of(n) && !(n instanceof Un)) {
          if (n instanceof On) return n
          if (ii.call(n, "__wrapped__")) return $e(n)
        }
        return new On(n)
      }
      function En() {}
      function On(n, t) {
        ;(this.__wrapped__ = n),
          (this.__actions__ = []),
          (this.__chain__ = !!t),
          (this.__index__ = 0),
          (this.__values__ = T)
      }
      function Un(n) {
        ;(this.__wrapped__ = n),
          (this.__actions__ = []),
          (this.__dir__ = 1),
          (this.__filtered__ = false),
          (this.__iteratees__ = []),
          (this.__takeCount__ = 4294967295),
          (this.__views__ = [])
      }
      function Mn(n) {
        var t = -1,
          r = null == n ? 0 : n.length
        for (this.clear(); ++t < r; ) {
          var e = n[t]
          this.set(e[0], e[1])
        }
      }
      function Tn(n) {
        var t = -1,
          r = null == n ? 0 : n.length
        for (this.clear(); ++t < r; ) {
          var e = n[t]
          this.set(e[0], e[1])
        }
      }
      function Fn(n) {
        var t = -1,
          r = null == n ? 0 : n.length
        for (this.clear(); ++t < r; ) {
          var e = n[t]
          this.set(e[0], e[1])
        }
      }
      function Nn(n) {
        var t = -1,
          r = null == n ? 0 : n.length
        for (this.__data__ = new Fn(); ++t < r; ) this.add(n[t])
      }
      function Zn(n) {
        this.size = (this.__data__ = new Tn(n)).size
      }
      function qn(n, t) {
        var r,
          e = of(n),
          u = !e && uf(n),
          i = !e && !u && cf(n),
          o = !e && !u && !i && pf(n),
          u = (e = e || u || i || o) ? A(n.length, Xu) : [],
          f = u.length
        for (r in n)
          (!t && !ii.call(n, r)) ||
            (e &&
              ("length" == r ||
                (i && ("offset" == r || "parent" == r)) ||
                (o && ("buffer" == r || "byteLength" == r || "byteOffset" == r)) ||
                Se(r, f))) ||
            u.push(r)
        return u
      }
      function Qn(n) {
        var t = n.length
        return t ? n[ir(0, t - 1)] : T
      }
      function et(n, t) {
        return Ce(Ur(n), pt(t, 0, n.length))
      }
      function ut(n) {
        return Ce(Ur(n))
      }
      function it(n, t, r) {
        ;((r === T || au(n[t], r)) && (r !== T || t in n)) || st(n, t, r)
      }
      function ot(n, t, r) {
        var e = n[t]
        ;(ii.call(n, t) && au(e, r) && (r !== T || t in n)) || st(n, t, r)
      }
      function ft(n, t) {
        for (var r = n.length; r--; ) if (au(n[r][0], t)) return r
        return -1
      }
      function ct(n, t, r, e) {
        return (
          eo(n, function (n, u, i) {
            t(e, n, r(n), i)
          }),
          e
        )
      }
      function at(n, t) {
        return n && Cr(t, zu(t), n)
      }
      function lt(n, t) {
        return n && Cr(t, Wu(t), n)
      }
      function st(n, t, r) {
        "__proto__" == t && mi
          ? mi(n, t, { configurable: true, enumerable: true, value: r, writable: true })
          : (n[t] = r)
      }
      function ht(n, t) {
        for (var r = -1, e = t.length, u = Vu(e), i = null == n; ++r < e; )
          u[r] = i ? T : Iu(n, t[r])
        return u
      }
      function pt(n, t, r) {
        return n === n && (r !== T && (n = n <= r ? n : r), t !== T && (n = n >= t ? n : t)), n
      }
      function _t(n, t, e, u, i, o) {
        var f,
          c = 1 & t,
          a = 2 & t,
          l = 4 & t
        if ((e && (f = i ? e(n, u, i, o) : e(n)), f !== T)) return f
        if (!gu(n)) return n
        if ((u = of(n))) {
          if (((f = me(n)), !c)) return Ur(n, f)
        } else {
          var s = _o(n),
            h = "[object Function]" == s || "[object GeneratorFunction]" == s
          if (cf(n)) return Ir(n, c)
          if ("[object Object]" == s || "[object Arguments]" == s || (h && !i)) {
            if (((f = a || h ? {} : Ae(n)), !c)) return a ? Mr(n, lt(f, n)) : Dr(n, at(f, n))
          } else {
            if (!Ln[s]) return i ? n : {}
            f = Ee(n, s, c)
          }
        }
        if ((o || (o = new Zn()), (i = o.get(n)))) return i
        if ((o.set(n, f), hf(n)))
          return (
            n.forEach(function (r) {
              f.add(_t(r, t, e, r, n, o))
            }),
            f
          )
        if (lf(n))
          return (
            n.forEach(function (r, u) {
              f.set(u, _t(r, t, e, u, n, o))
            }),
            f
          )
        var a = l ? (a ? ve : _e) : a ? Wu : zu,
          p = u ? T : a(n)
        return (
          r(p || n, function (r, u) {
            p && ((u = r), (r = n[u])), ot(f, u, _t(r, t, e, u, n, o))
          }),
          f
        )
      }
      function vt(n) {
        var t = zu(n)
        return function (r) {
          return gt(r, n, t)
        }
      }
      function gt(n, t, r) {
        var e = r.length
        if (null == n) return !e
        for (n = Yu(n); e--; ) {
          var u = r[e],
            i = t[u],
            o = n[u]
          if ((o === T && !(u in n)) || !i(o)) return false
        }
        return true
      }
      function dt(n, t, r) {
        if (typeof n != "function") throw new ni("Expected a function")
        return yo(function () {
          n.apply(T, r)
        }, t)
      }
      function yt(n, t, r, e) {
        var u = -1,
          i = o,
          a = true,
          l = n.length,
          s = [],
          h = t.length
        if (!l) return s
        r && (t = c(t, k(r))),
          e ? ((i = f), (a = false)) : 200 <= t.length && ((i = O), (a = false), (t = new Nn(t)))
        n: for (; ++u < l; ) {
          var p = n[u],
            _ = null == r ? p : r(p),
            p = e || 0 !== p ? p : 0
          if (a && _ === _) {
            for (var v = h; v--; ) if (t[v] === _) continue n
            s.push(p)
          } else i(t, _, e) || s.push(p)
        }
        return s
      }
      function bt(n, t) {
        var r = true
        return (
          eo(n, function (n, e, u) {
            return (r = !!t(n, e, u))
          }),
          r
        )
      }
      function xt(n, t, r) {
        for (var e = -1, u = n.length; ++e < u; ) {
          var i = n[e],
            o = t(i)
          if (null != o && (f === T ? o === o && !ju(o) : r(o, f)))
            var f = o,
              c = i
        }
        return c
      }
      function jt(n, t) {
        var r = []
        return (
          eo(n, function (n, e, u) {
            t(n, e, u) && r.push(n)
          }),
          r
        )
      }
      function wt(n, t, r, e, u) {
        var i = -1,
          o = n.length
        for (r || (r = ke), u || (u = []); ++i < o; ) {
          var f = n[i]
          0 < t && r(f) ? (1 < t ? wt(f, t - 1, r, e, u) : a(u, f)) : e || (u[u.length] = f)
        }
        return u
      }
      function mt(n, t) {
        return n && io(n, t, zu)
      }
      function At(n, t) {
        return n && oo(n, t, zu)
      }
      function Et(n, t) {
        return i(t, function (t) {
          return pu(n[t])
        })
      }
      function kt(n, t) {
        t = Sr(t, n)
        for (var r = 0, e = t.length; null != n && r < e; ) n = n[De(t[r++])]
        return r && r == e ? n : T
      }
      function St(n, t, r) {
        return (t = t(n)), of(n) ? t : a(t, r(n))
      }
      function Ot(n) {
        if (null == n) n = n === T ? "[object Undefined]" : "[object Null]"
        else if (wi && wi in Yu(n)) {
          var t = ii.call(n, wi),
            r = n[wi]
          try {
            n[wi] = T
            var e = true
          } catch (n) {}
          var u = ci.call(n)
          e && (t ? (n[wi] = r) : delete n[wi]), (n = u)
        } else n = ci.call(n)
        return n
      }
      function It(n, t) {
        return n > t
      }
      function Rt(n, t) {
        return null != n && ii.call(n, t)
      }
      function zt(n, t) {
        return null != n && t in Yu(n)
      }
      function Wt(n, t, r) {
        for (
          var e = r ? f : o, u = n[0].length, i = n.length, a = i, l = Vu(i), s = 1 / 0, h = [];
          a--;

        ) {
          var p = n[a]
          a && t && (p = c(p, k(t))),
            (s = Ui(p.length, s)),
            (l[a] = !r && (t || (120 <= u && 120 <= p.length)) ? new Nn(a && p) : T)
        }
        var p = n[0],
          _ = -1,
          v = l[0]
        n: for (; ++_ < u && h.length < s; ) {
          var g = p[_],
            d = t ? t(g) : g,
            g = r || 0 !== g ? g : 0
          if (v ? !O(v, d) : !e(h, d, r)) {
            for (a = i; --a; ) {
              var y = l[a]
              if (y ? !O(y, d) : !e(n[a], d, r)) continue n
            }
            v && v.push(d), h.push(g)
          }
        }
        return h
      }
      function Bt(n, t, r) {
        var e = {}
        return (
          mt(n, function (n, u, i) {
            t(e, r(n), u, i)
          }),
          e
        )
      }
      function Lt(t, r, e) {
        return (
          (r = Sr(r, t)),
          (t = 2 > r.length ? t : kt(t, hr(r, 0, -1))),
          (r = null == t ? t : t[De(qe(r))]),
          null == r ? T : n(r, t, e)
        )
      }
      function Ut(n) {
        return du(n) && "[object Arguments]" == Ot(n)
      }
      function Ct(n) {
        return du(n) && "[object ArrayBuffer]" == Ot(n)
      }
      function Dt(n) {
        return du(n) && "[object Date]" == Ot(n)
      }
      function Mt(n, t, r, e, u) {
        if (n === t) t = true
        else if (null == n || null == t || (!du(n) && !du(t))) t = n !== n && t !== t
        else
          n: {
            var i = of(n),
              o = of(t),
              f = i ? "[object Array]" : _o(n),
              c = o ? "[object Array]" : _o(t),
              f = "[object Arguments]" == f ? "[object Object]" : f,
              c = "[object Arguments]" == c ? "[object Object]" : c,
              a = "[object Object]" == f,
              o = "[object Object]" == c
            if ((c = f == c) && cf(n)) {
              if (!cf(t)) {
                t = false
                break n
              }
              ;(i = true), (a = false)
            }
            if (c && !a)
              u || (u = new Zn()),
                (t = i || pf(n) ? se(n, t, r, e, Mt, u) : he(n, t, f, r, e, Mt, u))
            else {
              if (
                !(1 & r) &&
                ((i = a && ii.call(n, "__wrapped__")), (f = o && ii.call(t, "__wrapped__")), i || f)
              ) {
                ;(n = i ? n.value() : n),
                  (t = f ? t.value() : t),
                  u || (u = new Zn()),
                  (t = Mt(n, t, r, e, u))
                break n
              }
              if (c)
                t: if (
                  (u || (u = new Zn()),
                  (i = 1 & r),
                  (f = _e(n)),
                  (o = f.length),
                  (c = _e(t).length),
                  o == c || i)
                ) {
                  for (a = o; a--; ) {
                    var l = f[a]
                    if (!(i ? l in t : ii.call(t, l))) {
                      t = false
                      break t
                    }
                  }
                  if ((c = u.get(n)) && u.get(t)) t = c == t
                  else {
                    ;(c = true), u.set(n, t), u.set(t, n)
                    for (var s = i; ++a < o; ) {
                      var l = f[a],
                        h = n[l],
                        p = t[l]
                      if (e) var _ = i ? e(p, h, l, t, n, u) : e(h, p, l, n, t, u)
                      if (_ === T ? h !== p && !Mt(h, p, r, e, u) : !_) {
                        c = false
                        break
                      }
                      s || (s = "constructor" == l)
                    }
                    c &&
                      !s &&
                      ((r = n.constructor),
                      (e = t.constructor),
                      r != e &&
                        "constructor" in n &&
                        "constructor" in t &&
                        !(
                          typeof r == "function" &&
                          r instanceof r &&
                          typeof e == "function" &&
                          e instanceof e
                        ) &&
                        (c = false)),
                      u.delete(n),
                      u.delete(t),
                      (t = c)
                  }
                } else t = false
              else t = false
            }
          }
        return t
      }
      function Tt(n) {
        return du(n) && "[object Map]" == _o(n)
      }
      function $t(n, t, r, e) {
        var u = r.length,
          i = u,
          o = !e
        if (null == n) return !i
        for (n = Yu(n); u--; ) {
          var f = r[u]
          if (o && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return false
        }
        for (; ++u < i; ) {
          var f = r[u],
            c = f[0],
            a = n[c],
            l = f[1]
          if (o && f[2]) {
            if (a === T && !(c in n)) return false
          } else {
            if (((f = new Zn()), e)) var s = e(a, l, c, n, t, f)
            if (s === T ? !Mt(l, a, 3, e, f) : !s) return false
          }
        }
        return true
      }
      function Ft(n) {
        return !(!gu(n) || (fi && fi in n)) && (pu(n) ? si : dn).test(Me(n))
      }
      function Nt(n) {
        return du(n) && "[object RegExp]" == Ot(n)
      }
      function Pt(n) {
        return du(n) && "[object Set]" == _o(n)
      }
      function Zt(n) {
        return du(n) && vu(n.length) && !!Bn[Ot(n)]
      }
      function qt(n) {
        return typeof n == "function"
          ? n
          : null == n
          ? Tu
          : typeof n == "object"
          ? of(n)
            ? Jt(n[0], n[1])
            : Ht(n)
          : Pu(n)
      }
      function Vt(n) {
        if (!ze(n)) return Bi(n)
        var t,
          r = []
        for (t in Yu(n)) ii.call(n, t) && "constructor" != t && r.push(t)
        return r
      }
      function Kt(n, t) {
        return n < t
      }
      function Gt(n, t) {
        var r = -1,
          e = lu(n) ? Vu(n.length) : []
        return (
          eo(n, function (n, u, i) {
            e[++r] = t(n, u, i)
          }),
          e
        )
      }
      function Ht(n) {
        var t = xe(n)
        return 1 == t.length && t[0][2]
          ? We(t[0][0], t[0][1])
          : function (r) {
              return r === n || $t(r, n, t)
            }
      }
      function Jt(n, t) {
        return Ie(n) && t === t && !gu(t)
          ? We(De(n), t)
          : function (r) {
              var e = Iu(r, n)
              return e === T && e === t ? Ru(r, n) : Mt(t, e, 3)
            }
      }
      function Yt(n, t, r, e, u) {
        n !== t &&
          io(
            t,
            function (i, o) {
              if (gu(i)) {
                u || (u = new Zn())
                var f = u,
                  c = "__proto__" == o ? T : n[o],
                  a = "__proto__" == o ? T : t[o],
                  l = f.get(a)
                if (l) it(n, o, l)
                else {
                  var l = e ? e(c, a, o + "", n, t, f) : T,
                    s = l === T
                  if (s) {
                    var h = of(a),
                      p = !h && cf(a),
                      _ = !h && !p && pf(a),
                      l = a
                    h || p || _
                      ? of(c)
                        ? (l = c)
                        : su(c)
                        ? (l = Ur(c))
                        : p
                        ? ((s = false), (l = Ir(a, true)))
                        : _
                        ? ((s = false), (l = zr(a, true)))
                        : (l = [])
                      : bu(a) || uf(a)
                      ? ((l = c), uf(c) ? (l = Su(c)) : (!gu(c) || (r && pu(c))) && (l = Ae(a)))
                      : (s = false)
                  }
                  s && (f.set(a, l), Yt(l, a, r, e, f), f.delete(a)), it(n, o, l)
                }
              } else
                (f = e ? e("__proto__" == o ? T : n[o], i, o + "", n, t, u) : T),
                  f === T && (f = i),
                  it(n, o, f)
            },
            Wu
          )
      }
      function Qt(n, t) {
        var r = n.length
        if (r) return (t += 0 > t ? r : 0), Se(t, r) ? n[t] : T
      }
      function Xt(n, t, r) {
        var e = -1
        return (
          (t = c(t.length ? t : [Tu], k(ye()))),
          (n = Gt(n, function (n) {
            return {
              a: c(t, function (t) {
                return t(n)
              }),
              b: ++e,
              c: n
            }
          })),
          w(n, function (n, t) {
            var e
            n: {
              e = -1
              for (var u = n.a, i = t.a, o = u.length, f = r.length; ++e < o; ) {
                var c = Wr(u[e], i[e])
                if (c) {
                  e = e >= f ? c : c * ("desc" == r[e] ? -1 : 1)
                  break n
                }
              }
              e = n.b - t.b
            }
            return e
          })
        )
      }
      function nr(n, t) {
        return tr(n, t, function (t, r) {
          return Ru(n, r)
        })
      }
      function tr(n, t, r) {
        for (var e = -1, u = t.length, i = {}; ++e < u; ) {
          var o = t[e],
            f = kt(n, o)
          r(f, o) && lr(i, Sr(o, n), f)
        }
        return i
      }
      function rr(n) {
        return function (t) {
          return kt(t, n)
        }
      }
      function er(n, t, r, e) {
        var u = e ? g : v,
          i = -1,
          o = t.length,
          f = n
        for (n === t && (t = Ur(t)), r && (f = c(n, k(r))); ++i < o; )
          for (var a = 0, l = t[i], l = r ? r(l) : l; -1 < (a = u(f, l, a, e)); )
            f !== n && bi.call(f, a, 1), bi.call(n, a, 1)
        return n
      }
      function ur(n, t) {
        for (var r = n ? t.length : 0, e = r - 1; r--; ) {
          var u = t[r]
          if (r == e || u !== i) {
            var i = u
            Se(u) ? bi.call(n, u, 1) : xr(n, u)
          }
        }
      }
      function ir(n, t) {
        return n + Oi(Mi() * (t - n + 1))
      }
      function or(n, t) {
        var r = ""
        if (!n || 1 > t || 9007199254740991 < t) return r
        do t % 2 && (r += n), (t = Oi(t / 2)) && (n += n)
        while (t)
        return r
      }
      function fr(n, t) {
        return bo(Be(n, t, Tu), n + "")
      }
      function cr(n) {
        return Qn(Lu(n))
      }
      function ar(n, t) {
        var r = Lu(n)
        return Ce(r, pt(t, 0, r.length))
      }
      function lr(n, t, r, e) {
        if (!gu(n)) return n
        t = Sr(t, n)
        for (var u = -1, i = t.length, o = i - 1, f = n; null != f && ++u < i; ) {
          var c = De(t[u]),
            a = r
          if (u != o) {
            var l = f[c],
              a = e ? e(l, c, f) : T
            a === T && (a = gu(l) ? l : Se(t[u + 1]) ? [] : {})
          }
          ot(f, c, a), (f = f[c])
        }
        return n
      }
      function sr(n) {
        return Ce(Lu(n))
      }
      function hr(n, t, r) {
        var e = -1,
          u = n.length
        for (
          0 > t && (t = -t > u ? 0 : u + t),
            r = r > u ? u : r,
            0 > r && (r += u),
            u = t > r ? 0 : (r - t) >>> 0,
            t >>>= 0,
            r = Vu(u);
          ++e < u;

        )
          r[e] = n[e + t]
        return r
      }
      function pr(n, t) {
        var r
        return (
          eo(n, function (n, e, u) {
            return (r = t(n, e, u)), !r
          }),
          !!r
        )
      }
      function _r(n, t, r) {
        var e = 0,
          u = null == n ? e : n.length
        if (typeof t == "number" && t === t && 2147483647 >= u) {
          for (; e < u; ) {
            var i = (e + u) >>> 1,
              o = n[i]
            null !== o && !ju(o) && (r ? o <= t : o < t) ? (e = i + 1) : (u = i)
          }
          return u
        }
        return vr(n, t, Tu, r)
      }
      function vr(n, t, r, e) {
        t = r(t)
        for (
          var u = 0,
            i = null == n ? 0 : n.length,
            o = t !== t,
            f = null === t,
            c = ju(t),
            a = t === T;
          u < i;

        ) {
          var l = Oi((u + i) / 2),
            s = r(n[l]),
            h = s !== T,
            p = null === s,
            _ = s === s,
            v = ju(s)
          ;(
            o
              ? e || _
              : a
              ? _ && (e || h)
              : f
              ? _ && h && (e || !p)
              : c
              ? _ && h && !p && (e || !v)
              : p || v
              ? 0
              : e
              ? s <= t
              : s < t
          )
            ? (u = l + 1)
            : (i = l)
        }
        return Ui(i, 4294967294)
      }
      function gr(n, t) {
        for (var r = -1, e = n.length, u = 0, i = []; ++r < e; ) {
          var o = n[r],
            f = t ? t(o) : o
          if (!r || !au(f, c)) {
            var c = f
            i[u++] = 0 === o ? 0 : o
          }
        }
        return i
      }
      function dr(n) {
        return typeof n == "number" ? n : ju(n) ? F : +n
      }
      function yr(n) {
        if (typeof n == "string") return n
        if (of(n)) return c(n, yr) + ""
        if (ju(n)) return to ? to.call(n) : ""
        var t = n + ""
        return "0" == t && 1 / n == -$ ? "-0" : t
      }
      function br(n, t, r) {
        var e = -1,
          u = o,
          i = n.length,
          c = true,
          a = [],
          l = a
        if (r) (c = false), (u = f)
        else if (200 <= i) {
          if ((u = t ? null : lo(n))) return U(u)
          ;(c = false), (u = O), (l = new Nn())
        } else l = t ? [] : a
        n: for (; ++e < i; ) {
          var s = n[e],
            h = t ? t(s) : s,
            s = r || 0 !== s ? s : 0
          if (c && h === h) {
            for (var p = l.length; p--; ) if (l[p] === h) continue n
            t && l.push(h), a.push(s)
          } else u(l, h, r) || (l !== a && l.push(h), a.push(s))
        }
        return a
      }
      function xr(n, t) {
        return (
          (t = Sr(t, n)),
          (n = 2 > t.length ? n : kt(n, hr(t, 0, -1))),
          null == n || delete n[De(qe(t))]
        )
      }
      function jr(n, t, r, e) {
        for (var u = n.length, i = e ? u : -1; (e ? i-- : ++i < u) && t(n[i], i, n); );
        return r ? hr(n, e ? 0 : i, e ? i + 1 : u) : hr(n, e ? i + 1 : 0, e ? u : i)
      }
      function wr(n, t) {
        var r = n
        return (
          r instanceof Un && (r = r.value()),
          l(
            t,
            function (n, t) {
              return t.func.apply(t.thisArg, a([n], t.args))
            },
            r
          )
        )
      }
      function mr(n, t, r) {
        var e = n.length
        if (2 > e) return e ? br(n[0]) : []
        for (var u = -1, i = Vu(e); ++u < e; )
          for (var o = n[u], f = -1; ++f < e; ) f != u && (i[u] = yt(i[u] || o, n[f], t, r))
        return br(wt(i, 1), t, r)
      }
      function Ar(n, t, r) {
        for (var e = -1, u = n.length, i = t.length, o = {}; ++e < u; ) r(o, n[e], e < i ? t[e] : T)
        return o
      }
      function Er(n) {
        return su(n) ? n : []
      }
      function kr(n) {
        return typeof n == "function" ? n : Tu
      }
      function Sr(n, t) {
        return of(n) ? n : Ie(n, t) ? [n] : xo(Ou(n))
      }
      function Or(n, t, r) {
        var e = n.length
        return (r = r === T ? e : r), !t && r >= e ? n : hr(n, t, r)
      }
      function Ir(n, t) {
        if (t) return n.slice()
        var r = n.length,
          r = vi ? vi(r) : new n.constructor(r)
        return n.copy(r), r
      }
      function Rr(n) {
        var t = new n.constructor(n.byteLength)
        return new _i(t).set(new _i(n)), t
      }
      function zr(n, t) {
        return new n.constructor(t ? Rr(n.buffer) : n.buffer, n.byteOffset, n.length)
      }
      function Wr(n, t) {
        if (n !== t) {
          var r = n !== T,
            e = null === n,
            u = n === n,
            i = ju(n),
            o = t !== T,
            f = null === t,
            c = t === t,
            a = ju(t)
          if (
            (!f && !a && !i && n > t) ||
            (i && o && c && !f && !a) ||
            (e && o && c) ||
            (!r && c) ||
            !u
          )
            return 1
          if (
            (!e && !i && !a && n < t) ||
            (a && r && u && !e && !i) ||
            (f && r && u) ||
            (!o && u) ||
            !c
          )
            return -1
        }
        return 0
      }
      function Br(n, t, r, e) {
        var u = -1,
          i = n.length,
          o = r.length,
          f = -1,
          c = t.length,
          a = Li(i - o, 0),
          l = Vu(c + a)
        for (e = !e; ++f < c; ) l[f] = t[f]
        for (; ++u < o; ) (e || u < i) && (l[r[u]] = n[u])
        for (; a--; ) l[f++] = n[u++]
        return l
      }
      function Lr(n, t, r, e) {
        var u = -1,
          i = n.length,
          o = -1,
          f = r.length,
          c = -1,
          a = t.length,
          l = Li(i - f, 0),
          s = Vu(l + a)
        for (e = !e; ++u < l; ) s[u] = n[u]
        for (l = u; ++c < a; ) s[l + c] = t[c]
        for (; ++o < f; ) (e || u < i) && (s[l + r[o]] = n[u++])
        return s
      }
      function Ur(n, t) {
        var r = -1,
          e = n.length
        for (t || (t = Vu(e)); ++r < e; ) t[r] = n[r]
        return t
      }
      function Cr(n, t, r, e) {
        var u = !r
        r || (r = {})
        for (var i = -1, o = t.length; ++i < o; ) {
          var f = t[i],
            c = e ? e(r[f], n[f], f, r, n) : T
          c === T && (c = n[f]), u ? st(r, f, c) : ot(r, f, c)
        }
        return r
      }
      function Dr(n, t) {
        return Cr(n, ho(n), t)
      }
      function Mr(n, t) {
        return Cr(n, po(n), t)
      }
      function Tr(n, r) {
        return function (e, u) {
          var i = of(e) ? t : ct,
            o = r ? r() : {}
          return i(e, n, ye(u, 2), o)
        }
      }
      function $r(n) {
        return fr(function (t, r) {
          var e = -1,
            u = r.length,
            i = 1 < u ? r[u - 1] : T,
            o = 2 < u ? r[2] : T,
            i = 3 < n.length && typeof i == "function" ? (u--, i) : T
          for (o && Oe(r[0], r[1], o) && ((i = 3 > u ? T : i), (u = 1)), t = Yu(t); ++e < u; )
            (o = r[e]) && n(t, o, e, i)
          return t
        })
      }
      function Fr(n, t) {
        return function (r, e) {
          if (null == r) return r
          if (!lu(r)) return n(r, e)
          for (
            var u = r.length, i = t ? u : -1, o = Yu(r);
            (t ? i-- : ++i < u) && false !== e(o[i], i, o);

          );
          return r
        }
      }
      function Nr(n) {
        return function (t, r, e) {
          var u = -1,
            i = Yu(t)
          e = e(t)
          for (var o = e.length; o--; ) {
            var f = e[n ? o : ++u]
            if (false === r(i[f], f, i)) break
          }
          return t
        }
      }
      function Pr(n, t, r) {
        function e() {
          return (this && this !== $n && this instanceof e ? i : n).apply(u ? r : this, arguments)
        }
        var u = 1 & t,
          i = Vr(n)
        return e
      }
      function Zr(n) {
        return function (t) {
          t = Ou(t)
          var r = Rn.test(t) ? M(t) : T,
            e = r ? r[0] : t.charAt(0)
          return (t = r ? Or(r, 1).join("") : t.slice(1)), e[n]() + t
        }
      }
      function qr(n) {
        return function (t) {
          return l(Du(Cu(t).replace(kn, "")), n, "")
        }
      }
      function Vr(n) {
        return function () {
          var t = arguments
          switch (t.length) {
            case 0:
              return new n()
            case 1:
              return new n(t[0])
            case 2:
              return new n(t[0], t[1])
            case 3:
              return new n(t[0], t[1], t[2])
            case 4:
              return new n(t[0], t[1], t[2], t[3])
            case 5:
              return new n(t[0], t[1], t[2], t[3], t[4])
            case 6:
              return new n(t[0], t[1], t[2], t[3], t[4], t[5])
            case 7:
              return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6])
          }
          var r = ro(n.prototype),
            t = n.apply(r, t)
          return gu(t) ? t : r
        }
      }
      function Kr(t, r, e) {
        function u() {
          for (var o = arguments.length, f = Vu(o), c = o, a = de(u); c--; ) f[c] = arguments[c]
          return (
            (c = 3 > o && f[0] !== a && f[o - 1] !== a ? [] : L(f, a)),
            (o -= c.length),
            o < e
              ? ue(t, r, Jr, u.placeholder, T, f, c, T, T, e - o)
              : n(this && this !== $n && this instanceof u ? i : t, this, f)
          )
        }
        var i = Vr(t)
        return u
      }
      function Gr(n) {
        return function (t, r, e) {
          var u = Yu(t)
          if (!lu(t)) {
            var i = ye(r, 3)
            ;(t = zu(t)),
              (r = function (n) {
                return i(u[n], n, u)
              })
          }
          return (r = n(t, r, e)), -1 < r ? u[i ? t[r] : r] : T
        }
      }
      function Hr(n) {
        return pe(function (t) {
          var r = t.length,
            e = r,
            u = On.prototype.thru
          for (n && t.reverse(); e--; ) {
            var i = t[e]
            if (typeof i != "function") throw new ni("Expected a function")
            if (u && !o && "wrapper" == ge(i)) var o = new On([], true)
          }
          for (e = o ? e : r; ++e < r; )
            var i = t[e],
              u = ge(i),
              f = "wrapper" == u ? so(i) : T,
              o =
                f && Re(f[0]) && 424 == f[1] && !f[4].length && 1 == f[9]
                  ? o[ge(f[0])].apply(o, f[3])
                  : 1 == i.length && Re(i)
                  ? o[u]()
                  : o.thru(i)
          return function () {
            var n = arguments,
              e = n[0]
            if (o && 1 == n.length && of(e)) return o.plant(e).value()
            for (var u = 0, n = r ? t[u].apply(this, n) : e; ++u < r; ) n = t[u].call(this, n)
            return n
          }
        })
      }
      function Jr(n, t, r, e, u, i, o, f, c, a) {
        function l() {
          for (var d = arguments.length, y = Vu(d), b = d; b--; ) y[b] = arguments[b]
          if (_) {
            var x,
              j = de(l),
              b = y.length
            for (x = 0; b--; ) y[b] === j && ++x
          }
          if ((e && (y = Br(y, e, u, _)), i && (y = Lr(y, i, o, _)), (d -= x), _ && d < a))
            return (j = L(y, j)), ue(n, t, Jr, l.placeholder, r, y, j, f, c, a - d)
          if (((j = h ? r : this), (b = p ? j[n] : n), (d = y.length), f)) {
            x = y.length
            for (var w = Ui(f.length, x), m = Ur(y); w--; ) {
              var A = f[w]
              y[w] = Se(A, x) ? m[A] : T
            }
          } else v && 1 < d && y.reverse()
          return (
            s && c < d && (y.length = c),
            this && this !== $n && this instanceof l && (b = g || Vr(b)),
            b.apply(j, y)
          )
        }
        var s = 128 & t,
          h = 1 & t,
          p = 2 & t,
          _ = 24 & t,
          v = 512 & t,
          g = p ? T : Vr(n)
        return l
      }
      function Yr(n, t) {
        return function (r, e) {
          return Bt(r, n, t(e))
        }
      }
      function Qr(n, t) {
        return function (r, e) {
          var u
          if (r === T && e === T) return t
          if ((r !== T && (u = r), e !== T)) {
            if (u === T) return e
            typeof r == "string" || typeof e == "string"
              ? ((r = yr(r)), (e = yr(e)))
              : ((r = dr(r)), (e = dr(e))),
              (u = n(r, e))
          }
          return u
        }
      }
      function Xr(t) {
        return pe(function (r) {
          return (
            (r = c(r, k(ye()))),
            fr(function (e) {
              var u = this
              return t(r, function (t) {
                return n(t, u, e)
              })
            })
          )
        })
      }
      function ne(n, t) {
        t = t === T ? " " : yr(t)
        var r = t.length
        return 2 > r
          ? r
            ? or(t, n)
            : t
          : ((r = or(t, Si(n / D(t)))), Rn.test(t) ? Or(M(r), 0, n).join("") : r.slice(0, n))
      }
      function te(t, r, e, u) {
        function i() {
          for (
            var r = -1,
              c = arguments.length,
              a = -1,
              l = u.length,
              s = Vu(l + c),
              h = this && this !== $n && this instanceof i ? f : t;
            ++a < l;

          )
            s[a] = u[a]
          for (; c--; ) s[a++] = arguments[++r]
          return n(h, o ? e : this, s)
        }
        var o = 1 & r,
          f = Vr(t)
        return i
      }
      function re(n) {
        return function (t, r, e) {
          e && typeof e != "number" && Oe(t, r, e) && (r = e = T),
            (t = mu(t)),
            r === T ? ((r = t), (t = 0)) : (r = mu(r)),
            (e = e === T ? (t < r ? 1 : -1) : mu(e))
          var u = -1
          r = Li(Si((r - t) / (e || 1)), 0)
          for (var i = Vu(r); r--; ) (i[n ? r : ++u] = t), (t += e)
          return i
        }
      }
      function ee(n) {
        return function (t, r) {
          return (
            (typeof t == "string" && typeof r == "string") || ((t = ku(t)), (r = ku(r))), n(t, r)
          )
        }
      }
      function ue(n, t, r, e, u, i, o, f, c, a) {
        var l = 8 & t,
          s = l ? o : T
        o = l ? T : o
        var h = l ? i : T
        return (
          (i = l ? T : i),
          (t = (t | (l ? 32 : 64)) & ~(l ? 64 : 32)),
          4 & t || (t &= -4),
          (u = [n, t, u, h, s, i, o, f, c, a]),
          (r = r.apply(T, u)),
          Re(n) && go(r, u),
          (r.placeholder = e),
          Le(r, n, t)
        )
      }
      function ie(n) {
        var t = Ju[n]
        return function (n, r) {
          if (((n = ku(n)), (r = null == r ? 0 : Ui(Au(r), 292)))) {
            var e = (Ou(n) + "e").split("e"),
              e = t(e[0] + "e" + (+e[1] + r)),
              e = (Ou(e) + "e").split("e")
            return +(e[0] + "e" + (+e[1] - r))
          }
          return t(n)
        }
      }
      function oe(n) {
        return function (t) {
          var r = _o(t)
          return "[object Map]" == r ? W(t) : "[object Set]" == r ? C(t) : E(t, n(t))
        }
      }
      function fe(n, t, r, e, u, i, o, f) {
        var c = 2 & t
        if (!c && typeof n != "function") throw new ni("Expected a function")
        var a = e ? e.length : 0
        if (
          (a || ((t &= -97), (e = u = T)),
          (o = o === T ? o : Li(Au(o), 0)),
          (f = f === T ? f : Au(f)),
          (a -= u ? u.length : 0),
          64 & t)
        ) {
          var l = e,
            s = u
          e = u = T
        }
        var h = c ? T : so(n)
        return (
          (i = [n, t, r, e, u, l, s, i, o, f]),
          h &&
            ((r = i[1]),
            (n = h[1]),
            (t = r | n),
            (e =
              (128 == n && 8 == r) ||
              (128 == n && 256 == r && i[7].length <= h[8]) ||
              (384 == n && h[7].length <= h[8] && 8 == r)),
            131 > t || e) &&
            (1 & n && ((i[2] = h[2]), (t |= 1 & r ? 0 : 4)),
            (r = h[3]) &&
              ((e = i[3]),
              (i[3] = e ? Br(e, r, h[4]) : r),
              (i[4] = e ? L(i[3], "__lodash_placeholder__") : h[4])),
            (r = h[5]) &&
              ((e = i[5]),
              (i[5] = e ? Lr(e, r, h[6]) : r),
              (i[6] = e ? L(i[5], "__lodash_placeholder__") : h[6])),
            (r = h[7]) && (i[7] = r),
            128 & n && (i[8] = null == i[8] ? h[8] : Ui(i[8], h[8])),
            null == i[9] && (i[9] = h[9]),
            (i[0] = h[0]),
            (i[1] = t)),
          (n = i[0]),
          (t = i[1]),
          (r = i[2]),
          (e = i[3]),
          (u = i[4]),
          (f = i[9] = i[9] === T ? (c ? 0 : n.length) : Li(i[9] - a, 0)),
          !f && 24 & t && (t &= -25),
          Le(
            (h ? fo : go)(
              t && 1 != t
                ? 8 == t || 16 == t
                  ? Kr(n, t, f)
                  : (32 != t && 33 != t) || u.length
                  ? Jr.apply(T, i)
                  : te(n, t, r, e)
                : Pr(n, t, r),
              i
            ),
            n,
            t
          )
        )
      }
      function ce(n, t, r, e) {
        return n === T || (au(n, ri[r]) && !ii.call(e, r)) ? t : n
      }
      function ae(n, t, r, e, u, i) {
        return gu(n) && gu(t) && (i.set(t, n), Yt(n, t, T, ae, i), i.delete(t)), n
      }
      function le(n) {
        return bu(n) ? T : n
      }
      function se(n, t, r, e, u, i) {
        var o = 1 & r,
          f = n.length,
          c = t.length
        if (f != c && !(o && c > f)) return false
        if ((c = i.get(n)) && i.get(t)) return c == t
        var c = -1,
          a = true,
          l = 2 & r ? new Nn() : T
        for (i.set(n, t), i.set(t, n); ++c < f; ) {
          var s = n[c],
            p = t[c]
          if (e) var _ = o ? e(p, s, c, t, n, i) : e(s, p, c, n, t, i)
          if (_ !== T) {
            if (_) continue
            a = false
            break
          }
          if (l) {
            if (
              !h(t, function (n, t) {
                if (!O(l, t) && (s === n || u(s, n, r, e, i))) return l.push(t)
              })
            ) {
              a = false
              break
            }
          } else if (s !== p && !u(s, p, r, e, i)) {
            a = false
            break
          }
        }
        return i.delete(n), i.delete(t), a
      }
      function he(n, t, r, e, u, i, o) {
        switch (r) {
          case "[object DataView]":
            if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) break
            ;(n = n.buffer), (t = t.buffer)
          case "[object ArrayBuffer]":
            if (n.byteLength != t.byteLength || !i(new _i(n), new _i(t))) break
            return true
          case "[object Boolean]":
          case "[object Date]":
          case "[object Number]":
            return au(+n, +t)
          case "[object Error]":
            return n.name == t.name && n.message == t.message
          case "[object RegExp]":
          case "[object String]":
            return n == t + ""
          case "[object Map]":
            var f = W
          case "[object Set]":
            if ((f || (f = U), n.size != t.size && !(1 & e))) break
            return (r = o.get(n))
              ? r == t
              : ((e |= 2), o.set(n, t), (t = se(f(n), f(t), e, u, i, o)), o.delete(n), t)
          case "[object Symbol]":
            if (no) return no.call(n) == no.call(t)
        }
        return false
      }
      function pe(n) {
        return bo(Be(n, T, Pe), n + "")
      }
      function _e(n) {
        return St(n, zu, ho)
      }
      function ve(n) {
        return St(n, Wu, po)
      }
      function ge(n) {
        for (var t = n.name + "", r = Ki[t], e = ii.call(Ki, t) ? r.length : 0; e--; ) {
          var u = r[e],
            i = u.func
          if (null == i || i == n) return u.name
        }
        return t
      }
      function de(n) {
        return (ii.call(An, "placeholder") ? An : n).placeholder
      }
      function ye() {
        var n = An.iteratee || $u,
          n = n === $u ? qt : n
        return arguments.length ? n(arguments[0], arguments[1]) : n
      }
      function be(n, t) {
        var r = n.__data__,
          e = typeof t
        return (
          "string" == e || "number" == e || "symbol" == e || "boolean" == e
            ? "__proto__" !== t
            : null === t
        )
          ? r[typeof t == "string" ? "string" : "hash"]
          : r.map
      }
      function xe(n) {
        for (var t = zu(n), r = t.length; r--; ) {
          var e = t[r],
            u = n[e]
          t[r] = [e, u, u === u && !gu(u)]
        }
        return t
      }
      function je(n, t) {
        var r = null == n ? T : n[t]
        return Ft(r) ? r : T
      }
      function we(n, t, r) {
        t = Sr(t, n)
        for (var e = -1, u = t.length, i = false; ++e < u; ) {
          var o = De(t[e])
          if (!(i = null != n && r(n, o))) break
          n = n[o]
        }
        return i || ++e != u
          ? i
          : ((u = null == n ? 0 : n.length), !!u && vu(u) && Se(o, u) && (of(n) || uf(n)))
      }
      function me(n) {
        var t = n.length,
          r = new n.constructor(t)
        return (
          t &&
            "string" == typeof n[0] &&
            ii.call(n, "index") &&
            ((r.index = n.index), (r.input = n.input)),
          r
        )
      }
      function Ae(n) {
        return typeof n.constructor != "function" || ze(n) ? {} : ro(gi(n))
      }
      function Ee(n, t, r) {
        var e = n.constructor
        switch (t) {
          case "[object ArrayBuffer]":
            return Rr(n)
          case "[object Boolean]":
          case "[object Date]":
            return new e(+n)
          case "[object DataView]":
            return (
              (t = r ? Rr(n.buffer) : n.buffer), new n.constructor(t, n.byteOffset, n.byteLength)
            )
          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return zr(n, r)
          case "[object Map]":
            return new e()
          case "[object Number]":
          case "[object String]":
            return new e(n)
          case "[object RegExp]":
            return (t = new n.constructor(n.source, _n.exec(n))), (t.lastIndex = n.lastIndex), t
          case "[object Set]":
            return new e()
          case "[object Symbol]":
            return no ? Yu(no.call(n)) : {}
        }
      }
      function ke(n) {
        return of(n) || uf(n) || !!(xi && n && n[xi])
      }
      function Se(n, t) {
        var r = typeof n
        return (
          (t = null == t ? 9007199254740991 : t),
          !!t && ("number" == r || ("symbol" != r && bn.test(n))) && -1 < n && 0 == n % 1 && n < t
        )
      }
      function Oe(n, t, r) {
        if (!gu(r)) return false
        var e = typeof t
        return !!("number" == e ? lu(r) && Se(t, r.length) : "string" == e && t in r) && au(r[t], n)
      }
      function Ie(n, t) {
        if (of(n)) return false
        var r = typeof n
        return (
          !("number" != r && "symbol" != r && "boolean" != r && null != n && !ju(n)) ||
          nn.test(n) ||
          !X.test(n) ||
          (null != t && n in Yu(t))
        )
      }
      function Re(n) {
        var t = ge(n),
          r = An[t]
        return (
          typeof r == "function" &&
          t in Un.prototype &&
          (n === r || ((t = so(r)), !!t && n === t[0]))
        )
      }
      function ze(n) {
        var t = n && n.constructor
        return n === ((typeof t == "function" && t.prototype) || ri)
      }
      function We(n, t) {
        return function (r) {
          return null != r && r[n] === t && (t !== T || n in Yu(r))
        }
      }
      function Be(t, r, e) {
        return (
          (r = Li(r === T ? t.length - 1 : r, 0)),
          function () {
            for (var u = arguments, i = -1, o = Li(u.length - r, 0), f = Vu(o); ++i < o; )
              f[i] = u[r + i]
            for (i = -1, o = Vu(r + 1); ++i < r; ) o[i] = u[i]
            return (o[r] = e(f)), n(t, this, o)
          }
        )
      }
      function Le(n, t, r) {
        var e = t + ""
        t = bo
        var u,
          i = Te
        return (
          (u = (u = e.match(an)) ? u[1].split(ln) : []),
          (r = i(u, r)),
          (i = r.length) &&
            ((u = i - 1),
            (r[u] = (1 < i ? "& " : "") + r[u]),
            (r = r.join(2 < i ? ", " : " ")),
            (e = e.replace(cn, "{\n/* [wrapped with " + r + "] */\n"))),
          t(n, e)
        )
      }
      function Ue(n) {
        var t = 0,
          r = 0
        return function () {
          var e = Ci(),
            u = 16 - (e - r)
          if (((r = e), 0 < u)) {
            if (800 <= ++t) return arguments[0]
          } else t = 0
          return n.apply(T, arguments)
        }
      }
      function Ce(n, t) {
        var r = -1,
          e = n.length,
          u = e - 1
        for (t = t === T ? e : t; ++r < t; ) {
          var e = ir(r, u),
            i = n[e]
          ;(n[e] = n[r]), (n[r] = i)
        }
        return (n.length = t), n
      }
      function De(n) {
        if (typeof n == "string" || ju(n)) return n
        var t = n + ""
        return "0" == t && 1 / n == -$ ? "-0" : t
      }
      function Me(n) {
        if (null != n) {
          try {
            return ui.call(n)
          } catch (n) {}
          return n + ""
        }
        return ""
      }
      function Te(n, t) {
        return (
          r(N, function (r) {
            var e = "_." + r[0]
            t & r[1] && !o(n, e) && n.push(e)
          }),
          n.sort()
        )
      }
      function $e(n) {
        if (n instanceof Un) return n.clone()
        var t = new On(n.__wrapped__, n.__chain__)
        return (
          (t.__actions__ = Ur(n.__actions__)),
          (t.__index__ = n.__index__),
          (t.__values__ = n.__values__),
          t
        )
      }
      function Fe(n, t, r) {
        var e = null == n ? 0 : n.length
        return e
          ? ((r = null == r ? 0 : Au(r)), 0 > r && (r = Li(e + r, 0)), _(n, ye(t, 3), r))
          : -1
      }
      function Ne(n, t, r) {
        var e = null == n ? 0 : n.length
        if (!e) return -1
        var u = e - 1
        return (
          r !== T && ((u = Au(r)), (u = 0 > r ? Li(e + u, 0) : Ui(u, e - 1))),
          _(n, ye(t, 3), u, true)
        )
      }
      function Pe(n) {
        return (null == n ? 0 : n.length) ? wt(n, 1) : []
      }
      function Ze(n) {
        return n && n.length ? n[0] : T
      }
      function qe(n) {
        var t = null == n ? 0 : n.length
        return t ? n[t - 1] : T
      }
      function Ve(n, t) {
        return n && n.length && t && t.length ? er(n, t) : n
      }
      function Ke(n) {
        return null == n ? n : Ti.call(n)
      }
      function Ge(n) {
        if (!n || !n.length) return []
        var t = 0
        return (
          (n = i(n, function (n) {
            if (su(n)) return (t = Li(n.length, t)), true
          })),
          A(t, function (t) {
            return c(n, b(t))
          })
        )
      }
      function He(t, r) {
        if (!t || !t.length) return []
        var e = Ge(t)
        return null == r
          ? e
          : c(e, function (t) {
              return n(r, T, t)
            })
      }
      function Je(n) {
        return (n = An(n)), (n.__chain__ = true), n
      }
      function Ye(n, t) {
        return t(n)
      }
      function Qe() {
        return this
      }
      function Xe(n, t) {
        return (of(n) ? r : eo)(n, ye(t, 3))
      }
      function nu(n, t) {
        return (of(n) ? e : uo)(n, ye(t, 3))
      }
      function tu(n, t) {
        return (of(n) ? c : Gt)(n, ye(t, 3))
      }
      function ru(n, t, r) {
        return (t = r ? T : t), (t = n && null == t ? n.length : t), fe(n, 128, T, T, T, T, t)
      }
      function eu(n, t) {
        var r
        if (typeof t != "function") throw new ni("Expected a function")
        return (
          (n = Au(n)),
          function () {
            return 0 < --n && (r = t.apply(this, arguments)), 1 >= n && (t = T), r
          }
        )
      }
      function uu(n, t, r) {
        return (
          (t = r ? T : t), (n = fe(n, 8, T, T, T, T, T, t)), (n.placeholder = uu.placeholder), n
        )
      }
      function iu(n, t, r) {
        return (
          (t = r ? T : t), (n = fe(n, 16, T, T, T, T, T, t)), (n.placeholder = iu.placeholder), n
        )
      }
      function ou(n, t, r) {
        function e(t) {
          var r = c,
            e = a
          return (c = a = T), (_ = t), (s = n.apply(e, r))
        }
        function u(n) {
          var r = n - p
          return (n -= _), p === T || r >= t || 0 > r || (g && n >= l)
        }
        function i() {
          var n = Ko()
          if (u(n)) return o(n)
          var r,
            e = yo
          ;(r = n - _), (n = t - (n - p)), (r = g ? Ui(n, l - r) : n), (h = e(i, r))
        }
        function o(n) {
          return (h = T), d && c ? e(n) : ((c = a = T), s)
        }
        function f() {
          var n = Ko(),
            r = u(n)
          if (((c = arguments), (a = this), (p = n), r)) {
            if (h === T) return (_ = n = p), (h = yo(i, t)), v ? e(n) : s
            if (g) return (h = yo(i, t)), e(p)
          }
          return h === T && (h = yo(i, t)), s
        }
        var c,
          a,
          l,
          s,
          h,
          p,
          _ = 0,
          v = false,
          g = false,
          d = true
        if (typeof n != "function") throw new ni("Expected a function")
        return (
          (t = ku(t) || 0),
          gu(r) &&
            ((v = !!r.leading),
            (l = (g = "maxWait" in r) ? Li(ku(r.maxWait) || 0, t) : l),
            (d = "trailing" in r ? !!r.trailing : d)),
          (f.cancel = function () {
            h !== T && ao(h), (_ = 0), (c = p = a = h = T)
          }),
          (f.flush = function () {
            return h === T ? s : o(Ko())
          }),
          f
        )
      }
      function fu(n, t) {
        function r() {
          var e = arguments,
            u = t ? t.apply(this, e) : e[0],
            i = r.cache
          return i.has(u) ? i.get(u) : ((e = n.apply(this, e)), (r.cache = i.set(u, e) || i), e)
        }
        if (typeof n != "function" || (null != t && typeof t != "function"))
          throw new ni("Expected a function")
        return (r.cache = new (fu.Cache || Fn)()), r
      }
      function cu(n) {
        if (typeof n != "function") throw new ni("Expected a function")
        return function () {
          var t = arguments
          switch (t.length) {
            case 0:
              return !n.call(this)
            case 1:
              return !n.call(this, t[0])
            case 2:
              return !n.call(this, t[0], t[1])
            case 3:
              return !n.call(this, t[0], t[1], t[2])
          }
          return !n.apply(this, t)
        }
      }
      function au(n, t) {
        return n === t || (n !== n && t !== t)
      }
      function lu(n) {
        return null != n && vu(n.length) && !pu(n)
      }
      function su(n) {
        return du(n) && lu(n)
      }
      function hu(n) {
        if (!du(n)) return false
        var t = Ot(n)
        return (
          "[object Error]" == t ||
          "[object DOMException]" == t ||
          (typeof n.message == "string" && typeof n.name == "string" && !bu(n))
        )
      }
      function pu(n) {
        return (
          !!gu(n) &&
          ((n = Ot(n)),
          "[object Function]" == n ||
            "[object GeneratorFunction]" == n ||
            "[object AsyncFunction]" == n ||
            "[object Proxy]" == n)
        )
      }
      function _u(n) {
        return typeof n == "number" && n == Au(n)
      }
      function vu(n) {
        return typeof n == "number" && -1 < n && 0 == n % 1 && 9007199254740991 >= n
      }
      function gu(n) {
        var t = typeof n
        return null != n && ("object" == t || "function" == t)
      }
      function du(n) {
        return null != n && typeof n == "object"
      }
      function yu(n) {
        return typeof n == "number" || (du(n) && "[object Number]" == Ot(n))
      }
      function bu(n) {
        return (
          !(!du(n) || "[object Object]" != Ot(n)) &&
          ((n = gi(n)),
          null === n ||
            ((n = ii.call(n, "constructor") && n.constructor),
            typeof n == "function" && n instanceof n && ui.call(n) == ai))
        )
      }
      function xu(n) {
        return typeof n == "string" || (!of(n) && du(n) && "[object String]" == Ot(n))
      }
      function ju(n) {
        return typeof n == "symbol" || (du(n) && "[object Symbol]" == Ot(n))
      }
      function wu(n) {
        if (!n) return []
        if (lu(n)) return xu(n) ? M(n) : Ur(n)
        if (ji && n[ji]) {
          n = n[ji]()
          for (var t, r = []; !(t = n.next()).done; ) r.push(t.value)
          return r
        }
        return (t = _o(n)), ("[object Map]" == t ? W : "[object Set]" == t ? U : Lu)(n)
      }
      function mu(n) {
        return n
          ? ((n = ku(n)),
            n === $ || n === -$ ? 1.7976931348623157e308 * (0 > n ? -1 : 1) : n === n ? n : 0)
          : 0 === n
          ? n
          : 0
      }
      function Au(n) {
        n = mu(n)
        var t = n % 1
        return n === n ? (t ? n - t : n) : 0
      }
      function Eu(n) {
        return n ? pt(Au(n), 0, 4294967295) : 0
      }
      function ku(n) {
        if (typeof n == "number") return n
        if (ju(n)) return F
        if (
          (gu(n) &&
            ((n = typeof n.valueOf == "function" ? n.valueOf() : n), (n = gu(n) ? n + "" : n)),
          typeof n != "string")
        )
          return 0 === n ? n : +n
        n = n.replace(un, "")
        var t = gn.test(n)
        return t || yn.test(n) ? Dn(n.slice(2), t ? 2 : 8) : vn.test(n) ? F : +n
      }
      function Su(n) {
        return Cr(n, Wu(n))
      }
      function Ou(n) {
        return null == n ? "" : yr(n)
      }
      function Iu(n, t, r) {
        return (n = null == n ? T : kt(n, t)), n === T ? r : n
      }
      function Ru(n, t) {
        return null != n && we(n, t, zt)
      }
      function zu(n) {
        return lu(n) ? qn(n) : Vt(n)
      }
      function Wu(n) {
        if (lu(n)) n = qn(n, true)
        else if (gu(n)) {
          var t,
            r = ze(n),
            e = []
          for (t in n) ("constructor" != t || (!r && ii.call(n, t))) && e.push(t)
          n = e
        } else {
          if (((t = []), null != n)) for (r in Yu(n)) t.push(r)
          n = t
        }
        return n
      }
      function Bu(n, t) {
        if (null == n) return {}
        var r = c(ve(n), function (n) {
          return [n]
        })
        return (
          (t = ye(t)),
          tr(n, r, function (n, r) {
            return t(n, r[0])
          })
        )
      }
      function Lu(n) {
        return null == n ? [] : S(n, zu(n))
      }
      function Uu(n) {
        return Tf(Ou(n).toLowerCase())
      }
      function Cu(n) {
        return (n = Ou(n)) && n.replace(xn, Xn).replace(Sn, "")
      }
      function Du(n, t, r) {
        return (
          (n = Ou(n)),
          (t = r ? T : t),
          t === T ? (zn.test(n) ? n.match(In) || [] : n.match(sn) || []) : n.match(t) || []
        )
      }
      function Mu(n) {
        return function () {
          return n
        }
      }
      function Tu(n) {
        return n
      }
      function $u(n) {
        return qt(typeof n == "function" ? n : _t(n, 1))
      }
      function Fu(n, t, e) {
        var u = zu(t),
          i = Et(t, u)
        null != e ||
          (gu(t) && (i.length || !u.length)) ||
          ((e = t), (t = n), (n = this), (i = Et(t, zu(t))))
        var o = !(gu(e) && "chain" in e && !e.chain),
          f = pu(n)
        return (
          r(i, function (r) {
            var e = t[r]
            ;(n[r] = e),
              f &&
                (n.prototype[r] = function () {
                  var t = this.__chain__
                  if (o || t) {
                    var r = n(this.__wrapped__)
                    return (
                      (r.__actions__ = Ur(this.__actions__)).push({
                        func: e,
                        args: arguments,
                        thisArg: n
                      }),
                      (r.__chain__ = t),
                      r
                    )
                  }
                  return e.apply(n, a([this.value()], arguments))
                })
          }),
          n
        )
      }
      function Nu() {}
      function Pu(n) {
        return Ie(n) ? b(De(n)) : rr(n)
      }
      function Zu() {
        return []
      }
      function qu() {
        return false
      }
      mn = null == mn ? $n : rt.defaults($n.Object(), mn, rt.pick($n, Wn))
      var Vu = mn.Array,
        Ku = mn.Date,
        Gu = mn.Error,
        Hu = mn.Function,
        Ju = mn.Math,
        Yu = mn.Object,
        Qu = mn.RegExp,
        Xu = mn.String,
        ni = mn.TypeError,
        ti = Vu.prototype,
        ri = Yu.prototype,
        ei = mn["__core-js_shared__"],
        ui = Hu.prototype.toString,
        ii = ri.hasOwnProperty,
        oi = 0,
        fi = (function () {
          var n = /[^.]+$/.exec((ei && ei.keys && ei.keys.IE_PROTO) || "")
          return n ? "Symbol(src)_1." + n : ""
        })(),
        ci = ri.toString,
        ai = ui.call(Yu),
        li = $n._,
        si = Qu(
          "^" +
            ui
              .call(ii)
              .replace(rn, "\\$&")
              .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") +
            "$"
        ),
        hi = Pn ? mn.Buffer : T,
        pi = mn.Symbol,
        _i = mn.Uint8Array,
        vi = hi ? hi.g : T,
        gi = B(Yu.getPrototypeOf, Yu),
        di = Yu.create,
        yi = ri.propertyIsEnumerable,
        bi = ti.splice,
        xi = pi ? pi.isConcatSpreadable : T,
        ji = pi ? pi.iterator : T,
        wi = pi ? pi.toStringTag : T,
        mi = (function () {
          try {
            var n = je(Yu, "defineProperty")
            return n({}, "", {}), n
          } catch (n) {}
        })(),
        Ai = mn.clearTimeout !== $n.clearTimeout && mn.clearTimeout,
        Ei = Ku && Ku.now !== $n.Date.now && Ku.now,
        ki = mn.setTimeout !== $n.setTimeout && mn.setTimeout,
        Si = Ju.ceil,
        Oi = Ju.floor,
        Ii = Yu.getOwnPropertySymbols,
        Ri = hi ? hi.isBuffer : T,
        zi = mn.isFinite,
        Wi = ti.join,
        Bi = B(Yu.keys, Yu),
        Li = Ju.max,
        Ui = Ju.min,
        Ci = Ku.now,
        Di = mn.parseInt,
        Mi = Ju.random,
        Ti = ti.reverse,
        $i = je(mn, "DataView"),
        Fi = je(mn, "Map"),
        Ni = je(mn, "Promise"),
        Pi = je(mn, "Set"),
        Zi = je(mn, "WeakMap"),
        qi = je(Yu, "create"),
        Vi = Zi && new Zi(),
        Ki = {},
        Gi = Me($i),
        Hi = Me(Fi),
        Ji = Me(Ni),
        Yi = Me(Pi),
        Qi = Me(Zi),
        Xi = pi ? pi.prototype : T,
        no = Xi ? Xi.valueOf : T,
        to = Xi ? Xi.toString : T,
        ro = (function () {
          function n() {}
          return function (t) {
            return gu(t)
              ? di
                ? di(t)
                : ((n.prototype = t), (t = new n()), (n.prototype = T), t)
              : {}
          }
        })()
      ;(An.templateSettings = {
        escape: J,
        evaluate: Y,
        interpolate: Q,
        variable: "",
        imports: { _: An }
      }),
        (An.prototype = En.prototype),
        (An.prototype.constructor = An),
        (On.prototype = ro(En.prototype)),
        (On.prototype.constructor = On),
        (Un.prototype = ro(En.prototype)),
        (Un.prototype.constructor = Un),
        (Mn.prototype.clear = function () {
          ;(this.__data__ = qi ? qi(null) : {}), (this.size = 0)
        }),
        (Mn.prototype.delete = function (n) {
          return (n = this.has(n) && delete this.__data__[n]), (this.size -= n ? 1 : 0), n
        }),
        (Mn.prototype.get = function (n) {
          var t = this.__data__
          return qi
            ? ((n = t[n]), "__lodash_hash_undefined__" === n ? T : n)
            : ii.call(t, n)
            ? t[n]
            : T
        }),
        (Mn.prototype.has = function (n) {
          var t = this.__data__
          return qi ? t[n] !== T : ii.call(t, n)
        }),
        (Mn.prototype.set = function (n, t) {
          var r = this.__data__
          return (
            (this.size += this.has(n) ? 0 : 1),
            (r[n] = qi && t === T ? "__lodash_hash_undefined__" : t),
            this
          )
        }),
        (Tn.prototype.clear = function () {
          ;(this.__data__ = []), (this.size = 0)
        }),
        (Tn.prototype.delete = function (n) {
          var t = this.__data__
          return (
            (n = ft(t, n)),
            !(0 > n) && (n == t.length - 1 ? t.pop() : bi.call(t, n, 1), --this.size, true)
          )
        }),
        (Tn.prototype.get = function (n) {
          var t = this.__data__
          return (n = ft(t, n)), 0 > n ? T : t[n][1]
        }),
        (Tn.prototype.has = function (n) {
          return -1 < ft(this.__data__, n)
        }),
        (Tn.prototype.set = function (n, t) {
          var r = this.__data__,
            e = ft(r, n)
          return 0 > e ? (++this.size, r.push([n, t])) : (r[e][1] = t), this
        }),
        (Fn.prototype.clear = function () {
          ;(this.size = 0),
            (this.__data__ = { hash: new Mn(), map: new (Fi || Tn)(), string: new Mn() })
        }),
        (Fn.prototype.delete = function (n) {
          return (n = be(this, n).delete(n)), (this.size -= n ? 1 : 0), n
        }),
        (Fn.prototype.get = function (n) {
          return be(this, n).get(n)
        }),
        (Fn.prototype.has = function (n) {
          return be(this, n).has(n)
        }),
        (Fn.prototype.set = function (n, t) {
          var r = be(this, n),
            e = r.size
          return r.set(n, t), (this.size += r.size == e ? 0 : 1), this
        }),
        (Nn.prototype.add = Nn.prototype.push =
          function (n) {
            return this.__data__.set(n, "__lodash_hash_undefined__"), this
          }),
        (Nn.prototype.has = function (n) {
          return this.__data__.has(n)
        }),
        (Zn.prototype.clear = function () {
          ;(this.__data__ = new Tn()), (this.size = 0)
        }),
        (Zn.prototype.delete = function (n) {
          var t = this.__data__
          return (n = t.delete(n)), (this.size = t.size), n
        }),
        (Zn.prototype.get = function (n) {
          return this.__data__.get(n)
        }),
        (Zn.prototype.has = function (n) {
          return this.__data__.has(n)
        }),
        (Zn.prototype.set = function (n, t) {
          var r = this.__data__
          if (r instanceof Tn) {
            var e = r.__data__
            if (!Fi || 199 > e.length) return e.push([n, t]), (this.size = ++r.size), this
            r = this.__data__ = new Fn(e)
          }
          return r.set(n, t), (this.size = r.size), this
        })
      var eo = Fr(mt),
        uo = Fr(At, true),
        io = Nr(),
        oo = Nr(true),
        fo = Vi
          ? function (n, t) {
              return Vi.set(n, t), n
            }
          : Tu,
        co = mi
          ? function (n, t) {
              return mi(n, "toString", {
                configurable: true,
                enumerable: false,
                value: Mu(t),
                writable: true
              })
            }
          : Tu,
        ao =
          Ai ||
          function (n) {
            return $n.clearTimeout(n)
          },
        lo =
          Pi && 1 / U(new Pi([, -0]))[1] == $
            ? function (n) {
                return new Pi(n)
              }
            : Nu,
        so = Vi
          ? function (n) {
              return Vi.get(n)
            }
          : Nu,
        ho = Ii
          ? function (n) {
              return null == n
                ? []
                : ((n = Yu(n)),
                  i(Ii(n), function (t) {
                    return yi.call(n, t)
                  }))
            }
          : Zu,
        po = Ii
          ? function (n) {
              for (var t = []; n; ) a(t, ho(n)), (n = gi(n))
              return t
            }
          : Zu,
        _o = Ot
      ;(($i && "[object DataView]" != _o(new $i(new ArrayBuffer(1)))) ||
        (Fi && "[object Map]" != _o(new Fi())) ||
        (Ni && "[object Promise]" != _o(Ni.resolve())) ||
        (Pi && "[object Set]" != _o(new Pi())) ||
        (Zi && "[object WeakMap]" != _o(new Zi()))) &&
        (_o = function (n) {
          var t = Ot(n)
          if ((n = (n = "[object Object]" == t ? n.constructor : T) ? Me(n) : ""))
            switch (n) {
              case Gi:
                return "[object DataView]"
              case Hi:
                return "[object Map]"
              case Ji:
                return "[object Promise]"
              case Yi:
                return "[object Set]"
              case Qi:
                return "[object WeakMap]"
            }
          return t
        })
      var vo = ei ? pu : qu,
        go = Ue(fo),
        yo =
          ki ||
          function (n, t) {
            return $n.setTimeout(n, t)
          },
        bo = Ue(co),
        xo = (function (n) {
          n = fu(n, function (n) {
            return 500 === t.size && t.clear(), n
          })
          var t = n.cache
          return n
        })(function (n) {
          var t = []
          return (
            46 === n.charCodeAt(0) && t.push(""),
            n.replace(tn, function (n, r, e, u) {
              t.push(e ? u.replace(hn, "$1") : r || n)
            }),
            t
          )
        }),
        jo = fr(function (n, t) {
          return su(n) ? yt(n, wt(t, 1, su, true)) : []
        }),
        wo = fr(function (n, t) {
          var r = qe(t)
          return su(r) && (r = T), su(n) ? yt(n, wt(t, 1, su, true), ye(r, 2)) : []
        }),
        mo = fr(function (n, t) {
          var r = qe(t)
          return su(r) && (r = T), su(n) ? yt(n, wt(t, 1, su, true), T, r) : []
        }),
        Ao = fr(function (n) {
          var t = c(n, Er)
          return t.length && t[0] === n[0] ? Wt(t) : []
        }),
        Eo = fr(function (n) {
          var t = qe(n),
            r = c(n, Er)
          return t === qe(r) ? (t = T) : r.pop(), r.length && r[0] === n[0] ? Wt(r, ye(t, 2)) : []
        }),
        ko = fr(function (n) {
          var t = qe(n),
            r = c(n, Er)
          return (
            (t = typeof t == "function" ? t : T) && r.pop(),
            r.length && r[0] === n[0] ? Wt(r, T, t) : []
          )
        }),
        So = fr(Ve),
        Oo = pe(function (n, t) {
          var r = null == n ? 0 : n.length,
            e = ht(n, t)
          return (
            ur(
              n,
              c(t, function (n) {
                return Se(n, r) ? +n : n
              }).sort(Wr)
            ),
            e
          )
        }),
        Io = fr(function (n) {
          return br(wt(n, 1, su, true))
        }),
        Ro = fr(function (n) {
          var t = qe(n)
          return su(t) && (t = T), br(wt(n, 1, su, true), ye(t, 2))
        }),
        zo = fr(function (n) {
          var t = qe(n),
            t = typeof t == "function" ? t : T
          return br(wt(n, 1, su, true), T, t)
        }),
        Wo = fr(function (n, t) {
          return su(n) ? yt(n, t) : []
        }),
        Bo = fr(function (n) {
          return mr(i(n, su))
        }),
        Lo = fr(function (n) {
          var t = qe(n)
          return su(t) && (t = T), mr(i(n, su), ye(t, 2))
        }),
        Uo = fr(function (n) {
          var t = qe(n),
            t = typeof t == "function" ? t : T
          return mr(i(n, su), T, t)
        }),
        Co = fr(Ge),
        Do = fr(function (n) {
          var t = n.length,
            t = 1 < t ? n[t - 1] : T,
            t = typeof t == "function" ? (n.pop(), t) : T
          return He(n, t)
        }),
        Mo = pe(function (n) {
          function t(t) {
            return ht(t, n)
          }
          var r = n.length,
            e = r ? n[0] : 0,
            u = this.__wrapped__
          return !(1 < r || this.__actions__.length) && u instanceof Un && Se(e)
            ? ((u = u.slice(e, +e + (r ? 1 : 0))),
              u.__actions__.push({ func: Ye, args: [t], thisArg: T }),
              new On(u, this.__chain__).thru(function (n) {
                return r && !n.length && n.push(T), n
              }))
            : this.thru(t)
        }),
        To = Tr(function (n, t, r) {
          ii.call(n, r) ? ++n[r] : st(n, r, 1)
        }),
        $o = Gr(Fe),
        Fo = Gr(Ne),
        No = Tr(function (n, t, r) {
          ii.call(n, r) ? n[r].push(t) : st(n, r, [t])
        }),
        Po = fr(function (t, r, e) {
          var u = -1,
            i = typeof r == "function",
            o = lu(t) ? Vu(t.length) : []
          return (
            eo(t, function (t) {
              o[++u] = i ? n(r, t, e) : Lt(t, r, e)
            }),
            o
          )
        }),
        Zo = Tr(function (n, t, r) {
          st(n, r, t)
        }),
        qo = Tr(
          function (n, t, r) {
            n[r ? 0 : 1].push(t)
          },
          function () {
            return [[], []]
          }
        ),
        Vo = fr(function (n, t) {
          if (null == n) return []
          var r = t.length
          return (
            1 < r && Oe(n, t[0], t[1]) ? (t = []) : 2 < r && Oe(t[0], t[1], t[2]) && (t = [t[0]]),
            Xt(n, wt(t, 1), [])
          )
        }),
        Ko =
          Ei ||
          function () {
            return $n.Date.now()
          },
        Go = fr(function (n, t, r) {
          var e = 1
          if (r.length)
            var u = L(r, de(Go)),
              e = 32 | e
          return fe(n, e, t, r, u)
        }),
        Ho = fr(function (n, t, r) {
          var e = 3
          if (r.length)
            var u = L(r, de(Ho)),
              e = 32 | e
          return fe(t, e, n, r, u)
        }),
        Jo = fr(function (n, t) {
          return dt(n, 1, t)
        }),
        Yo = fr(function (n, t, r) {
          return dt(n, ku(t) || 0, r)
        })
      fu.Cache = Fn
      var Qo = fr(function (t, r) {
          r = 1 == r.length && of(r[0]) ? c(r[0], k(ye())) : c(wt(r, 1), k(ye()))
          var e = r.length
          return fr(function (u) {
            for (var i = -1, o = Ui(u.length, e); ++i < o; ) u[i] = r[i].call(this, u[i])
            return n(t, this, u)
          })
        }),
        Xo = fr(function (n, t) {
          return fe(n, 32, T, t, L(t, de(Xo)))
        }),
        nf = fr(function (n, t) {
          return fe(n, 64, T, t, L(t, de(nf)))
        }),
        tf = pe(function (n, t) {
          return fe(n, 256, T, T, T, t)
        }),
        rf = ee(It),
        ef = ee(function (n, t) {
          return n >= t
        }),
        uf = Ut(
          (function () {
            return arguments
          })()
        )
          ? Ut
          : function (n) {
              return du(n) && ii.call(n, "callee") && !yi.call(n, "callee")
            },
        of = Vu.isArray,
        ff = Vn ? k(Vn) : Ct,
        cf = Ri || qu,
        af = Kn ? k(Kn) : Dt,
        lf = Gn ? k(Gn) : Tt,
        sf = Hn ? k(Hn) : Nt,
        hf = Jn ? k(Jn) : Pt,
        pf = Yn ? k(Yn) : Zt,
        _f = ee(Kt),
        vf = ee(function (n, t) {
          return n <= t
        }),
        gf = $r(function (n, t) {
          if (ze(t) || lu(t)) Cr(t, zu(t), n)
          else for (var r in t) ii.call(t, r) && ot(n, r, t[r])
        }),
        df = $r(function (n, t) {
          Cr(t, Wu(t), n)
        }),
        yf = $r(function (n, t, r, e) {
          Cr(t, Wu(t), n, e)
        }),
        bf = $r(function (n, t, r, e) {
          Cr(t, zu(t), n, e)
        }),
        xf = pe(ht),
        jf = fr(function (n, t) {
          n = Yu(n)
          var r = -1,
            e = t.length,
            u = 2 < e ? t[2] : T
          for (u && Oe(t[0], t[1], u) && (e = 1); ++r < e; )
            for (var u = t[r], i = Wu(u), o = -1, f = i.length; ++o < f; ) {
              var c = i[o],
                a = n[c]
              ;(a === T || (au(a, ri[c]) && !ii.call(n, c))) && (n[c] = u[c])
            }
          return n
        }),
        wf = fr(function (t) {
          return t.push(T, ae), n(Sf, T, t)
        }),
        mf = Yr(function (n, t, r) {
          null != t && typeof t.toString != "function" && (t = ci.call(t)), (n[t] = r)
        }, Mu(Tu)),
        Af = Yr(function (n, t, r) {
          null != t && typeof t.toString != "function" && (t = ci.call(t)),
            ii.call(n, t) ? n[t].push(r) : (n[t] = [r])
        }, ye),
        Ef = fr(Lt),
        kf = $r(function (n, t, r) {
          Yt(n, t, r)
        }),
        Sf = $r(function (n, t, r, e) {
          Yt(n, t, r, e)
        }),
        Of = pe(function (n, t) {
          var r = {}
          if (null == n) return r
          var e = false
          ;(t = c(t, function (t) {
            return (t = Sr(t, n)), e || (e = 1 < t.length), t
          })),
            Cr(n, ve(n), r),
            e && (r = _t(r, 7, le))
          for (var u = t.length; u--; ) xr(r, t[u])
          return r
        }),
        If = pe(function (n, t) {
          return null == n ? {} : nr(n, t)
        }),
        Rf = oe(zu),
        zf = oe(Wu),
        Wf = qr(function (n, t, r) {
          return (t = t.toLowerCase()), n + (r ? Uu(t) : t)
        }),
        Bf = qr(function (n, t, r) {
          return n + (r ? "-" : "") + t.toLowerCase()
        }),
        Lf = qr(function (n, t, r) {
          return n + (r ? " " : "") + t.toLowerCase()
        }),
        Uf = Zr("toLowerCase"),
        Cf = qr(function (n, t, r) {
          return n + (r ? "_" : "") + t.toLowerCase()
        }),
        Df = qr(function (n, t, r) {
          return n + (r ? " " : "") + Tf(t)
        }),
        Mf = qr(function (n, t, r) {
          return n + (r ? " " : "") + t.toUpperCase()
        }),
        Tf = Zr("toUpperCase"),
        $f = fr(function (t, r) {
          try {
            return n(t, T, r)
          } catch (n) {
            return hu(n) ? n : new Gu(n)
          }
        }),
        Ff = pe(function (n, t) {
          return (
            r(t, function (t) {
              ;(t = De(t)), st(n, t, Go(n[t], n))
            }),
            n
          )
        }),
        Nf = Hr(),
        Pf = Hr(true),
        Zf = fr(function (n, t) {
          return function (r) {
            return Lt(r, n, t)
          }
        }),
        qf = fr(function (n, t) {
          return function (r) {
            return Lt(n, r, t)
          }
        }),
        Vf = Xr(c),
        Kf = Xr(u),
        Gf = Xr(h),
        Hf = re(),
        Jf = re(true),
        Yf = Qr(function (n, t) {
          return n + t
        }, 0),
        Qf = ie("ceil"),
        Xf = Qr(function (n, t) {
          return n / t
        }, 1),
        nc = ie("floor"),
        tc = Qr(function (n, t) {
          return n * t
        }, 1),
        rc = ie("round"),
        ec = Qr(function (n, t) {
          return n - t
        }, 0)
      return (
        (An.after = function (n, t) {
          if (typeof t != "function") throw new ni("Expected a function")
          return (
            (n = Au(n)),
            function () {
              if (1 > --n) return t.apply(this, arguments)
            }
          )
        }),
        (An.ary = ru),
        (An.assign = gf),
        (An.assignIn = df),
        (An.assignInWith = yf),
        (An.assignWith = bf),
        (An.at = xf),
        (An.before = eu),
        (An.bind = Go),
        (An.bindAll = Ff),
        (An.bindKey = Ho),
        (An.castArray = function () {
          if (!arguments.length) return []
          var n = arguments[0]
          return of(n) ? n : [n]
        }),
        (An.chain = Je),
        (An.chunk = function (n, t, r) {
          if (
            ((t = (r ? Oe(n, t, r) : t === T) ? 1 : Li(Au(t), 0)),
            (r = null == n ? 0 : n.length),
            !r || 1 > t)
          )
            return []
          for (var e = 0, u = 0, i = Vu(Si(r / t)); e < r; ) i[u++] = hr(n, e, (e += t))
          return i
        }),
        (An.compact = function (n) {
          for (var t = -1, r = null == n ? 0 : n.length, e = 0, u = []; ++t < r; ) {
            var i = n[t]
            i && (u[e++] = i)
          }
          return u
        }),
        (An.concat = function () {
          var n = arguments.length
          if (!n) return []
          for (var t = Vu(n - 1), r = arguments[0]; n--; ) t[n - 1] = arguments[n]
          return a(of(r) ? Ur(r) : [r], wt(t, 1))
        }),
        (An.cond = function (t) {
          var r = null == t ? 0 : t.length,
            e = ye()
          return (
            (t = r
              ? c(t, function (n) {
                  if ("function" != typeof n[1]) throw new ni("Expected a function")
                  return [e(n[0]), n[1]]
                })
              : []),
            fr(function (e) {
              for (var u = -1; ++u < r; ) {
                var i = t[u]
                if (n(i[0], this, e)) return n(i[1], this, e)
              }
            })
          )
        }),
        (An.conforms = function (n) {
          return vt(_t(n, 1))
        }),
        (An.constant = Mu),
        (An.countBy = To),
        (An.create = function (n, t) {
          var r = ro(n)
          return null == t ? r : at(r, t)
        }),
        (An.curry = uu),
        (An.curryRight = iu),
        (An.debounce = ou),
        (An.defaults = jf),
        (An.defaultsDeep = wf),
        (An.defer = Jo),
        (An.delay = Yo),
        (An.difference = jo),
        (An.differenceBy = wo),
        (An.differenceWith = mo),
        (An.drop = function (n, t, r) {
          var e = null == n ? 0 : n.length
          return e ? ((t = r || t === T ? 1 : Au(t)), hr(n, 0 > t ? 0 : t, e)) : []
        }),
        (An.dropRight = function (n, t, r) {
          var e = null == n ? 0 : n.length
          return e ? ((t = r || t === T ? 1 : Au(t)), (t = e - t), hr(n, 0, 0 > t ? 0 : t)) : []
        }),
        (An.dropRightWhile = function (n, t) {
          return n && n.length ? jr(n, ye(t, 3), true, true) : []
        }),
        (An.dropWhile = function (n, t) {
          return n && n.length ? jr(n, ye(t, 3), true) : []
        }),
        (An.fill = function (n, t, r, e) {
          var u = null == n ? 0 : n.length
          if (!u) return []
          for (
            r && typeof r != "number" && Oe(n, t, r) && ((r = 0), (e = u)),
              u = n.length,
              r = Au(r),
              0 > r && (r = -r > u ? 0 : u + r),
              e = e === T || e > u ? u : Au(e),
              0 > e && (e += u),
              e = r > e ? 0 : Eu(e);
            r < e;

          )
            n[r++] = t
          return n
        }),
        (An.filter = function (n, t) {
          return (of(n) ? i : jt)(n, ye(t, 3))
        }),
        (An.flatMap = function (n, t) {
          return wt(tu(n, t), 1)
        }),
        (An.flatMapDeep = function (n, t) {
          return wt(tu(n, t), $)
        }),
        (An.flatMapDepth = function (n, t, r) {
          return (r = r === T ? 1 : Au(r)), wt(tu(n, t), r)
        }),
        (An.flatten = Pe),
        (An.flattenDeep = function (n) {
          return (null == n ? 0 : n.length) ? wt(n, $) : []
        }),
        (An.flattenDepth = function (n, t) {
          return null != n && n.length ? ((t = t === T ? 1 : Au(t)), wt(n, t)) : []
        }),
        (An.flip = function (n) {
          return fe(n, 512)
        }),
        (An.flow = Nf),
        (An.flowRight = Pf),
        (An.fromPairs = function (n) {
          for (var t = -1, r = null == n ? 0 : n.length, e = {}; ++t < r; ) {
            var u = n[t]
            e[u[0]] = u[1]
          }
          return e
        }),
        (An.functions = function (n) {
          return null == n ? [] : Et(n, zu(n))
        }),
        (An.functionsIn = function (n) {
          return null == n ? [] : Et(n, Wu(n))
        }),
        (An.groupBy = No),
        (An.initial = function (n) {
          return (null == n ? 0 : n.length) ? hr(n, 0, -1) : []
        }),
        (An.intersection = Ao),
        (An.intersectionBy = Eo),
        (An.intersectionWith = ko),
        (An.invert = mf),
        (An.invertBy = Af),
        (An.invokeMap = Po),
        (An.iteratee = $u),
        (An.keyBy = Zo),
        (An.keys = zu),
        (An.keysIn = Wu),
        (An.map = tu),
        (An.mapKeys = function (n, t) {
          var r = {}
          return (
            (t = ye(t, 3)),
            mt(n, function (n, e, u) {
              st(r, t(n, e, u), n)
            }),
            r
          )
        }),
        (An.mapValues = function (n, t) {
          var r = {}
          return (
            (t = ye(t, 3)),
            mt(n, function (n, e, u) {
              st(r, e, t(n, e, u))
            }),
            r
          )
        }),
        (An.matches = function (n) {
          return Ht(_t(n, 1))
        }),
        (An.matchesProperty = function (n, t) {
          return Jt(n, _t(t, 1))
        }),
        (An.memoize = fu),
        (An.merge = kf),
        (An.mergeWith = Sf),
        (An.method = Zf),
        (An.methodOf = qf),
        (An.mixin = Fu),
        (An.negate = cu),
        (An.nthArg = function (n) {
          return (
            (n = Au(n)),
            fr(function (t) {
              return Qt(t, n)
            })
          )
        }),
        (An.omit = Of),
        (An.omitBy = function (n, t) {
          return Bu(n, cu(ye(t)))
        }),
        (An.once = function (n) {
          return eu(2, n)
        }),
        (An.orderBy = function (n, t, r, e) {
          return null == n
            ? []
            : (of(t) || (t = null == t ? [] : [t]),
              (r = e ? T : r),
              of(r) || (r = null == r ? [] : [r]),
              Xt(n, t, r))
        }),
        (An.over = Vf),
        (An.overArgs = Qo),
        (An.overEvery = Kf),
        (An.overSome = Gf),
        (An.partial = Xo),
        (An.partialRight = nf),
        (An.partition = qo),
        (An.pick = If),
        (An.pickBy = Bu),
        (An.property = Pu),
        (An.propertyOf = function (n) {
          return function (t) {
            return null == n ? T : kt(n, t)
          }
        }),
        (An.pull = So),
        (An.pullAll = Ve),
        (An.pullAllBy = function (n, t, r) {
          return n && n.length && t && t.length ? er(n, t, ye(r, 2)) : n
        }),
        (An.pullAllWith = function (n, t, r) {
          return n && n.length && t && t.length ? er(n, t, T, r) : n
        }),
        (An.pullAt = Oo),
        (An.range = Hf),
        (An.rangeRight = Jf),
        (An.rearg = tf),
        (An.reject = function (n, t) {
          return (of(n) ? i : jt)(n, cu(ye(t, 3)))
        }),
        (An.remove = function (n, t) {
          var r = []
          if (!n || !n.length) return r
          var e = -1,
            u = [],
            i = n.length
          for (t = ye(t, 3); ++e < i; ) {
            var o = n[e]
            t(o, e, n) && (r.push(o), u.push(e))
          }
          return ur(n, u), r
        }),
        (An.rest = function (n, t) {
          if (typeof n != "function") throw new ni("Expected a function")
          return (t = t === T ? t : Au(t)), fr(n, t)
        }),
        (An.reverse = Ke),
        (An.sampleSize = function (n, t, r) {
          return (t = (r ? Oe(n, t, r) : t === T) ? 1 : Au(t)), (of(n) ? et : ar)(n, t)
        }),
        (An.set = function (n, t, r) {
          return null == n ? n : lr(n, t, r)
        }),
        (An.setWith = function (n, t, r, e) {
          return (e = typeof e == "function" ? e : T), null == n ? n : lr(n, t, r, e)
        }),
        (An.shuffle = function (n) {
          return (of(n) ? ut : sr)(n)
        }),
        (An.slice = function (n, t, r) {
          var e = null == n ? 0 : n.length
          return e
            ? (r && typeof r != "number" && Oe(n, t, r)
                ? ((t = 0), (r = e))
                : ((t = null == t ? 0 : Au(t)), (r = r === T ? e : Au(r))),
              hr(n, t, r))
            : []
        }),
        (An.sortBy = Vo),
        (An.sortedUniq = function (n) {
          return n && n.length ? gr(n) : []
        }),
        (An.sortedUniqBy = function (n, t) {
          return n && n.length ? gr(n, ye(t, 2)) : []
        }),
        (An.split = function (n, t, r) {
          return (
            r && typeof r != "number" && Oe(n, t, r) && (t = r = T),
            (r = r === T ? 4294967295 : r >>> 0),
            r
              ? (n = Ou(n)) &&
                (typeof t == "string" || (null != t && !sf(t))) &&
                ((t = yr(t)), !t && Rn.test(n))
                ? Or(M(n), 0, r)
                : n.split(t, r)
              : []
          )
        }),
        (An.spread = function (t, r) {
          if (typeof t != "function") throw new ni("Expected a function")
          return (
            (r = null == r ? 0 : Li(Au(r), 0)),
            fr(function (e) {
              var u = e[r]
              return (e = Or(e, 0, r)), u && a(e, u), n(t, this, e)
            })
          )
        }),
        (An.tail = function (n) {
          var t = null == n ? 0 : n.length
          return t ? hr(n, 1, t) : []
        }),
        (An.take = function (n, t, r) {
          return n && n.length ? ((t = r || t === T ? 1 : Au(t)), hr(n, 0, 0 > t ? 0 : t)) : []
        }),
        (An.takeRight = function (n, t, r) {
          var e = null == n ? 0 : n.length
          return e ? ((t = r || t === T ? 1 : Au(t)), (t = e - t), hr(n, 0 > t ? 0 : t, e)) : []
        }),
        (An.takeRightWhile = function (n, t) {
          return n && n.length ? jr(n, ye(t, 3), false, true) : []
        }),
        (An.takeWhile = function (n, t) {
          return n && n.length ? jr(n, ye(t, 3)) : []
        }),
        (An.tap = function (n, t) {
          return t(n), n
        }),
        (An.throttle = function (n, t, r) {
          var e = true,
            u = true
          if (typeof n != "function") throw new ni("Expected a function")
          return (
            gu(r) &&
              ((e = "leading" in r ? !!r.leading : e), (u = "trailing" in r ? !!r.trailing : u)),
            ou(n, t, { leading: e, maxWait: t, trailing: u })
          )
        }),
        (An.thru = Ye),
        (An.toArray = wu),
        (An.toPairs = Rf),
        (An.toPairsIn = zf),
        (An.toPath = function (n) {
          return of(n) ? c(n, De) : ju(n) ? [n] : Ur(xo(Ou(n)))
        }),
        (An.toPlainObject = Su),
        (An.transform = function (n, t, e) {
          var u = of(n),
            i = u || cf(n) || pf(n)
          if (((t = ye(t, 4)), null == e)) {
            var o = n && n.constructor
            e = i ? (u ? new o() : []) : gu(n) && pu(o) ? ro(gi(n)) : {}
          }
          return (
            (i ? r : mt)(n, function (n, r, u) {
              return t(e, n, r, u)
            }),
            e
          )
        }),
        (An.unary = function (n) {
          return ru(n, 1)
        }),
        (An.union = Io),
        (An.unionBy = Ro),
        (An.unionWith = zo),
        (An.uniq = function (n) {
          return n && n.length ? br(n) : []
        }),
        (An.uniqBy = function (n, t) {
          return n && n.length ? br(n, ye(t, 2)) : []
        }),
        (An.uniqWith = function (n, t) {
          return (t = typeof t == "function" ? t : T), n && n.length ? br(n, T, t) : []
        }),
        (An.unset = function (n, t) {
          return null == n || xr(n, t)
        }),
        (An.unzip = Ge),
        (An.unzipWith = He),
        (An.update = function (n, t, r) {
          return null == n ? n : lr(n, t, kr(r)(kt(n, t)), void 0)
        }),
        (An.updateWith = function (n, t, r, e) {
          return (
            (e = typeof e == "function" ? e : T), null != n && (n = lr(n, t, kr(r)(kt(n, t)), e)), n
          )
        }),
        (An.values = Lu),
        (An.valuesIn = function (n) {
          return null == n ? [] : S(n, Wu(n))
        }),
        (An.without = Wo),
        (An.words = Du),
        (An.wrap = function (n, t) {
          return Xo(kr(t), n)
        }),
        (An.xor = Bo),
        (An.xorBy = Lo),
        (An.xorWith = Uo),
        (An.zip = Co),
        (An.zipObject = function (n, t) {
          return Ar(n || [], t || [], ot)
        }),
        (An.zipObjectDeep = function (n, t) {
          return Ar(n || [], t || [], lr)
        }),
        (An.zipWith = Do),
        (An.entries = Rf),
        (An.entriesIn = zf),
        (An.extend = df),
        (An.extendWith = yf),
        Fu(An, An),
        (An.add = Yf),
        (An.attempt = $f),
        (An.camelCase = Wf),
        (An.capitalize = Uu),
        (An.ceil = Qf),
        (An.clamp = function (n, t, r) {
          return (
            r === T && ((r = t), (t = T)),
            r !== T && ((r = ku(r)), (r = r === r ? r : 0)),
            t !== T && ((t = ku(t)), (t = t === t ? t : 0)),
            pt(ku(n), t, r)
          )
        }),
        (An.clone = function (n) {
          return _t(n, 4)
        }),
        (An.cloneDeep = function (n) {
          return _t(n, 5)
        }),
        (An.cloneDeepWith = function (n, t) {
          return (t = typeof t == "function" ? t : T), _t(n, 5, t)
        }),
        (An.cloneWith = function (n, t) {
          return (t = typeof t == "function" ? t : T), _t(n, 4, t)
        }),
        (An.conformsTo = function (n, t) {
          return null == t || gt(n, t, zu(t))
        }),
        (An.deburr = Cu),
        (An.defaultTo = function (n, t) {
          return null == n || n !== n ? t : n
        }),
        (An.divide = Xf),
        (An.endsWith = function (n, t, r) {
          ;(n = Ou(n)), (t = yr(t))
          var e = n.length,
            e = (r = r === T ? e : pt(Au(r), 0, e))
          return (r -= t.length), 0 <= r && n.slice(r, e) == t
        }),
        (An.eq = au),
        (An.escape = function (n) {
          return (n = Ou(n)) && H.test(n) ? n.replace(K, nt) : n
        }),
        (An.escapeRegExp = function (n) {
          return (n = Ou(n)) && en.test(n) ? n.replace(rn, "\\$&") : n
        }),
        (An.every = function (n, t, r) {
          var e = of(n) ? u : bt
          return r && Oe(n, t, r) && (t = T), e(n, ye(t, 3))
        }),
        (An.find = $o),
        (An.findIndex = Fe),
        (An.findKey = function (n, t) {
          return p(n, ye(t, 3), mt)
        }),
        (An.findLast = Fo),
        (An.findLastIndex = Ne),
        (An.findLastKey = function (n, t) {
          return p(n, ye(t, 3), At)
        }),
        (An.floor = nc),
        (An.forEach = Xe),
        (An.forEachRight = nu),
        (An.forIn = function (n, t) {
          return null == n ? n : io(n, ye(t, 3), Wu)
        }),
        (An.forInRight = function (n, t) {
          return null == n ? n : oo(n, ye(t, 3), Wu)
        }),
        (An.forOwn = function (n, t) {
          return n && mt(n, ye(t, 3))
        }),
        (An.forOwnRight = function (n, t) {
          return n && At(n, ye(t, 3))
        }),
        (An.get = Iu),
        (An.gt = rf),
        (An.gte = ef),
        (An.has = function (n, t) {
          return null != n && we(n, t, Rt)
        }),
        (An.hasIn = Ru),
        (An.head = Ze),
        (An.identity = Tu),
        (An.includes = function (n, t, r, e) {
          return (
            (n = lu(n) ? n : Lu(n)),
            (r = r && !e ? Au(r) : 0),
            (e = n.length),
            0 > r && (r = Li(e + r, 0)),
            xu(n) ? r <= e && -1 < n.indexOf(t, r) : !!e && -1 < v(n, t, r)
          )
        }),
        (An.indexOf = function (n, t, r) {
          var e = null == n ? 0 : n.length
          return e ? ((r = null == r ? 0 : Au(r)), 0 > r && (r = Li(e + r, 0)), v(n, t, r)) : -1
        }),
        (An.inRange = function (n, t, r) {
          return (
            (t = mu(t)),
            r === T ? ((r = t), (t = 0)) : (r = mu(r)),
            (n = ku(n)),
            n >= Ui(t, r) && n < Li(t, r)
          )
        }),
        (An.invoke = Ef),
        (An.isArguments = uf),
        (An.isArray = of),
        (An.isArrayBuffer = ff),
        (An.isArrayLike = lu),
        (An.isArrayLikeObject = su),
        (An.isBoolean = function (n) {
          return true === n || false === n || (du(n) && "[object Boolean]" == Ot(n))
        }),
        (An.isBuffer = cf),
        (An.isDate = af),
        (An.isElement = function (n) {
          return du(n) && 1 === n.nodeType && !bu(n)
        }),
        (An.isEmpty = function (n) {
          if (null == n) return true
          if (
            lu(n) &&
            (of(n) ||
              typeof n == "string" ||
              typeof n.splice == "function" ||
              cf(n) ||
              pf(n) ||
              uf(n))
          )
            return !n.length
          var t = _o(n)
          if ("[object Map]" == t || "[object Set]" == t) return !n.size
          if (ze(n)) return !Vt(n).length
          for (var r in n) if (ii.call(n, r)) return false
          return true
        }),
        (An.isEqual = function (n, t) {
          return Mt(n, t)
        }),
        (An.isEqualWith = function (n, t, r) {
          var e = (r = typeof r == "function" ? r : T) ? r(n, t) : T
          return e === T ? Mt(n, t, T, r) : !!e
        }),
        (An.isError = hu),
        (An.isFinite = function (n) {
          return typeof n == "number" && zi(n)
        }),
        (An.isFunction = pu),
        (An.isInteger = _u),
        (An.isLength = vu),
        (An.isMap = lf),
        (An.isMatch = function (n, t) {
          return n === t || $t(n, t, xe(t))
        }),
        (An.isMatchWith = function (n, t, r) {
          return (r = typeof r == "function" ? r : T), $t(n, t, xe(t), r)
        }),
        (An.isNaN = function (n) {
          return yu(n) && n != +n
        }),
        (An.isNative = function (n) {
          if (vo(n)) throw new Gu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.")
          return Ft(n)
        }),
        (An.isNil = function (n) {
          return null == n
        }),
        (An.isNull = function (n) {
          return null === n
        }),
        (An.isNumber = yu),
        (An.isObject = gu),
        (An.isObjectLike = du),
        (An.isPlainObject = bu),
        (An.isRegExp = sf),
        (An.isSafeInteger = function (n) {
          return _u(n) && -9007199254740991 <= n && 9007199254740991 >= n
        }),
        (An.isSet = hf),
        (An.isString = xu),
        (An.isSymbol = ju),
        (An.isTypedArray = pf),
        (An.isUndefined = function (n) {
          return n === T
        }),
        (An.isWeakMap = function (n) {
          return du(n) && "[object WeakMap]" == _o(n)
        }),
        (An.isWeakSet = function (n) {
          return du(n) && "[object WeakSet]" == Ot(n)
        }),
        (An.join = function (n, t) {
          return null == n ? "" : Wi.call(n, t)
        }),
        (An.kebabCase = Bf),
        (An.last = qe),
        (An.lastIndexOf = function (n, t, r) {
          var e = null == n ? 0 : n.length
          if (!e) return -1
          var u = e
          if ((r !== T && ((u = Au(r)), (u = 0 > u ? Li(e + u, 0) : Ui(u, e - 1))), t === t)) {
            for (r = u + 1; r-- && n[r] !== t; );
            n = r
          } else n = _(n, d, u, true)
          return n
        }),
        (An.lowerCase = Lf),
        (An.lowerFirst = Uf),
        (An.lt = _f),
        (An.lte = vf),
        (An.max = function (n) {
          return n && n.length ? xt(n, Tu, It) : T
        }),
        (An.maxBy = function (n, t) {
          return n && n.length ? xt(n, ye(t, 2), It) : T
        }),
        (An.mean = function (n) {
          return y(n, Tu)
        }),
        (An.meanBy = function (n, t) {
          return y(n, ye(t, 2))
        }),
        (An.min = function (n) {
          return n && n.length ? xt(n, Tu, Kt) : T
        }),
        (An.minBy = function (n, t) {
          return n && n.length ? xt(n, ye(t, 2), Kt) : T
        }),
        (An.stubArray = Zu),
        (An.stubFalse = qu),
        (An.stubObject = function () {
          return {}
        }),
        (An.stubString = function () {
          return ""
        }),
        (An.stubTrue = function () {
          return true
        }),
        (An.multiply = tc),
        (An.nth = function (n, t) {
          return n && n.length ? Qt(n, Au(t)) : T
        }),
        (An.noConflict = function () {
          return $n._ === this && ($n._ = li), this
        }),
        (An.noop = Nu),
        (An.now = Ko),
        (An.pad = function (n, t, r) {
          n = Ou(n)
          var e = (t = Au(t)) ? D(n) : 0
          return !t || e >= t ? n : ((t = (t - e) / 2), ne(Oi(t), r) + n + ne(Si(t), r))
        }),
        (An.padEnd = function (n, t, r) {
          n = Ou(n)
          var e = (t = Au(t)) ? D(n) : 0
          return t && e < t ? n + ne(t - e, r) : n
        }),
        (An.padStart = function (n, t, r) {
          n = Ou(n)
          var e = (t = Au(t)) ? D(n) : 0
          return t && e < t ? ne(t - e, r) + n : n
        }),
        (An.parseInt = function (n, t, r) {
          return r || null == t ? (t = 0) : t && (t = +t), Di(Ou(n).replace(on, ""), t || 0)
        }),
        (An.random = function (n, t, r) {
          if (
            (r && typeof r != "boolean" && Oe(n, t, r) && (t = r = T),
            r === T &&
              (typeof t == "boolean"
                ? ((r = t), (t = T))
                : typeof n == "boolean" && ((r = n), (n = T))),
            n === T && t === T
              ? ((n = 0), (t = 1))
              : ((n = mu(n)), t === T ? ((t = n), (n = 0)) : (t = mu(t))),
            n > t)
          ) {
            var e = n
            ;(n = t), (t = e)
          }
          return r || n % 1 || t % 1
            ? ((r = Mi()), Ui(n + r * (t - n + Cn("1e-" + ((r + "").length - 1))), t))
            : ir(n, t)
        }),
        (An.reduce = function (n, t, r) {
          var e = of(n) ? l : j,
            u = 3 > arguments.length
          return e(n, ye(t, 4), r, u, eo)
        }),
        (An.reduceRight = function (n, t, r) {
          var e = of(n) ? s : j,
            u = 3 > arguments.length
          return e(n, ye(t, 4), r, u, uo)
        }),
        (An.repeat = function (n, t, r) {
          return (t = (r ? Oe(n, t, r) : t === T) ? 1 : Au(t)), or(Ou(n), t)
        }),
        (An.replace = function () {
          var n = arguments,
            t = Ou(n[0])
          return 3 > n.length ? t : t.replace(n[1], n[2])
        }),
        (An.result = function (n, t, r) {
          t = Sr(t, n)
          var e = -1,
            u = t.length
          for (u || ((u = 1), (n = T)); ++e < u; ) {
            var i = null == n ? T : n[De(t[e])]
            i === T && ((e = u), (i = r)), (n = pu(i) ? i.call(n) : i)
          }
          return n
        }),
        (An.round = rc),
        (An.runInContext = x),
        (An.sample = function (n) {
          return (of(n) ? Qn : cr)(n)
        }),
        (An.size = function (n) {
          if (null == n) return 0
          if (lu(n)) return xu(n) ? D(n) : n.length
          var t = _o(n)
          return "[object Map]" == t || "[object Set]" == t ? n.size : Vt(n).length
        }),
        (An.snakeCase = Cf),
        (An.some = function (n, t, r) {
          var e = of(n) ? h : pr
          return r && Oe(n, t, r) && (t = T), e(n, ye(t, 3))
        }),
        (An.sortedIndex = function (n, t) {
          return _r(n, t)
        }),
        (An.sortedIndexBy = function (n, t, r) {
          return vr(n, t, ye(r, 2))
        }),
        (An.sortedIndexOf = function (n, t) {
          var r = null == n ? 0 : n.length
          if (r) {
            var e = _r(n, t)
            if (e < r && au(n[e], t)) return e
          }
          return -1
        }),
        (An.sortedLastIndex = function (n, t) {
          return _r(n, t, true)
        }),
        (An.sortedLastIndexBy = function (n, t, r) {
          return vr(n, t, ye(r, 2), true)
        }),
        (An.sortedLastIndexOf = function (n, t) {
          if (null == n ? 0 : n.length) {
            var r = _r(n, t, true) - 1
            if (au(n[r], t)) return r
          }
          return -1
        }),
        (An.startCase = Df),
        (An.startsWith = function (n, t, r) {
          return (
            (n = Ou(n)),
            (r = null == r ? 0 : pt(Au(r), 0, n.length)),
            (t = yr(t)),
            n.slice(r, r + t.length) == t
          )
        }),
        (An.subtract = ec),
        (An.sum = function (n) {
          return n && n.length ? m(n, Tu) : 0
        }),
        (An.sumBy = function (n, t) {
          return n && n.length ? m(n, ye(t, 2)) : 0
        }),
        (An.template = function (n, t, r) {
          var e = An.templateSettings
          r && Oe(n, t, r) && (t = T),
            (n = Ou(n)),
            (t = yf({}, t, e, ce)),
            (r = yf({}, t.imports, e.imports, ce))
          var u,
            i,
            o = zu(r),
            f = S(r, o),
            c = 0
          r = t.interpolate || jn
          var a = "__p+='"
          r = Qu(
            (t.escape || jn).source +
              "|" +
              r.source +
              "|" +
              (r === Q ? pn : jn).source +
              "|" +
              (t.evaluate || jn).source +
              "|$",
            "g"
          )
          var l = "sourceURL" in t ? "//# sourceURL=" + t.sourceURL + "\n" : ""
          if (
            (n.replace(r, function (t, r, e, o, f, l) {
              return (
                e || (e = o),
                (a += n.slice(c, l).replace(wn, z)),
                r && ((u = true), (a += "'+__e(" + r + ")+'")),
                f && ((i = true), (a += "';" + f + ";\n__p+='")),
                e && (a += "'+((__t=(" + e + "))==null?'':__t)+'"),
                (c = l + t.length),
                t
              )
            }),
            (a += "';"),
            (t = t.variable) || (a = "with(obj){" + a + "}"),
            (a = (i ? a.replace(P, "") : a).replace(Z, "$1").replace(q, "$1;")),
            (a =
              "function(" +
              (t || "obj") +
              "){" +
              (t ? "" : "obj||(obj={});") +
              "var __t,__p=''" +
              (u ? ",__e=_.escape" : "") +
              (i
                ? ",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}"
                : ";") +
              a +
              "return __p}"),
            (t = $f(function () {
              return Hu(o, l + "return " + a).apply(T, f)
            })),
            (t.source = a),
            hu(t))
          )
            throw t
          return t
        }),
        (An.times = function (n, t) {
          if (((n = Au(n)), 1 > n || 9007199254740991 < n)) return []
          var r = 4294967295,
            e = Ui(n, 4294967295)
          for (t = ye(t), n -= 4294967295, e = A(e, t); ++r < n; ) t(r)
          return e
        }),
        (An.toFinite = mu),
        (An.toInteger = Au),
        (An.toLength = Eu),
        (An.toLower = function (n) {
          return Ou(n).toLowerCase()
        }),
        (An.toNumber = ku),
        (An.toSafeInteger = function (n) {
          return n ? pt(Au(n), -9007199254740991, 9007199254740991) : 0 === n ? n : 0
        }),
        (An.toString = Ou),
        (An.toUpper = function (n) {
          return Ou(n).toUpperCase()
        }),
        (An.trim = function (n, t, r) {
          return (n = Ou(n)) && (r || t === T)
            ? n.replace(un, "")
            : n && (t = yr(t))
            ? ((n = M(n)), (r = M(t)), (t = I(n, r)), (r = R(n, r) + 1), Or(n, t, r).join(""))
            : n
        }),
        (An.trimEnd = function (n, t, r) {
          return (n = Ou(n)) && (r || t === T)
            ? n.replace(fn, "")
            : n && (t = yr(t))
            ? ((n = M(n)), (t = R(n, M(t)) + 1), Or(n, 0, t).join(""))
            : n
        }),
        (An.trimStart = function (n, t, r) {
          return (n = Ou(n)) && (r || t === T)
            ? n.replace(on, "")
            : n && (t = yr(t))
            ? ((n = M(n)), (t = I(n, M(t))), Or(n, t).join(""))
            : n
        }),
        (An.truncate = function (n, t) {
          var r = 30,
            e = "..."
          if (gu(t))
            var u = "separator" in t ? t.separator : u,
              r = "length" in t ? Au(t.length) : r,
              e = "omission" in t ? yr(t.omission) : e
          n = Ou(n)
          var i = n.length
          if (Rn.test(n))
            var o = M(n),
              i = o.length
          if (r >= i) return n
          if (((i = r - D(e)), 1 > i)) return e
          if (((r = o ? Or(o, 0, i).join("") : n.slice(0, i)), u === T)) return r + e
          if ((o && (i += r.length - i), sf(u))) {
            if (n.slice(i).search(u)) {
              var f = r
              for (
                u.global || (u = Qu(u.source, Ou(_n.exec(u)) + "g")), u.lastIndex = 0;
                (o = u.exec(f));

              )
                var c = o.index
              r = r.slice(0, c === T ? i : c)
            }
          } else n.indexOf(yr(u), i) != i && ((u = r.lastIndexOf(u)), -1 < u && (r = r.slice(0, u)))
          return r + e
        }),
        (An.unescape = function (n) {
          return (n = Ou(n)) && G.test(n) ? n.replace(V, tt) : n
        }),
        (An.uniqueId = function (n) {
          var t = ++oi
          return Ou(n) + t
        }),
        (An.upperCase = Mf),
        (An.upperFirst = Tf),
        (An.each = Xe),
        (An.eachRight = nu),
        (An.first = Ze),
        Fu(
          An,
          (function () {
            var n = {}
            return (
              mt(An, function (t, r) {
                ii.call(An.prototype, r) || (n[r] = t)
              }),
              n
            )
          })(),
          { chain: false }
        ),
        (An.VERSION = "4.17.10"),
        r("bind bindKey curry curryRight partial partialRight".split(" "), function (n) {
          An[n].placeholder = An
        }),
        r(["drop", "take"], function (n, t) {
          ;(Un.prototype[n] = function (r) {
            r = r === T ? 1 : Li(Au(r), 0)
            var e = this.__filtered__ && !t ? new Un(this) : this.clone()
            return (
              e.__filtered__
                ? (e.__takeCount__ = Ui(r, e.__takeCount__))
                : e.__views__.push({
                    size: Ui(r, 4294967295),
                    type: n + (0 > e.__dir__ ? "Right" : "")
                  }),
              e
            )
          }),
            (Un.prototype[n + "Right"] = function (t) {
              return this.reverse()[n](t).reverse()
            })
        }),
        r(["filter", "map", "takeWhile"], function (n, t) {
          var r = t + 1,
            e = 1 == r || 3 == r
          Un.prototype[n] = function (n) {
            var t = this.clone()
            return (
              t.__iteratees__.push({
                iteratee: ye(n, 3),
                type: r
              }),
              (t.__filtered__ = t.__filtered__ || e),
              t
            )
          }
        }),
        r(["head", "last"], function (n, t) {
          var r = "take" + (t ? "Right" : "")
          Un.prototype[n] = function () {
            return this[r](1).value()[0]
          }
        }),
        r(["initial", "tail"], function (n, t) {
          var r = "drop" + (t ? "" : "Right")
          Un.prototype[n] = function () {
            return this.__filtered__ ? new Un(this) : this[r](1)
          }
        }),
        (Un.prototype.compact = function () {
          return this.filter(Tu)
        }),
        (Un.prototype.find = function (n) {
          return this.filter(n).head()
        }),
        (Un.prototype.findLast = function (n) {
          return this.reverse().find(n)
        }),
        (Un.prototype.invokeMap = fr(function (n, t) {
          return typeof n == "function"
            ? new Un(this)
            : this.map(function (r) {
                return Lt(r, n, t)
              })
        })),
        (Un.prototype.reject = function (n) {
          return this.filter(cu(ye(n)))
        }),
        (Un.prototype.slice = function (n, t) {
          n = Au(n)
          var r = this
          return r.__filtered__ && (0 < n || 0 > t)
            ? new Un(r)
            : (0 > n ? (r = r.takeRight(-n)) : n && (r = r.drop(n)),
              t !== T && ((t = Au(t)), (r = 0 > t ? r.dropRight(-t) : r.take(t - n))),
              r)
        }),
        (Un.prototype.takeRightWhile = function (n) {
          return this.reverse().takeWhile(n).reverse()
        }),
        (Un.prototype.toArray = function () {
          return this.take(4294967295)
        }),
        mt(Un.prototype, function (n, t) {
          var r = /^(?:filter|find|map|reject)|While$/.test(t),
            e = /^(?:head|last)$/.test(t),
            u = An[e ? "take" + ("last" == t ? "Right" : "") : t],
            i = e || /^find/.test(t)
          u &&
            (An.prototype[t] = function () {
              function t(n) {
                return (n = u.apply(An, a([n], f))), e && h ? n[0] : n
              }
              var o = this.__wrapped__,
                f = e ? [1] : arguments,
                c = o instanceof Un,
                l = f[0],
                s = c || of(o)
              s && r && typeof l == "function" && 1 != l.length && (c = s = false)
              var h = this.__chain__,
                p = !!this.__actions__.length,
                l = i && !h,
                c = c && !p
              return !i && s
                ? ((o = c ? o : new Un(this)),
                  (o = n.apply(o, f)),
                  o.__actions__.push({
                    func: Ye,
                    args: [t],
                    thisArg: T
                  }),
                  new On(o, h))
                : l && c
                ? n.apply(this, f)
                : ((o = this.thru(t)), l ? (e ? o.value()[0] : o.value()) : o)
            })
        }),
        r("pop push shift sort splice unshift".split(" "), function (n) {
          var t = ti[n],
            r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru",
            e = /^(?:pop|shift)$/.test(n)
          An.prototype[n] = function () {
            var n = arguments
            if (e && !this.__chain__) {
              var u = this.value()
              return t.apply(of(u) ? u : [], n)
            }
            return this[r](function (r) {
              return t.apply(of(r) ? r : [], n)
            })
          }
        }),
        mt(Un.prototype, function (n, t) {
          var r = An[t]
          if (r) {
            var e = r.name + ""
            ;(Ki[e] || (Ki[e] = [])).push({ name: t, func: r })
          }
        }),
        (Ki[Jr(T, 2).name] = [{ name: "wrapper", func: T }]),
        (Un.prototype.clone = function () {
          var n = new Un(this.__wrapped__)
          return (
            (n.__actions__ = Ur(this.__actions__)),
            (n.__dir__ = this.__dir__),
            (n.__filtered__ = this.__filtered__),
            (n.__iteratees__ = Ur(this.__iteratees__)),
            (n.__takeCount__ = this.__takeCount__),
            (n.__views__ = Ur(this.__views__)),
            n
          )
        }),
        (Un.prototype.reverse = function () {
          if (this.__filtered__) {
            var n = new Un(this)
            ;(n.__dir__ = -1), (n.__filtered__ = true)
          } else (n = this.clone()), (n.__dir__ *= -1)
          return n
        }),
        (Un.prototype.value = function () {
          var n,
            t = this.__wrapped__.value(),
            r = this.__dir__,
            e = of(t),
            u = 0 > r,
            i = e ? t.length : 0
          n = i
          for (var o = this.__views__, f = 0, c = -1, a = o.length; ++c < a; ) {
            var l = o[c],
              s = l.size
            switch (l.type) {
              case "drop":
                f += s
                break
              case "dropRight":
                n -= s
                break
              case "take":
                n = Ui(n, f + s)
                break
              case "takeRight":
                f = Li(f, n - s)
            }
          }
          if (
            ((n = { start: f, end: n }),
            (o = n.start),
            (f = n.end),
            (n = f - o),
            (o = u ? f : o - 1),
            (f = this.__iteratees__),
            (c = f.length),
            (a = 0),
            (l = Ui(n, this.__takeCount__)),
            !e || (!u && i == n && l == n))
          )
            return wr(t, this.__actions__)
          e = []
          n: for (; n-- && a < l; ) {
            for (o += r, u = -1, i = t[o]; ++u < c; ) {
              var h = f[u],
                s = h.type,
                h = (0, h.iteratee)(i)
              if (2 == s) i = h
              else if (!h) {
                if (1 == s) continue n
                break n
              }
            }
            e[a++] = i
          }
          return e
        }),
        (An.prototype.at = Mo),
        (An.prototype.chain = function () {
          return Je(this)
        }),
        (An.prototype.commit = function () {
          return new On(this.value(), this.__chain__)
        }),
        (An.prototype.next = function () {
          this.__values__ === T && (this.__values__ = wu(this.value()))
          var n = this.__index__ >= this.__values__.length
          return { done: n, value: n ? T : this.__values__[this.__index__++] }
        }),
        (An.prototype.plant = function (n) {
          for (var t, r = this; r instanceof En; ) {
            var e = $e(r)
            ;(e.__index__ = 0), (e.__values__ = T), t ? (u.__wrapped__ = e) : (t = e)
            var u = e,
              r = r.__wrapped__
          }
          return (u.__wrapped__ = n), t
        }),
        (An.prototype.reverse = function () {
          var n = this.__wrapped__
          return n instanceof Un
            ? (this.__actions__.length && (n = new Un(this)),
              (n = n.reverse()),
              n.__actions__.push({ func: Ye, args: [Ke], thisArg: T }),
              new On(n, this.__chain__))
            : this.thru(Ke)
        }),
        (An.prototype.toJSON =
          An.prototype.valueOf =
          An.prototype.value =
            function () {
              return wr(this.__wrapped__, this.__actions__)
            }),
        (An.prototype.first = An.prototype.head),
        ji && (An.prototype[ji] = Qe),
        An
      )
    })()
  typeof define == "function" && typeof define.amd == "object" && define.amd
    ? (($n._ = rt),
      define(function () {
        return rt
      }))
    : Nn
    ? (((Nn.exports = rt)._ = rt), (Fn._ = rt))
    : ($n._ = rt)
}).call(this)

/*! JavaScript Cookie v2.1.4 https://github.com/js-cookie/js-cookie Copyright 2006, 2015 Klaus Hartl & Fagner Brack Released under the MIT license */
/*! js-cookie v2.2.0 | MIT */
!(function (e) {
  var n = !1
  if (
    ("function" == typeof define && define.amd && (define(e), (n = !0)),
    "object" == typeof exports && ((module.exports = e()), (n = !0)),
    !n)
  ) {
    var o = window.Cookies,
      t = (window.Cookies = e())
    t.noConflict = function () {
      return (window.Cookies = o), t
    }
  }
})(function () {
  function e() {
    for (var e = 0, n = {}; e < arguments.length; e++) {
      var o = arguments[e]
      for (var t in o) n[t] = o[t]
    }
    return n
  }
  function n(o) {
    function t(n, r, i) {
      var c
      if ("undefined" != typeof document) {
        if (arguments.length > 1) {
          if ("number" == typeof (i = e({ path: "/" }, t.defaults, i)).expires) {
            var a = new Date()
            a.setMilliseconds(a.getMilliseconds() + 864e5 * i.expires), (i.expires = a)
          }
          i.expires = i.expires ? i.expires.toUTCString() : ""
          try {
            ;(c = JSON.stringify(r)), /^[\{\[]/.test(c) && (r = c)
          } catch (e) {}
          ;(r = o.write
            ? o.write(r, n)
            : encodeURIComponent(r + "").replace(
                /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                decodeURIComponent
              )),
            (n = (n = (n = encodeURIComponent(n + "")).replace(
              /%(23|24|26|2B|5E|60|7C)/g,
              decodeURIComponent
            )).replace(/[\(\)]/g, escape))
          var s = ""
          for (var f in i) i[f] && ((s += "; " + f), !0 !== i[f] && (s += "=" + i[f]))
          return (document.cookie = n + "=" + r + s)
        }
        n || (c = {})
        for (
          var p = document.cookie ? document.cookie.split("; ") : [], d = /(%[0-9A-Z]{2})+/g, u = 0;
          u < p.length;
          u++
        ) {
          var l = p[u].split("="),
            C = l.slice(1).join("=")
          this.json || '"' !== C.charAt(0) || (C = C.slice(1, -1))
          try {
            var m = l[0].replace(d, decodeURIComponent)
            if (
              ((C = o.read ? o.read(C, m) : o(C, m) || C.replace(d, decodeURIComponent)), this.json)
            )
              try {
                C = JSON.parse(C)
              } catch (e) {}
            if (n === m) {
              c = C
              break
            }
            n || (c[m] = C)
          } catch (e) {}
        }
        return c
      }
    }
    return (
      (t.set = t),
      (t.get = function (e) {
        return t.call(t, e)
      }),
      (t.getJSON = function () {
        return t.apply({ json: !0 }, [].slice.call(arguments))
      }),
      (t.defaults = {}),
      (t.remove = function (n, o) {
        t(n, "", e(o, { expires: -1 }))
      }),
      (t.withConverter = n),
      t
    )
  }
  return n(function () {})
})

/** * TinySort is a small script that sorts HTML elements. It sorts by text- or attribute value, or by that of one of it's children. * @summary A nodeElement sorting script. * @version 2.3.6 * @license MIT * @author Ron Valstar <ron@ronvalstar.nl * @copyright Ron Valstar <ron@ronvalstar.nl>* @namespace tinysort */
!(function (e, t) {
  "use strict"
  function r() {
    return t
  }
  "function" == typeof define && define.amd ? define("tinysort", r) : (e.tinysort = t)
})(
  this,
  (function () {
    "use strict"
    function e(e, n) {
      function s() {
        0 === arguments.length
          ? v({})
          : t(arguments, function (e) {
              v(x(e) ? { selector: e } : e)
            }),
          (d = $.length)
      }
      function v(e) {
        var t = !!e.selector,
          n = t && ":" === e.selector[0],
          o = r(e || {}, m)
        $.push(
          r(
            {
              hasSelector: t,
              hasAttr: !(o.attr === l || "" === o.attr),
              hasData: o.data !== l,
              hasFilter: n,
              sortReturnNumber: "asc" === o.order ? 1 : -1
            },
            o
          )
        )
      }
      function S() {
        t(e, function (e, t) {
          M ? M !== e.parentNode && (k = !1) : (M = e.parentNode)
          var r = $[0],
            n = r.hasFilter,
            o = r.selector,
            a = !o || (n && e.matchesSelector(o)) || (o && e.querySelector(o)),
            l = a ? R : V,
            s = { elm: e, pos: t, posn: l.length }
          B.push(s), l.push(s)
        }),
          (D = R.slice(0))
      }
      function y(e, t, r) {
        for (var n = r(e.toString()), o = r(t.toString()), a = 0; n[a] && o[a]; a++)
          if (n[a] !== o[a]) {
            var l = Number(n[a]),
              s = Number(o[a])
            return l == n[a] && s == o[a] ? l - s : n[a] > o[a] ? 1 : -1
          }
        return n.length - o.length
      }
      function N(e) {
        for (var t, r, n = [], o = 0, a = -1, l = 0; (t = (r = e.charAt(o++)).charCodeAt(0)); ) {
          var s = 46 == t || (t >= 48 && 57 >= t)
          s !== l && ((n[++a] = ""), (l = s)), (n[a] += r)
        }
        return n
      }
      function C(e, r) {
        var n = 0
        for (0 !== p && (p = 0); 0 === n && d > p; ) {
          var l = $[p],
            s = l.ignoreDashes ? f : u
          if (
            (t(h, function (e) {
              var t = e.prepare
              t && t(l)
            }),
            l.sortFunction)
          )
            n = l.sortFunction(e, r)
          else if ("rand" == l.order) n = Math.random() < 0.5 ? 1 : -1
          else {
            var c = a,
              g = w(e, l),
              m = w(r, l),
              v = "" === g || g === o,
              S = "" === m || m === o
            if (g === m) n = 0
            else if (l.emptyEnd && (v || S)) n = v && S ? 0 : v ? 1 : -1
            else {
              if (!l.forceStrings) {
                var C = x(g) ? g && g.match(s) : a,
                  b = x(m) ? m && m.match(s) : a
                if (C && b) {
                  var A = g.substr(0, g.length - C[0].length),
                    F = m.substr(0, m.length - b[0].length)
                  A == F && ((c = !a), (g = i(C[0])), (m = i(b[0])))
                }
              }
              n =
                g === o || m === o
                  ? 0
                  : l.natural && (isNaN(g) || isNaN(m))
                  ? y(g, m, N)
                  : m > g
                  ? -1
                  : g > m
                  ? 1
                  : 0
            }
          }
          t(h, function (e) {
            var t = e.sort
            t && (n = t(l, c, g, m, n))
          }),
            (n *= l.sortReturnNumber),
            0 === n && p++
        }
        return 0 === n && (n = e.pos > r.pos ? 1 : -1), n
      }
      function b() {
        var e = R.length === B.length
        if (k && e)
          O
            ? R.forEach(function (e, t) {
                e.elm.style.order = t
              })
            : M
            ? M.appendChild(A())
            : console.warn("parentNode has been removed")
        else {
          var t = $[0],
            r = t.place,
            n = "org" === r,
            o = "start" === r,
            a = "end" === r,
            l = "first" === r,
            s = "last" === r
          if (n)
            R.forEach(F),
              R.forEach(function (e, t) {
                E(D[t], e.elm)
              })
          else if (o || a) {
            var c = D[o ? 0 : D.length - 1],
              i = c && c.elm.parentNode,
              u = i && ((o && i.firstChild) || i.lastChild)
            u && (u !== c.elm && (c = { elm: u }), F(c), a && i.appendChild(c.ghost), E(c, A()))
          } else if (l || s) {
            var f = D[l ? 0 : D.length - 1]
            E(F(f), A())
          }
        }
      }
      function A() {
        return (
          R.forEach(function (e) {
            q.appendChild(e.elm)
          }),
          q
        )
      }
      function F(e) {
        var t = e.elm,
          r = c.createElement("div")
        return (e.ghost = r), t.parentNode.insertBefore(r, t), e
      }
      function E(e, t) {
        var r = e.ghost,
          n = r.parentNode
        n.insertBefore(t, r), n.removeChild(r), delete e.ghost
      }
      function w(e, t) {
        var r,
          n = e.elm
        return (
          t.selector &&
            (t.hasFilter
              ? n.matchesSelector(t.selector) || (n = l)
              : (n = n.querySelector(t.selector))),
          t.hasAttr
            ? (r = n.getAttribute(t.attr))
            : t.useVal
            ? (r = n.value || n.getAttribute("value"))
            : t.hasData
            ? (r = n.getAttribute("data-" + t.data))
            : n && (r = n.textContent),
          x(r) && (t.cases || (r = r.toLowerCase()), (r = r.replace(/\s+/g, " "))),
          null === r && (r = g),
          r
        )
      }
      function x(e) {
        return "string" == typeof e
      }
      x(e) && (e = c.querySelectorAll(e)), 0 === e.length && console.warn("No elements to sort")
      var D,
        M,
        q = c.createDocumentFragment(),
        B = [],
        R = [],
        V = [],
        $ = [],
        k = !0,
        z = e.length && e[0].parentNode,
        L = z.rootNode !== document,
        O =
          e.length &&
          (n === o || n.useFlex !== !1) &&
          !L &&
          -1 !== getComputedStyle(z, null).display.indexOf("flex")
      return (
        s.apply(l, Array.prototype.slice.call(arguments, 1)),
        S(),
        R.sort(C),
        b(),
        R.map(function (e) {
          return e.elm
        })
      )
    }
    function t(e, t) {
      for (var r, n = e.length, o = n; o--; ) (r = n - o - 1), t(e[r], r)
    }
    function r(e, t, r) {
      for (var n in t) (r || e[n] === o) && (e[n] = t[n])
      return e
    }
    function n(e, t, r) {
      h.push({ prepare: e, sort: t, sortBy: r })
    }
    var o,
      a = !1,
      l = null,
      s = window,
      c = s.document,
      i = parseFloat,
      u = /(-?\d+\.?\d*)\s*$/g,
      f = /(\d+\.?\d*)\s*$/g,
      h = [],
      d = 0,
      p = 0,
      g = String.fromCharCode(4095),
      m = {
        selector: l,
        order: "asc",
        attr: l,
        data: l,
        useVal: a,
        place: "org",
        returns: a,
        cases: a,
        natural: a,
        forceStrings: a,
        ignoreDashes: a,
        sortFunction: l,
        useFlex: a,
        emptyEnd: a
      }
    return (
      s.Element &&
        (function (e) {
          e.matchesSelector =
            e.matchesSelector ||
            e.mozMatchesSelector ||
            e.msMatchesSelector ||
            e.oMatchesSelector ||
            e.webkitMatchesSelector ||
            function (e) {
              for (
                var t = this, r = (t.parentNode || t.document).querySelectorAll(e), n = -1;
                r[++n] && r[n] != t;

              );
              return !!r[n]
            }
        })(Element.prototype),
      r(n, { loop: t }),
      r(e, { plugin: n, defaults: m })
    )
  })()
)

var KlaviyoSubscribe = KlaviyoSubscribe || {}

;(function () {
  if (!KlaviyoSubscribe._loaded) {
    KlaviyoSubscribe._loaded = !0
    var m = {
        "modal.html":
          '<div class="klaviyo_modal" style="display:none;"><div class="klaviyo_inner"><a href="#" class="klaviyo_close_modal klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_fieldset"></div><div class="klaviyo_fine_print"></div><div class="klaviyo_form_actions"><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="klaviyo_below_submit"></div><div class="error_message" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>',
        "flyout.html":
          '<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_flyout_action"><a href="#"><span /> &raquo;</a></div></div></div>',

        "flyout_form.html":
          '<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_inline_fieldset"><input type="email" name="email" placeholder="Your email address" /><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="error_message" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>'
      },
      p =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      q = { $email: "Email Address", $first_name: "First Name", $last_name: "Last Name" },
      h = "klaClosedPopup"
    KlaviyoSubscribe._debug = -1 < document.location.hash.indexOf("#test")
    KlaviyoSubscribe.has_called_bootstrap = !1
    KlaviyoSubscribe.is_requirements_loaded = !1
    KlaviyoSubscribe.bootstrap_queue = []
    KlaviyoSubscribe.bootstrap_attempts = 0
    KlaviyoSubscribe.instances = {}
    KlaviyoSubscribe.isDebugMode = function () {
      return KlaviyoSubscribe._debug
    }
    KlaviyoSubscribe.bootstrap = function (a) {
      KlaviyoSubscribe.has_called_bootstrap ||
        ((KlaviyoSubscribe.has_called_bootstrap = !0),
        KlaviyoSubscribe.loadCss("//a.klaviyo.com/media/css/public/klaviyo_subscribe.css"),
        KlaviyoSubscribe.fetchRequirements(a))
    }
    KlaviyoSubscribe.setHasClosedModalCookieName = function (a) {
      h = a || h
    }
    KlaviyoSubscribe.loadScript = function (a, b, c) {
      var d = document.getElementsByTagName("head")[0],
        e = document.createElement("script")

      e.type = "text/javascript"
      e.src = a
      d.appendChild(e)
      KlaviyoSubscribe.log("Loaded JS", a)
      KlaviyoSubscribe.whenTrue(b, c)
    }
    KlaviyoSubscribe.loadCss = function (a) {
      var b = document.getElementsByTagName("head")[0],
        c = document.createElement("link")
      c.rel = "stylesheet"
      c.type = "text/css"
      c.href = a
      b.appendChild(c)
      KlaviyoSubscribe.log("Loaded CSS", a)
    }
    KlaviyoSubscribe.injectCSS = function (a) {
      var b = document.getElementsByTagName("head")[0],
        c = document.createElement("style")
      c.type = "text/css"
      c.styleSheet ? (c.styleSheet.cssText = a) : c.appendChild(document.createTextNode(a))
      b.appendChild(c)
    }
    KlaviyoSubscribe.whenTrue = function (a, b) {
      var c = 0,
        d = function () {
          a() ? b() : (c++, 100 > c && setTimeout(d, 200))
        }
      d()
    }
    KlaviyoSubscribe.loadJQuery = function (a) {
      KlaviyoSubscribe.loadScript(
        "//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",
        function () {
          return !!window.jQuery
        },
        a
      )
    }
    KlaviyoSubscribe.loadJQueryForm = function (a) {
      KlaviyoSubscribe.loadScript(
        "//cdnjs.cloudflare.com/ajax/libs/jquery.form/3.32/jquery.form.min.js",
        function () {
          return !!window.jQuery && jQuery.fn.ajaxForm && jQuery.fn.formSerialize
        },
        a
      )
    }
    KlaviyoSubscribe.fetchRequirements = function (a) {
      document.getElementsByTagName("head")
      a = a || {}
      if (window.jQuery)
        jQuery.fn.ajaxForm
          ? KlaviyoSubscribe.processQueue()
          : KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue)
      else {
        var b = function () {
          KlaviyoSubscribe.log("jQuery loaded.")
          KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue)
        }
        !0 === a.assume_jquery
          ? KlaviyoSubscribe.whenTrue(function () {
              return !!window.jQuery
            }, b)
          : KlaviyoSubscribe.loadJQuery(b)
      }
    }

    KlaviyoSubscribe.processQueue = function () {
      var a,
        b = function () {
          for (
            KlaviyoSubscribe.log("Processing queue.");
            (a = KlaviyoSubscribe.bootstrap_queue.shift());

          )
            a()
          KlaviyoSubscribe.bootstrap_queue.push = function (a) {
            a()
          }
        }
      KlaviyoSubscribe.log("Waiting for DOM to process queue.")
      jQuery(b)
      setTimeout(b, 5e3)
    }
    KlaviyoSubscribe.executeWhenRequirementsLoaded = function (a) {
      KlaviyoSubscribe.bootstrap_queue.push(a)
    }
    KlaviyoSubscribe.watchField = function (a, b, c) {
      c = c || {}
      c.type = c.type || "text"
      if ("email" === b || "$email" === b) c.type = "email"
      KlaviyoSubscribe.bootstrap()
      KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        KlaviyoSubscribe.log("Watching field", a, jQuery(a).length)
        var d = function (a) {
          a = jQuery.trim($(a.target).val())
          KlaviyoSubscribe.log("Watch field value", a)
          if ("email" !== c.type || p.test(a)) {
            if (window._learnq && _learnq.push) {
              var d = {}
              d[b] = a
              _learnq.push(["identify", d])
            }
            c.callback && c.callback(b, a)
          }
        }
        if (c.delegate) jQuery(c.delegate).on("change blur", a, d)
        else jQuery(a).on("change blur", d)
      })
    }
    KlaviyoSubscribe.watchFormSubmission = function (a, b) {
      b = b || {}
      b.properties = b.properties || {}
      b.list &&
        (KlaviyoSubscribe.bootstrap(),
        KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
          if (b.properties) {
            var c = []
            jQuery.each(b.properties, function (a, b) {
              c.push(a)
            })
            c.length && (b.properties.$fields = c.join(","))
          }
          KlaviyoSubscribe.log("Watching form", a, jQuery(a).length)
          var d = function (a) {
            var c = $(a.target)
            if (window._learnq && _learnq.identify) {
              var d = _learnq.identify()
              if (d && (d = d.$email || d.email)) {
                if (b["if"]) {
                  var g = jQuery(b["if"])
                  if (!g.length || (g.is(":checkbox") ? !g.is(":checked") : !g.val())) {
                    KlaviyoSubscribe.log("Subscribe if fails", g)
                    return
                  }
                }
                d = jQuery.extend({ g: b.list, email: d }, b.properties)
                KlaviyoSubscribe.log("Subscribing", d)
                $.post("//manage.kmail-lists.com/ajax/subscriptions/subscribe", d)
                b.wait_seconds &&
                  (a.preventDefault(),
                  setTimeout(function () {
                    KlaviyoSubscribe.log("Submitting form", c)
                    c.get(0).submit()
                  }, 1e3 * b.wait_seconds))
              }
            }
          }
          if (b.delegate) jQuery(b.delegate).on("submit", a, d)
          else jQuery(a).on("submit", d)
        }))
    }
    KlaviyoSubscribe.attachToForms = function (a, b) {
      b = b || {}
      var c = b.extra_properties || {}
      c.$source = c.$source || "$embed"
      KlaviyoSubscribe.bootstrap()
      KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        KlaviyoSubscribe.log("Attaching to forms", a, jQuery(a).length)
        jQuery(a).each(function () {
          var a = jQuery(this),
            e = a.data("ajax-submit")
          e || (e = "//manage.kmail-lists.com/ajax/subscriptions/subscribe")
          a.ajaxForm({
            url: e,
            type: "POST",
            beforeSubmit: function (b, e, g) {
              try {
                if (!KlaviyoSubscribe.isFormValid(a)) return !1
              } catch (l) {
                return (
                  KlaviyoSubscribe.log(l),
                  a.find(".error_message").show().html(l),
                  a.trigger("klaviyo.subscribe.error"),
                  !1
                )
              }
              KlaviyoSubscribe.log("$source", c.$source)
              KlaviyoSubscribe.normalizeFormFields(b, a, c, g)
              a.find(".klaviyo_submit_button").attr("disabled", !0)
            },
            success: function (c, e, g) {
              a.find(".success_message, .error_message").hide()
              a.find(".klaviyo_submit_button").attr("disabled", !1)
              c.success
                ? (KlaviyoSubscribe.setClosedModalCookie(),
                  (e = a.find(".success_message").show()),
                  e.length || (e = a.parent().find(".success_message").show()),
                  window._learnq &&
                    _learnq.push &&
                    (g = a.find('[name="email"]').val()) &&
                    (_learnq.push(["identify", { $email: g }]), _learnq.push(["trackActivity"])),
                  b.success_url
                    ? (window.location = b.success_url)
                    : (!0 !== b.custom_success_message &&
                        e
                          .html(
                            b.success_message ||
                              '<div class="klaviyo_header">Thanks for subscribing!</div><div class="klaviyo_subheader">Check your email for a confirmation message.</div>'
                          )
                          .end(),
                      !0 === b.hide_form_on_success &&
                        (a.find(".klaviyo_field_group input, .klaviyo_form_actions").hide(),
                        a.is(".klaviyo_horizontal_form") && a.find(".klaviyo_field_group").hide()),
                      b.success && b.success(a, c.data),
                      a.trigger("klaviyo.subscribe.success").resetForm()))
                : (KlaviyoSubscribe.log(c.errors),
                  a.find(".error_message").show().html(c.errors.join(" ")),
                  a.trigger("klaviyo.subscribe.error"))
            }
          })
          KlaviyoSubscribe.log("Attached to form", this)
        })
      })
    }
    KlaviyoSubscribe.attachModalSignUp = function (a) {
      a = a || {}
      a.pages = a.pages || []
      a.excluded_pages = a.excluded_pages || []
      a.delay_seconds = a.delay_seconds || 0.1
      a.delay_num_pages = a.delay_num_pages || 0
      a.content = a.content || {}
      a.extra_properties = a.extra_properties || {}
      a.extra_properties.$source = a.extra_properties.$source || "$modal"
      a.list &&
        (KlaviyoSubscribe.bootstrap(),
        KlaviyoSubscribe.setHasClosedModalCookieName(a.has_closed_modal_cookie_name),
        KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
          var b = KlaviyoSubscribe._buildModalSignUp(a)
          b.find('[name="g"]').val(a.list)
          b.appendTo(jQuery("body"))
          KlaviyoSubscribe.attachToModalForm(b, {
            pages: a.pages,
            excluded_pages: a.excluded_pages,
            delay: a.delay_seconds,

            delay_num_pages: a.delay_num_pages,
            ignore_cookie: a.ignore_cookie,
            extra_properties: a.extra_properties,
            custom_success_message: !!a.content.success,
            success_url: a.success_url,
            success: function (b) {
              b.hide()
              a.success && a.success(b)
            }
          })
        }))
    }
    KlaviyoSubscribe._buildModalSignUp = function (a) {
      var b = a.content
      b.fields = b.extra_fields || []
      ;-1 === jQuery.inArray("$email", b.fields) && b.fields.unshift("$email")
      if (b.element) return jQuery(b.element)
      var c = jQuery(m["modal.html"])
        .attr("id", "k_id_modal")
        .find(".klaviyo_header")
        .html(b.header || "Interested in our Newsletter?")
        .end()
        .find(".klaviyo_subscription_form")
        .attr("action", a.subscribe_url || "//manage.kmail-lists.com/subscriptions/subscribe")
        .data(
          "ajax-submit",
          a.ajax_subscribe_url || "//manage.kmail-lists.com/ajax/subscriptions/subscribe"
        )
        .end()
        .find(".klaviyo_submit_button span")
        .html(b.button || "Subscribe")
        .end()
      b.clazz && c.addClass(b.clazz)
      b.styles && KlaviyoSubscribe.injectCSS(b.styles)
      !1 !== b.subheader &&
        c
          .find(".klaviyo_subheader")
          .html(b.subheader || "Stay in the know with news and promotions.")

      b.below_submit
        ? c.find(".klaviyo_below_submit").html(b.below_submit)
        : c.find(".klaviyo_below_submit").hide()
      b.success && c.find(".success_message").html(b.success)
      !0 === a.ack &&
        c.append(
          jQuery(
            '<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'
          )
        )
      var d = c.find(".klaviyo_fieldset")
      jQuery.each(b.fields, function (a, b) {
        "string" === typeof b && (b = { name: b })
        b.type || (b.type = "$email" === b.name ? "email" : "text")
        b.label || (b.label = q[b.name] || b.name)
        var c = "k_id_modal_" + b.name
        d.append(
          jQuery('<div class="klaviyo_field_group" />')
            .append(jQuery("<label />").attr("for", c).html(b.label))
            .append(
              jQuery("<input />").attr({
                type: b.type,
                id: c,
                name: "$" === b.name[0] ? b.name.slice(1) : b.name
              })
            )
        )
      })
      a = b.fine_print || ""
      b.email_frequency &&
        (a += " Our newsletter is delivered to your inbox " + b.email_frequency + ".")
      c.find(".klaviyo_fine_print").html(a)
      return c
    }
    KlaviyoSubscribe.attachToModalForm = function (a, b) {
      b = b || {}
      b.pages = b.pages || []
      b.excluded_pages = b.excluded_pages || []
      b.extra_properties = b.extra_properties || {}
      b.extra_properties.$source = b.extra_properties.$source || "$modal"
      void 0 === b.delay_seconds && (b.delay_seconds = void 0 === b.delay ? 2 : b.delay)
      KlaviyoSubscribe.bootstrap()
      KlaviyoSubscribe.setHasClosedModalCookieName(b.has_closed_modal_cookie_name)
      KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        var c = jQuery(a)
        KlaviyoSubscribe.attachToForms(jQuery(a).find(".klaviyo_subscription_form"), b)
        c.delegate(".klaviyo_close_modal", "click", function (a) {
          a.preventDefault()
          c.hide()
          KlaviyoSubscribe.setClosedModalCookie()
        })

        c.click(function (a) {
          a.currentTarget === a.target && (c.hide(), KlaviyoSubscribe.setClosedModalCookie())
        })
        KlaviyoSubscribe._canShowElem(b) &&
          jQuery(function () {
            setTimeout(function () {
              c.fadeIn(1e3)
              c.trigger("klaviyo.modal.show")
            }, 1e3 * b.delay_seconds)
          })
      })
    }
    KlaviyoSubscribe.attachFlyoutSignUp = function (a) {
      a = a || {}
      a.pages = a.pages || []
      a.excluded_pages = a.excluded_pages || []
      a.delay_scroll = void 0 === a.delay_scroll ? 50 : a.delay_scroll
      a.delay_seconds = a.delay_seconds || 0.1
      a.delay_num_pages = a.delay_num_pages || 0
      a.position = a.position || "right"
      a.content = a.content || {}
      a.extra_properties = a.extra_properties || {}
      a.extra_properties.$source = a.extra_properties.$source || "$flyout"
      void 0 === a.modal_content && (a.modal_content = a.content)
      a.list &&
        (KlaviyoSubscribe.bootstrap(),
        KlaviyoSubscribe.setHasClosedModalCookieName(a.has_closed_modal_cookie_name),
        KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
          var b = !1 === a.modal_content,
            c = KlaviyoSubscribe._buildFlyoutSignUp(jQuery.extend({ include_form: b }, a))
          c.appendTo(jQuery("body"))

          if (b) {
            var d = a.success
            a.success = function (a) {
              a.hide()
              KlaviyoSubscribe.setClosedModalCookie()
              d && d(a)
            }
            a.custom_success_message = !!a.content.success
            c.find('[name="g"]').val(a.list)
            KlaviyoSubscribe.attachToForms(c.find(".klaviyo_subscription_form"), a)
          }
          KlaviyoSubscribe.attachToFlyout(c, {
            pages: a.pages,
            excluded_pages: a.excluded_pages,
            delay: a.delay_seconds,
            delay_scroll: a.delay_scroll,
            delay_num_pages: a.delay_num_pages,
            position: a.position,
            ignore_cookie: a.ignore_cookie,
            extra_properties: a.extra_properties,

            click: function (b) {
              b = KlaviyoSubscribe._buildModalSignUp({ content: a.modal_content })
              b.find('[name="g"]').val(a.list)
              b.appendTo(jQuery("body"))
              KlaviyoSubscribe.attachToModalForm(b, {
                delay: 0.01,
                extra_properties: a.extra_properties,
                success_url: a.success_url,
                success: function (b) {
                  b.hide()
                  a.success && a.success(b)
                }
              })
            }
          })
        }))
    }
    KlaviyoSubscribe._buildFlyoutSignUp = function (a) {
      var b = a.content
      if (b.element) return jQuery(b.element)
      var c = jQuery(m[a.include_form ? "flyout_form.html" : "flyout.html"])
        .attr("id", "k_id_flyout")
        .find(".klaviyo_header")
        .html(b.header || "Interested in our Newsletter?")
        .end()
        .find(".klaviyo_subscription_form")
        .attr("action", a.subscribe_url || "//manage.kmail-lists.com/subscriptions/subscribe")
        .data(
          "ajax-submit",
          a.ajax_subscribe_url || "//manage.kmail-lists.com/ajax/subscriptions/subscribe"
        )
        .end()
        .find(".klaviyo_flyout_action a span, .klaviyo_submit_button span")
        .html(b.button || "Subscribe")
        .end()
      c.addClass("klaviyo_" + a.position)
      b.clazz && c.addClass(b.clazz)
      b.styles && KlaviyoSubscribe.injectCSS(b.styles)
      !1 !== b.subheader &&
        c
          .find(".klaviyo_subheader")
          .html(b.subheader || "Stay in the know with news and promotions.")
      b.success && c.find(".success_message").html(b.success)
      !0 === a.ack &&
        c
          .find(".klaviyo_inner")
          .append(
            jQuery(
              '<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'
            )
          )
      return c
    }
    KlaviyoSubscribe.attachToFlyout = function (a, b) {
      b = b || {}
      b.pages = b.pages || []
      b.excluded_pages = b.excluded_pages || []
      b.position = b.position || "right"
      b.extra_properties = b.extra_properties || {}
      b.extra_properties.$source = b.extra_properties.$source || "$flyout"
      KlaviyoSubscribe.bootstrap()
      KlaviyoSubscribe.setHasClosedModalCookieName(b.has_closed_modal_cookie_name)
      KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        var c = jQuery(a)
        c.delegate(".klaviyo_close_flyout", "click", function (a) {
          a.preventDefault()
          c.hide()
          KlaviyoSubscribe.setClosedModalCookie()
        })
        c.find(".klaviyo_flyout_action a").click(function (a) {
          a.preventDefault()
          c.hide()
          b.click && b.click()
        })
        KlaviyoSubscribe._canShowElem(b) &&
          jQuery(function () {
            var a = b.delay_scroll,
              e = function () {
                if (!c.data("opened")) {
                  var a = b.delay_seconds || b.delay
                  void 0 === a && (a = 2)
                  setTimeout(
                    function () {
                      if (!c.data("opened")) {
                        c.data("opened", !0)
                        c.trigger("klaviyo.flyout.show")
                        var a = c.find(".klaviyo_inner"),
                          d =
                            -1 < jQuery.inArray(b.position, ["left", "right", "bottom", "top"])
                              ? b.position
                              : "right",
                          e = {},
                          g
                        e[d] = 0
                        c.css("visibility", "hidden").show()
                        "left" === d
                          ? (g = 1.2 * -a.width())
                          : "right" === d
                          ? (g = 1.2 * -a.width())
                          : "top" === d
                          ? (g = 1.2 * -a.height())
                          : "bottom" === d && (g = 1.2 * -a.height())
                        a.css(d, g)
                        c.css("visibility", "visible")
                        a.animate(e, 1e3 * (b.slide_seconds || 2))
                      }
                    },

                    1e3 * a
                  )
                }
              }
            if (!1 === a || 0 === a) e()
            else {
              var f = jQuery(document),
                k = jQuery(window),
                g = "bottom" === a ? 95 : a,
                l = function () {
                  var a = f.height() - k.height()
                  ;(0 > a ? 100 : (100 * f.scrollTop()) / a) > g && (e(), f.unbind("scroll", l))
                }
              f.scroll(l)
            }
          })
      })
    }
    KlaviyoSubscribe.isFormValid = function (a) {
      var b = a.find('[name="email"]').val()
      if (!b || !/@/.test(b))
        throw (KlaviyoSubscribe.log("Invalid email address"), "Invalid email address")
      a.find('input[required="true"], select[required="true"]').each(function (b, d) {
        d = jQuery(d)
        if (d.is(":radio") || d.is(":checked")) {
          has_value = !!a.find('[name="' + d.attr("name") + '"]:checked').length
          if (!has_value)
            throw (
              (KlaviyoSubscribe.log("Required field missing", d.attr("name")),
              "Required field missing: " + d.attr("name"))
            )
          return has_value
        }
        if (!d.val())
          throw (
            (KlaviyoSubscribe.log("Required field missing", d.attr("name")),
            "Required field missing: " + d.attr("name"))
          )
      })
      a.find(".select-date-widget").each(function (a, b) {
        b = jQuery(b)
        var e = KlaviyoSubscribe._int(b.find('[name$="_day"]').val()),
          f = KlaviyoSubscribe._int(b.find('[name$="_month"]').val()),
          k = KlaviyoSubscribe._int(b.find('[name$="_year"]').val())
        if (!(isNaN(e) || isNaN(f) || isNaN(k))) {
          switch (f) {
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
              if (1 <= e && 31 >= e) return
            case 4:
            case 6:
            case 9:
            case 11:
              if (1 <= e && 30 >= e) return
            case 2:
              if (1 <= e && e <= (k % 4 ? 28 : 29)) return
          }
          KlaviyoSubscribe.log("Invalid date", k, f, e)
          throw "Invalid date"
        }
      })
      return !0
    }
    KlaviyoSubscribe.normalizeFormFields = function (a, b, c, d) {
      a.push({ name: "$timezone_offset", type: "text", value: this._getUtcOffset() })
      var e = [],
        f
      jQuery.each(
        c,
        function (
          b,

          c
        ) {
          a.push({ name: b, type: "text", value: c })
          e.push(b)
        }
      )
      e.length &&
        (jQuery.each(a, function (a, b) {
          if ("$fields" === b.name) return (f = b), !1
        }),
        f
          ? (f.value += "," + e.join())
          : a.push({ name: "$fields", type: "text", value: e.join() }))
      b.find(".select-date-widget").each(function (b, c) {
        c = jQuery(c)
        var d = c.find('[name$="_day"]'),
          e = c.find('[name$="_month"]'),
          f = c.find('[name$="_year"]'),
          h = d.attr("name"),
          m = e.attr("name"),
          p = f.attr("name"),
          d = KlaviyoSubscribe._int(d.val()),
          e = KlaviyoSubscribe._int(e.val()),
          f = KlaviyoSubscribe._int(f.val())

        if (!(isNaN(d) || isNaN(e) || isNaN(f))) {
          for (b = 0; b < a.length; ) {
            var n = a[b]
            !n || (n.name !== h && n.name !== m && n.name !== p) ? b++ : a.splice(b, 1)
          }
          a.push({
            name: h.replace("_day", ""),
            required: !0,
            type: "text",
            value: KlaviyoSubscribe._formatDate(f, e, d)
          })
        }
      })
    }
    KlaviyoSubscribe.isCurrentLocationInPatterns = function (a) {
      for (var b = location.toString(), c = 0, d = a.length; c < d; c++)
        if (KlaviyoSubscribe.patternMatchesUrl(a[c], b)) return !0
      return !1
    }
    KlaviyoSubscribe.patternMatchesUrl = function (a, b) {
      b = b.toLowerCase()
      if (a === b) return !0
      if (-1 === a.indexOf("?")) {
        var c = b.indexOf("?")
        ;-1 !== c && (b = b.substring(0, c))
      }
      if (-1 === a.indexOf("*"))
        return (
          (a = a.replace(/\/$/, "")),
          "" === a && (a = "/"),
          (b = b.replace(/\/$/, "")),
          a === b
            ? !0
            : 0 === a.indexOf("/")
            ? ((c = KlaviyoSubscribe.parseDomain(b)), "" === a ? "/" === c : c === a)
            : !1
        )
      if (a === b) return !0
      if (!a.length) return !1
      c = a
        .replace(RegExp("[.+?|()\\[\\]{}\\\\]", "g"), "\\$&")
        .replace(RegExp("\\*", "g"), "(.*?)")
      c = /\/$/.test(c) ? "^" + c + "$" : "^" + c + "/?$"
      c = RegExp(c, "i")
      return c.test(b) ? !0 : a.indexOf("/") ? !1 : c.test(KlaviyoSubscribe.parseDomain(b))
    }
    KlaviyoSubscribe.parseDomain = function (a) {
      return "/" + a.split("//")[1].split("/").splice(1).join("/")
    }
    KlaviyoSubscribe.incrPageViews = function () {
      var a = parseInt(KlaviyoSubscribe._getCookie("klaPages"), 10)
      isNaN(a) && (a = 0)
      a += 1
      KlaviyoSubscribe._setCookie("klaPages", a, 31536e6)
      return a
    }
    KlaviyoSubscribe.setClosedModalCookie = function () {
      KlaviyoSubscribe._setCookie(h, "1", 31536e6)
    }
    KlaviyoSubscribe.resetClosedModalCookie = function () {
      KlaviyoSubscribe._deleteCookie(h)
    }
    KlaviyoSubscribe.hasClosedModal = function () {
      return !!KlaviyoSubscribe._getCookie(h) && !KlaviyoSubscribe.isDebugMode()
    }
    KlaviyoSubscribe._setCookie = function (a, b, c) {
      c = new Date(new Date().getTime() + c)
      document.cookie = a + "=" + b + ";expires=" + c.toGMTString() + ";path=/"
    }
    KlaviyoSubscribe._getCookie = function (a) {
      return (a = RegExp("(^|;)[ ]*" + a + "=([^;]*)").exec(document.cookie)) ? a[2] : ""
    }
    KlaviyoSubscribe._deleteCookie = function (a) {
      KlaviyoSubscribe._getCookie(a) && KlaviyoSubscribe._setCookie(a, "", -1)
    }
    KlaviyoSubscribe._getUtcOffset = function () {
      return new Date().getTimezoneOffset() / -60
    }
    KlaviyoSubscribe._canShowElem = function (a) {
      return (a.delay_num_pages && a.delay_num_pages > KlaviyoSubscribe.incrPageViews()) ||
        (a.pages.length && !KlaviyoSubscribe.isCurrentLocationInPatterns(a.pages)) ||
        (a.excluded_pages.length && KlaviyoSubscribe.isCurrentLocationInPatterns(a.excluded_pages))
        ? !1
        : a.ignore_cookie || !KlaviyoSubscribe.hasClosedModal()
    }
    KlaviyoSubscribe._int = function (a) {
      return parseInt(a, 10)
    }
    KlaviyoSubscribe._formatDate = function (a, b, c) {
      1 === c.toString().length && (c = "0" + c)
      1 === b.toString().length && (b = "0" + b)
      return a + "-" + b + "-" + c
    }
    KlaviyoSubscribe.log = function () {
      // window.console&&console.log&&console.log(arguments)
    }
  }
})()

$(document).ready(function () {
  /* ================= Mobile Chrome vh units fix ============ */

  var options = [
    {
      selector: ".hp-pillar", // Mandatory, CSS selector
      vh: 100 // Mandatory, height in vh units
    }
  ]
  var vhFix = new VHChromeFix(options)

  /* ============== Remove Class ====================== */
  function removeClassWithPrefix(element, classPrefix) {
    var regex = new RegExp("(^|\\s)" + classPrefix + "\\S+", "g")
    element.removeClass(function (index, css) {
      return (css.match(regex) || []).join(" ")
    })
  }

  /* ============== Get Url Parameter ================ */

  $.urlParam = function (name) {
    var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href)
    return results || 0
  }

  /* ============= Wait For Image ================ */

  const $jsWaitForImage = document.querySelector(".js-wait-for-image")

  if (!$jsWaitForImage) return

  $($jsWaitForImage).waitForImages(function () {
    $(".hidden-before-images-ready").animate(
      {
        opacity: "1"
      },
      200
    )
  })

  /* ============ Browser Scrolled Detect =============== */
  function scrolledCheck() {
    if ($(window).scrollTop() > 0) {
      $("body").addClass("browser-scrolled")
    } else {
      $("body").removeClass("browser-scrolled")
    }
    if ($(window).scrollTop() > 0) {
      $("body").addClass("navbar-condensed")
    } else {
      $("body").removeClass("navbar-condensed")
    }
  }
  scrolledCheck()
  $(window).on("scroll", function () {
    scrolledCheck()
  })

  /* ========== Browser Scroller ====================== */

  $(document).on("click", ".js-browser-back-to-top", function () {
    $("html, body").animate(
      {
        scrollTop: 0
      },
      600,
      "easeOutExpo"
    )
  })

  /* ==============  Sroll Down Window Height ================ */

  $(document).on("click", ".js-scroll-down-window-height", function () {
    $("html, body").animate(
      {
        scrollTop: $(window).height() - $(".desktop-navbar").height()
      },
      600,
      "easeOutExpo"
    )
  })

  /* =========== Scroll To Element =================== */

  $(document).on("click", ".js-body-scroll-to-element", function (event) {
    var elementSelector = $(this).data("element-selector")
    var scrollOffset = $(".desktop-navbar-nav").height() + $(".page-breadcrumb").height()
    $("html, body").animate(
      {
        scrollTop: $(elementSelector).offset().top - scrollOffset
      },
      600,
      "easeOutExpo"
    )
  })

  /* ====== Dropdown ======================== */

  $(document).on("click", ".js-dropdown-toggle", function () {
    var $dropdown = $(this).parent()
    $dropdown.toggleClass("open").siblings().removeClass("open")
  })

  $(document).on("click", ".js-dropdown-toggle-update", function () {
    var $this = $(this)
    var $dropdown = $this.parents(".dropdown")
    $dropdown.removeClass("open").find(".dropdown-toggle").html($this.html())
  })

  /* ============ Body Class ======================= */

  $(document).on("click", ".js-body-add-class", function () {
    $("body").addClass($(this).data("body-class"))
  })

  $(document).on("click", ".js-body-remove-class", function () {
    $("body").removeClass($(this).data("body-class"))
  })

  $(document).on("click", ".js-body-toggle-class", function () {
    $("body").toggleClass($(this).data("body-class"))
  })

  /* ============= Element Class =============================== */
  $(document).on("click", ".js-class", function () {
    var $this = $(this)
    var arrayData = $this.data("js-class")
    $.each(arrayData, function (index, item) {
      var ancestorSelector = item.ancestor_selector
      var targetSelector = item.target_selector
      var className = item.class_name
      var classAction = item.class_action
      var $target = ancestorSelector
        ? $this.parents(ancestorSelector).find(targetSelector)
        : $(targetSelector)

      switch (classAction) {
        case "add":
          $target.addClass(className)
          break
        case "remove":
          $target.removeClass(className)
          break
        case "toggle":
          $target.toggleClass(className)
      }
    })
    setTimeout(function () {
      $("#searchbarInput").focus()
      console.log("here click")
    }, 800)
    $(".popup-close").focus()
  })

  /* =========== Element Fadein Fadeout ===================== */
  $(document).on("click", ".js-element-fadein", function () {
    $($(this).data("element-selector")).fadeIn(400)
  })

  $(document).on("click", ".js-element-fadeout", function () {
    $($(this).data("element-selector")).fadeOut(400)
  })

  $(document).on("click", ".js-element-toggle", function () {
    $($(this).data("element-selector")).fadeToggle(400)
  })

  $(document).on("click", ".js-element-fadeinout", function () {
    var $this = $(this)
    $($this.data("in-element-selector")).show()
    $($this.data("out-element-selector")).hide()
  })

  $(document).on("click", ".js-element-slideupdown", function () {
    var $this = $(this)
    var index = $this.index()
    var $switchTargets = $($this.data("element-selector"))
    var $activeTarget = $switchTargets.filter(":visible")
    $this.addClass("active").siblings().removeClass("active")
    if ($activeTarget.length) {
      $activeTarget.slideUp(300, function () {
        $switchTargets.eq(index).slideDown(300)
      })
    } else {
      $switchTargets.eq(index).slideDown(300)
    }
  })

  /* ========= Stop Propagation =================== */

  $(document).on("click", ".js-stop-propagation", function (event) {
    event.stopPropagation()
  })

  /* =========== Tab ======================== */
  $(document).on("click", ".tab-label", function (event) {
    event.preventDefault()
    var $this = $(this)
    var index = $this.index()
    var $tabContent = $this.parents(".tab").find(".tab-content")
    $this.addClass("active").siblings().removeClass("active")
    $tabContent.filter(":visible").fadeOut(0, function () {
      $tabContent.eq(index).fadeIn(0)
    })
  })

  /* ============ Pagination Load More Ajax =============== */
  ;(function () {
    var paginationIsLoading = false
    $(document).on("click", ".js-pagination-load-more", function (event) {
      event.preventDefault()
      var $ajaxWrapper = $("#load-more-target")
      var ajaxURL = $(this).attr("href")
      $.ajax({
        url: ajaxURL,
        dataType: "html"
      }).done(function (data) {
        // loadmore button update
        var $pagination = $(data).find(".pagination-load-more")
        $(".pagination-load-more-wrapper").html($pagination)
        var ajaxURLNext = $(".pagination-load-more").attr("href")
        if (!ajaxURLNext) {
          $(".pagination-load-more-wrapper").remove()
        }
        // append the new items
        var $items = $(data).find("#load-more-target").children()
        // $items.css('opacity', '0');
        $ajaxWrapper.append($items)
        //set the flag
        paginationIsLoading = false
      })
    })

    if ($(".pagination-style-scroll").length) {
      $(window).on(
        "scroll",
        _.throttle(
          function () {
            if (!paginationIsLoading) {
              paginationIsLoading = true
              $(".pagination-load-more").trigger("click")
            }
          },
          100,
          { leading: true, trailing: true }
        )
      )
    }
  })()

  /* ========= Image Swap ====================== */
  var imageSourceSwap = function () {
    var $this = $(this)
    if ($this.data("image-alt")) {
      var imageAlt = $this.data("image-alt")
      $this.data("image-alt", $this.css("background-image"))
      $this.css("background-image", imageAlt)
    }
  }
  $(".js-product-card-image-swap").hover(imageSourceSwap, imageSourceSwap)

  /* ============  Email Subscribe Popup ================= */

  function initEmailPopup() {
    if (!Cookies.get("site_visited")) {
      var documentClicks = localStorage.getItem("subscribe_popup_clicks")
        ? localStorage.getItem("subscribe_popup_clicks")
        : 0
      $(document).on("click", function () {
        documentClicks++
        localStorage.setItem("subscribe_popup_clicks", documentClicks)
      })
      var idleTime = 0
      //Increment the idle time counter every X seconds.
      var idleInterval = setInterval(timerIncrement, 1000)
      //Zero the idle timer on mouse movement.
      $(document).mousemove(function (e) {
        idleTime = 0
      })
      $(document).keypress(function (e) {
        idleTime = 0
      })
      function timerIncrement() {
        idleTime = idleTime + 1
        tryOpenPopup()
      }
      function tryOpenPopup() {
        if (
          documentClicks >= _subscribePopupSettings.click_max ||
          idleTime >= _subscribePopupSettings.idle_max
        ) {
          // Delay a bit to make sure popup doesn't occur on a page transition
          setTimeout(function () {
            $("body").addClass("scroll-lock")
            $(".subscribe-popup").addClass("active")
            Cookies.set("site_visited", "true", { expires: _subscribePopupSettings.expiry_days })
            clearInterval(idleInterval)
            localStorage.setItem("subscribe_popup_clicks", 0)
          }, 1500)
        }
      }
    }
  }
  if ($(".subscribe-popup").length) {
    initEmailPopup()
  }

  /* =============== Royal Slider ============================ */

  var rsDefaultOptions = {
    controlNavigation: "none",
    arrowsNav: !1,
    arrowsNavAutoHide: !1,
    arrowsNavHideOnTouch: !1,
    navigateByClick: !1,
    keyboardNavEnabled: !0,
    controlsInside: !1,
    transitionType: "fade",
    usePreloader: !1,
    loop: !0,
    slidesSpacing: 0,
    addActiveClass: !0,
    autoHeight: !0
  }
  function arrowsSliderInit($slider, slidesHtml) {
    var rsOptions = $.extend(true, {}, rsDefaultOptions, {
      slides: slidesHtml,
      arrowsNav: true,
      arrowsNavAutoHide: false
    })
    $slider.royalSlider(rsOptions)
  }

  function bulletsSliderInit($slider, slidesHtml) {
    var rsOptions = $.extend(true, {}, rsDefaultOptions, {
      slides: slidesHtml,
      controlNavigation: "bullets",
      transitionType: "move"
    })
    $slider.royalSlider(rsOptions)
  }

  function autoMoveSliderInit($slider, slidesHtml) {
    var rsOptions = $.extend(true, {}, rsDefaultOptions, {
      slides: slidesHtml,
      transitionType: "move",
      autoPlay: {
        enabled: true,
        stopAtAction: true,
        pauseOnHover: true,
        delay: 2000
      }
    })
    $slider.royalSlider(rsOptions)
  }

  function autoFadeSliderInit($slider, slidesHtml) {
    var rsOptions = $.extend(true, {}, rsDefaultOptions, {
      slides: slidesHtml,
      transitionType: "fade",
      autoPlay: {
        enabled: true,
        stopAtAction: false,
        pauseOnHover: false,
        delay: 900
      }
    })
    $slider.royalSlider(rsOptions)
  }

  $(".royalSlider").each(function (index) {
    var $this = $(this)
    if ($this.children().length) {
      if ($this.is(".js-arrows-slider")) {
        arrowsSliderInit($this, null)
      } else if ($this.is(".js-bullets-slider")) {
        bulletsSliderInit($this, null)
      } else if ($this.is(".js-auto-move-slider")) {
        autoMoveSliderInit($this, null)
      } else if ($this.is(".js-auto-fade-slider")) {
        autoFadeSliderInit($this, null)
      }
      if ($this.is(".js-auto-fade-hover-slider")) {
        autoFadeSliderInit($this, null)
        $this.data("royalSlider").stopAutoPlay()
      }
      if ($this.data("royalSlider").numSlides === 1) {
        $this.find(".rsNav").hide()
      }
    }
  })

  /* ============ Owl Carousel =============================== */
  $(".owl-carousel-nav-prev").click(function () {
    $(this).parents(".owl-carousel-wrapper").find(".owl-carousel").trigger("prev.owl.carousel")
  })
  $(".owl-carousel-nav-next").click(function () {
    $(this).parents(".owl-carousel-wrapper").find(".owl-carousel").trigger("next.owl.carousel")
  })

  /* ===============  Klaviyo Email Subscribe ============================ */

  $(".subscribe-form").each(function () {
    var elementID = $(this).attr("id")
    var idSelector = "#" + elementID
    KlaviyoSubscribe.attachToForms(idSelector, {
      success_message: "Thank you for subscribing!",
      success: function ($form) {
        if (idSelector == "#lock-subscribe-form") {
          setCookie("signedup", idSelector, 360)
        }
      }
    })
  })
  function setCookie(cname, cvalue, exdays) {
    var d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    var expires = "expires=" + d.toGMTString()
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
  }

  /* ================ Lookbook mouse following title ================ */

  $(document).on("mousemove", ".lookbook-item", function (event) {
    var offset = $(this).offset()
    var relX = event.pageX - offset.left
    var relY = event.pageY - offset.top
    $(this).find(".lookbook-item-title").css({
      display: "block",
      left: relX,
      top: relY
    })
  })

  /* ============= Customer ==================== */

  $(document).on("click", ".js-reset-password-fadein", function () {
    $(".recover-password-form").fadeIn(0)
    $(".customer-login-form").fadeOut(0)
  })

  $(document).on("click", ".js-rest-password-fadeout", function () {
    $(".recover-password-form").fadeOut(0)
    $(".customer-login-form").fadeIn(0)
  })
  if ($(".template-directory-customers").length) {
    // Initialize observers on address selectors, defined in shopify_common.js
    if ($(".template-customers-addresses").length) {
      // Initialize each edit form's country/province selector
      $(document).on("click", ".address-country-option", function () {
        var formId = $(this).data("form-id")
        var countrySelector = "AddressCountry_" + formId
        var provinceSelector = "AddressProvince_" + formId
        var containerSelector = "AddressProvinceContainer_" + formId
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        })
      })
      $(document).on("click", ".address-delete", function () {
        var $el = $(this)
        var formId = $el.data("form-id")
        var confirmMessage = $el.data("confirm-message")
        if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
          Shopify.postLink("/account/addresses/" + formId, { parameters: { _method: "delete" } })
        }
      })
    }
  }

  /* ========== General ========================= */

  var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy"
  })
  $(document).on("focusin", ".footer-subscribe-form", function () {
    $(this).addClass("focused")
  })

  /* ============= Homepage =========================== */

  if ($(".template-index").length) {
    // if the first section is desktop slider
    if ($(".main .shopify-section:first-child:has(.hp-slider-desktop)").length) {
      var $hpSliderDesktop = $(".hp-slider-desktop").first()
      var hpSliderDesktopData = $hpSliderDesktop.data("royalSlider")
      var navbarColorClass = hpSliderDesktopData.currSlide.content.attr("data-navbar-color")
      $("body").addClass(navbarColorClass)
    }
    // spead the navbar color class to body on slider play
    $(".hp-slider-desktop").each(function (index) {
      var $slider = $(this)
      if ($slider.children().length) {
        var hpSliderDesktopData = $slider.data("royalSlider")
        hpSliderDesktopData.ev.on("rsBeforeAnimStart", function (event) {
          removeClassWithPrefix($("body"), "navbar-color-")
          var navbarColorClass = hpSliderDesktopData.currSlide.content.attr("data-navbar-color")
          $slider.attr("data-navbar-color", navbarColorClass)
          $("body").addClass(navbarColorClass)
        })
      }
    })

    $(document).on("click", ".js-video-package-control", function () {
      var $this = $(this),
        $package = $this.parents(".video-package"),
        $poster = $package.find(".video-package-poster"),
        $video = $package.find(".video-package-video").get(0),
        $button = $package.find(".video-package-cta")
      $package.addClass("active")
      if ($video.paused) {
        $button.text("pause")
        $video.play()
      } else {
        $button.text("continue")
        $video.pause()
      }
    })
  }

  /* =============== Collection Page ========================= */
  if ($(".template-name-collection").length) {
    $(document).on("click", ".collection-fxbar-filter-tab-header", function () {
      index0 = $(this).index()
      $content = $(".collection-fxbar-filter-tab-content")
      $thisContent = $content.eq(index0)
      $otherContent = $content.not($thisContent)
      $otherContent.removeClass("active")
      $thisContent.toggleClass("active")
      $header = $(".collection-fxbar-filter-tab-header")
      $thisHeader = $(this)
      $otherHeader = $header.not($thisHeader)
      $otherHeader.removeClass("active")
      $thisHeader.toggleClass("active")
    })

    $(document).on("click", ".collection-fxbar-sort-tab-header", function () {
      $(this).toggleClass("active")
      $(".collection-fxbar-sort-tab-content").toggleClass("active")
    })
    tinysort(".collection-filter-tag", { data: "size-sort", order: "desc" })

    $(document).on("click", ".collection-fxbar-item-trigger", function () {
      $this = $(this)
      var $activeItem = $($this.data("active-element-selector")),
        $inactiveItem = $($this.data("inactive-element-selector")),
        $title = $(".collection-fxbar-collection-title"),
        $currentFilter = $(".collection-current-filter")
      $(".collection-fxbar-item-trigger").removeClass("active")

      $this.addClass("active")
      $activeItem.toggleClass("active")
      $inactiveItem.removeClass("active")
      if ($inactiveItem.hasClass("active") || $activeItem.hasClass("active")) {
        $title.removeClass("active")
        $currentFilter.removeClass("active")
      } else {
        $title.addClass("active")
        $currentFilter.addClass("active")
      }
    })
  }

  /* =================== Product Card Color Swatch ======================= */

  $(document).on("click", ".js-product-card-color-swatch", function () {
    var $this = $(this)
    var canvasEle = $this.find(".canvas")

    // Check if the item is disabled (out of stock)
    var isDisabled = canvasEle.attr("aria-disabled") === "true"

    if (isDisabled) {
      // If disabled, do not allow focus and set aria-checked to false
      canvasEle.attr("tabindex", "-1")
      canvasEle.attr("aria-checked", "false")
    } else {
      // Normal functionality when the item is not disabled
      $this
        .addClass("selected")
        .siblings()
        .removeClass("selected")
        .find(".canvas")
        .attr("aria-checked", "false")

      if ($this.hasClass("selected")) {
        canvasEle.attr("aria-checked", "true")
        canvasEle.attr("tabindex", "0")
      } else {
        canvasEle.attr("aria-checked", "false")
        canvasEle.attr("tabindex", "-1")
      }
    }
    // data
    var productHandle = $this.data("product-handle")
    var $finalorder = $this.data("finalorder")
    const preorderNote = $this.data("preorder-note") || $this.data("preordernote")
    const available = $this.data("available")
    const title = $this.data("product-title")
    const badges = $this.data("badges") ? $this.data("badges").split(",") : []

    const badgeTags = badges
      .map((badge) => `<div class="final_sale_tag badge-tag">${badge}</div>`)
      .join("")

    const productTitle = `
      ${available === false ? '<div class="final_sale_tag">Sold Out</div>' : ""}
      ${preorderNote !== "" ? '<div class="preprder_tag" style="color:#000;">PRE-ORDER</div>' : ""}
      ${badgeTags}
      <div class="title_box">
        <a href="/products/${productHandle}">
        ${title}
        </a>
      </div>
    `

    var price = $this.data("variant-price-html"),
      $productCard = $this.closest(".product-card"),
      $productCardAlbum = $productCard.find(".product-card-album"),
      $productCardTitle = $productCard.find(".product-card-title"),
      $productQuickShop = $productCard.find("product-card-quickshop"),
      $productPriceField = $productCard.find(".product-card-price")
    $productCardAlbum
      .removeClass("active")
      .filter('[data-product-handle="' + productHandle + '"]')
      .addClass("active")
    $productQuickShop
      .removeClass("active")
      .filter('[data-product-handle="' + productHandle + '"]')
      .addClass("active")
    $productCardTitle.html(productTitle)
    $productPriceField.html(price)
  })
  /* ================  Cart Quantity Input ===================== */

  $(document).on("click", ".js-line-item-quantity-input", function () {
    $(this).select()
  })
  $(document).on(
    "keyup",
    ".js-line-item-quantity-input",
    _.debounce(function () {
      var lineQuantity = parseInt($(this).val()),
        lineNumber = parseInt($(this).data("line-number"))
      CartJS.updateItem(lineNumber, lineQuantity)
    }, 300)
  )

  $(document).on("cart.requestComplete", function (event, data) {
    //console.log(data);
  })

  /* ============== Back in Stock App ================== */
  window.onclick = function (c) {
    "product-shop-back-in-stock-email" == c.srcElement.className &&
      c.srcElement.classList.add("currentFieldzx")
  }
  $(document).on("click", ".js-product-back-in-stock-submit", function () {
    var a = $(this)
    if (a.parents(".product-shop-submit").hasClass("is_stuck"))
      $("html, body").animate({ scrollTop: 0 }, 600, "easeOutExpo")
    else {
      var t = a.attr("data-product-id"),
        r = a.attr("data-variant-id"),
        i = $(".product-shop-back-in-stock-email.currentFieldzx").val()
      BIS.create(i, r, t).then(function (t) {
        var r = ""
        if ("OK" == t.status) r = "Thank you!"
        else {
          var i = ""
          for (var e in t.errors) i += e + " " + t.errors[e].join()
          r =
            i.indexOf("already") >= 0
              ? "Thank you!"
              : i.indexOf("invalid") >= 0
              ? "invalid email"
              : "error"
        }
        a.text(r)
      })
    }
  })
  $(document).on("click", ".product-shop-back-in-stock-submit", function () {
    var a = $(".product-shop-back-in-stock-email"),
      t = $(".product-add-to-cart"),
      r = a.val(),
      i = t.attr("data-product-id"),
      o = t.attr("data-variant-id")
    BIS.create(r, o, i).then(function (a) {
      var r = ""
      if ("OK" == a.status) r = "Thank you!"
      else {
        var i = ""
        for (var o in a.errors) i += o + " " + a.errors[o].join()
        r =
          i.indexOf("already") >= 0
            ? "Thank you!"
            : i.indexOf("invalid") >= 0
            ? "invalid email"
            : "error"
      }
      t.text(r)
    })
  })
  /* ======= Wishlist App =============================== */
  function isInWishlist(i, s) {
    return (
      (pIdString = i.toString()),
      (vIdString = s.toString()),
      void 0 !== iWishlistmain[pIdString] && iWishlistmain[pIdString].indexOf(vIdString) >= 0
    )
  }
  function iwish_addOnly(i, s, n) {
    void 0 === iWishlistmain[i] && (iWishlistmain[i] = []),
      iWishlistmain[i].indexOf(s) < 0 &&
        (iWishlistmain[i].push(s),
        iWishCnt++,
        pushToSession(),
        parseInt(iwish_cid) > 0 &&
          jQuery.ajax({
            url: "//iwish.shopapps.in/ajax/iwishAdd.php",
            data: { shop: iwish_shop, cId: iwish_cid, pId: i, vId: s, pTitle: n },
            dataType: "jsonp",
            jsonpCallback: "iWishCallback",
            success: function (i) {},
            error: function (i, s, n) {}
          }))
  }
  $(document).on("click", ".product-add-to-wishlist", function () {
    var i = $(this)
    if (iwish_cid) {
      var a = i.attr("data-variant")
      iwish_add(i, a)
    } else $("body").addClass("mini-account-open")
  })
  /* Remove product from wishlist */
  $(".iwishRemoveBtn").click(function () {
    if ($(this).hasClass("iwishRemoved")) return !1
    var i = $(this).attr("data-variant")
    return (
      iwish_remove($(this), i, !0) &&
        ($(this).addClass("iwishRemoved"),
        $(this).parents(".iwishItem").remove(),
        iWishCnt < 4 && $(".iwish-no-result-item").css("display", "block")),
      !1
    )
  })
  $('a[href="/apps/iwish"]').click(function (e) {
    if (typeof Storage !== "undefined") {
      e.preventDefault()
      iWishPost("/apps/iwish", { iwishlist: JSON.stringify(iWishlistmain), cId: iwish_cid })
    }
  })
})

// Adding keyboard navigation plp
var colorGroup = null
var colorButtons = []

window.addEventListener("DOMContentLoaded", function (e) {
  colorGroup = document.querySelectorAll(".product-card-color-swatch-list")
  colorGroup.forEach(function (group) {
    colorButtons = group.querySelectorAll(".canvas")

    colorButtons.forEach(function (colorButton) {
      colorButton.addEventListener("click", function (e) {
        // If the button is disabled, do not proceed
        if (
          colorButton.hasAttribute("aria-disabled") &&
          colorButton.getAttribute("aria-disabled") === "true"
        ) {
          e.preventDefault()
          return
        }
        selectColorButton(e.currentTarget)
      })

      colorButton.addEventListener("keydown", function (e) {
        switch (e.key) {
          case "ArrowUp":
          case "ArrowLeft":
            selectPreviousColorButton(e.currentTarget)
            break

          case "ArrowDown":
          case "ArrowRight":
            selectNextColorButton(e.currentTarget)
            break

          case " ":
          case "Enter":
            e.preventDefault()
            selectColorButton(e.currentTarget)
            break
        }
      })
    })
  })
})

// Function to select the previous color button while skipping disabled ones
function selectPreviousColorButton(currentButton) {
  var allButtons = Array.from(
    currentButton.closest(".product-card-color-swatch-list").querySelectorAll(".canvas")
  )
  var currentIndex = allButtons.indexOf(currentButton)
  var prevIndex = currentIndex - 1

  // Skip disabled buttons
  while (prevIndex >= 0 && allButtons[prevIndex].getAttribute("aria-disabled") === "true") {
    prevIndex--
  }

  if (prevIndex >= 0) {
    allButtons[prevIndex].focus()
    selectColorButton(allButtons[prevIndex])
  }
}

// Function to select the next color button while skipping disabled ones
function selectNextColorButton(currentButton) {
  var allButtons = Array.from(
    currentButton.closest(".product-card-color-swatch-list").querySelectorAll(".canvas")
  )
  var currentIndex = allButtons.indexOf(currentButton)
  var nextIndex = currentIndex + 1

  // Skip disabled buttons
  while (
    nextIndex < allButtons.length &&
    allButtons[nextIndex].getAttribute("aria-disabled") === "true"
  ) {
    nextIndex++
  }

  if (nextIndex < allButtons.length) {
    allButtons[nextIndex].focus()
    selectColorButton(allButtons[nextIndex])
  }
}

// Function to select the color button
function selectColorButton(colorButton) {
  var canvasSelect = colorButton.closest(".product-card-color-swatch-list")
  canvasSelect.querySelectorAll(".canvas").forEach(function (otherColorButton) {
    otherColorButton.setAttribute("aria-checked", "false")
    otherColorButton.setAttribute("tabindex", "-1")
  })

  colorButton.setAttribute("aria-checked", "true")
  colorButton.setAttribute("tabindex", "0")
  colorButton.focus()

  // Trigger the click event on the parent button
  colorButton.closest(".js-product-card-color-swatch").click()
}

$(document).on("click", ".more-colors", function () {
  // Get the parent grid item that contains the "more-colors" button
  var parentGridItem = $(this).closest(".product-card-color-swatch-list")
  parentGridItem.attr("data-show", "true")
  // Target the 8th child (or the first hidden child) within this grid item
  var firstHiddenItem = parentGridItem.find(".canvas").eq(7)
  if (firstHiddenItem.length) {
    firstHiddenItem.attr("tabindex", 0)
    var parentSwatch = firstHiddenItem.closest(".product-card-color-swatch")
    parentGridItem.find(".product-card-color-swatch").removeClass("selected")
    parentSwatch.addClass("selected")

    // Focus the item
    firstHiddenItem.focus()
  }
})

CartJS.getCart()

// Mini-Cart Qty Updates
$(".add").click(function () {
  //alert("plus");
  var th = $(this).closest(".addhere").find(".count")
  th.val(+th.val() + 1)
})
$(".sub").click(function () {
  //alert("minus");
  var th = $(this).closest(".addhere").find(".count")
  if (th.val() > 1) th.val(+th.val() - 1)
})

// Mini-Cart Qty Updates
$(document).on("change", ".js-qty__adjust", function () {
  var $this = $(this)
  var lineQuantity = parseInt($(this).val()),
    lineNumber = parseInt($(this).data("line-number"))
  CartJS.updateItem(lineNumber, lineQuantity)
})
